//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class ChatbotClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getMessage(version: string, chatbotGetMessageModel: GetAnswerChatbotModel, signal?: AbortSignal): Promise<ChatbotAnswer> {
        let url_ = this.baseUrl + "/api/v{version}/Chatbot/GetMessage";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(chatbotGetMessageModel);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMessage(_response);
        });
    }

    protected processGetMessage(response: Response): Promise<ChatbotAnswer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatbotAnswer.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChatbotAnswer>(null as any);
    }

    isConfigured(workspaceId: number | undefined, version: string, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v{version}/Chatbot/IsConfigured?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (workspaceId === null)
            throw new Error("The parameter 'workspaceId' cannot be null.");
        else if (workspaceId !== undefined)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsConfigured(_response);
        });
    }

    protected processIsConfigured(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class DocumentClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getPageUrlAndOcrFull(externalId: string | null | undefined, taskId: number | undefined, workspaceId: number | undefined, pageNumber: number | undefined, fromHistory: boolean | null | undefined, version: string, signal?: AbortSignal): Promise<ResultWithCodeOfSdTaskPageAndOcrFullViewModelAndBlobError> {
        let url_ = this.baseUrl + "/api/v{version}/Document/PageAndOCR?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (externalId !== undefined && externalId !== null)
            url_ += "ExternalId=" + encodeURIComponent("" + externalId) + "&";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (workspaceId === null)
            throw new Error("The parameter 'workspaceId' cannot be null.");
        else if (workspaceId !== undefined)
            url_ += "WorkspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (fromHistory !== undefined && fromHistory !== null)
            url_ += "FromHistory=" + encodeURIComponent("" + fromHistory) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPageUrlAndOcrFull(_response);
        });
    }

    protected processGetPageUrlAndOcrFull(response: Response): Promise<ResultWithCodeOfSdTaskPageAndOcrFullViewModelAndBlobError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithCodeOfSdTaskPageAndOcrFullViewModelAndBlobError.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithCodeOfSdTaskPageAndOcrFullViewModelAndBlobError>(null as any);
    }

    getPageDocument(externalId: string | null | undefined, taskId: number | undefined, workspaceId: number | undefined, pageNumber: number | undefined, fromHistory: boolean | null | undefined, version: string, signal?: AbortSignal): Promise<ResultWithCodeOfDocumentModelAndBlobError> {
        let url_ = this.baseUrl + "/api/v{version}/Document/PageDocument?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (externalId !== undefined && externalId !== null)
            url_ += "ExternalId=" + encodeURIComponent("" + externalId) + "&";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (workspaceId === null)
            throw new Error("The parameter 'workspaceId' cannot be null.");
        else if (workspaceId !== undefined)
            url_ += "WorkspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (fromHistory !== undefined && fromHistory !== null)
            url_ += "FromHistory=" + encodeURIComponent("" + fromHistory) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPageDocument(_response);
        });
    }

    protected processGetPageDocument(response: Response): Promise<ResultWithCodeOfDocumentModelAndBlobError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithCodeOfDocumentModelAndBlobError.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithCodeOfDocumentModelAndBlobError>(null as any);
    }

    saveDocumentChanges(version: string, model: DocumentSaveModel, signal?: AbortSignal): Promise<ResultWithCodeOfSdTaskSavedPagesViewModelAndSdTaskError> {
        let url_ = this.baseUrl + "/api/v{version}/Document/SaveDocumentChanges";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveDocumentChanges(_response);
        });
    }

    protected processSaveDocumentChanges(response: Response): Promise<ResultWithCodeOfSdTaskSavedPagesViewModelAndSdTaskError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithCodeOfSdTaskSavedPagesViewModelAndSdTaskError.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithCodeOfSdTaskSavedPagesViewModelAndSdTaskError>(null as any);
    }
}

export class FieldRuleClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getFieldRuleConfig(workspaceId: number, version: string, signal?: AbortSignal): Promise<FieldRuleTypeConfigModel[]> {
        let url_ = this.baseUrl + "/api/v{version}/FieldRule/FieldRuleConfig/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFieldRuleConfig(_response);
        });
    }

    protected processGetFieldRuleConfig(response: Response): Promise<FieldRuleTypeConfigModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FieldRuleTypeConfigModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FieldRuleTypeConfigModel[]>(null as any);
    }

    patchFieldRuleConfig(workspaceId: number, version: string, model: FieldRuleTypeConfigModel[], signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/FieldRule/FieldRuleConfig/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchFieldRuleConfig(_response);
        });
    }

    protected processPatchFieldRuleConfig(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class GenericStorageClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getItems(serviceName: string, directoryPath: string | null | undefined, connectorType: LoadBalancedServiceType | null | undefined, version: string, signal?: AbortSignal): Promise<ResultWithCodeOfListOfStorageItemListEntryModelAndStorageIntegrationError> {
        let url_ = this.baseUrl + "/api/v{version}/GenericStorage/Items/{serviceName}?";
        if (serviceName === undefined || serviceName === null)
            throw new Error("The parameter 'serviceName' must be defined.");
        url_ = url_.replace("{serviceName}", encodeURIComponent("" + serviceName));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (directoryPath !== undefined && directoryPath !== null)
            url_ += "directoryPath=" + encodeURIComponent("" + directoryPath) + "&";
        if (connectorType !== undefined && connectorType !== null)
            url_ += "connectorType=" + encodeURIComponent("" + connectorType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetItems(_response);
        });
    }

    protected processGetItems(response: Response): Promise<ResultWithCodeOfListOfStorageItemListEntryModelAndStorageIntegrationError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithCodeOfListOfStorageItemListEntryModelAndStorageIntegrationError.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithCodeOfListOfStorageItemListEntryModelAndStorageIntegrationError>(null as any);
    }
}

export class IndexClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getIndexLogs(taskId: number, version: string, signal?: AbortSignal): Promise<IndexLogViewModel[]> {
        let url_ = this.baseUrl + "/api/v{version}/Index/logs/{taskId}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetIndexLogs(_response);
        });
    }

    protected processGetIndexLogs(response: Response): Promise<IndexLogViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IndexLogViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IndexLogViewModel[]>(null as any);
    }

    search(search: string | undefined, workspaceId: number | undefined, batchId: number | null | undefined, taskSource: TaskSource | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, version: string, signal?: AbortSignal): Promise<PaginatedListOfSdTaskViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/Index/Search?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (workspaceId === null)
            throw new Error("The parameter 'workspaceId' cannot be null.");
        else if (workspaceId !== undefined)
            url_ += "WorkspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        if (batchId !== undefined && batchId !== null)
            url_ += "BatchId=" + encodeURIComponent("" + batchId) + "&";
        if (taskSource !== undefined && taskSource !== null)
            url_ += "TaskSource=" + encodeURIComponent("" + taskSource) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<PaginatedListOfSdTaskViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfSdTaskViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfSdTaskViewModel>(null as any);
    }

    isSummarizableByTenant(version: string, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v{version}/Index/IsSummarizable";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsSummarizableByTenant(_response);
        });
    }

    protected processIsSummarizableByTenant(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    createOrUpdateVideoTextualSummary(version: string, model: CreateOrUpdateVideoTextualSummaryViewModel, signal?: AbortSignal): Promise<ResultWithCodeOfVideoTextualSummaryViewModelAndSdTaskError> {
        let url_ = this.baseUrl + "/api/v{version}/Index/CreateOrUpdateVideoTextualSummary";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateOrUpdateVideoTextualSummary(_response);
        });
    }

    protected processCreateOrUpdateVideoTextualSummary(response: Response): Promise<ResultWithCodeOfVideoTextualSummaryViewModelAndSdTaskError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithCodeOfVideoTextualSummaryViewModelAndSdTaskError.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithCodeOfVideoTextualSummaryViewModelAndSdTaskError>(null as any);
    }

    getVideoTextualSummary(taskId: number, version: string, signal?: AbortSignal): Promise<VideoTextualSummaryViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/Index/GetVideoTextualSummary/{taskId}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVideoTextualSummary(_response);
        });
    }

    protected processGetVideoTextualSummary(response: Response): Promise<VideoTextualSummaryViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VideoTextualSummaryViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VideoTextualSummaryViewModel>(null as any);
    }

    getSummaryCostsInfo(taskId: number, version: string, signal?: AbortSignal): Promise<SummaryCostsInfoViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/Index/GetSummaryCostsInfo/{taskId}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSummaryCostsInfo(_response);
        });
    }

    protected processGetSummaryCostsInfo(response: Response): Promise<SummaryCostsInfoViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SummaryCostsInfoViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SummaryCostsInfoViewModel>(null as any);
    }
}

export class LicenseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    get(version: string, signal?: AbortSignal): Promise<LicenseViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/License/Get";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<LicenseViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenseViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseViewModel>(null as any);
    }

    getLicenseVolumeHistory(continuationToken: string | null | undefined, version: string, filters: PaginatedRequestQueryFilter[], signal?: AbortSignal): Promise<PaginatedTableListOfLicenseVolumeHistory> {
        let url_ = this.baseUrl + "/api/v{version}/License/GetLicenseVolumeHistory?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (continuationToken !== undefined && continuationToken !== null)
            url_ += "continuationToken=" + encodeURIComponent("" + continuationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLicenseVolumeHistory(_response);
        });
    }

    protected processGetLicenseVolumeHistory(response: Response): Promise<PaginatedTableListOfLicenseVolumeHistory> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedTableListOfLicenseVolumeHistory.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedTableListOfLicenseVolumeHistory>(null as any);
    }

    getLicenseHistory(token: string | null | undefined, version: string, signal?: AbortSignal): Promise<PaginatedTableListOfLicenseHistory> {
        let url_ = this.baseUrl + "/api/v{version}/License/GetLicenseHistory?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLicenseHistory(_response);
        });
    }

    protected processGetLicenseHistory(response: Response): Promise<PaginatedTableListOfLicenseHistory> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedTableListOfLicenseHistory.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedTableListOfLicenseHistory>(null as any);
    }

    activate(version: string, request: LicenseActivateModel, signal?: AbortSignal): Promise<ResultWithCodeOfBooleanAndLicenseError> {
        let url_ = this.baseUrl + "/api/v{version}/License/Activate";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivate(_response);
        });
    }

    protected processActivate(response: Response): Promise<ResultWithCodeOfBooleanAndLicenseError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithCodeOfBooleanAndLicenseError.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithCodeOfBooleanAndLicenseError>(null as any);
    }

    syncLicense(version: string, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v{version}/License/SyncLicense";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSyncLicense(_response);
        });
    }

    protected processSyncLicense(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    validatePayment(paymentsucceeded: boolean | undefined, version: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/License/ValidatePayment?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (paymentsucceeded === null)
            throw new Error("The parameter 'paymentsucceeded' cannot be null.");
        else if (paymentsucceeded !== undefined)
            url_ += "paymentsucceeded=" + encodeURIComponent("" + paymentsucceeded) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValidatePayment(_response);
        });
    }

    protected processValidatePayment(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class NotificationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getNotificationConfig(workspaceId: number, version: string, signal?: AbortSignal): Promise<NotificationConfigFullViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/Notification/NotificationConfig/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNotificationConfig(_response);
        });
    }

    protected processGetNotificationConfig(response: Response): Promise<NotificationConfigFullViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationConfigFullViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationConfigFullViewModel>(null as any);
    }

    patchNotificationConfig(workspaceId: number, version: string, model: NotificationConfigFullViewModel, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/Notification/NotificationConfig/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchNotificationConfig(_response);
        });
    }

    protected processPatchNotificationConfig(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PaymentClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    createStripeOrder(version: string, cartModel: CartProductCreateModel[], signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/v{version}/Payment/CreateStripeOrder";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cartModel);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateStripeOrder(_response);
        });
    }

    protected processCreateStripeOrder(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    cancelStripeSubscriptionPayment(licenseKey: string | null | undefined, version: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/Payment/CancelStripeSubscriptionPayment?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (licenseKey !== undefined && licenseKey !== null)
            url_ += "licenseKey=" + encodeURIComponent("" + licenseKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCancelStripeSubscriptionPayment(_response);
        });
    }

    protected processCancelStripeSubscriptionPayment(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PipelineClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getCustomConfig(workspaceId: number, version: string, signal?: AbortSignal): Promise<PipelineModel> {
        let url_ = this.baseUrl + "/api/v{version}/Pipeline/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomConfig(_response);
        });
    }

    protected processGetCustomConfig(response: Response): Promise<PipelineModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PipelineModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PipelineModel>(null as any);
    }
}

export class SdBatchClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    createBatch(version: string, model: CreateSdBatchModel, signal?: AbortSignal): Promise<SdBatchViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/SdBatch";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateBatch(_response);
        });
    }

    protected processCreateBatch(response: Response): Promise<SdBatchViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdBatchViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdBatchViewModel>(null as any);
    }

    deleteBatch(id: number, version: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/SdBatch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteBatch(_response);
        });
    }

    protected processDeleteBatch(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getWithPaginationByWorkspace(workspaceId: number, version: string, request: PaginatedRequestQuery, signal?: AbortSignal): Promise<PaginatedListOfSdBatchViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/SdBatch/GetWithPagination/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWithPaginationByWorkspace(_response);
        });
    }

    protected processGetWithPaginationByWorkspace(response: Response): Promise<PaginatedListOfSdBatchViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfSdBatchViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfSdBatchViewModel>(null as any);
    }

    deleteMany(version: string, request: MultipleBatchSelectionModel, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/SdBatch/DeleteMany";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteMany(_response);
        });
    }

    protected processDeleteMany(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class SdTaskClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    get(id: number, version: string, signal?: AbortSignal): Promise<SdTaskViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<SdTaskViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdTaskViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdTaskViewModel>(null as any);
    }

    getResultUrl(id: number, version: string, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/ResultUrl/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetResultUrl(_response);
        });
    }

    protected processGetResultUrl(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getTotalToReviewByWorkSpaceId(version: string, workspaceIds: number[], signal?: AbortSignal): Promise<TotalTasksToReviewModel[]> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/GetTotalToReviewByWorkSpaceId";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workspaceIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTotalToReviewByWorkSpaceId(_response);
        });
    }

    protected processGetTotalToReviewByWorkSpaceId(response: Response): Promise<TotalTasksToReviewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TotalTasksToReviewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TotalTasksToReviewModel[]>(null as any);
    }

    getTotalToReviewWithDetectionsByWorkSpaceId(version: string, workspaceIds: number[], signal?: AbortSignal): Promise<TotalTasksToReviewModel[]> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/GetTotalToReviewWithDetectionsByWorkSpaceId";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workspaceIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTotalToReviewWithDetectionsByWorkSpaceId(_response);
        });
    }

    protected processGetTotalToReviewWithDetectionsByWorkSpaceId(response: Response): Promise<TotalTasksToReviewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TotalTasksToReviewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TotalTasksToReviewModel[]>(null as any);
    }

    getWithPaginationByWorkspace(inBatchesOnly: boolean | undefined, workspaceId: number, version: string, request: PaginatedRequestQuery, signal?: AbortSignal): Promise<PaginatedListOfSdTaskViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/GetWithPagination/{workspaceId}?";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (inBatchesOnly === null)
            throw new Error("The parameter 'inBatchesOnly' cannot be null.");
        else if (inBatchesOnly !== undefined)
            url_ += "inBatchesOnly=" + encodeURIComponent("" + inBatchesOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWithPaginationByWorkspace(_response);
        });
    }

    protected processGetWithPaginationByWorkspace(response: Response): Promise<PaginatedListOfSdTaskViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfSdTaskViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfSdTaskViewModel>(null as any);
    }

    getMyAssignmentsWithPaginationByWorkspace(inBatchesOnly: boolean | undefined, workspaceId: number, version: string, request: PaginatedRequestQuery, signal?: AbortSignal): Promise<PaginatedListOfSdTaskViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/GetMyAssignmentsWithPagination/{workspaceId}?";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (inBatchesOnly === null)
            throw new Error("The parameter 'inBatchesOnly' cannot be null.");
        else if (inBatchesOnly !== undefined)
            url_ += "inBatchesOnly=" + encodeURIComponent("" + inBatchesOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyAssignmentsWithPaginationByWorkspace(_response);
        });
    }

    protected processGetMyAssignmentsWithPaginationByWorkspace(response: Response): Promise<PaginatedListOfSdTaskViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfSdTaskViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfSdTaskViewModel>(null as any);
    }

    getReadyToReview(version: string, signal?: AbortSignal): Promise<SdTaskViewModel[]> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/GetReadyToReview";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetReadyToReview(_response);
        });
    }

    protected processGetReadyToReview(response: Response): Promise<SdTaskViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SdTaskViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdTaskViewModel[]>(null as any);
    }

    getTaskIntegrationDetails(taskId: number, version: string, signal?: AbortSignal): Promise<SdTaskIntegrationDetailsModel> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/GetTaskIntegrationDetailsAsync/{taskId}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTaskIntegrationDetails(_response);
        });
    }

    protected processGetTaskIntegrationDetails(response: Response): Promise<SdTaskIntegrationDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdTaskIntegrationDetailsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdTaskIntegrationDetailsModel>(null as any);
    }

    getAllHistoryByWorkspaceWithPagination(workspaceId: number, version: string, requestQuery: PaginatedRequestQuery, signal?: AbortSignal): Promise<PaginatedListOfSdTaskViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/history/GetAllHistoryByWorkspaceAsync/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllHistoryByWorkspaceWithPagination(_response);
        });
    }

    protected processGetAllHistoryByWorkspaceWithPagination(response: Response): Promise<PaginatedListOfSdTaskViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfSdTaskViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfSdTaskViewModel>(null as any);
    }

    getAllArchivedByWorkspaceWithPagination(workspaceId: number, continuationToken: string | null | undefined, version: string, requestQuery: PaginatedRequest, signal?: AbortSignal): Promise<PaginatedTableListOfSdArchivedTask> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/archive/GetAllArchiveByWorkspaceAsync/{workspaceId}?";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (continuationToken !== undefined && continuationToken !== null)
            url_ += "continuationToken=" + encodeURIComponent("" + continuationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllArchivedByWorkspaceWithPagination(_response);
        });
    }

    protected processGetAllArchivedByWorkspaceWithPagination(response: Response): Promise<PaginatedTableListOfSdArchivedTask> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedTableListOfSdArchivedTask.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedTableListOfSdArchivedTask>(null as any);
    }

    getByWorkspaceAndBatchWithPagination(workspaceId: number, batchId: number, continuationToken: string | null | undefined, version: string, requestQuery: PaginatedRequest, signal?: AbortSignal): Promise<PaginatedTableListOfSdArchivedTask> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/archive/GetAllByWorkspaceAndBatchWithPaginationAsync/{workspaceId}/{batchId}?";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (batchId === undefined || batchId === null)
            throw new Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (continuationToken !== undefined && continuationToken !== null)
            url_ += "continuationToken=" + encodeURIComponent("" + continuationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetByWorkspaceAndBatchWithPagination(_response);
        });
    }

    protected processGetByWorkspaceAndBatchWithPagination(response: Response): Promise<PaginatedTableListOfSdArchivedTask> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedTableListOfSdArchivedTask.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedTableListOfSdArchivedTask>(null as any);
    }

    getNextTaskId(workspaceId: number, batchId: number | null | undefined, version: string, signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/GetNextTask/{workspaceId}?";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (batchId !== undefined && batchId !== null)
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNextTaskId(_response);
        });
    }

    protected processGetNextTaskId(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    restartProcessing(externalId: string | null | undefined, taskId: number | null | undefined, version: string, signal?: AbortSignal): Promise<ResultWithCodeOfSdTaskReprocessTaskViewModelAndSdTaskError> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/RestartProcessing?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (externalId !== undefined && externalId !== null)
            url_ += "ExternalId=" + encodeURIComponent("" + externalId) + "&";
        if (taskId !== undefined && taskId !== null)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRestartProcessing(_response);
        });
    }

    protected processRestartProcessing(response: Response): Promise<ResultWithCodeOfSdTaskReprocessTaskViewModelAndSdTaskError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithCodeOfSdTaskReprocessTaskViewModelAndSdTaskError.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithCodeOfSdTaskReprocessTaskViewModelAndSdTaskError>(null as any);
    }

    restartProcessingMany(version: string, request: MultipleTaskSelectionModel, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/RestartProcessingMany";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRestartProcessingMany(_response);
        });
    }

    protected processRestartProcessingMany(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteMany(version: string, request: MultipleTaskSelectionModel, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/DeleteMany";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteMany(_response);
        });
    }

    protected processDeleteMany(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteTaskFromHistory(taskId: number | undefined, version: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/history/DeleteTaskFromHistoryAsync?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteTaskFromHistory(_response);
        });
    }

    protected processDeleteTaskFromHistory(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteWorkSpaceAndTasks(workSpaceId: number | undefined, version: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/history/DeleteWorkSpaceAndTasksAsync?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (workSpaceId === null)
            throw new Error("The parameter 'workSpaceId' cannot be null.");
        else if (workSpaceId !== undefined)
            url_ += "workSpaceId=" + encodeURIComponent("" + workSpaceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteWorkSpaceAndTasks(_response);
        });
    }

    protected processDeleteWorkSpaceAndTasks(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    importTask(version: string, createModel: SdTaskProcessCreateModel, signal?: AbortSignal): Promise<SdTaskProcessCreateViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/Import";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createModel);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImportTask(_response);
        });
    }

    protected processImportTask(response: Response): Promise<SdTaskProcessCreateViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdTaskProcessCreateViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ReturnWithCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdTaskProcessCreateViewModel>(null as any);
    }

    countTotalTasks(workspaceIds: number[] | null | undefined, version: string, signal?: AbortSignal): Promise<SdTaskCountViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/CountTotal?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (workspaceIds !== undefined && workspaceIds !== null)
            workspaceIds && workspaceIds.forEach(item => { url_ += "workspaceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCountTotalTasks(_response);
        });
    }

    protected processCountTotalTasks(response: Response): Promise<SdTaskCountViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdTaskCountViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdTaskCountViewModel>(null as any);
    }

    countReviewedDocuments(workspaceIds: number[] | null | undefined, version: string, signal?: AbortSignal): Promise<SdTaskCountReviewedDocumentsViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/CountReviewedDocuments?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (workspaceIds !== undefined && workspaceIds !== null)
            workspaceIds && workspaceIds.forEach(item => { url_ += "workspaceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCountReviewedDocuments(_response);
        });
    }

    protected processCountReviewedDocuments(response: Response): Promise<SdTaskCountReviewedDocumentsViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdTaskCountReviewedDocumentsViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdTaskCountReviewedDocumentsViewModel>(null as any);
    }

    countTimestampByStatus(workspaceIds: number[] | null | undefined, version: string, signal?: AbortSignal): Promise<SdTaskTimestampByStatusViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/CountTimestampByStatus?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (workspaceIds !== undefined && workspaceIds !== null)
            workspaceIds && workspaceIds.forEach(item => { url_ += "workspaceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCountTimestampByStatus(_response);
        });
    }

    protected processCountTimestampByStatus(response: Response): Promise<SdTaskTimestampByStatusViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdTaskTimestampByStatusViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdTaskTimestampByStatusViewModel>(null as any);
    }

    countTasksForCurrentUser(workspaceIds: number[] | null | undefined, version: string, signal?: AbortSignal): Promise<SdTaskCountViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/CountTotalUser?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (workspaceIds !== undefined && workspaceIds !== null)
            workspaceIds && workspaceIds.forEach(item => { url_ += "workspaceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCountTasksForCurrentUser(_response);
        });
    }

    protected processCountTasksForCurrentUser(response: Response): Promise<SdTaskCountViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdTaskCountViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdTaskCountViewModel>(null as any);
    }

    getTracesDashboardUrlForTask(taskId: number, version: string, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/TracesDashboardUrl/{taskId}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTracesDashboardUrlForTask(_response);
        });
    }

    protected processGetTracesDashboardUrlForTask(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    delete(id: number, version: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/DeleteTask/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exportPOST(version: string, model: MultipleExportDataModel, signal?: AbortSignal): Promise<ResultWithCodeOfExportDataViewModelAndSdTaskError> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/Export";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportPOST(_response);
        });
    }

    protected processExportPOST(response: Response): Promise<ResultWithCodeOfExportDataViewModelAndSdTaskError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithCodeOfExportDataViewModelAndSdTaskError.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithCodeOfExportDataViewModelAndSdTaskError>(null as any);
    }

    bulkExport(version: string, model: MultipleExportDataModel, signal?: AbortSignal): Promise<ResultWithCodeOfExportDataViewModelAndSdTaskError> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/BulkExport";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBulkExport(_response);
        });
    }

    protected processBulkExport(response: Response): Promise<ResultWithCodeOfExportDataViewModelAndSdTaskError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithCodeOfExportDataViewModelAndSdTaskError.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithCodeOfExportDataViewModelAndSdTaskError>(null as any);
    }

    getProcessedTasksCountInHistory(version: string, query: ProcessedTasksCountQuery, signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/ProcessedTasksCountInHistory";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProcessedTasksCountInHistory(_response);
        });
    }

    protected processGetProcessedTasksCountInHistory(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getTaskEventsByTaskId(taskId: number, eventType: string | null | undefined, version: string, signal?: AbortSignal): Promise<RenderFarmEventAllInfoViewModel[]> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/Events/{taskId}?";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (eventType !== undefined && eventType !== null)
            url_ += "eventType=" + encodeURIComponent("" + eventType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTaskEventsByTaskId(_response);
        });
    }

    protected processGetTaskEventsByTaskId(response: Response): Promise<RenderFarmEventAllInfoViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RenderFarmEventAllInfoViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RenderFarmEventAllInfoViewModel[]>(null as any);
    }

    updateTaskName(taskId: number, version: string, newTaskName: string, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/UpdateDisplayName/{taskId}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newTaskName);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTaskName(_response);
        });
    }

    protected processUpdateTaskName(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    shareTask(version: string, model: ShareTaskWithUsersModel, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/Share";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processShareTask(_response);
        });
    }

    protected processShareTask(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getFolderMonitorUrl(version: string, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/GetFolderMonitorUrl";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFolderMonitorUrl(_response);
        });
    }

    protected processGetFolderMonitorUrl(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    recoverTask(taskId: number | undefined, version: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/Recover?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRecoverTask(_response);
        });
    }

    protected processRecoverTask(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateTaskAssignment(taskId: number | undefined, orderType: number | undefined, removeAssignment: boolean | undefined, version: string, users: GenericUserTaskSharingViewModel[], signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/UpdateTaskAssignment?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        if (orderType === null)
            throw new Error("The parameter 'orderType' cannot be null.");
        else if (orderType !== undefined)
            url_ += "orderType=" + encodeURIComponent("" + orderType) + "&";
        if (removeAssignment === null)
            throw new Error("The parameter 'removeAssignment' cannot be null.");
        else if (removeAssignment !== undefined)
            url_ += "removeAssignment=" + encodeURIComponent("" + removeAssignment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(users);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTaskAssignment(_response);
        });
    }

    protected processUpdateTaskAssignment(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getTaskMetaFields(taskId: number | undefined, version: string, signal?: AbortSignal): Promise<SdMetaField[]> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/GetTaskMetaFields?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTaskMetaFields(_response);
        });
    }

    protected processGetTaskMetaFields(response: Response): Promise<SdMetaField[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SdMetaField.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdMetaField[]>(null as any);
    }

    exportGET(taskId: number, type: ExportType, version: string, signal?: AbortSignal): Promise<ResultWithCodeOfExportDataViewModelAndSdTaskError> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/Export/{taskId}/{type}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportGET(_response);
        });
    }

    protected processExportGET(response: Response): Promise<ResultWithCodeOfExportDataViewModelAndSdTaskError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithCodeOfExportDataViewModelAndSdTaskError.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithCodeOfExportDataViewModelAndSdTaskError>(null as any);
    }

    getExportResult(requestId: string | undefined, expiresOnHours: number | undefined, version: string, signal?: AbortSignal): Promise<SdTaskExportResultModel> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/GetExportResult?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        if (expiresOnHours === null)
            throw new Error("The parameter 'expiresOnHours' cannot be null.");
        else if (expiresOnHours !== undefined)
            url_ += "expiresOnHours=" + encodeURIComponent("" + expiresOnHours) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExportResult(_response);
        });
    }

    protected processGetExportResult(response: Response): Promise<SdTaskExportResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdTaskExportResultModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdTaskExportResultModel>(null as any);
    }

    handleRenderFarmTaskEvents(version: string, evt: RenderFarmEventContext, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/RenderFarmEvents";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(evt);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHandleRenderFarmTaskEvents(_response);
        });
    }

    protected processHandleRenderFarmTaskEvents(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    handleRenderFarmSplitTaskEvents(version: string, evt: RenderFarmEventContext, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/RenderFarmSplitTasksEvents";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(evt);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHandleRenderFarmSplitTaskEvents(_response);
        });
    }

    protected processHandleRenderFarmSplitTaskEvents(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    handleRenderFarmSdTaskExportEvents(version: string, evt: RenderFarmEventContext, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/SdTaskExportEvents";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(evt);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHandleRenderFarmSdTaskExportEvents(_response);
        });
    }

    protected processHandleRenderFarmSdTaskExportEvents(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    processTask(version: string, createModel: SdTaskProcessCreateModel, signal?: AbortSignal): Promise<SdTaskProcessCreateViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/Process";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createModel);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProcessTask(_response);
        });
    }

    protected processProcessTask(response: Response): Promise<SdTaskProcessCreateViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdTaskProcessCreateViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ReturnWithCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdTaskProcessCreateViewModel>(null as any);
    }

    getStatus(externalId: string | null | undefined, taskId: number | null | undefined, version: string, signal?: AbortSignal): Promise<SdTaskIntegrationStatusViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/Status?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (externalId !== undefined && externalId !== null)
            url_ += "ExternalId=" + encodeURIComponent("" + externalId) + "&";
        if (taskId !== undefined && taskId !== null)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStatus(_response);
        });
    }

    protected processGetStatus(response: Response): Promise<SdTaskIntegrationStatusViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdTaskIntegrationStatusViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdTaskIntegrationStatusViewModel>(null as any);
    }

    getStatusListAll(startDate: Date | null | undefined, endDate: Date | null | undefined, taskStatus: SdTaskStatus[] | null | undefined, integrationStatus: SdTaskIntegrationStatus[] | null | undefined, workspaceId: number[] | null | undefined, batchId: number[] | null | undefined, externalIntegrationStatus: string | null | undefined, version: string, signal?: AbortSignal): Promise<SdTaskIntegrationStatusViewModel[]> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/StatusList?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (taskStatus !== undefined && taskStatus !== null)
            taskStatus && taskStatus.forEach(item => { url_ += "TaskStatus=" + encodeURIComponent("" + item) + "&"; });
        if (integrationStatus !== undefined && integrationStatus !== null)
            integrationStatus && integrationStatus.forEach(item => { url_ += "IntegrationStatus=" + encodeURIComponent("" + item) + "&"; });
        if (workspaceId !== undefined && workspaceId !== null)
            workspaceId && workspaceId.forEach(item => { url_ += "WorkspaceId=" + encodeURIComponent("" + item) + "&"; });
        if (batchId !== undefined && batchId !== null)
            batchId && batchId.forEach(item => { url_ += "BatchId=" + encodeURIComponent("" + item) + "&"; });
        if (externalIntegrationStatus !== undefined && externalIntegrationStatus !== null)
            url_ += "ExternalIntegrationStatus=" + encodeURIComponent("" + externalIntegrationStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStatusListAll(_response);
        });
    }

    protected processGetStatusListAll(response: Response): Promise<SdTaskIntegrationStatusViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SdTaskIntegrationStatusViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdTaskIntegrationStatusViewModel[]>(null as any);
    }

    getStatusList(pageNumber: number | undefined, pageSize: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, taskStatus: SdTaskStatus[] | null | undefined, integrationStatus: SdTaskIntegrationStatus[] | null | undefined, workspaceId: number[] | null | undefined, batchId: number[] | null | undefined, externalIntegrationStatus: string | null | undefined, version: string, signal?: AbortSignal): Promise<PaginatedListOfSdTaskIntegrationStatusViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/SdTask/StatusListPaginated?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (taskStatus !== undefined && taskStatus !== null)
            taskStatus && taskStatus.forEach(item => { url_ += "TaskStatus=" + encodeURIComponent("" + item) + "&"; });
        if (integrationStatus !== undefined && integrationStatus !== null)
            integrationStatus && integrationStatus.forEach(item => { url_ += "IntegrationStatus=" + encodeURIComponent("" + item) + "&"; });
        if (workspaceId !== undefined && workspaceId !== null)
            workspaceId && workspaceId.forEach(item => { url_ += "WorkspaceId=" + encodeURIComponent("" + item) + "&"; });
        if (batchId !== undefined && batchId !== null)
            batchId && batchId.forEach(item => { url_ += "BatchId=" + encodeURIComponent("" + item) + "&"; });
        if (externalIntegrationStatus !== undefined && externalIntegrationStatus !== null)
            url_ += "ExternalIntegrationStatus=" + encodeURIComponent("" + externalIntegrationStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStatusList(_response);
        });
    }

    protected processGetStatusList(response: Response): Promise<PaginatedListOfSdTaskIntegrationStatusViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfSdTaskIntegrationStatusViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfSdTaskIntegrationStatusViewModel>(null as any);
    }
}

export class SdTaskShareClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getShareTaskUrl(taskId: number | undefined, version: string, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/v{version}/SdTaskShare/GetShareTaskUrl?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetShareTaskUrl(_response);
        });
    }

    protected processGetShareTaskUrl(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    shareMediaSegment(version: string, config: ShareInputConfig, signal?: AbortSignal): Promise<ShareMediaSegmentUrlResult> {
        let url_ = this.baseUrl + "/api/v{version}/SdTaskShare/ShareMediaSegment";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(config);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processShareMediaSegment(_response);
        });
    }

    protected processShareMediaSegment(response: Response): Promise<ShareMediaSegmentUrlResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShareMediaSegmentUrlResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShareMediaSegmentUrlResult>(null as any);
    }

    getTaskShareHistoryDetails(taskId: number, version: string, signal?: AbortSignal): Promise<TaskShareHistoryDetailsModel> {
        let url_ = this.baseUrl + "/api/v{version}/SdTaskShare/GetTaskShareHistoryDetails/{taskId}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTaskShareHistoryDetails(_response);
        });
    }

    protected processGetTaskShareHistoryDetails(response: Response): Promise<TaskShareHistoryDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskShareHistoryDetailsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskShareHistoryDetailsModel>(null as any);
    }

    handleRenderFarmTaskShareMediaSegmentEvents(version: string, evt: RenderFarmEventContext, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/SdTaskShare/RenderFarmTaskShareMediaSegmentEvents";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(evt);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHandleRenderFarmTaskShareMediaSegmentEvents(_response);
        });
    }

    protected processHandleRenderFarmTaskShareMediaSegmentEvents(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class SdWorkspaceClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getCurrentUserWorkspaces(workspaceType: WorkspaceType | undefined, version: string, signal?: AbortSignal): Promise<WorkspaceUserGetViewModel[]> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/UserWorkspaces?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (workspaceType === null)
            throw new Error("The parameter 'workspaceType' cannot be null.");
        else if (workspaceType !== undefined)
            url_ += "workspaceType=" + encodeURIComponent("" + workspaceType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCurrentUserWorkspaces(_response);
        });
    }

    protected processGetCurrentUserWorkspaces(response: Response): Promise<WorkspaceUserGetViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkspaceUserGetViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkspaceUserGetViewModel[]>(null as any);
    }

    getAvailableTaskTypes(version: string, signal?: AbortSignal): Promise<TaskType[]> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/TaskTypes";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAvailableTaskTypes(_response);
        });
    }

    protected processGetAvailableTaskTypes(response: Response): Promise<TaskType[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskType[]>(null as any);
    }

    getAllUsersInWorkspace(workspaceId: number, version: string, signal?: AbortSignal): Promise<GenericUserViewModel[]> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/Users/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllUsersInWorkspace(_response);
        });
    }

    protected processGetAllUsersInWorkspace(response: Response): Promise<GenericUserViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GenericUserViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GenericUserViewModel[]>(null as any);
    }

    updateUserStatus(version: string, model: GenericUpdateUserStatusModel, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/UpdateUserStatus";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateUserStatus(_response);
        });
    }

    protected processUpdateUserStatus(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    checkIfUserCanBeInvited(email: string | null | undefined, workspaceId: number | null | undefined, version: string, signal?: AbortSignal): Promise<GenericInviteUserViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/CheckIfUserCanBeInvited?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (workspaceId !== undefined && workspaceId !== null)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckIfUserCanBeInvited(_response);
        });
    }

    protected processCheckIfUserCanBeInvited(response: Response): Promise<GenericInviteUserViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericInviteUserViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GenericInviteUserViewModel>(null as any);
    }

    getWorkspaceCustomConfig(workspaceId: number | undefined, version: string, signal?: AbortSignal): Promise<SdWorkspaceCustomConfigModel> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/GetWorkspaceCustomConfig?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (workspaceId === null)
            throw new Error("The parameter 'workspaceId' cannot be null.");
        else if (workspaceId !== undefined)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkspaceCustomConfig(_response);
        });
    }

    protected processGetWorkspaceCustomConfig(response: Response): Promise<SdWorkspaceCustomConfigModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdWorkspaceCustomConfigModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdWorkspaceCustomConfigModel>(null as any);
    }

    inviteUser(version: string, model: GenericInviteUserModel, signal?: AbortSignal): Promise<GenericUserViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/InviteUser";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInviteUser(_response);
        });
    }

    protected processInviteUser(response: Response): Promise<GenericUserViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericUserViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GenericUserViewModel>(null as any);
    }

    getAdvancedSettings(workspaceId: number, version: string, signal?: AbortSignal): Promise<SdWorkspaceAdvancedSettingsViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/AdvancedSettings/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAdvancedSettings(_response);
        });
    }

    protected processGetAdvancedSettings(response: Response): Promise<SdWorkspaceAdvancedSettingsViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdWorkspaceAdvancedSettingsViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdWorkspaceAdvancedSettingsViewModel>(null as any);
    }

    patchWorkspaceAdvancedSettings(workspaceId: number, version: string, advancedSettingsModel: SdWorkspaceAdvancedSettingsModel, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/AdvancedSettings/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(advancedSettingsModel);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchWorkspaceAdvancedSettings(_response);
        });
    }

    protected processPatchWorkspaceAdvancedSettings(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = NifConflictResponse.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getWorkspaceFields(workspaceId: number, version: string, signal?: AbortSignal): Promise<SdWorkspaceFieldsViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/Fields/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkspaceFields(_response);
        });
    }

    protected processGetWorkspaceFields(response: Response): Promise<SdWorkspaceFieldsViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdWorkspaceFieldsViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdWorkspaceFieldsViewModel>(null as any);
    }

    patchWorkspaceFields(workspaceId: number, version: string, fieldsModel: SdWorkspaceFieldsModel, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/Fields/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fieldsModel);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchWorkspaceFields(_response);
        });
    }

    protected processPatchWorkspaceFields(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getWorkspaceFieldsPresets(version: string, signal?: AbortSignal): Promise<SdWorkspaceFieldsPresetsViewModel[]> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/FieldsPresets";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkspaceFieldsPresets(_response);
        });
    }

    protected processGetWorkspaceFieldsPresets(response: Response): Promise<SdWorkspaceFieldsPresetsViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SdWorkspaceFieldsPresetsViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdWorkspaceFieldsPresetsViewModel[]>(null as any);
    }

    getSelectOptions(workspaceId: number, categoryKey: string, version: string, signal?: AbortSignal): Promise<SelectProps> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/SelectOptions/{workspaceId}/{categoryKey}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (categoryKey === undefined || categoryKey === null)
            throw new Error("The parameter 'categoryKey' must be defined.");
        url_ = url_.replace("{categoryKey}", encodeURIComponent("" + categoryKey));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSelectOptions(_response);
        });
    }

    protected processGetSelectOptions(response: Response): Promise<SelectProps> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectProps.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectProps>(null as any);
    }

    setSelectOptions(workspaceId: number, categoryKey: string, version: string, selectProps: SelectProps, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/SelectOptions/{workspaceId}/{categoryKey}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (categoryKey === undefined || categoryKey === null)
            throw new Error("The parameter 'categoryKey' must be defined.");
        url_ = url_.replace("{categoryKey}", encodeURIComponent("" + categoryKey));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(selectProps);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetSelectOptions(_response);
        });
    }

    protected processSetSelectOptions(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getWorkspacePredefinedTexts(workspaceId: number, version: string, signal?: AbortSignal): Promise<SdWorkspacePredefinedTextsViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/PredefinedText/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkspacePredefinedTexts(_response);
        });
    }

    protected processGetWorkspacePredefinedTexts(response: Response): Promise<SdWorkspacePredefinedTextsViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdWorkspacePredefinedTextsViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdWorkspacePredefinedTextsViewModel>(null as any);
    }

    patchPredefinedText(workspaceId: number, version: string, predefinedTextsModel: SdWorkspacePredefinedTextsModel, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/PredefinedText/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(predefinedTextsModel);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchPredefinedText(_response);
        });
    }

    protected processPatchPredefinedText(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    patchStorageConfig(workspaceId: number, version: string, storageConfigModel: SdWorkspaceStorageConfigModel, signal?: AbortSignal): Promise<ResultWithCodeOfBooleanAndSdWorkspaceStorageConfigError> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/Storage/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(storageConfigModel);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchStorageConfig(_response);
        });
    }

    protected processPatchStorageConfig(response: Response): Promise<ResultWithCodeOfBooleanAndSdWorkspaceStorageConfigError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithCodeOfBooleanAndSdWorkspaceStorageConfigError.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithCodeOfBooleanAndSdWorkspaceStorageConfigError>(null as any);
    }

    deleteStorageConfig(workspaceId: number, version: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/Storage/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteStorageConfig(_response);
        });
    }

    protected processDeleteStorageConfig(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    patchGenericStorageConfig(workspaceId: number, version: string, storageConfigModel: SdStorageConfigModel, signal?: AbortSignal): Promise<ResultWithCodeOfBooleanAndSdStorageConfigError> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/Storage/Generic/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(storageConfigModel);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchGenericStorageConfig(_response);
        });
    }

    protected processPatchGenericStorageConfig(response: Response): Promise<ResultWithCodeOfBooleanAndSdStorageConfigError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithCodeOfBooleanAndSdStorageConfigError.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithCodeOfBooleanAndSdStorageConfigError>(null as any);
    }

    deleteGenericStorageConfig(workspaceId: number, version: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/Storage/Generic/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteGenericStorageConfig(_response);
        });
    }

    protected processDeleteGenericStorageConfig(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getImportEmail(id: number, version: string, signal?: AbortSignal): Promise<SdWorkspaceImportEmailViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/importEmail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetImportEmail(_response);
        });
    }

    protected processGetImportEmail(response: Response): Promise<SdWorkspaceImportEmailViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdWorkspaceImportEmailViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdWorkspaceImportEmailViewModel>(null as any);
    }

    updateBasicInfo(version: string, basicInfoModel: SdWorkspaceUpdateBasicInfoModel, signal?: AbortSignal): Promise<SdWorkspaceBasicInfoViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/basic";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(basicInfoModel);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateBasicInfo(_response);
        });
    }

    protected processUpdateBasicInfo(response: Response): Promise<SdWorkspaceBasicInfoViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdWorkspaceBasicInfoViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdWorkspaceBasicInfoViewModel>(null as any);
    }

    updateName(workspaceId: number | undefined, workspaceName: string | null | undefined, version: string, signal?: AbortSignal): Promise<SdWorkspaceBasicInfoViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/name?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (workspaceId === null)
            throw new Error("The parameter 'workspaceId' cannot be null.");
        else if (workspaceId !== undefined)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        if (workspaceName !== undefined && workspaceName !== null)
            url_ += "workspaceName=" + encodeURIComponent("" + workspaceName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateName(_response);
        });
    }

    protected processUpdateName(response: Response): Promise<SdWorkspaceBasicInfoViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdWorkspaceBasicInfoViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdWorkspaceBasicInfoViewModel>(null as any);
    }

    duplicateWorkspace(workspaceId: number, version: string, request: DuplicateWorkspaceRequest, signal?: AbortSignal): Promise<ResultWithCodeOfDuplicateWorkspaceResultViewModelAndDuplicateWorkspaceError> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/{workspaceId}/duplicate";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDuplicateWorkspace(_response);
        });
    }

    protected processDuplicateWorkspace(response: Response): Promise<ResultWithCodeOfDuplicateWorkspaceResultViewModelAndDuplicateWorkspaceError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithCodeOfDuplicateWorkspaceResultViewModelAndDuplicateWorkspaceError.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithCodeOfDuplicateWorkspaceResultViewModelAndDuplicateWorkspaceError>(null as any);
    }

    getBasicInfo(id: number, version: string, signal?: AbortSignal): Promise<SdWorkspaceBasicInfoViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/basic/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBasicInfo(_response);
        });
    }

    protected processGetBasicInfo(response: Response): Promise<SdWorkspaceBasicInfoViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdWorkspaceBasicInfoViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdWorkspaceBasicInfoViewModel>(null as any);
    }

    getWorkspaceTemplates(workspaceType: WorkspaceType | undefined, version: string, signal?: AbortSignal): Promise<SdWorkspaceTemplateViewModel[]> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/templates?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (workspaceType === null)
            throw new Error("The parameter 'workspaceType' cannot be null.");
        else if (workspaceType !== undefined)
            url_ += "workspaceType=" + encodeURIComponent("" + workspaceType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkspaceTemplates(_response);
        });
    }

    protected processGetWorkspaceTemplates(response: Response): Promise<SdWorkspaceTemplateViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SdWorkspaceTemplateViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdWorkspaceTemplateViewModel[]>(null as any);
    }

    getInitialConfiguration(workspaceId: number | null | undefined, version: string, signal?: AbortSignal): Promise<SdWorkspaceUpsertModel> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/Configuration?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (workspaceId !== undefined && workspaceId !== null)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInitialConfiguration(_response);
        });
    }

    protected processGetInitialConfiguration(response: Response): Promise<SdWorkspaceUpsertModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdWorkspaceUpsertModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdWorkspaceUpsertModel>(null as any);
    }

    upsertWorkspaceWithConfiguration(version: string, model: SdWorkspaceUpsertModel, signal?: AbortSignal): Promise<SdWorkspace> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/Configuration";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpsertWorkspaceWithConfiguration(_response);
        });
    }

    protected processUpsertWorkspaceWithConfiguration(response: Response): Promise<SdWorkspace> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdWorkspace.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdWorkspace>(null as any);
    }

    getIntegrationStepsConfig(workspaceId: number, version: string, signal?: AbortSignal): Promise<IntegrationStepConfigModel[]> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/IntegrationStepConfigs/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetIntegrationStepsConfig(_response);
        });
    }

    protected processGetIntegrationStepsConfig(response: Response): Promise<IntegrationStepConfigModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntegrationStepConfigModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IntegrationStepConfigModel[]>(null as any);
    }

    getStepConfig(workspaceId: number, stepId: string, version: string, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/StepConfig/{workspaceId}/{stepId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (stepId === undefined || stepId === null)
            throw new Error("The parameter 'stepId' must be defined.");
        url_ = url_.replace("{stepId}", encodeURIComponent("" + stepId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStepConfig(_response);
        });
    }

    protected processGetStepConfig(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    setExportStepConfig(workspaceId: number, stepId: string, version: string, base64Config: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/StepConfig/{workspaceId}/{stepId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (stepId === undefined || stepId === null)
            throw new Error("The parameter 'stepId' must be defined.");
        url_ = url_.replace("{stepId}", encodeURIComponent("" + stepId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(base64Config);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetExportStepConfig(_response);
        });
    }

    protected processSetExportStepConfig(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getAvailableCustomModel(currentModelId: number | undefined, version: string, signal?: AbortSignal): Promise<SdCustomModelUpdateAvailableViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/AvailableCustomModel?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (currentModelId === null)
            throw new Error("The parameter 'currentModelId' cannot be null.");
        else if (currentModelId !== undefined)
            url_ += "currentModelId=" + encodeURIComponent("" + currentModelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAvailableCustomModel(_response);
        });
    }

    protected processGetAvailableCustomModel(response: Response): Promise<SdCustomModelUpdateAvailableViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdCustomModelUpdateAvailableViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdCustomModelUpdateAvailableViewModel>(null as any);
    }

    updateCustomModel(version: string, request: UpdateWorkspaceCustomModelRequest, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/PatchCustomModel";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCustomModel(_response);
        });
    }

    protected processUpdateCustomModel(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getStepRedirected(pipelineId: string | undefined, stepId: string | undefined, version: string, signal?: AbortSignal): Promise<StepRedirectedViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/StepRedirected?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (pipelineId === null)
            throw new Error("The parameter 'pipelineId' cannot be null.");
        else if (pipelineId !== undefined)
            url_ += "pipelineId=" + encodeURIComponent("" + pipelineId) + "&";
        if (stepId === null)
            throw new Error("The parameter 'stepId' cannot be null.");
        else if (stepId !== undefined)
            url_ += "stepId=" + encodeURIComponent("" + stepId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStepRedirected(_response);
        });
    }

    protected processGetStepRedirected(response: Response): Promise<StepRedirectedViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StepRedirectedViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StepRedirectedViewModel>(null as any);
    }

    setStepRedirected(version: string, model: SetStepRedirectedModel, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/StepRedirected";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetStepRedirected(_response);
        });
    }

    protected processSetStepRedirected(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    pipelineHasRedirects(pipelineId: string | undefined, version: string, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/PipelineHasRedirects?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (pipelineId === null)
            throw new Error("The parameter 'pipelineId' cannot be null.");
        else if (pipelineId !== undefined)
            url_ += "pipelineId=" + encodeURIComponent("" + pipelineId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPipelineHasRedirects(_response);
        });
    }

    protected processPipelineHasRedirects(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getPipelineWithStepsByWorkspaceId(workspaceId: number | undefined, version: string, signal?: AbortSignal): Promise<PipelineWithStepsViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/PipelineWithSteps?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (workspaceId === null)
            throw new Error("The parameter 'workspaceId' cannot be null.");
        else if (workspaceId !== undefined)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPipelineWithStepsByWorkspaceId(_response);
        });
    }

    protected processGetPipelineWithStepsByWorkspaceId(response: Response): Promise<PipelineWithStepsViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PipelineWithStepsViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PipelineWithStepsViewModel>(null as any);
    }

    checkIfWorkspaceCanBeDeleted(workspaceId: number | undefined, version: string, signal?: AbortSignal): Promise<ResultWithCodeOfBooleanAndSdWorkspaceError> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/CheckWorkspaceCanBeDeleted?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (workspaceId === null)
            throw new Error("The parameter 'workspaceId' cannot be null.");
        else if (workspaceId !== undefined)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckIfWorkspaceCanBeDeleted(_response);
        });
    }

    protected processCheckIfWorkspaceCanBeDeleted(response: Response): Promise<ResultWithCodeOfBooleanAndSdWorkspaceError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithCodeOfBooleanAndSdWorkspaceError.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithCodeOfBooleanAndSdWorkspaceError>(null as any);
    }

    getAvailableHooks(hookServiceType: LoadBalancedServiceType | undefined, version: string, signal?: AbortSignal): Promise<SdWorkspaceHooksModel> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/AvailableHooks?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (hookServiceType === null)
            throw new Error("The parameter 'hookServiceType' cannot be null.");
        else if (hookServiceType !== undefined)
            url_ += "hookServiceType=" + encodeURIComponent("" + hookServiceType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAvailableHooks(_response);
        });
    }

    protected processGetAvailableHooks(response: Response): Promise<SdWorkspaceHooksModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdWorkspaceHooksModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdWorkspaceHooksModel>(null as any);
    }

    patchRecognizerHooks(workspaceId: number, version: string, model: SdWorkspaceHooksModel, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/RecognizerHooks/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchRecognizerHooks(_response);
        });
    }

    protected processPatchRecognizerHooks(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getValidUsersForTaskShare(workspaceId: number | undefined, includeSelf: boolean | undefined, version: string, signal?: AbortSignal): Promise<GenericUserTaskSharingViewModel[]> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/ValidUsersForTaskShare?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (workspaceId === null)
            throw new Error("The parameter 'workspaceId' cannot be null.");
        else if (workspaceId !== undefined)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        if (includeSelf === null)
            throw new Error("The parameter 'includeSelf' cannot be null.");
        else if (includeSelf !== undefined)
            url_ += "includeSelf=" + encodeURIComponent("" + includeSelf) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetValidUsersForTaskShare(_response);
        });
    }

    protected processGetValidUsersForTaskShare(response: Response): Promise<GenericUserTaskSharingViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GenericUserTaskSharingViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GenericUserTaskSharingViewModel[]>(null as any);
    }

    getValidUsersForTaskAssignment(workspaceId: number | undefined, version: string, signal?: AbortSignal): Promise<GenericUserTaskSharingViewModel[]> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/ValidUsersForTaskAssignment?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (workspaceId === null)
            throw new Error("The parameter 'workspaceId' cannot be null.");
        else if (workspaceId !== undefined)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetValidUsersForTaskAssignment(_response);
        });
    }

    protected processGetValidUsersForTaskAssignment(response: Response): Promise<GenericUserTaskSharingViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GenericUserTaskSharingViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GenericUserTaskSharingViewModel[]>(null as any);
    }

    getCurrentTaskAssignmentUsers(workspaceId: number | undefined, userIds: number[] | null | undefined, version: string, signal?: AbortSignal): Promise<GenericUserViewModel[]> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/CurrentTaskAssignmentUsers?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (workspaceId === null)
            throw new Error("The parameter 'workspaceId' cannot be null.");
        else if (workspaceId !== undefined)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        if (userIds !== undefined && userIds !== null)
            userIds && userIds.forEach(item => { url_ += "userIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCurrentTaskAssignmentUsers(_response);
        });
    }

    protected processGetCurrentTaskAssignmentUsers(response: Response): Promise<GenericUserViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GenericUserViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GenericUserViewModel[]>(null as any);
    }

    getDefaultAssignments(workspaceId: number | undefined, version: string, signal?: AbortSignal): Promise<DefaultAssignmentsModel> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/DefaultAssignments?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (workspaceId === null)
            throw new Error("The parameter 'workspaceId' cannot be null.");
        else if (workspaceId !== undefined)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDefaultAssignments(_response);
        });
    }

    protected processGetDefaultAssignments(response: Response): Promise<DefaultAssignmentsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DefaultAssignmentsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DefaultAssignmentsModel>(null as any);
    }

    patchDefaultAssignments(workspaceId: number, isEnabled: boolean | undefined, orderType: TaskAssignmentOrderType | undefined, version: string, users: GenericInviteUserModel[], signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/SdWorkspace/DefaultAssignments/{workspaceId}?";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (isEnabled === null)
            throw new Error("The parameter 'isEnabled' cannot be null.");
        else if (isEnabled !== undefined)
            url_ += "isEnabled=" + encodeURIComponent("" + isEnabled) + "&";
        if (orderType === null)
            throw new Error("The parameter 'orderType' cannot be null.");
        else if (orderType !== undefined)
            url_ += "orderType=" + encodeURIComponent("" + orderType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(users);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchDefaultAssignments(_response);
        });
    }

    protected processPatchDefaultAssignments(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class SharePointClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getItems(serviceName: string, directoryPath: string | null | undefined, version: string, signal?: AbortSignal): Promise<ResultWithCodeOfListOfDriveItemModelAndSharePointError> {
        let url_ = this.baseUrl + "/api/v{version}/SharePoint/Items/{serviceName}?";
        if (serviceName === undefined || serviceName === null)
            throw new Error("The parameter 'serviceName' must be defined.");
        url_ = url_.replace("{serviceName}", encodeURIComponent("" + serviceName));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (directoryPath !== undefined && directoryPath !== null)
            url_ += "directoryPath=" + encodeURIComponent("" + directoryPath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetItems(_response);
        });
    }

    protected processGetItems(response: Response): Promise<ResultWithCodeOfListOfDriveItemModelAndSharePointError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithCodeOfListOfDriveItemModelAndSharePointError.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithCodeOfListOfDriveItemModelAndSharePointError>(null as any);
    }
}

export class StoreClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAllStorePlanTypes(version: string, signal?: AbortSignal): Promise<StorePlanTypeViewModel[]> {
        let url_ = this.baseUrl + "/api/v{version}/Store/GetAllStorePlanTypes";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllStorePlanTypes(_response);
        });
    }

    protected processGetAllStorePlanTypes(response: Response): Promise<StorePlanTypeViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StorePlanTypeViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StorePlanTypeViewModel[]>(null as any);
    }

    getPlanTitleTranslationsByCode(planCode: string | null | undefined, version: string, signal?: AbortSignal): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/v{version}/Store/GetPlanTitleTranslationsByCode?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (planCode !== undefined && planCode !== null)
            url_ += "planCode=" + encodeURIComponent("" + planCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlanTitleTranslationsByCode(_response);
        });
    }

    protected processGetPlanTitleTranslationsByCode(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    getAllStoreFeatures(version: string, signal?: AbortSignal): Promise<StoreFeatureViewModel[]> {
        let url_ = this.baseUrl + "/api/v{version}/Store/GetAllStoreFeatures";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllStoreFeatures(_response);
        });
    }

    protected processGetAllStoreFeatures(response: Response): Promise<StoreFeatureViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StoreFeatureViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoreFeatureViewModel[]>(null as any);
    }

    getFeatureTitleTranslationsByCode(planCode: string | null | undefined, version: string, signal?: AbortSignal): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/v{version}/Store/GetFeatureTitleTranslationsByCode?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (planCode !== undefined && planCode !== null)
            url_ += "planCode=" + encodeURIComponent("" + planCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFeatureTitleTranslationsByCode(_response);
        });
    }

    protected processGetFeatureTitleTranslationsByCode(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    downloadInvoice(orderId: number | undefined, version: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/Store/DownloadInvoice?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadInvoice(_response);
        });
    }

    protected processDownloadInvoice(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class TemplateBuilderClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    createFields(workspaceId: number | undefined, version: string, fields: TemplateBuilderCustomFieldModel[], signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/TemplateBuilder/fields?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (workspaceId === null)
            throw new Error("The parameter 'workspaceId' cannot be null.");
        else if (workspaceId !== undefined)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fields);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateFields(_response);
        });
    }

    protected processCreateFields(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createAndTrainCustomTemplate(workspaceId: number | undefined, templateType: TemplateType | undefined, version: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/TemplateBuilder/train?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (workspaceId === null)
            throw new Error("The parameter 'workspaceId' cannot be null.");
        else if (workspaceId !== undefined)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        if (templateType === null)
            throw new Error("The parameter 'templateType' cannot be null.");
        else if (templateType !== undefined)
            url_ += "templateType=" + encodeURIComponent("" + templateType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateAndTrainCustomTemplate(_response);
        });
    }

    protected processCreateAndTrainCustomTemplate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    isValidToTrain(workspaceId: number | undefined, version: string, signal?: AbortSignal): Promise<TrainConditionsModel> {
        let url_ = this.baseUrl + "/api/v{version}/TemplateBuilder/validToTrain?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (workspaceId === null)
            throw new Error("The parameter 'workspaceId' cannot be null.");
        else if (workspaceId !== undefined)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsValidToTrain(_response);
        });
    }

    protected processIsValidToTrain(response: Response): Promise<TrainConditionsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainConditionsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrainConditionsModel>(null as any);
    }

    getCustomModelsWithPagination(pageNumber: number | undefined, pageSize: number | undefined, filter: string | undefined, filters: PaginatedRequestQueryFilter[] | undefined, sort: string[] | undefined, workspaceId: number, version: string, signal?: AbortSignal): Promise<PaginatedListOfSdCustomModelViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/TemplateBuilder/templates/{workspaceId}?";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach(item => { url_ += "Sort=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomModelsWithPagination(_response);
        });
    }

    protected processGetCustomModelsWithPagination(response: Response): Promise<PaginatedListOfSdCustomModelViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfSdCustomModelViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfSdCustomModelViewModel>(null as any);
    }

    updateField(version: string, model: TemplateBuilderCustomFieldModel, signal?: AbortSignal): Promise<TemplateBuilderCustomFieldModel> {
        let url_ = this.baseUrl + "/api/v{version}/TemplateBuilder/field";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateField(_response);
        });
    }

    protected processUpdateField(response: Response): Promise<TemplateBuilderCustomFieldModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemplateBuilderCustomFieldModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateBuilderCustomFieldModel>(null as any);
    }

    deleteField(uniqueId: string, workspaceId: number | undefined, version: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/TemplateBuilder/field/{uniqueId}?";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (workspaceId === null)
            throw new Error("The parameter 'workspaceId' cannot be null.");
        else if (workspaceId !== undefined)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteField(_response);
        });
    }

    protected processDeleteField(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getFields(workspaceId: number, version: string, signal?: AbortSignal): Promise<TemplateBuilderCustomFieldsModel> {
        let url_ = this.baseUrl + "/api/v{version}/TemplateBuilder/fields/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFields(_response);
        });
    }

    protected processGetFields(response: Response): Promise<TemplateBuilderCustomFieldsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemplateBuilderCustomFieldsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateBuilderCustomFieldsModel>(null as any);
    }

    upsertWorkspaceTemplate(customTemplateId: number, version: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/TemplateBuilder/UpsertWorkspaceTemplate/{customTemplateId}";
        if (customTemplateId === undefined || customTemplateId === null)
            throw new Error("The parameter 'customTemplateId' must be defined.");
        url_ = url_.replace("{customTemplateId}", encodeURIComponent("" + customTemplateId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpsertWorkspaceTemplate(_response);
        });
    }

    protected processUpsertWorkspaceTemplate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getTracesDashboardUrlForModel(modelId: number, version: string, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/v{version}/TemplateBuilder/TracesDashboardUrl/{modelId}";
        if (modelId === undefined || modelId === null)
            throw new Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{modelId}", encodeURIComponent("" + modelId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTracesDashboardUrlForModel(_response);
        });
    }

    protected processGetTracesDashboardUrlForModel(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getCustomModelEventsByModelId(modelId: number, eventType: string | null | undefined, version: string, signal?: AbortSignal): Promise<RenderFarmEventAllInfoViewModel[]> {
        let url_ = this.baseUrl + "/api/v{version}/TemplateBuilder/Events/{modelId}?";
        if (modelId === undefined || modelId === null)
            throw new Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{modelId}", encodeURIComponent("" + modelId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (eventType !== undefined && eventType !== null)
            url_ += "eventType=" + encodeURIComponent("" + eventType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomModelEventsByModelId(_response);
        });
    }

    protected processGetCustomModelEventsByModelId(response: Response): Promise<RenderFarmEventAllInfoViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RenderFarmEventAllInfoViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RenderFarmEventAllInfoViewModel[]>(null as any);
    }

    handleRenderFarmTaskEvents(version: string, evt: RenderFarmEventContext, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/TemplateBuilder/RenderFarmTemplateBuilderEvents";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(evt);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHandleRenderFarmTaskEvents(_response);
        });
    }

    protected processHandleRenderFarmTaskEvents(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class TenantConnectorsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @deprecated
     */
    getSharePointConnections(version: string, signal?: AbortSignal): Promise<SharePointConfigurationModel[]> {
        let url_ = this.baseUrl + "/api/v{version}/Tenant/Connectors/GetSharePointConnections";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSharePointConnections(_response);
        });
    }

    protected processGetSharePointConnections(response: Response): Promise<SharePointConfigurationModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SharePointConfigurationModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SharePointConfigurationModel[]>(null as any);
    }

    /**
     * @deprecated
     */
    upsertSharePointConnection(version: string, model: SharePointConfigurationModel, signal?: AbortSignal): Promise<ResultWithCodeOfSharePointConfigurationModelAndSharePointError> {
        let url_ = this.baseUrl + "/api/v{version}/Tenant/Connectors/UpsertSharePointConnection";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpsertSharePointConnection(_response);
        });
    }

    protected processUpsertSharePointConnection(response: Response): Promise<ResultWithCodeOfSharePointConfigurationModelAndSharePointError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithCodeOfSharePointConfigurationModelAndSharePointError.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithCodeOfSharePointConfigurationModelAndSharePointError>(null as any);
    }

    deleteConnector(id: number, version: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/Tenant/Connectors/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteConnector(_response);
        });
    }

    protected processDeleteConnector(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getConnector(id: number, version: string, signal?: AbortSignal): Promise<ConnectorConfigurationModel> {
        let url_ = this.baseUrl + "/api/v{version}/Tenant/Connectors/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetConnector(_response);
        });
    }

    protected processGetConnector(response: Response): Promise<ConnectorConfigurationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConnectorConfigurationModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConnectorConfigurationModel>(null as any);
    }

    getWorkspacesByConnectorService(serviceName: string, version: string, signal?: AbortSignal): Promise<SdWorkspaceBasicInfoViewModel[]> {
        let url_ = this.baseUrl + "/api/v{version}/Tenant/Connectors/workspaces/{serviceName}";
        if (serviceName === undefined || serviceName === null)
            throw new Error("The parameter 'serviceName' must be defined.");
        url_ = url_.replace("{serviceName}", encodeURIComponent("" + serviceName));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkspacesByConnectorService(_response);
        });
    }

    protected processGetWorkspacesByConnectorService(response: Response): Promise<SdWorkspaceBasicInfoViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SdWorkspaceBasicInfoViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdWorkspaceBasicInfoViewModel[]>(null as any);
    }

    getConnectors(serviceTypes: LoadBalancedServiceType[] | null | undefined, includeDetails: boolean | undefined, version: string, signal?: AbortSignal): Promise<ConnectorConfigurationModel[]> {
        let url_ = this.baseUrl + "/api/v{version}/Tenant/Connectors?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (serviceTypes !== undefined && serviceTypes !== null)
            serviceTypes && serviceTypes.forEach(item => { url_ += "serviceTypes=" + encodeURIComponent("" + item) + "&"; });
        if (includeDetails === null)
            throw new Error("The parameter 'includeDetails' cannot be null.");
        else if (includeDetails !== undefined)
            url_ += "includeDetails=" + encodeURIComponent("" + includeDetails) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetConnectors(_response);
        });
    }

    protected processGetConnectors(response: Response): Promise<ConnectorConfigurationModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConnectorConfigurationModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConnectorConfigurationModel[]>(null as any);
    }

    getAvailableAuthTypes(connectorType: LoadBalancedServiceType, version: string, signal?: AbortSignal): Promise<ConnectorAuthType[]> {
        let url_ = this.baseUrl + "/api/v{version}/Tenant/Connectors/available-auth-types/{connectorType}";
        if (connectorType === undefined || connectorType === null)
            throw new Error("The parameter 'connectorType' must be defined.");
        url_ = url_.replace("{connectorType}", encodeURIComponent("" + connectorType));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAvailableAuthTypes(_response);
        });
    }

    protected processGetAvailableAuthTypes(response: Response): Promise<ConnectorAuthType[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConnectorAuthType[]>(null as any);
    }

    createSharePointConnector(version: string, model: SharePointConnectorCreateModel, signal?: AbortSignal): Promise<ResultWithCodeOfSharePointConfigurationModelAndSharePointError> {
        let url_ = this.baseUrl + "/api/v{version}/Tenant/Connectors/sharepoint";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateSharePointConnector(_response);
        });
    }

    protected processCreateSharePointConnector(response: Response): Promise<ResultWithCodeOfSharePointConfigurationModelAndSharePointError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithCodeOfSharePointConfigurationModelAndSharePointError.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithCodeOfSharePointConfigurationModelAndSharePointError>(null as any);
    }

    updateSharePointConnector(id: number, version: string, model: SharePointConnectorCreateModel, signal?: AbortSignal): Promise<ResultWithCodeOfSharePointConfigurationModelAndSharePointError> {
        let url_ = this.baseUrl + "/api/v{version}/Tenant/Connectors/sharepoint/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSharePointConnector(_response);
        });
    }

    protected processUpdateSharePointConnector(response: Response): Promise<ResultWithCodeOfSharePointConfigurationModelAndSharePointError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithCodeOfSharePointConfigurationModelAndSharePointError.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithCodeOfSharePointConfigurationModelAndSharePointError>(null as any);
    }

    createOneDriveConnector(version: string, model: OneDriveConnectorCreateModel, signal?: AbortSignal): Promise<ResultWithCodeOfOneDriveConfigurationModelAndOneDriveError> {
        let url_ = this.baseUrl + "/api/v{version}/Tenant/Connectors/onedrive";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateOneDriveConnector(_response);
        });
    }

    protected processCreateOneDriveConnector(response: Response): Promise<ResultWithCodeOfOneDriveConfigurationModelAndOneDriveError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithCodeOfOneDriveConfigurationModelAndOneDriveError.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithCodeOfOneDriveConfigurationModelAndOneDriveError>(null as any);
    }

    updateOneDriveConnector(id: number, version: string, model: OneDriveConnectorCreateModel, signal?: AbortSignal): Promise<ResultWithCodeOfOneDriveConfigurationModelAndOneDriveError> {
        let url_ = this.baseUrl + "/api/v{version}/Tenant/Connectors/onedrive/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateOneDriveConnector(_response);
        });
    }

    protected processUpdateOneDriveConnector(response: Response): Promise<ResultWithCodeOfOneDriveConfigurationModelAndOneDriveError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithCodeOfOneDriveConfigurationModelAndOneDriveError.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithCodeOfOneDriveConfigurationModelAndOneDriveError>(null as any);
    }
}

export class TenantClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getCurrentSession(version: string, signal?: AbortSignal): Promise<TenantViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/Tenant/GetCurrentSession";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCurrentSession(_response);
        });
    }

    protected processGetCurrentSession(response: Response): Promise<TenantViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantViewModel>(null as any);
    }

    update(version: string, model: TenantUpdateModel, signal?: AbortSignal): Promise<TenantViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/Tenant/Update";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<TenantViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantViewModel>(null as any);
    }

    changeUserTenant(tenantId: number | undefined, version: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/Tenant/ChangeTenant?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangeUserTenant(_response);
        });
    }

    protected processChangeUserTenant(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getAllTenantsForUser(version: string, signal?: AbortSignal): Promise<UserInTenantViewModel[]> {
        let url_ = this.baseUrl + "/api/v{version}/Tenant/UserTenants";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllTenantsForUser(_response);
        });
    }

    protected processGetAllTenantsForUser(response: Response): Promise<UserInTenantViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserInTenantViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserInTenantViewModel[]>(null as any);
    }

    isUserTenantInvitationBlocked(version: string, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v{version}/Tenant/IsUserTenantInvitationBlocked";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsUserTenantInvitationBlocked(_response);
        });
    }

    protected processIsUserTenantInvitationBlocked(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getSecrets(version: string, signal?: AbortSignal): Promise<SecretsResponse> {
        let url_ = this.baseUrl + "/api/v{version}/Tenant/Secrets";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSecrets(_response);
        });
    }

    protected processGetSecrets(response: Response): Promise<SecretsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecretsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SecretsResponse>(null as any);
    }

    createSecrets(expiration: Date | undefined, version: string, signal?: AbortSignal): Promise<SecretsResponse> {
        let url_ = this.baseUrl + "/api/v{version}/Tenant/Secrets/Create?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (expiration === null)
            throw new Error("The parameter 'expiration' cannot be null.");
        else if (expiration !== undefined)
            url_ += "expiration=" + encodeURIComponent(expiration ? "" + expiration.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateSecrets(_response);
        });
    }

    protected processCreateSecrets(response: Response): Promise<SecretsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecretsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SecretsResponse>(null as any);
    }

    updateSecrets(expiration: Date | undefined, version: string, signal?: AbortSignal): Promise<SecretsResponse> {
        let url_ = this.baseUrl + "/api/v{version}/Tenant/Secrets/Update?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (expiration === null)
            throw new Error("The parameter 'expiration' cannot be null.");
        else if (expiration !== undefined)
            url_ += "expiration=" + encodeURIComponent(expiration ? "" + expiration.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSecrets(_response);
        });
    }

    protected processUpdateSecrets(response: Response): Promise<SecretsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecretsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SecretsResponse>(null as any);
    }

    getAllUsersInTenant(version: string, signal?: AbortSignal): Promise<GenericUserViewModel[]> {
        let url_ = this.baseUrl + "/api/v{version}/Tenant/AllUsers";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllUsersInTenant(_response);
        });
    }

    protected processGetAllUsersInTenant(response: Response): Promise<GenericUserViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GenericUserViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GenericUserViewModel[]>(null as any);
    }

    checkIfUserCanBeInvited(email: string | null | undefined, version: string, signal?: AbortSignal): Promise<GenericInviteUserViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/Tenant/CheckIfUserCanBeInvited?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckIfUserCanBeInvited(_response);
        });
    }

    protected processCheckIfUserCanBeInvited(response: Response): Promise<GenericInviteUserViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericInviteUserViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GenericInviteUserViewModel>(null as any);
    }

    updateUserStatus(version: string, model: GenericUpdateUserStatusModel, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/Tenant/UpdateUserStatus";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateUserStatus(_response);
        });
    }

    protected processUpdateUserStatus(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateUserRole(version: string, model: GenericUpdateUserRoleModel, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/Tenant/UpdateUserRole";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateUserRole(_response);
        });
    }

    protected processUpdateUserRole(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    inviteUser(version: string, model: GenericInviteUserModel, signal?: AbortSignal): Promise<GenericUserViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/Tenant/InviteUser";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInviteUser(_response);
        });
    }

    protected processInviteUser(response: Response): Promise<GenericUserViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenericUserViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GenericUserViewModel>(null as any);
    }

    updateUserImpersonateRoleId(roleId: number | null | undefined, version: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/Tenant/UpdateUserImpersonateRoleId?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (roleId !== undefined && roleId !== null)
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateUserImpersonateRoleId(_response);
        });
    }

    protected processUpdateUserImpersonateRoleId(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class TenantFeatureFlagsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getCatalog(version: string, signal?: AbortSignal): Promise<TenantFeatureFlagCatalogItem[]> {
        let url_ = this.baseUrl + "/api/v{version}/TenantFeatureFlags";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCatalog(_response);
        });
    }

    protected processGetCatalog(response: Response): Promise<TenantFeatureFlagCatalogItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantFeatureFlagCatalogItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantFeatureFlagCatalogItem[]>(null as any);
    }

    getTenants(featureKey: string, tenantName: string | null | undefined, tenantId: number | null | undefined, enabled: boolean | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, version: string, signal?: AbortSignal): Promise<TenantFeatureFlagTenantPage> {
        let url_ = this.baseUrl + "/api/v{version}/TenantFeatureFlags/{featureKey}/tenants?";
        if (featureKey === undefined || featureKey === null)
            throw new Error("The parameter 'featureKey' must be defined.");
        url_ = url_.replace("{featureKey}", encodeURIComponent("" + featureKey));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (tenantName !== undefined && tenantName !== null)
            url_ += "tenantName=" + encodeURIComponent("" + tenantName) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (enabled !== undefined && enabled !== null)
            url_ += "enabled=" + encodeURIComponent("" + enabled) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTenants(_response);
        });
    }

    protected processGetTenants(response: Response): Promise<TenantFeatureFlagTenantPage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantFeatureFlagTenantPage.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantFeatureFlagTenantPage>(null as any);
    }

    applyChanges(featureKey: string, version: string, request: TenantFeatureFlagChangeRequest, signal?: AbortSignal): Promise<TenantFeatureFlagChangeResult> {
        let url_ = this.baseUrl + "/api/v{version}/TenantFeatureFlags/{featureKey}/changes";
        if (featureKey === undefined || featureKey === null)
            throw new Error("The parameter 'featureKey' must be defined.");
        url_ = url_.replace("{featureKey}", encodeURIComponent("" + featureKey));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApplyChanges(_response);
        });
    }

    protected processApplyChanges(response: Response): Promise<TenantFeatureFlagChangeResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantFeatureFlagChangeResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantFeatureFlagChangeResult>(null as any);
    }

    getHistory(featureKey: string, continuationToken: string | null | undefined, batchSize: number | undefined, version: string, signal?: AbortSignal): Promise<TenantFeatureFlagHistoryPage> {
        let url_ = this.baseUrl + "/api/v{version}/TenantFeatureFlags/{featureKey}/history?";
        if (featureKey === undefined || featureKey === null)
            throw new Error("The parameter 'featureKey' must be defined.");
        url_ = url_.replace("{featureKey}", encodeURIComponent("" + featureKey));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (continuationToken !== undefined && continuationToken !== null)
            url_ += "continuationToken=" + encodeURIComponent("" + continuationToken) + "&";
        if (batchSize === null)
            throw new Error("The parameter 'batchSize' cannot be null.");
        else if (batchSize !== undefined)
            url_ += "batchSize=" + encodeURIComponent("" + batchSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHistory(_response);
        });
    }

    protected processGetHistory(response: Response): Promise<TenantFeatureFlagHistoryPage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantFeatureFlagHistoryPage.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantFeatureFlagHistoryPage>(null as any);
    }
}

export class TenantSettingsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    get(version: string, signal?: AbortSignal): Promise<TenantSettingsViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/TenantSettings";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<TenantSettingsViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantSettingsViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantSettingsViewModel>(null as any);
    }

    update(version: string, request: TenantSettingsUpdateModel, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/TenantSettings/Update";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class TranscriptClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getMediaUrlAndTranscriptFull(externalId: string | null | undefined, taskId: number | undefined, workspaceId: number | undefined, version: string, signal?: AbortSignal): Promise<ResultWithCodeOfSdTaskMediaUrlAndTranscriptFullViewModelAndBlobError> {
        let url_ = this.baseUrl + "/api/v{version}/Transcript/MediaUrlAndTranscript?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (externalId !== undefined && externalId !== null)
            url_ += "ExternalId=" + encodeURIComponent("" + externalId) + "&";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (workspaceId === null)
            throw new Error("The parameter 'workspaceId' cannot be null.");
        else if (workspaceId !== undefined)
            url_ += "WorkspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMediaUrlAndTranscriptFull(_response);
        });
    }

    protected processGetMediaUrlAndTranscriptFull(response: Response): Promise<ResultWithCodeOfSdTaskMediaUrlAndTranscriptFullViewModelAndBlobError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithCodeOfSdTaskMediaUrlAndTranscriptFullViewModelAndBlobError.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithCodeOfSdTaskMediaUrlAndTranscriptFullViewModelAndBlobError>(null as any);
    }

    saveTranscriptChanges(version: string, model: SaveTranscriptFullModel, signal?: AbortSignal): Promise<ResultWithCodeOfSavedTranscriptFullViewModelAndSdTaskError> {
        let url_ = this.baseUrl + "/api/v{version}/Transcript/SaveTranscriptChanges";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveTranscriptChanges(_response);
        });
    }

    protected processSaveTranscriptChanges(response: Response): Promise<ResultWithCodeOfSavedTranscriptFullViewModelAndSdTaskError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithCodeOfSavedTranscriptFullViewModelAndSdTaskError.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithCodeOfSavedTranscriptFullViewModelAndSdTaskError>(null as any);
    }

    export(taskId: number, version: string, model: TranscriptExportModel, signal?: AbortSignal): Promise<ResultWithCodeOfExportDataViewModelAndSdTaskError> {
        let url_ = this.baseUrl + "/api/v{version}/Transcript/Export/{taskId}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<ResultWithCodeOfExportDataViewModelAndSdTaskError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithCodeOfExportDataViewModelAndSdTaskError.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithCodeOfExportDataViewModelAndSdTaskError>(null as any);
    }

    exportMultiple(version: string, model: TranscriptMultipleExportDataModel, signal?: AbortSignal): Promise<ResultWithCodeOfExportDataViewModelAndSdTaskError> {
        let url_ = this.baseUrl + "/api/v{version}/Transcript/ExportMultiple";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportMultiple(_response);
        });
    }

    protected processExportMultiple(response: Response): Promise<ResultWithCodeOfExportDataViewModelAndSdTaskError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithCodeOfExportDataViewModelAndSdTaskError.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithCodeOfExportDataViewModelAndSdTaskError>(null as any);
    }

    getPredefinedSpeakers(workspaceId: number, version: string, signal?: AbortSignal): Promise<PredefinedSpeakersViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/Transcript/PredefinedSpeakers/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPredefinedSpeakers(_response);
        });
    }

    protected processGetPredefinedSpeakers(response: Response): Promise<PredefinedSpeakersViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PredefinedSpeakersViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PredefinedSpeakersViewModel>(null as any);
    }

    patchPredefinedSpeakers(workspaceId: number, version: string, predefinedSpeakersModel: PredefinedSpeakersModel, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/Transcript/PredefinedSpeakers/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(predefinedSpeakersModel);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchPredefinedSpeakers(_response);
        });
    }

    protected processPatchPredefinedSpeakers(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class UserClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getUserAuthDetails(version: string, signal?: AbortSignal): Promise<UserAuthDetailsViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/User/GetUserAuthDetails";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserAuthDetails(_response);
        });
    }

    protected processGetUserAuthDetails(response: Response): Promise<UserAuthDetailsViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAuthDetailsViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserAuthDetailsViewModel>(null as any);
    }

    get(email: string | null | undefined, version: string, signal?: AbortSignal): Promise<UserViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/User/Get?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<UserViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserViewModel>(null as any);
    }

    remove(version: string, request: UserViewModel, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/User/Remove";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getWithPagination(version: string, request: PaginatedRequestQuery, signal?: AbortSignal): Promise<PaginatedListOfUserViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/User/GetWithPagination";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWithPagination(_response);
        });
    }

    protected processGetWithPagination(response: Response): Promise<PaginatedListOfUserViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfUserViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfUserViewModel>(null as any);
    }

    getCurrentUser(version: string, signal?: AbortSignal): Promise<UserViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/User/GetCurrentUser";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCurrentUser(_response);
        });
    }

    protected processGetCurrentUser(response: Response): Promise<UserViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserViewModel>(null as any);
    }

    updateCurrentUserDefaultTenant(version: string, request: UpdateDefaultTenantUserModel, signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/api/v{version}/User/UpdateCurrentUserDefaultTenant";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCurrentUserDefaultTenant(_response);
        });
    }

    protected processUpdateCurrentUserDefaultTenant(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getAllRoles(version: string, signal?: AbortSignal): Promise<AuthorizationRole[]> {
        let url_ = this.baseUrl + "/api/v{version}/User/AllRoles";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllRoles(_response);
        });
    }

    protected processGetAllRoles(response: Response): Promise<AuthorizationRole[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuthorizationRole.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthorizationRole[]>(null as any);
    }

    getUserDetails(version: string, signal?: AbortSignal): Promise<UserAuthDetailsViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/User/GetUserDetails";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserDetails(_response);
        });
    }

    protected processGetUserDetails(response: Response): Promise<UserAuthDetailsViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAuthDetailsViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserAuthDetailsViewModel>(null as any);
    }

    sendVerificationEmail(version: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/User/SendVerificationEmail";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendVerificationEmail(_response);
        });
    }

    protected processSendVerificationEmail(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    confirmEmail(version: string, model: ConfirmEmailDataModel, signal?: AbortSignal): Promise<Result> {
        let url_ = this.baseUrl + "/api/v{version}/User/ConfirmEmail";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConfirmEmail(_response);
        });
    }

    protected processConfirmEmail(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    confirmChangeEmail(version: string, model: ConfirmChangeEmailDataModel, signal?: AbortSignal): Promise<Result> {
        let url_ = this.baseUrl + "/api/v{version}/User/ConfirmChangeEmail";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConfirmChangeEmail(_response);
        });
    }

    protected processConfirmChangeEmail(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    setPersonalInfo(version: string, model: PersonalInfoModel, signal?: AbortSignal): Promise<Result> {
        let url_ = this.baseUrl + "/api/v{version}/User/SetPersonalInfo";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetPersonalInfo(_response);
        });
    }

    protected processSetPersonalInfo(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    changeEmail(language: string | null | undefined, version: string, newEmail: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/User/ChangeEmail?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newEmail);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangeEmail(_response);
        });
    }

    protected processChangeEmail(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getMetrics(version: string, signal?: AbortSignal): Promise<PersonalMetricsViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/User/GetMetrics";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMetrics(_response);
        });
    }

    protected processGetMetrics(response: Response): Promise<PersonalMetricsViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonalMetricsViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonalMetricsViewModel>(null as any);
    }

    getExternalLogins(version: string, signal?: AbortSignal): Promise<ExternalLoginsViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/User/GetExternalLogins";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExternalLogins(_response);
        });
    }

    protected processGetExternalLogins(response: Response): Promise<ExternalLoginsViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalLoginsViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExternalLoginsViewModel>(null as any);
    }

    addPassword(version: string, password: string, signal?: AbortSignal): Promise<Result> {
        let url_ = this.baseUrl + "/api/v{version}/User/AddPassword";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(password);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddPassword(_response);
        });
    }

    protected processAddPassword(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    changePassword(version: string, model: SecurityModel, signal?: AbortSignal): Promise<Result> {
        let url_ = this.baseUrl + "/api/v{version}/User/ChangePassword";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    removeLogin(version: string, model: LoginInfoModel, signal?: AbortSignal): Promise<Result> {
        let url_ = this.baseUrl + "/api/v{version}/User/RemoveLogin";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveLogin(_response);
        });
    }

    protected processRemoveLogin(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    delete(version: string, password: string, signal?: AbortSignal): Promise<Result> {
        let url_ = this.baseUrl + "/api/v{version}/User/Delete";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(password);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    deleteWithAllData(version: string, password: string, signal?: AbortSignal): Promise<Result> {
        let url_ = this.baseUrl + "/api/v{version}/User/DeleteWithAllData";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(password);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteWithAllData(_response);
        });
    }

    protected processDeleteWithAllData(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Result.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    verifyRulesToDelete(version: string, signal?: AbortSignal): Promise<UserDeleteInfo> {
        let url_ = this.baseUrl + "/api/v{version}/User/VerifyRulesToDelete";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVerifyRulesToDelete(_response);
        });
    }

    protected processVerifyRulesToDelete(response: Response): Promise<UserDeleteInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDeleteInfo>(null as any);
    }

    downloadPersonalData(version: string, signal?: AbortSignal): Promise<PersonalDataViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/User/DownloadPersonalData";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadPersonalData(_response);
        });
    }

    protected processDownloadPersonalData(response: Response): Promise<PersonalDataViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonalDataViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonalDataViewModel>(null as any);
    }

    importPicture(version: string, model: PictureImportModel, signal?: AbortSignal): Promise<ResultWithCodeOfPictureImportViewModelAndUserError> {
        let url_ = this.baseUrl + "/api/v{version}/User/ChangePicture";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImportPicture(_response);
        });
    }

    protected processImportPicture(response: Response): Promise<ResultWithCodeOfPictureImportViewModelAndUserError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithCodeOfPictureImportViewModelAndUserError.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithCodeOfPictureImportViewModelAndUserError>(null as any);
    }

    getProfilePicture(userId: number, version: string, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/v{version}/User/GetProfilePicture/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProfilePicture(_response);
        });
    }

    protected processGetProfilePicture(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getProfilePicturesByUserId(userIds: number[] | null | undefined, version: string, signal?: AbortSignal): Promise<SdTaskAssignmentUserInfo[]> {
        let url_ = this.baseUrl + "/api/v{version}/User/GetProfilePicturesByUserId?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (userIds !== undefined && userIds !== null)
            userIds && userIds.forEach(item => { url_ += "userIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProfilePicturesByUserId(_response);
        });
    }

    protected processGetProfilePicturesByUserId(response: Response): Promise<SdTaskAssignmentUserInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SdTaskAssignmentUserInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdTaskAssignmentUserInfo[]>(null as any);
    }

    getTours(version: string, signal?: AbortSignal): Promise<UserTourViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/User/GetToursSeen";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTours(_response);
        });
    }

    protected processGetTours(response: Response): Promise<UserTourViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTourViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserTourViewModel>(null as any);
    }

    updateToursSeen(version: string, tour: UserTourViewModel, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/User/UpdateToursSeen";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tour);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateToursSeen(_response);
        });
    }

    protected processUpdateToursSeen(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ViewerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getViewerInit(taskId: number | null | undefined, externalId: string | null | undefined, version: string, signal?: AbortSignal): Promise<ResultWithCodeOfSdTaskViewerInitViewModelAndSdTaskError> {
        let url_ = this.baseUrl + "/api/v{version}/Viewer/ViewerInit?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        if (externalId !== undefined && externalId !== null)
            url_ += "externalId=" + encodeURIComponent("" + externalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetViewerInit(_response);
        });
    }

    protected processGetViewerInit(response: Response): Promise<ResultWithCodeOfSdTaskViewerInitViewModelAndSdTaskError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithCodeOfSdTaskViewerInitViewModelAndSdTaskError.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithCodeOfSdTaskViewerInitViewModelAndSdTaskError>(null as any);
    }

    checkoutTask(version: string, model: SdTaskCheckoutModel, signal?: AbortSignal): Promise<ResultWithCodeOfSdTaskCheckoutViewModelAndSdTaskError> {
        let url_ = this.baseUrl + "/api/v{version}/Viewer/Checkout";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckoutTask(_response);
        });
    }

    protected processCheckoutTask(response: Response): Promise<ResultWithCodeOfSdTaskCheckoutViewModelAndSdTaskError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithCodeOfSdTaskCheckoutViewModelAndSdTaskError.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithCodeOfSdTaskCheckoutViewModelAndSdTaskError>(null as any);
    }

    renewCheckout(taskId: number, externalId: string | null | undefined, version: string, signal?: AbortSignal): Promise<ResultWithCodeOfBooleanAndSdTaskError> {
        let url_ = this.baseUrl + "/api/v{version}/Viewer/Review/Renew/{taskId}?";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (externalId !== undefined && externalId !== null)
            url_ += "externalId=" + encodeURIComponent("" + externalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenewCheckout(_response);
        });
    }

    protected processRenewCheckout(response: Response): Promise<ResultWithCodeOfBooleanAndSdTaskError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithCodeOfBooleanAndSdTaskError.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithCodeOfBooleanAndSdTaskError>(null as any);
    }

    cancelReview(taskId: number, externalId: string | null | undefined, version: string, signal?: AbortSignal): Promise<ResultWithCodeOfBooleanAndSdTaskError> {
        let url_ = this.baseUrl + "/api/v{version}/Viewer/Review/Cancel/{taskId}?";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (externalId !== undefined && externalId !== null)
            url_ += "externalId=" + encodeURIComponent("" + externalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCancelReview(_response);
        });
    }

    protected processCancelReview(response: Response): Promise<ResultWithCodeOfBooleanAndSdTaskError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithCodeOfBooleanAndSdTaskError.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithCodeOfBooleanAndSdTaskError>(null as any);
    }

    finishReview(taskId: number, externalId: string | null | undefined, version: string, signal?: AbortSignal): Promise<ResultWithCodeOfBooleanAndSdTaskError> {
        let url_ = this.baseUrl + "/api/v{version}/Viewer/Review/Finish/{taskId}?";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (externalId !== undefined && externalId !== null)
            url_ += "externalId=" + encodeURIComponent("" + externalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFinishReview(_response);
        });
    }

    protected processFinishReview(response: Response): Promise<ResultWithCodeOfBooleanAndSdTaskError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithCodeOfBooleanAndSdTaskError.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithCodeOfBooleanAndSdTaskError>(null as any);
    }
}

export class WorkspaceFieldAssistantClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    get(workspaceId: number, version: string, signal?: AbortSignal): Promise<WorkspaceFieldAssistantStateModel> {
        let url_ = this.baseUrl + "/api/v{version}/WorkspaceFieldAssistant/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<WorkspaceFieldAssistantStateModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkspaceFieldAssistantStateModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkspaceFieldAssistantStateModel>(null as any);
    }

    uploadDocument(workspaceId: number, version: string, file: FileParameter | null | undefined, signal?: AbortSignal): Promise<WorkspaceFieldAssistantStateModel> {
        let url_ = this.baseUrl + "/api/v{version}/WorkspaceFieldAssistant/{workspaceId}/document";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadDocument(_response);
        });
    }

    protected processUploadDocument(response: Response): Promise<WorkspaceFieldAssistantStateModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkspaceFieldAssistantStateModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkspaceFieldAssistantStateModel>(null as any);
    }

    deleteDocument(workspaceId: number, version: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/WorkspaceFieldAssistant/{workspaceId}/document";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteDocument(_response);
        });
    }

    protected processDeleteDocument(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    retryOcr(workspaceId: number, version: string, signal?: AbortSignal): Promise<WorkspaceFieldAssistantStateModel> {
        let url_ = this.baseUrl + "/api/v{version}/WorkspaceFieldAssistant/{workspaceId}/document/retry-ocr";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRetryOcr(_response);
        });
    }

    protected processRetryOcr(response: Response): Promise<WorkspaceFieldAssistantStateModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkspaceFieldAssistantStateModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkspaceFieldAssistantStateModel>(null as any);
    }

    generateDescription(workspaceId: number, version: string, request: GenerateFieldDescriptionRequest, signal?: AbortSignal): Promise<GenerateFieldDescriptionResponse> {
        let url_ = this.baseUrl + "/api/v{version}/WorkspaceFieldAssistant/{workspaceId}/description";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateDescription(_response);
        });
    }

    protected processGenerateDescription(response: Response): Promise<GenerateFieldDescriptionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenerateFieldDescriptionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GenerateFieldDescriptionResponse>(null as any);
    }

    test(workspaceId: number, version: string, file: FileParameter | null | undefined, signal?: AbortSignal): Promise<FieldAssistantTestResponse> {
        let url_ = this.baseUrl + "/api/v{version}/WorkspaceFieldAssistant/{workspaceId}/test";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTest(_response);
        });
    }

    protected processTest(response: Response): Promise<FieldAssistantTestResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FieldAssistantTestResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FieldAssistantTestResponse>(null as any);
    }

    testDraft(workspaceId: number, version: string, file: FileParameter | null | undefined, fields: string | null | undefined, signal?: AbortSignal): Promise<FieldAssistantTestResponse> {
        let url_ = this.baseUrl + "/api/v{version}/WorkspaceFieldAssistant/{workspaceId}/test/draft";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (fields !== null && fields !== undefined)
            content_.append("fields", fields.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTestDraft(_response);
        });
    }

    protected processTestDraft(response: Response): Promise<FieldAssistantTestResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FieldAssistantTestResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FieldAssistantTestResponse>(null as any);
    }
}

export class SdTaskJobClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    validateUploadLicense(workspaceId: number | undefined, totalPages: number | undefined, creditedTotalPages: number | undefined, fileName: string | null | undefined, taskId: number | null | undefined, requestId: string | null | undefined, version: string, signal?: AbortSignal): Promise<ResultWithCodeOfBooleanAndSdTaskError> {
        let url_ = this.baseUrl + "/api/v{version}/jobs/sdtask/ValidateUploadLicense?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (workspaceId === null)
            throw new Error("The parameter 'workspaceId' cannot be null.");
        else if (workspaceId !== undefined)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        if (totalPages === null)
            throw new Error("The parameter 'totalPages' cannot be null.");
        else if (totalPages !== undefined)
            url_ += "totalPages=" + encodeURIComponent("" + totalPages) + "&";
        if (creditedTotalPages === null)
            throw new Error("The parameter 'creditedTotalPages' cannot be null.");
        else if (creditedTotalPages !== undefined)
            url_ += "creditedTotalPages=" + encodeURIComponent("" + creditedTotalPages) + "&";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (taskId !== undefined && taskId !== null)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        if (requestId !== undefined && requestId !== null)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValidateUploadLicense(_response);
        });
    }

    protected processValidateUploadLicense(response: Response): Promise<ResultWithCodeOfBooleanAndSdTaskError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithCodeOfBooleanAndSdTaskError.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithCodeOfBooleanAndSdTaskError>(null as any);
    }

    validateTrainingLicense(customModelId: number | undefined, durationMinutes: number | undefined, version: string, signal?: AbortSignal): Promise<ResultWithCodeOfBooleanAndSdTaskError> {
        let url_ = this.baseUrl + "/api/v{version}/jobs/sdtask/ValidateTrainingLicense?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (customModelId === null)
            throw new Error("The parameter 'customModelId' cannot be null.");
        else if (customModelId !== undefined)
            url_ += "customModelId=" + encodeURIComponent("" + customModelId) + "&";
        if (durationMinutes === null)
            throw new Error("The parameter 'durationMinutes' cannot be null.");
        else if (durationMinutes !== undefined)
            url_ += "durationMinutes=" + encodeURIComponent("" + durationMinutes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValidateTrainingLicense(_response);
        });
    }

    protected processValidateTrainingLicense(response: Response): Promise<ResultWithCodeOfBooleanAndSdTaskError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithCodeOfBooleanAndSdTaskError.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithCodeOfBooleanAndSdTaskError>(null as any);
    }

    reIndex(version: string, payload: ScheduleIndexPayload, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/jobs/sdtask/ReIndex";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReIndex(_response);
        });
    }

    protected processReIndex(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    setTaskResultStorageProps(taskId: number, version: string, model: SetSdTaskResultStoragePropsModel, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/jobs/sdtask/SetTaskResultStorageProps/{taskId}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetTaskResultStorageProps(_response);
        });
    }

    protected processSetTaskResultStorageProps(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ExternalBlobProxyClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getBlobProxiedUrl(version: string, model: BuildProxiedUrlModel, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/v{version}/external/blobproxy/GetBlobProxiedUrl";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBlobProxiedUrl(_response);
        });
    }

    protected processGetBlobProxiedUrl(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class ExternalIndexClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getIndexInfo(taskId: number, version: string, signal?: AbortSignal): Promise<IndexInfoViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/external/index/info/{taskId}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetIndexInfo(_response);
        });
    }

    protected processGetIndexInfo(response: Response): Promise<IndexInfoViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IndexInfoViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IndexInfoViewModel>(null as any);
    }

    updateIndexInfo(taskId: number, version: string, request: UpdateIndexInfoModel, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/external/index/info/{taskId}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateIndexInfo(_response);
        });
    }

    protected processUpdateIndexInfo(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    scheduleIndex(taskId: number, version: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/external/index/schedule/{taskId}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processScheduleIndex(_response);
        });
    }

    protected processScheduleIndex(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    search(search: string | undefined, workspaceId: number | undefined, batchId: number | null | undefined, taskSource: TaskSource | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, version: string, signal?: AbortSignal): Promise<PaginatedListOfSdTaskViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/external/index/Search?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (workspaceId === null)
            throw new Error("The parameter 'workspaceId' cannot be null.");
        else if (workspaceId !== undefined)
            url_ += "WorkspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        if (batchId !== undefined && batchId !== null)
            url_ += "BatchId=" + encodeURIComponent("" + batchId) + "&";
        if (taskSource !== undefined && taskSource !== null)
            url_ += "TaskSource=" + encodeURIComponent("" + taskSource) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<PaginatedListOfSdTaskViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfSdTaskViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfSdTaskViewModel>(null as any);
    }
}

export class ExternalLicenseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    validateExpirationAndVolume(workspaceId: number, version: string, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v{version}/external/license/ValidateExpirationAndVolume/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValidateExpirationAndVolume(_response);
        });
    }

    protected processValidateExpirationAndVolume(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class ExternalLoadBalancingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getService(serviceType: LoadBalancedServiceType | undefined, capabilities: string[] | undefined, metricToMinimize: string | undefined, version: string, signal?: AbortSignal): Promise<AvailableLoadBalancedService> {
        let url_ = this.baseUrl + "/api/v{version}/external/loadbalancing?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (serviceType === null)
            throw new Error("The parameter 'serviceType' cannot be null.");
        else if (serviceType !== undefined)
            url_ += "ServiceType=" + encodeURIComponent("" + serviceType) + "&";
        if (capabilities === null)
            throw new Error("The parameter 'capabilities' cannot be null.");
        else if (capabilities !== undefined)
            capabilities && capabilities.forEach(item => { url_ += "Capabilities=" + encodeURIComponent("" + item) + "&"; });
        if (metricToMinimize === null)
            throw new Error("The parameter 'metricToMinimize' cannot be null.");
        else if (metricToMinimize !== undefined)
            url_ += "MetricToMinimize=" + encodeURIComponent("" + metricToMinimize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetService(_response);
        });
    }

    protected processGetService(response: Response): Promise<AvailableLoadBalancedService> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvailableLoadBalancedService.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AvailableLoadBalancedService>(null as any);
    }

    updateServiceMetric(version: string, request: UpdateLoadBalancedServiceMetricRequest, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/external/loadbalancing";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateServiceMetric(_response);
        });
    }

    protected processUpdateServiceMetric(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    incLoadBalancingServiceErrorCount(serviceName: string | null | undefined, statusCode: number | null | undefined, version: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/external/loadbalancing?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (serviceName !== undefined && serviceName !== null)
            url_ += "serviceName=" + encodeURIComponent("" + serviceName) + "&";
        if (statusCode !== undefined && statusCode !== null)
            url_ += "statusCode=" + encodeURIComponent("" + statusCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIncLoadBalancingServiceErrorCount(_response);
        });
    }

    protected processIncLoadBalancingServiceErrorCount(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ExternalSdBatchClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    createBatch(version: string, model: CreateSdBatchModel, signal?: AbortSignal): Promise<SdBatchViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/external/sdbatch";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateBatch(_response);
        });
    }

    protected processCreateBatch(response: Response): Promise<SdBatchViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdBatchViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdBatchViewModel>(null as any);
    }

    getBatch(batchId: number | undefined, version: string, signal?: AbortSignal): Promise<SdBatchViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/external/sdbatch?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (batchId === null)
            throw new Error("The parameter 'batchId' cannot be null.");
        else if (batchId !== undefined)
            url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBatch(_response);
        });
    }

    protected processGetBatch(response: Response): Promise<SdBatchViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdBatchViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdBatchViewModel>(null as any);
    }

    getWithPaginationByWorkspace(startDate: Date | null | undefined, endDate: Date | null | undefined, workspaceId: number[] | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, version: string, signal?: AbortSignal): Promise<PaginatedListOfSdBatchViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/external/sdbatch/Paginated?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (workspaceId !== undefined && workspaceId !== null)
            workspaceId && workspaceId.forEach(item => { url_ += "WorkspaceId=" + encodeURIComponent("" + item) + "&"; });
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWithPaginationByWorkspace(_response);
        });
    }

    protected processGetWithPaginationByWorkspace(response: Response): Promise<PaginatedListOfSdBatchViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfSdBatchViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfSdBatchViewModel>(null as any);
    }
}

export class ExternalSdTaskClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getStructuredExportData(taskId: number, version: string, signal?: AbortSignal): Promise<StructuredExportModel> {
        let url_ = this.baseUrl + "/api/v{version}/external/sdtask/GetExportData/{taskId}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStructuredExportData(_response);
        });
    }

    protected processGetStructuredExportData(response: Response): Promise<StructuredExportModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StructuredExportModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StructuredExportModel>(null as any);
    }

    getSimplifiedStructuredExportData(taskId: number, version: string, signal?: AbortSignal): Promise<SimplifiedStructuredExportModel> {
        let url_ = this.baseUrl + "/api/v{version}/external/sdtask/GetExportData/{taskId}/simplified";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSimplifiedStructuredExportData(_response);
        });
    }

    protected processGetSimplifiedStructuredExportData(response: Response): Promise<SimplifiedStructuredExportModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SimplifiedStructuredExportModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimplifiedStructuredExportModel>(null as any);
    }

    getAnonymizationExportFileToUrl(taskId: number, expiresOnHours: number | undefined, exportType: ExportType | undefined, version: string, signal?: AbortSignal): Promise<SdTaskExportResultModel> {
        let url_ = this.baseUrl + "/api/v{version}/external/sdtask/GetExportData/Anonymization/{taskId}/exportFileToUrl?";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (expiresOnHours === null)
            throw new Error("The parameter 'expiresOnHours' cannot be null.");
        else if (expiresOnHours !== undefined)
            url_ += "expiresOnHours=" + encodeURIComponent("" + expiresOnHours) + "&";
        if (exportType === null)
            throw new Error("The parameter 'exportType' cannot be null.");
        else if (exportType !== undefined)
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAnonymizationExportFileToUrl(_response);
        });
    }

    protected processGetAnonymizationExportFileToUrl(response: Response): Promise<SdTaskExportResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdTaskExportResultModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdTaskExportResultModel>(null as any);
    }

    getTranscriptExportFileToUrl(taskId: number, expiresOnHours: number | undefined, includeTimestamps: boolean | undefined, includeSpeakers: boolean | undefined, mergeParagraphs: boolean | undefined, exportType: ExportType | undefined, version: string, signal?: AbortSignal): Promise<ExportTranscriptFileToUrlPageModel> {
        let url_ = this.baseUrl + "/api/v{version}/external/sdtask/GetExportData/Transcript/{taskId}/exportFileToUrl?";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (expiresOnHours === null)
            throw new Error("The parameter 'expiresOnHours' cannot be null.");
        else if (expiresOnHours !== undefined)
            url_ += "expiresOnHours=" + encodeURIComponent("" + expiresOnHours) + "&";
        if (includeTimestamps === null)
            throw new Error("The parameter 'includeTimestamps' cannot be null.");
        else if (includeTimestamps !== undefined)
            url_ += "includeTimestamps=" + encodeURIComponent("" + includeTimestamps) + "&";
        if (includeSpeakers === null)
            throw new Error("The parameter 'includeSpeakers' cannot be null.");
        else if (includeSpeakers !== undefined)
            url_ += "includeSpeakers=" + encodeURIComponent("" + includeSpeakers) + "&";
        if (mergeParagraphs === null)
            throw new Error("The parameter 'mergeParagraphs' cannot be null.");
        else if (mergeParagraphs !== undefined)
            url_ += "mergeParagraphs=" + encodeURIComponent("" + mergeParagraphs) + "&";
        if (exportType === null)
            throw new Error("The parameter 'exportType' cannot be null.");
        else if (exportType !== undefined)
            url_ += "exportType=" + encodeURIComponent("" + exportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTranscriptExportFileToUrl(_response);
        });
    }

    protected processGetTranscriptExportFileToUrl(response: Response): Promise<ExportTranscriptFileToUrlPageModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportTranscriptFileToUrlPageModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExportTranscriptFileToUrlPageModel>(null as any);
    }

    getStructuredTranscriptExportData(taskId: number, version: string, signal?: AbortSignal): Promise<StructuredTranscriptExportModel> {
        let url_ = this.baseUrl + "/api/v{version}/external/sdtask/GetExportData/Transcript/{taskId}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStructuredTranscriptExportData(_response);
        });
    }

    protected processGetStructuredTranscriptExportData(response: Response): Promise<StructuredTranscriptExportModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StructuredTranscriptExportModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StructuredTranscriptExportModel>(null as any);
    }

    getStructuredSimplifiedTranscriptExportData(taskId: number, version: string, signal?: AbortSignal): Promise<StructuredSimplifiedTranscriptExportModel> {
        let url_ = this.baseUrl + "/api/v{version}/external/sdtask/GetExportData/Transcript/{taskId}/simplified";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStructuredSimplifiedTranscriptExportData(_response);
        });
    }

    protected processGetStructuredSimplifiedTranscriptExportData(response: Response): Promise<StructuredSimplifiedTranscriptExportModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StructuredSimplifiedTranscriptExportModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StructuredSimplifiedTranscriptExportModel>(null as any);
    }

    export(taskId: number, type: ExportType, version: string, signal?: AbortSignal): Promise<ResultWithCodeOfExportDataViewModelAndSdTaskError> {
        let url_ = this.baseUrl + "/api/v{version}/external/sdtask/Export/{taskId}/{type}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<ResultWithCodeOfExportDataViewModelAndSdTaskError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithCodeOfExportDataViewModelAndSdTaskError.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithCodeOfExportDataViewModelAndSdTaskError>(null as any);
    }

    getExportResult(requestId: string | undefined, expiresOnHours: number | undefined, version: string, signal?: AbortSignal): Promise<SdTaskExportResultModel> {
        let url_ = this.baseUrl + "/api/v{version}/external/sdtask/GetExportResult?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        if (expiresOnHours === null)
            throw new Error("The parameter 'expiresOnHours' cannot be null.");
        else if (expiresOnHours !== undefined)
            url_ += "expiresOnHours=" + encodeURIComponent("" + expiresOnHours) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExportResult(_response);
        });
    }

    protected processGetExportResult(response: Response): Promise<SdTaskExportResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdTaskExportResultModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdTaskExportResultModel>(null as any);
    }

    getStatus(externalId: string | null | undefined, taskId: number | null | undefined, version: string, signal?: AbortSignal): Promise<SdTaskIntegrationStatusViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/external/sdtask/Status?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (externalId !== undefined && externalId !== null)
            url_ += "ExternalId=" + encodeURIComponent("" + externalId) + "&";
        if (taskId !== undefined && taskId !== null)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStatus(_response);
        });
    }

    protected processGetStatus(response: Response): Promise<SdTaskIntegrationStatusViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdTaskIntegrationStatusViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdTaskIntegrationStatusViewModel>(null as any);
    }

    getStatusListAll(startDate: Date | null | undefined, endDate: Date | null | undefined, taskStatus: SdTaskStatus[] | null | undefined, integrationStatus: SdTaskIntegrationStatus[] | null | undefined, workspaceId: number[] | null | undefined, batchId: number[] | null | undefined, externalIntegrationStatus: string | null | undefined, version: string, signal?: AbortSignal): Promise<SdTaskIntegrationStatusViewModel[]> {
        let url_ = this.baseUrl + "/api/v{version}/external/sdtask/StatusList?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (taskStatus !== undefined && taskStatus !== null)
            taskStatus && taskStatus.forEach(item => { url_ += "TaskStatus=" + encodeURIComponent("" + item) + "&"; });
        if (integrationStatus !== undefined && integrationStatus !== null)
            integrationStatus && integrationStatus.forEach(item => { url_ += "IntegrationStatus=" + encodeURIComponent("" + item) + "&"; });
        if (workspaceId !== undefined && workspaceId !== null)
            workspaceId && workspaceId.forEach(item => { url_ += "WorkspaceId=" + encodeURIComponent("" + item) + "&"; });
        if (batchId !== undefined && batchId !== null)
            batchId && batchId.forEach(item => { url_ += "BatchId=" + encodeURIComponent("" + item) + "&"; });
        if (externalIntegrationStatus !== undefined && externalIntegrationStatus !== null)
            url_ += "ExternalIntegrationStatus=" + encodeURIComponent("" + externalIntegrationStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStatusListAll(_response);
        });
    }

    protected processGetStatusListAll(response: Response): Promise<SdTaskIntegrationStatusViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SdTaskIntegrationStatusViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdTaskIntegrationStatusViewModel[]>(null as any);
    }

    getStatusList(pageNumber: number | undefined, pageSize: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, taskStatus: SdTaskStatus[] | null | undefined, integrationStatus: SdTaskIntegrationStatus[] | null | undefined, workspaceId: number[] | null | undefined, batchId: number[] | null | undefined, externalIntegrationStatus: string | null | undefined, version: string, signal?: AbortSignal): Promise<PaginatedListOfSdTaskIntegrationStatusViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/external/sdtask/StatusListPaginated?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (taskStatus !== undefined && taskStatus !== null)
            taskStatus && taskStatus.forEach(item => { url_ += "TaskStatus=" + encodeURIComponent("" + item) + "&"; });
        if (integrationStatus !== undefined && integrationStatus !== null)
            integrationStatus && integrationStatus.forEach(item => { url_ += "IntegrationStatus=" + encodeURIComponent("" + item) + "&"; });
        if (workspaceId !== undefined && workspaceId !== null)
            workspaceId && workspaceId.forEach(item => { url_ += "WorkspaceId=" + encodeURIComponent("" + item) + "&"; });
        if (batchId !== undefined && batchId !== null)
            batchId && batchId.forEach(item => { url_ += "BatchId=" + encodeURIComponent("" + item) + "&"; });
        if (externalIntegrationStatus !== undefined && externalIntegrationStatus !== null)
            url_ += "ExternalIntegrationStatus=" + encodeURIComponent("" + externalIntegrationStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStatusList(_response);
        });
    }

    protected processGetStatusList(response: Response): Promise<PaginatedListOfSdTaskIntegrationStatusViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfSdTaskIntegrationStatusViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfSdTaskIntegrationStatusViewModel>(null as any);
    }

    restartProcessing(externalId: string | null | undefined, taskId: number | null | undefined, version: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/external/sdtask/RestartProcessing?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (externalId !== undefined && externalId !== null)
            url_ += "ExternalId=" + encodeURIComponent("" + externalId) + "&";
        if (taskId !== undefined && taskId !== null)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRestartProcessing(_response);
        });
    }

    protected processRestartProcessing(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    patchExternalIntegrationStatus(externalId: string | null | undefined, taskId: number | null | undefined, version: string, model: PatchExternalIntegrationStatusModel, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/external/sdtask/ExternalIntegrationStatus?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (externalId !== undefined && externalId !== null)
            url_ += "ExternalId=" + encodeURIComponent("" + externalId) + "&";
        if (taskId !== undefined && taskId !== null)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPatchExternalIntegrationStatus(_response);
        });
    }

    protected processPatchExternalIntegrationStatus(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    delete(id: number, version: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/external/sdtask/DeleteTask/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    processTask(version: string, createModel: SdTaskProcessCreateModel, signal?: AbortSignal): Promise<SdTaskProcessCreateViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/external/sdtask/Process";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createModel);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProcessTask(_response);
        });
    }

    protected processProcessTask(response: Response): Promise<SdTaskProcessCreateViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdTaskProcessCreateViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdTaskProcessCreateViewModel>(null as any);
    }
}

export class ExternalSdWorkSpaceClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getWorkSpaceAndTenantId(emailAlias: string | undefined, version: string, signal?: AbortSignal): Promise<WorkspaceIdViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/external/sdworkspace?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (emailAlias === null)
            throw new Error("The parameter 'emailAlias' cannot be null.");
        else if (emailAlias !== undefined)
            url_ += "EmailAlias=" + encodeURIComponent("" + emailAlias) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkSpaceAndTenantId(_response);
        });
    }

    protected processGetWorkSpaceAndTenantId(response: Response): Promise<WorkspaceIdViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkspaceIdViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkspaceIdViewModel>(null as any);
    }

    getCurrentUserWorkspaces(version: string, signal?: AbortSignal): Promise<WorkspaceUserGetSimplifiedViewModel[]> {
        let url_ = this.baseUrl + "/api/v{version}/external/sdworkspace/CurrentWorkspaces";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCurrentUserWorkspaces(_response);
        });
    }

    protected processGetCurrentUserWorkspaces(response: Response): Promise<WorkspaceUserGetSimplifiedViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkspaceUserGetSimplifiedViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkspaceUserGetSimplifiedViewModel[]>(null as any);
    }

    getTenantIdFromWorkspace(workspaceId: number, version: string, signal?: AbortSignal): Promise<WorkspaceIdViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/external/sdworkspace/tenantFromWorkspace/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTenantIdFromWorkspace(_response);
        });
    }

    protected processGetTenantIdFromWorkspace(response: Response): Promise<WorkspaceIdViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkspaceIdViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkspaceIdViewModel>(null as any);
    }

    getWorkspaceCustomConfig(workspaceId: number, version: string, signal?: AbortSignal): Promise<SdWorkspaceCustomConfigModel> {
        let url_ = this.baseUrl + "/api/v{version}/external/sdworkspace/config/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkspaceCustomConfig(_response);
        });
    }

    protected processGetWorkspaceCustomConfig(response: Response): Promise<SdWorkspaceCustomConfigModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdWorkspaceCustomConfigModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdWorkspaceCustomConfigModel>(null as any);
    }

    getDefaultWorkspaceId(version: string, signal?: AbortSignal): Promise<SdWorkspaceDefaultIdViewModel> {
        let url_ = this.baseUrl + "/api/v{version}/external/sdworkspace/DefaultWorkspaceId";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDefaultWorkspaceId(_response);
        });
    }

    protected processGetDefaultWorkspaceId(response: Response): Promise<SdWorkspaceDefaultIdViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SdWorkspaceDefaultIdViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SdWorkspaceDefaultIdViewModel>(null as any);
    }

    getWorkspaceIdByNif(nif: string | null | undefined, version: string, signal?: AbortSignal): Promise<ResultWithCodeOfSdWorkspaceIdViewModelAndWorkspaceIdByNifError> {
        let url_ = this.baseUrl + "/api/v{version}/external/sdworkspace/WorkspaceIdByNif?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (nif !== undefined && nif !== null)
            url_ += "nif=" + encodeURIComponent("" + nif) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkspaceIdByNif(_response);
        });
    }

    protected processGetWorkspaceIdByNif(response: Response): Promise<ResultWithCodeOfSdWorkspaceIdViewModelAndWorkspaceIdByNifError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithCodeOfSdWorkspaceIdViewModelAndWorkspaceIdByNifError.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithCodeOfSdWorkspaceIdViewModelAndWorkspaceIdByNifError>(null as any);
    }

    getAllUsers(workspaceId: number, version: string, signal?: AbortSignal): Promise<ExternalUserViewModel[]> {
        let url_ = this.baseUrl + "/api/v{version}/external/sdworkspace/AllUsers/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllUsers(_response);
        });
    }

    protected processGetAllUsers(response: Response): Promise<ExternalUserViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalUserViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExternalUserViewModel[]>(null as any);
    }

    getSelectOptions(workspaceId: number, categoryKey: string, version: string, signal?: AbortSignal): Promise<SelectProps> {
        let url_ = this.baseUrl + "/api/v{version}/external/sdworkspace/SelectOptions/{workspaceId}/{categoryKey}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (categoryKey === undefined || categoryKey === null)
            throw new Error("The parameter 'categoryKey' must be defined.");
        url_ = url_.replace("{categoryKey}", encodeURIComponent("" + categoryKey));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSelectOptions(_response);
        });
    }

    protected processGetSelectOptions(response: Response): Promise<SelectProps> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectProps.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SelectProps>(null as any);
    }

    inviteUsers(version: string, request: InviteWorkspaceUsersRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v{version}/external/sdworkspace/InviteUsers";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInviteUsers(_response);
        });
    }

    protected processInviteUsers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ExternalSharePointClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getItemByItemPath(serviceName: string, itemPath: string | null | undefined, version: string, signal?: AbortSignal): Promise<DriveItemModel> {
        let url_ = this.baseUrl + "/api/v{version}/external/sharepoint/Items/{serviceName}?";
        if (serviceName === undefined || serviceName === null)
            throw new Error("The parameter 'serviceName' must be defined.");
        url_ = url_.replace("{serviceName}", encodeURIComponent("" + serviceName));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (itemPath !== undefined && itemPath !== null)
            url_ += "itemPath=" + encodeURIComponent("" + itemPath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetItemByItemPath(_response);
        });
    }

    protected processGetItemByItemPath(response: Response): Promise<DriveItemModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DriveItemModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DriveItemModel>(null as any);
    }

    uploadFileFromUrl(version: string, model: UploadFileModel, signal?: AbortSignal): Promise<ResultWithCodeOfDriveItemModelAndSharePointError> {
        let url_ = this.baseUrl + "/api/v{version}/external/sharepoint/UploadFile";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadFileFromUrl(_response);
        });
    }

    protected processUploadFileFromUrl(response: Response): Promise<ResultWithCodeOfDriveItemModelAndSharePointError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithCodeOfDriveItemModelAndSharePointError.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithCodeOfDriveItemModelAndSharePointError>(null as any);
    }
}

export class ExternalStorageClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getItem(serviceName: string | null | undefined, itemPath: string | null | undefined, connectorType: LoadBalancedServiceType | null | undefined, version: string, signal?: AbortSignal): Promise<ResultWithCodeOfStorageItemResolvedModelAndStorageIntegrationError> {
        let url_ = this.baseUrl + "/api/v{version}/external/storage/Item?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (serviceName !== undefined && serviceName !== null)
            url_ += "serviceName=" + encodeURIComponent("" + serviceName) + "&";
        if (itemPath !== undefined && itemPath !== null)
            url_ += "itemPath=" + encodeURIComponent("" + itemPath) + "&";
        if (connectorType !== undefined && connectorType !== null)
            url_ += "connectorType=" + encodeURIComponent("" + connectorType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetItem(_response);
        });
    }

    protected processGetItem(response: Response): Promise<ResultWithCodeOfStorageItemResolvedModelAndStorageIntegrationError> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultWithCodeOfStorageItemResolvedModelAndStorageIntegrationError.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultWithCodeOfStorageItemResolvedModelAndStorageIntegrationError>(null as any);
    }
}

export class ExternalTemplateBuilderClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getFields(workspaceId: number, version: string, signal?: AbortSignal): Promise<TemplateBuilderCustomFieldsModel> {
        let url_ = this.baseUrl + "/api/v{version}/external/templatebuilder/Fields/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFields(_response);
        });
    }

    protected processGetFields(response: Response): Promise<TemplateBuilderCustomFieldsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemplateBuilderCustomFieldsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateBuilderCustomFieldsModel>(null as any);
    }

    getTasksToTrain(workspaceId: number, version: string, signal?: AbortSignal): Promise<TaskToTrainModel[]> {
        let url_ = this.baseUrl + "/api/v{version}/external/templatebuilder/TasksToTrain/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTasksToTrain(_response);
        });
    }

    protected processGetTasksToTrain(response: Response): Promise<TaskToTrainModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskToTrainModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskToTrainModel[]>(null as any);
    }
}

export class ExternalTenantClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    inviteUsers(version: string, request: InviteUsersRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v{version}/external/tenant/InviteUsers";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInviteUsers(_response);
        });
    }

    protected processInviteUsers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAllUsers(version: string, signal?: AbortSignal): Promise<ExternalUserViewModel[]> {
        let url_ = this.baseUrl + "/api/v{version}/external/tenant/AllUsers";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllUsers(_response);
        });
    }

    protected processGetAllUsers(response: Response): Promise<ExternalUserViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalUserViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExternalUserViewModel[]>(null as any);
    }

    getAvailableRoles(version: string, signal?: AbortSignal): Promise<AvailableRoleViewModel[]> {
        let url_ = this.baseUrl + "/api/v{version}/external/tenant/AvailableRoles";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAvailableRoles(_response);
        });
    }

    protected processGetAvailableRoles(response: Response): Promise<AvailableRoleViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AvailableRoleViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AvailableRoleViewModel[]>(null as any);
    }
}

export class ExternalTranscriptClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getTaskSpeakers(taskId: number, workspaceId: number, version: string, signal?: AbortSignal): Promise<ExternalTaskSpeakers> {
        let url_ = this.baseUrl + "/api/v{version}/external/transcripts/speakers/tasks/{taskId}/{workspaceId}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTaskSpeakers(_response);
        });
    }

    protected processGetTaskSpeakers(response: Response): Promise<ExternalTaskSpeakers> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalTaskSpeakers.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExternalTaskSpeakers>(null as any);
    }

    postTaskSpeakers(taskId: number, workspaceId: number, version: string, model: ExternalTaskSpeakerModel, signal?: AbortSignal): Promise<ExternalTaskSpeakerModel> {
        let url_ = this.baseUrl + "/api/v{version}/external/transcripts/speakers/tasks/{taskId}/{workspaceId}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostTaskSpeakers(_response);
        });
    }

    protected processPostTaskSpeakers(response: Response): Promise<ExternalTaskSpeakerModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalTaskSpeakerModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExternalTaskSpeakerModel>(null as any);
    }

    putTaskSpeakers(taskId: number, workspaceId: number, version: string, model: ExternalTaskSpeakerModel, signal?: AbortSignal): Promise<ExternalTaskSpeakerModel> {
        let url_ = this.baseUrl + "/api/v{version}/external/transcripts/speakers/tasks/{taskId}/{workspaceId}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPutTaskSpeakers(_response);
        });
    }

    protected processPutTaskSpeakers(response: Response): Promise<ExternalTaskSpeakerModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalTaskSpeakerModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExternalTaskSpeakerModel>(null as any);
    }

    deleteTaskSpeakers(taskId: number, workspaceId: number, speakerId: string, version: string, signal?: AbortSignal): Promise<ExternalTaskSpeakerModel> {
        let url_ = this.baseUrl + "/api/v{version}/external/transcripts/speakers/tasks/{taskId}/{workspaceId}/{speakerId}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (speakerId === undefined || speakerId === null)
            throw new Error("The parameter 'speakerId' must be defined.");
        url_ = url_.replace("{speakerId}", encodeURIComponent("" + speakerId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteTaskSpeakers(_response);
        });
    }

    protected processDeleteTaskSpeakers(response: Response): Promise<ExternalTaskSpeakerModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalTaskSpeakerModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExternalTaskSpeakerModel>(null as any);
    }

    getWorkspaceSpeakers(workspaceId: number, version: string, signal?: AbortSignal): Promise<ExternalWorkspaceSpeakers> {
        let url_ = this.baseUrl + "/api/v{version}/external/transcripts/speakers/workspaces/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkspaceSpeakers(_response);
        });
    }

    protected processGetWorkspaceSpeakers(response: Response): Promise<ExternalWorkspaceSpeakers> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalWorkspaceSpeakers.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExternalWorkspaceSpeakers>(null as any);
    }

    putWorkspaceSpeakers(workspaceId: number, version: string, model: ExternalWorkspaceSpeakers, signal?: AbortSignal): Promise<ExternalWorkspaceSpeakers> {
        let url_ = this.baseUrl + "/api/v{version}/external/transcripts/speakers/workspaces/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPutWorkspaceSpeakers(_response);
        });
    }

    protected processPutWorkspaceSpeakers(response: Response): Promise<ExternalWorkspaceSpeakers> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalWorkspaceSpeakers.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExternalWorkspaceSpeakers>(null as any);
    }
}

export class ExternalUserClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    currentUserWithAbilities(version: string, signal?: AbortSignal): Promise<CurrentUserWithAbilities> {
        let url_ = this.baseUrl + "/api/v{version}/external/user/CurrentUserWithAbilities";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCurrentUserWithAbilities(_response);
        });
    }

    protected processCurrentUserWithAbilities(response: Response): Promise<CurrentUserWithAbilities> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrentUserWithAbilities.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CurrentUserWithAbilities>(null as any);
    }
}

export class ChatbotAnswer implements IChatbotAnswer {
    messages!: string;
    thread_id!: string;

    constructor(data?: IChatbotAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"];
            this.thread_id = _data["thread_id"];
        }
    }

    static fromJS(data: any): ChatbotAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new ChatbotAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages;
        data["thread_id"] = this.thread_id;
        return data;
    }
}

export interface IChatbotAnswer {
    messages: string;
    thread_id: string;
}

export class GetAnswerChatbotModel implements IGetAnswerChatbotModel {
    workspace_id!: number;
    query!: string;
    thread_id!: string;

    constructor(data?: IGetAnswerChatbotModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workspace_id = _data["workspace_id"];
            this.query = _data["query"];
            this.thread_id = _data["thread_id"];
        }
    }

    static fromJS(data: any): GetAnswerChatbotModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAnswerChatbotModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workspace_id"] = this.workspace_id;
        data["query"] = this.query;
        data["thread_id"] = this.thread_id;
        return data;
    }
}

export interface IGetAnswerChatbotModel {
    workspace_id: number;
    query: string;
    thread_id: string;
}

export class ResultWithCodeOfSdTaskPageAndOcrFullViewModelAndBlobError implements IResultWithCodeOfSdTaskPageAndOcrFullViewModelAndBlobError {
    succeeded!: boolean;
    result!: SdTaskPageAndOcrFullViewModel | undefined;
    errors!: ErrorWithCodeOfBlobError[];

    constructor(data?: IResultWithCodeOfSdTaskPageAndOcrFullViewModelAndBlobError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.result = _data["result"] ? SdTaskPageAndOcrFullViewModel.fromJS(_data["result"]) : <any>undefined;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorWithCodeOfBlobError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultWithCodeOfSdTaskPageAndOcrFullViewModelAndBlobError {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithCodeOfSdTaskPageAndOcrFullViewModelAndBlobError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResultWithCodeOfSdTaskPageAndOcrFullViewModelAndBlobError {
    succeeded: boolean;
    result: SdTaskPageAndOcrFullViewModel | undefined;
    errors: ErrorWithCodeOfBlobError[];
}

export class SdTaskPageAndOcrFullViewModel implements ISdTaskPageAndOcrFullViewModel {
    urlResult!: ResultWithCodeOfStringAndBlobError;
    ocrFullResult!: ResultWithCodeOfOcrFullViewModelAndBlobError;

    constructor(data?: ISdTaskPageAndOcrFullViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.urlResult = _data["urlResult"] ? ResultWithCodeOfStringAndBlobError.fromJS(_data["urlResult"]) : <any>undefined;
            this.ocrFullResult = _data["ocrFullResult"] ? ResultWithCodeOfOcrFullViewModelAndBlobError.fromJS(_data["ocrFullResult"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SdTaskPageAndOcrFullViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdTaskPageAndOcrFullViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["urlResult"] = this.urlResult ? this.urlResult.toJSON() : <any>undefined;
        data["ocrFullResult"] = this.ocrFullResult ? this.ocrFullResult.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISdTaskPageAndOcrFullViewModel {
    urlResult: ResultWithCodeOfStringAndBlobError;
    ocrFullResult: ResultWithCodeOfOcrFullViewModelAndBlobError;
}

export class ResultWithCodeOfStringAndBlobError implements IResultWithCodeOfStringAndBlobError {
    succeeded!: boolean;
    result!: string | undefined;
    errors!: ErrorWithCodeOfBlobError[];

    constructor(data?: IResultWithCodeOfStringAndBlobError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.result = _data["result"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorWithCodeOfBlobError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultWithCodeOfStringAndBlobError {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithCodeOfStringAndBlobError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["result"] = this.result;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResultWithCodeOfStringAndBlobError {
    succeeded: boolean;
    result: string | undefined;
    errors: ErrorWithCodeOfBlobError[];
}

export class ErrorWithCodeOfBlobError implements IErrorWithCodeOfBlobError {
    code!: BlobError;
    error!: string;

    constructor(data?: IErrorWithCodeOfBlobError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): ErrorWithCodeOfBlobError {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorWithCodeOfBlobError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["error"] = this.error;
        return data;
    }
}

export interface IErrorWithCodeOfBlobError {
    code: BlobError;
    error: string;
}

export enum BlobError {
    CouldNotCreateClient = 1,
    BlobDoesNotExist = 2,
    CouldNotDownload = 3,
    CouldNotDeserialize = 4,
    CouldNotBase64Decode = 5,
    CouldNotGzipInflate = 6,
    CouldNotGenerateSasToken = 7,
    CouldNotUpload = 8,
    ParentNotFound = 9,
    NoStorageConfig = 10,
    WorkspacesDontMatch = 11,
    FailedValidation = 12,
    CouldNotSetTier = 13,
    CouldNotDelete = 14,
    BasePathDoesNotExists = 15,
}

export class ResultWithCodeOfOcrFullViewModelAndBlobError implements IResultWithCodeOfOcrFullViewModelAndBlobError {
    succeeded!: boolean;
    result!: OcrFullViewModel | undefined;
    errors!: ErrorWithCodeOfBlobError[];

    constructor(data?: IResultWithCodeOfOcrFullViewModelAndBlobError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.result = _data["result"] ? OcrFullViewModel.fromJS(_data["result"]) : <any>undefined;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorWithCodeOfBlobError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultWithCodeOfOcrFullViewModelAndBlobError {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithCodeOfOcrFullViewModelAndBlobError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResultWithCodeOfOcrFullViewModelAndBlobError {
    succeeded: boolean;
    result: OcrFullViewModel | undefined;
    errors: ErrorWithCodeOfBlobError[];
}

export class OcrFullViewModel implements IOcrFullViewModel {
    entities!: OcrFullEntityWord[];
    pageSize!: OcrFullPageSize;
    pageOrientation!: string;
    status!: string;
    errorCode!: number;
    errorMessage!: string;
    elapsedTime!: number;
    ocrEngine!: string;
    ocrEngineConfig!: OcrFullModelConfiguration;
    version!: string;

    constructor(data?: IOcrFullViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(OcrFullEntityWord.fromJS(item));
            }
            this.pageSize = _data["pageSize"] ? OcrFullPageSize.fromJS(_data["pageSize"]) : <any>undefined;
            this.pageOrientation = _data["pageOrientation"];
            this.status = _data["status"];
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.elapsedTime = _data["elapsedTime"];
            this.ocrEngine = _data["ocrEngine"];
            this.ocrEngineConfig = _data["ocrEngineConfig"] ? OcrFullModelConfiguration.fromJS(_data["ocrEngineConfig"]) : <any>undefined;
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): OcrFullViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OcrFullViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        data["pageSize"] = this.pageSize ? this.pageSize.toJSON() : <any>undefined;
        data["pageOrientation"] = this.pageOrientation;
        data["status"] = this.status;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["elapsedTime"] = this.elapsedTime;
        data["ocrEngine"] = this.ocrEngine;
        data["ocrEngineConfig"] = this.ocrEngineConfig ? this.ocrEngineConfig.toJSON() : <any>undefined;
        data["version"] = this.version;
        return data;
    }
}

export interface IOcrFullViewModel {
    entities: OcrFullEntityWord[];
    pageSize: OcrFullPageSize;
    pageOrientation: string;
    status: string;
    errorCode: number;
    errorMessage: string;
    elapsedTime: number;
    ocrEngine: string;
    ocrEngineConfig: OcrFullModelConfiguration;
    version: string;
}

export class OcrFullEntityBase implements IOcrFullEntityBase {
    bbox!: number[];
    bBoxObj!: BBoxObject;
    points!: DocumentPointModel[];
    text!: string;
    confidence!: number;

    constructor(data?: IOcrFullEntityBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["bbox"])) {
                this.bbox = [] as any;
                for (let item of _data["bbox"])
                    this.bbox!.push(item);
            }
            this.bBoxObj = _data["bBoxObj"] ? BBoxObject.fromJS(_data["bBoxObj"]) : <any>undefined;
            if (Array.isArray(_data["points"])) {
                this.points = [] as any;
                for (let item of _data["points"])
                    this.points!.push(DocumentPointModel.fromJS(item));
            }
            this.text = _data["text"];
            this.confidence = _data["confidence"];
        }
    }

    static fromJS(data: any): OcrFullEntityBase {
        data = typeof data === 'object' ? data : {};
        let result = new OcrFullEntityBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bbox)) {
            data["bbox"] = [];
            for (let item of this.bbox)
                data["bbox"].push(item);
        }
        data["bBoxObj"] = this.bBoxObj ? this.bBoxObj.toJSON() : <any>undefined;
        if (Array.isArray(this.points)) {
            data["points"] = [];
            for (let item of this.points)
                data["points"].push(item.toJSON());
        }
        data["text"] = this.text;
        data["confidence"] = this.confidence;
        return data;
    }
}

export interface IOcrFullEntityBase {
    bbox: number[];
    bBoxObj: BBoxObject;
    points: DocumentPointModel[];
    text: string;
    confidence: number;
}

export class OcrFullEntityWord extends OcrFullEntityBase implements IOcrFullEntityWord {
    chars!: OcrFullEntityBase[];

    constructor(data?: IOcrFullEntityWord) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["chars"])) {
                this.chars = [] as any;
                for (let item of _data["chars"])
                    this.chars!.push(OcrFullEntityBase.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OcrFullEntityWord {
        data = typeof data === 'object' ? data : {};
        let result = new OcrFullEntityWord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.chars)) {
            data["chars"] = [];
            for (let item of this.chars)
                data["chars"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IOcrFullEntityWord extends IOcrFullEntityBase {
    chars: OcrFullEntityBase[];
}

export class BBoxObject implements IBBoxObject {
    x!: number;
    y!: number;
    width!: number;
    height!: number;

    constructor(data?: IBBoxObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"];
            this.y = _data["y"];
            this.width = _data["width"];
            this.height = _data["height"];
        }
    }

    static fromJS(data: any): BBoxObject {
        data = typeof data === 'object' ? data : {};
        let result = new BBoxObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data;
    }
}

export interface IBBoxObject {
    x: number;
    y: number;
    width: number;
    height: number;
}

export class DocumentPointModel implements IDocumentPointModel {
    x!: number;
    y!: number;

    constructor(data?: IDocumentPointModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"];
            this.y = _data["y"];
        }
    }

    static fromJS(data: any): DocumentPointModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentPointModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        return data;
    }
}

export interface IDocumentPointModel {
    x: number;
    y: number;
}

export class OcrFullPageSize implements IOcrFullPageSize {
    width!: number;
    height!: number;
    unit!: string;
    angle!: number | undefined;

    constructor(data?: IOcrFullPageSize) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.width = _data["width"];
            this.height = _data["height"];
            this.unit = _data["unit"];
            this.angle = _data["angle"];
        }
    }

    static fromJS(data: any): OcrFullPageSize {
        data = typeof data === 'object' ? data : {};
        let result = new OcrFullPageSize();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["width"] = this.width;
        data["height"] = this.height;
        data["unit"] = this.unit;
        data["angle"] = this.angle;
        return data;
    }
}

export interface IOcrFullPageSize {
    width: number;
    height: number;
    unit: string;
    angle: number | undefined;
}

export class OcrFullModelConfiguration implements IOcrFullModelConfiguration {
    useWordDetection!: boolean;
    useCharDetection!: boolean;
    name!: string;
    containsRectOffsets!: OcrFullModelOffsets;
    containsPointOffsets!: OcrFullModelOffsets;

    constructor(data?: IOcrFullModelConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.useWordDetection = _data["useWordDetection"];
            this.useCharDetection = _data["useCharDetection"];
            this.name = _data["name"];
            this.containsRectOffsets = _data["containsRectOffsets"] ? OcrFullModelOffsets.fromJS(_data["containsRectOffsets"]) : <any>undefined;
            this.containsPointOffsets = _data["containsPointOffsets"] ? OcrFullModelOffsets.fromJS(_data["containsPointOffsets"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OcrFullModelConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new OcrFullModelConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["useWordDetection"] = this.useWordDetection;
        data["useCharDetection"] = this.useCharDetection;
        data["name"] = this.name;
        data["containsRectOffsets"] = this.containsRectOffsets ? this.containsRectOffsets.toJSON() : <any>undefined;
        data["containsPointOffsets"] = this.containsPointOffsets ? this.containsPointOffsets.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOcrFullModelConfiguration {
    useWordDetection: boolean;
    useCharDetection: boolean;
    name: string;
    containsRectOffsets: OcrFullModelOffsets;
    containsPointOffsets: OcrFullModelOffsets;
}

export class OcrFullModelOffsets implements IOcrFullModelOffsets {
    xLeftOffset!: number;
    xRightOffset!: number;
    yTopOffset!: number;
    yBottomOffset!: number;

    constructor(data?: IOcrFullModelOffsets) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.xLeftOffset = _data["xLeftOffset"];
            this.xRightOffset = _data["xRightOffset"];
            this.yTopOffset = _data["yTopOffset"];
            this.yBottomOffset = _data["yBottomOffset"];
        }
    }

    static fromJS(data: any): OcrFullModelOffsets {
        data = typeof data === 'object' ? data : {};
        let result = new OcrFullModelOffsets();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["xLeftOffset"] = this.xLeftOffset;
        data["xRightOffset"] = this.xRightOffset;
        data["yTopOffset"] = this.yTopOffset;
        data["yBottomOffset"] = this.yBottomOffset;
        return data;
    }
}

export interface IOcrFullModelOffsets {
    xLeftOffset: number;
    xRightOffset: number;
    yTopOffset: number;
    yBottomOffset: number;
}

export class ResultWithCodeOfDocumentModelAndBlobError implements IResultWithCodeOfDocumentModelAndBlobError {
    succeeded!: boolean;
    result!: DocumentModel | undefined;
    errors!: ErrorWithCodeOfBlobError[];

    constructor(data?: IResultWithCodeOfDocumentModelAndBlobError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.result = _data["result"] ? DocumentModel.fromJS(_data["result"]) : <any>undefined;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorWithCodeOfBlobError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultWithCodeOfDocumentModelAndBlobError {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithCodeOfDocumentModelAndBlobError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResultWithCodeOfDocumentModelAndBlobError {
    succeeded: boolean;
    result: DocumentModel | undefined;
    errors: ErrorWithCodeOfBlobError[];
}

export class DocumentExportModel implements IDocumentExportModel {
    entities!: DocumentEntityExportModel[];
    version!: string;
    retrievedOn!: Date | undefined;
    lastModifiedBy!: number | undefined;
    lastModifiedByExternal!: string | undefined;
    lastModifiedOn!: Date | undefined;
    averageConfidence!: number;

    constructor(data?: IDocumentExportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(DocumentEntityExportModel.fromJS(item));
            }
            this.version = _data["version"];
            this.retrievedOn = _data["retrievedOn"] ? new Date(_data["retrievedOn"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedByExternal = _data["lastModifiedByExternal"];
            this.lastModifiedOn = _data["lastModifiedOn"] ? new Date(_data["lastModifiedOn"].toString()) : <any>undefined;
            this.averageConfidence = _data["averageConfidence"];
        }
    }

    static fromJS(data: any): DocumentExportModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentExportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        data["version"] = this.version;
        data["retrievedOn"] = this.retrievedOn ? this.retrievedOn.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedByExternal"] = this.lastModifiedByExternal;
        data["lastModifiedOn"] = this.lastModifiedOn ? this.lastModifiedOn.toISOString() : <any>undefined;
        data["averageConfidence"] = this.averageConfidence;
        return data;
    }
}

export interface IDocumentExportModel {
    entities: DocumentEntityExportModel[];
    version: string;
    retrievedOn: Date | undefined;
    lastModifiedBy: number | undefined;
    lastModifiedByExternal: string | undefined;
    lastModifiedOn: Date | undefined;
    averageConfidence: number;
}

export class DocumentModel extends DocumentExportModel implements IDocumentModel {
    asset!: DocumentAssetModel;
    documentConfidence!: number;
    entities!: DocumentEntityModel[];
    tables!: DocumentTableModel[] | undefined;
    averageConfidence!: number;

    constructor(data?: IDocumentModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.asset = _data["asset"] ? DocumentAssetModel.fromJS(_data["asset"]) : <any>undefined;
            this.documentConfidence = _data["documentConfidence"];
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(DocumentEntityModel.fromJS(item));
            }
            if (Array.isArray(_data["tables"])) {
                this.tables = [] as any;
                for (let item of _data["tables"])
                    this.tables!.push(DocumentTableModel.fromJS(item));
            }
            this.averageConfidence = _data["averageConfidence"];
        }
    }

    static fromJS(data: any): DocumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["asset"] = this.asset ? this.asset.toJSON() : <any>undefined;
        data["documentConfidence"] = this.documentConfidence;
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        if (Array.isArray(this.tables)) {
            data["tables"] = [];
            for (let item of this.tables)
                data["tables"].push(item.toJSON());
        }
        data["averageConfidence"] = this.averageConfidence;
        super.toJSON(data);
        return data;
    }
}

export interface IDocumentModel extends IDocumentExportModel {
    asset: DocumentAssetModel;
    documentConfidence: number;
    entities: DocumentEntityModel[];
    tables: DocumentTableModel[] | undefined;
    averageConfidence: number;
}

export class DocumentAssetModel implements IDocumentAssetModel {
    format!: string;
    id!: string;
    path!: string;
    type!: string;

    constructor(data?: IDocumentAssetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.format = _data["format"];
            this.id = _data["id"];
            this.path = _data["path"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): DocumentAssetModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentAssetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["format"] = this.format;
        data["id"] = this.id;
        data["path"] = this.path;
        data["type"] = this.type;
        return data;
    }
}

export interface IDocumentAssetModel {
    format: string;
    id: string;
    path: string;
    type: string;
}

export class DocumentEntityExportModel implements IDocumentEntityExportModel {
    type!: string;
    category!: string;
    groupName!: string | undefined;
    pageNumber!: number;
    chunkNumber!: number;
    customFormValues!: any | undefined;
    qrCode!: DocumentQrCodeModel | undefined;
    table!: DocumentTableModel | undefined;
    templateBuilderField!: DocumentTemplateBuilderFieldModel | undefined;
    keyValues!: DocumentKeyValueExportModel[] | undefined;
    addedOn!: Date | undefined;
    addedBy!: number | undefined;
    addedByExternal!: string | undefined;
    editedOn!: Date | undefined;
    viewerEditedOn!: Date | undefined;
    editedBy!: number | undefined;
    editedByExternal!: string | undefined;
    integratedOn!: Date | undefined;
    integratedBy!: number | undefined;
    integratedByExternal!: string | undefined;
    integrationFailedReason!: string | undefined;
    integrationFailedReasonDetailed!: string | undefined;
    markedAsSolved!: boolean | undefined;
    notDetected!: boolean | undefined;
    contentUnderstandingDetected!: boolean | undefined;
    confidence!: number;

    constructor(data?: IDocumentEntityExportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.category = _data["category"];
            this.groupName = _data["groupName"];
            this.pageNumber = _data["pageNumber"];
            this.chunkNumber = _data["chunkNumber"];
            this.customFormValues = _data["customFormValues"];
            this.qrCode = _data["qrCode"] ? DocumentQrCodeModel.fromJS(_data["qrCode"]) : <any>undefined;
            this.table = _data["table"] ? DocumentTableModel.fromJS(_data["table"]) : <any>undefined;
            this.templateBuilderField = _data["templateBuilderField"] ? DocumentTemplateBuilderFieldModel.fromJS(_data["templateBuilderField"]) : <any>undefined;
            if (Array.isArray(_data["keyValues"])) {
                this.keyValues = [] as any;
                for (let item of _data["keyValues"])
                    this.keyValues!.push(DocumentKeyValueExportModel.fromJS(item));
            }
            this.addedOn = _data["addedOn"] ? new Date(_data["addedOn"].toString()) : <any>undefined;
            this.addedBy = _data["addedBy"];
            this.addedByExternal = _data["addedByExternal"];
            this.editedOn = _data["editedOn"] ? new Date(_data["editedOn"].toString()) : <any>undefined;
            this.viewerEditedOn = _data["viewerEditedOn"] ? new Date(_data["viewerEditedOn"].toString()) : <any>undefined;
            this.editedBy = _data["editedBy"];
            this.editedByExternal = _data["editedByExternal"];
            this.integratedOn = _data["integratedOn"] ? new Date(_data["integratedOn"].toString()) : <any>undefined;
            this.integratedBy = _data["integratedBy"];
            this.integratedByExternal = _data["integratedByExternal"];
            this.integrationFailedReason = _data["integrationFailedReason"];
            this.integrationFailedReasonDetailed = _data["integrationFailedReasonDetailed"];
            this.markedAsSolved = _data["markedAsSolved"];
            this.notDetected = _data["notDetected"];
            this.contentUnderstandingDetected = _data["contentUnderstandingDetected"];
            this.confidence = _data["confidence"];
        }
    }

    static fromJS(data: any): DocumentEntityExportModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentEntityExportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["category"] = this.category;
        data["groupName"] = this.groupName;
        data["pageNumber"] = this.pageNumber;
        data["chunkNumber"] = this.chunkNumber;
        data["customFormValues"] = this.customFormValues;
        data["qrCode"] = this.qrCode ? this.qrCode.toJSON() : <any>undefined;
        data["table"] = this.table ? this.table.toJSON() : <any>undefined;
        data["templateBuilderField"] = this.templateBuilderField ? this.templateBuilderField.toJSON() : <any>undefined;
        if (Array.isArray(this.keyValues)) {
            data["keyValues"] = [];
            for (let item of this.keyValues)
                data["keyValues"].push(item.toJSON());
        }
        data["addedOn"] = this.addedOn ? this.addedOn.toISOString() : <any>undefined;
        data["addedBy"] = this.addedBy;
        data["addedByExternal"] = this.addedByExternal;
        data["editedOn"] = this.editedOn ? this.editedOn.toISOString() : <any>undefined;
        data["viewerEditedOn"] = this.viewerEditedOn ? this.viewerEditedOn.toISOString() : <any>undefined;
        data["editedBy"] = this.editedBy;
        data["editedByExternal"] = this.editedByExternal;
        data["integratedOn"] = this.integratedOn ? this.integratedOn.toISOString() : <any>undefined;
        data["integratedBy"] = this.integratedBy;
        data["integratedByExternal"] = this.integratedByExternal;
        data["integrationFailedReason"] = this.integrationFailedReason;
        data["integrationFailedReasonDetailed"] = this.integrationFailedReasonDetailed;
        data["markedAsSolved"] = this.markedAsSolved;
        data["notDetected"] = this.notDetected;
        data["contentUnderstandingDetected"] = this.contentUnderstandingDetected;
        data["confidence"] = this.confidence;
        return data;
    }
}

export interface IDocumentEntityExportModel {
    type: string;
    category: string;
    groupName: string | undefined;
    pageNumber: number;
    chunkNumber: number;
    customFormValues: any | undefined;
    qrCode: DocumentQrCodeModel | undefined;
    table: DocumentTableModel | undefined;
    templateBuilderField: DocumentTemplateBuilderFieldModel | undefined;
    keyValues: DocumentKeyValueExportModel[] | undefined;
    addedOn: Date | undefined;
    addedBy: number | undefined;
    addedByExternal: string | undefined;
    editedOn: Date | undefined;
    viewerEditedOn: Date | undefined;
    editedBy: number | undefined;
    editedByExternal: string | undefined;
    integratedOn: Date | undefined;
    integratedBy: number | undefined;
    integratedByExternal: string | undefined;
    integrationFailedReason: string | undefined;
    integrationFailedReasonDetailed: string | undefined;
    markedAsSolved: boolean | undefined;
    notDetected: boolean | undefined;
    contentUnderstandingDetected: boolean | undefined;
    confidence: number;
}

export class DocumentEntityModel extends DocumentEntityExportModel implements IDocumentEntityModel {
    temporaryId!: string;
    keyValues!: DocumentKeyValueModel[] | undefined;

    constructor(data?: IDocumentEntityModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.temporaryId = _data["temporaryId"];
            if (Array.isArray(_data["keyValues"])) {
                this.keyValues = [] as any;
                for (let item of _data["keyValues"])
                    this.keyValues!.push(DocumentKeyValueModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentEntityModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentEntityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["temporaryId"] = this.temporaryId;
        if (Array.isArray(this.keyValues)) {
            data["keyValues"] = [];
            for (let item of this.keyValues)
                data["keyValues"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDocumentEntityModel extends IDocumentEntityExportModel {
    temporaryId: string;
    keyValues: DocumentKeyValueModel[] | undefined;
}

export class DocumentEntityElementModel implements IDocumentEntityElementModel {
    boundingBox!: DocumentBboxModel | undefined;
    points!: DocumentPointModel[] | undefined;
    confidence!: number;
    spans!: DocumentSpanModel[] | undefined;

    constructor(data?: IDocumentEntityElementModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boundingBox = _data["boundingBox"] ? DocumentBboxModel.fromJS(_data["boundingBox"]) : <any>undefined;
            if (Array.isArray(_data["points"])) {
                this.points = [] as any;
                for (let item of _data["points"])
                    this.points!.push(DocumentPointModel.fromJS(item));
            }
            this.confidence = _data["confidence"];
            if (Array.isArray(_data["spans"])) {
                this.spans = [] as any;
                for (let item of _data["spans"])
                    this.spans!.push(DocumentSpanModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentEntityElementModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentEntityElementModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boundingBox"] = this.boundingBox ? this.boundingBox.toJSON() : <any>undefined;
        if (Array.isArray(this.points)) {
            data["points"] = [];
            for (let item of this.points)
                data["points"].push(item.toJSON());
        }
        data["confidence"] = this.confidence;
        if (Array.isArray(this.spans)) {
            data["spans"] = [];
            for (let item of this.spans)
                data["spans"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDocumentEntityElementModel {
    boundingBox: DocumentBboxModel | undefined;
    points: DocumentPointModel[] | undefined;
    confidence: number;
    spans: DocumentSpanModel[] | undefined;
}

export class DocumentKeyValueExportModel extends DocumentEntityElementModel implements IDocumentKeyValueExportModel {
    pageNumber!: number | undefined;
    category!: string;
    categoryNormalized!: string | undefined;
    content!: string;
    contentNormalized!: string;

    constructor(data?: IDocumentKeyValueExportModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.category = _data["category"];
            this.categoryNormalized = _data["categoryNormalized"];
            this.content = _data["content"];
            this.contentNormalized = _data["contentNormalized"];
        }
    }

    static fromJS(data: any): DocumentKeyValueExportModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentKeyValueExportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["category"] = this.category;
        data["categoryNormalized"] = this.categoryNormalized;
        data["content"] = this.content;
        data["contentNormalized"] = this.contentNormalized;
        super.toJSON(data);
        return data;
    }
}

export interface IDocumentKeyValueExportModel extends IDocumentEntityElementModel {
    pageNumber: number | undefined;
    category: string;
    categoryNormalized: string | undefined;
    content: string;
    contentNormalized: string;
}

export class DocumentKeyValueModel extends DocumentKeyValueExportModel implements IDocumentKeyValueModel {
    childTemporaryId!: string;

    constructor(data?: IDocumentKeyValueModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.childTemporaryId = _data["childTemporaryId"];
        }
    }

    static fromJS(data: any): DocumentKeyValueModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentKeyValueModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["childTemporaryId"] = this.childTemporaryId;
        super.toJSON(data);
        return data;
    }
}

export interface IDocumentKeyValueModel extends IDocumentKeyValueExportModel {
    childTemporaryId: string;
}

export class DocumentBboxModel implements IDocumentBboxModel {
    height!: number;
    width!: number;
    left!: number;
    bottom!: number;
    x!: number;
    y!: number;
    right!: number;
    top!: number;

    constructor(data?: IDocumentBboxModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.height = _data["height"];
            this.width = _data["width"];
            this.left = _data["left"];
            this.bottom = _data["bottom"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.right = _data["right"];
            this.top = _data["top"];
        }
    }

    static fromJS(data: any): DocumentBboxModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentBboxModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["height"] = this.height;
        data["width"] = this.width;
        data["left"] = this.left;
        data["bottom"] = this.bottom;
        data["x"] = this.x;
        data["y"] = this.y;
        data["right"] = this.right;
        data["top"] = this.top;
        return data;
    }
}

export interface IDocumentBboxModel {
    height: number;
    width: number;
    left: number;
    bottom: number;
    x: number;
    y: number;
    right: number;
    top: number;
}

export class DocumentSpanModel implements IDocumentSpanModel {
    offset!: number;
    length!: number;

    constructor(data?: IDocumentSpanModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offset = _data["offset"];
            this.length = _data["length"];
        }
    }

    static fromJS(data: any): DocumentSpanModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentSpanModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offset"] = this.offset;
        data["length"] = this.length;
        return data;
    }
}

export interface IDocumentSpanModel {
    offset: number;
    length: number;
}

export class DocumentQrCodeModel extends DocumentEntityElementModel implements IDocumentQrCodeModel {
    keyValues!: DocumentKeyValueModel[] | undefined;
    qrCodeContent!: string | undefined;
    invalidKeysCount!: number | undefined;
    duplicatedKeys!: string[] | undefined;

    constructor(data?: IDocumentQrCodeModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["keyValues"])) {
                this.keyValues = [] as any;
                for (let item of _data["keyValues"])
                    this.keyValues!.push(DocumentKeyValueModel.fromJS(item));
            }
            this.qrCodeContent = _data["qrCodeContent"];
            this.invalidKeysCount = _data["invalidKeysCount"];
            if (Array.isArray(_data["duplicatedKeys"])) {
                this.duplicatedKeys = [] as any;
                for (let item of _data["duplicatedKeys"])
                    this.duplicatedKeys!.push(item);
            }
        }
    }

    static fromJS(data: any): DocumentQrCodeModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentQrCodeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.keyValues)) {
            data["keyValues"] = [];
            for (let item of this.keyValues)
                data["keyValues"].push(item.toJSON());
        }
        data["qrCodeContent"] = this.qrCodeContent;
        data["invalidKeysCount"] = this.invalidKeysCount;
        if (Array.isArray(this.duplicatedKeys)) {
            data["duplicatedKeys"] = [];
            for (let item of this.duplicatedKeys)
                data["duplicatedKeys"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDocumentQrCodeModel extends IDocumentEntityElementModel {
    keyValues: DocumentKeyValueModel[] | undefined;
    qrCodeContent: string | undefined;
    invalidKeysCount: number | undefined;
    duplicatedKeys: string[] | undefined;
}

export class DocumentTableModel extends DocumentEntityElementModel implements IDocumentTableModel {
    rowCount!: number;
    columnCount!: number;
    tableHeaders!: DocumentTableHeaderModel[];
    tableRows!: { [key: string]: DocumentTableCellModel[]; };
    boundsAndPoints!: DocumentTableMultiPage[];
    tableRowsTableContent!: { [key: string]: string; } | undefined;
    hasAlternativeHeaders!: boolean | undefined;

    constructor(data?: IDocumentTableModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rowCount = _data["rowCount"];
            this.columnCount = _data["columnCount"];
            if (Array.isArray(_data["tableHeaders"])) {
                this.tableHeaders = [] as any;
                for (let item of _data["tableHeaders"])
                    this.tableHeaders!.push(DocumentTableHeaderModel.fromJS(item));
            }
            if (_data["tableRows"]) {
                this.tableRows = {} as any;
                for (let key in _data["tableRows"]) {
                    if (_data["tableRows"].hasOwnProperty(key))
                        (<any>this.tableRows)![key] = _data["tableRows"][key] ? _data["tableRows"][key].map((i: any) => DocumentTableCellModel.fromJS(i)) : [];
                }
            }
            if (Array.isArray(_data["boundsAndPoints"])) {
                this.boundsAndPoints = [] as any;
                for (let item of _data["boundsAndPoints"])
                    this.boundsAndPoints!.push(DocumentTableMultiPage.fromJS(item));
            }
            if (_data["tableRowsTableContent"]) {
                this.tableRowsTableContent = {} as any;
                for (let key in _data["tableRowsTableContent"]) {
                    if (_data["tableRowsTableContent"].hasOwnProperty(key))
                        (<any>this.tableRowsTableContent)![key] = _data["tableRowsTableContent"][key];
                }
            }
            this.hasAlternativeHeaders = _data["hasAlternativeHeaders"];
        }
    }

    static fromJS(data: any): DocumentTableModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTableModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowCount"] = this.rowCount;
        data["columnCount"] = this.columnCount;
        if (Array.isArray(this.tableHeaders)) {
            data["tableHeaders"] = [];
            for (let item of this.tableHeaders)
                data["tableHeaders"].push(item.toJSON());
        }
        if (this.tableRows) {
            data["tableRows"] = {};
            for (let key in this.tableRows) {
                if (this.tableRows.hasOwnProperty(key))
                    (<any>data["tableRows"])[key] = (<any>this.tableRows)[key];
            }
        }
        if (Array.isArray(this.boundsAndPoints)) {
            data["boundsAndPoints"] = [];
            for (let item of this.boundsAndPoints)
                data["boundsAndPoints"].push(item.toJSON());
        }
        if (this.tableRowsTableContent) {
            data["tableRowsTableContent"] = {};
            for (let key in this.tableRowsTableContent) {
                if (this.tableRowsTableContent.hasOwnProperty(key))
                    (<any>data["tableRowsTableContent"])[key] = (<any>this.tableRowsTableContent)[key];
            }
        }
        data["hasAlternativeHeaders"] = this.hasAlternativeHeaders;
        super.toJSON(data);
        return data;
    }
}

export interface IDocumentTableModel extends IDocumentEntityElementModel {
    rowCount: number;
    columnCount: number;
    tableHeaders: DocumentTableHeaderModel[];
    tableRows: { [key: string]: DocumentTableCellModel[]; };
    boundsAndPoints: DocumentTableMultiPage[];
    tableRowsTableContent: { [key: string]: string; } | undefined;
    hasAlternativeHeaders: boolean | undefined;
}

export class DocumentTableCellModel extends DocumentEntityElementModel implements IDocumentTableCellModel {
    rowIndex!: number;
    columnIndex!: number;
    content!: string;
    contentNormalized!: string;
    pageNumber!: number | undefined;

    constructor(data?: IDocumentTableCellModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rowIndex = _data["rowIndex"];
            this.columnIndex = _data["columnIndex"];
            this.content = _data["content"];
            this.contentNormalized = _data["contentNormalized"];
            this.pageNumber = _data["pageNumber"];
        }
    }

    static fromJS(data: any): DocumentTableCellModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTableCellModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowIndex"] = this.rowIndex;
        data["columnIndex"] = this.columnIndex;
        data["content"] = this.content;
        data["contentNormalized"] = this.contentNormalized;
        data["pageNumber"] = this.pageNumber;
        super.toJSON(data);
        return data;
    }
}

export interface IDocumentTableCellModel extends IDocumentEntityElementModel {
    rowIndex: number;
    columnIndex: number;
    content: string;
    contentNormalized: string;
    pageNumber: number | undefined;
}

export class DocumentTableHeaderModel extends DocumentTableCellModel implements IDocumentTableHeaderModel {
    category!: string;
    categoryNormalized!: string | undefined;

    constructor(data?: IDocumentTableHeaderModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.category = _data["category"];
            this.categoryNormalized = _data["categoryNormalized"];
        }
    }

    static fromJS(data: any): DocumentTableHeaderModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTableHeaderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["categoryNormalized"] = this.categoryNormalized;
        super.toJSON(data);
        return data;
    }
}

export interface IDocumentTableHeaderModel extends IDocumentTableCellModel {
    category: string;
    categoryNormalized: string | undefined;
}

export class DocumentTableMultiPage implements IDocumentTableMultiPage {
    pageNumber!: number;
    boundingBox!: DocumentBboxModel;
    points!: DocumentPointModel[];

    constructor(data?: IDocumentTableMultiPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.boundingBox = _data["boundingBox"] ? DocumentBboxModel.fromJS(_data["boundingBox"]) : <any>undefined;
            if (Array.isArray(_data["points"])) {
                this.points = [] as any;
                for (let item of _data["points"])
                    this.points!.push(DocumentPointModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentTableMultiPage {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTableMultiPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["boundingBox"] = this.boundingBox ? this.boundingBox.toJSON() : <any>undefined;
        if (Array.isArray(this.points)) {
            data["points"] = [];
            for (let item of this.points)
                data["points"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDocumentTableMultiPage {
    pageNumber: number;
    boundingBox: DocumentBboxModel;
    points: DocumentPointModel[];
}

export class DocumentTemplateBuilderFieldModel extends DocumentEntityElementModel implements IDocumentTemplateBuilderFieldModel {
    fieldUniqueId!: string;
    type!: string;
    keyValues!: DocumentKeyValueModel[];
    table!: TemplateBuilderTableFieldModel;

    constructor(data?: IDocumentTemplateBuilderFieldModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fieldUniqueId = _data["fieldUniqueId"];
            this.type = _data["type"];
            if (Array.isArray(_data["keyValues"])) {
                this.keyValues = [] as any;
                for (let item of _data["keyValues"])
                    this.keyValues!.push(DocumentKeyValueModel.fromJS(item));
            }
            this.table = _data["table"] ? TemplateBuilderTableFieldModel.fromJS(_data["table"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentTemplateBuilderFieldModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTemplateBuilderFieldModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldUniqueId"] = this.fieldUniqueId;
        data["type"] = this.type;
        if (Array.isArray(this.keyValues)) {
            data["keyValues"] = [];
            for (let item of this.keyValues)
                data["keyValues"].push(item.toJSON());
        }
        data["table"] = this.table ? this.table.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IDocumentTemplateBuilderFieldModel extends IDocumentEntityElementModel {
    fieldUniqueId: string;
    type: string;
    keyValues: DocumentKeyValueModel[];
    table: TemplateBuilderTableFieldModel;
}

export class TemplateBuilderTableFieldModel implements ITemplateBuilderTableFieldModel {
    rowCount!: number;
    columnCount!: number;
    tableHeaders!: TemplateBuilderTableHeaderFieldModel[];
    tableRows!: { [key: string]: TemplateBuilderTableCellFieldModel[]; };

    constructor(data?: ITemplateBuilderTableFieldModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowCount = _data["rowCount"];
            this.columnCount = _data["columnCount"];
            if (Array.isArray(_data["tableHeaders"])) {
                this.tableHeaders = [] as any;
                for (let item of _data["tableHeaders"])
                    this.tableHeaders!.push(TemplateBuilderTableHeaderFieldModel.fromJS(item));
            }
            if (_data["tableRows"]) {
                this.tableRows = {} as any;
                for (let key in _data["tableRows"]) {
                    if (_data["tableRows"].hasOwnProperty(key))
                        (<any>this.tableRows)![key] = _data["tableRows"][key] ? _data["tableRows"][key].map((i: any) => TemplateBuilderTableCellFieldModel.fromJS(i)) : [];
                }
            }
        }
    }

    static fromJS(data: any): TemplateBuilderTableFieldModel {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateBuilderTableFieldModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowCount"] = this.rowCount;
        data["columnCount"] = this.columnCount;
        if (Array.isArray(this.tableHeaders)) {
            data["tableHeaders"] = [];
            for (let item of this.tableHeaders)
                data["tableHeaders"].push(item.toJSON());
        }
        if (this.tableRows) {
            data["tableRows"] = {};
            for (let key in this.tableRows) {
                if (this.tableRows.hasOwnProperty(key))
                    (<any>data["tableRows"])[key] = (<any>this.tableRows)[key];
            }
        }
        return data;
    }
}

export interface ITemplateBuilderTableFieldModel {
    rowCount: number;
    columnCount: number;
    tableHeaders: TemplateBuilderTableHeaderFieldModel[];
    tableRows: { [key: string]: TemplateBuilderTableCellFieldModel[]; };
}

export class TemplateBuilderTableHeaderFieldModel extends DocumentTableHeaderModel implements ITemplateBuilderTableHeaderFieldModel {
    uniqueId!: string;
    fieldType!: TemplateBuilderFieldType;
    isRequired!: boolean;

    constructor(data?: ITemplateBuilderTableHeaderFieldModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.fieldType = _data["fieldType"];
            this.isRequired = _data["isRequired"];
        }
    }

    static fromJS(data: any): TemplateBuilderTableHeaderFieldModel {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateBuilderTableHeaderFieldModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["fieldType"] = this.fieldType;
        data["isRequired"] = this.isRequired;
        super.toJSON(data);
        return data;
    }
}

export interface ITemplateBuilderTableHeaderFieldModel extends IDocumentTableHeaderModel {
    uniqueId: string;
    fieldType: TemplateBuilderFieldType;
    isRequired: boolean;
}

export enum TemplateBuilderFieldType {
    StringNotSpecified = 50,
    StringAlphanumeric = 51,
    StringNoWhitespaces = 52,
    NumberNotSpecified = 100,
    NumberCurrency = 101,
    DateNotSpecified = 150,
    DateDmy = 151,
    DateMdy = 152,
    DateYmd = 153,
    TimeNotSpecified = 200,
    IntegerNotSpecified = 250,
    SelectionMarkNotSpecified = 300,
    SignatureNotSpecified = 350,
    DynamicTable = 400,
}

export class TemplateBuilderTableCellFieldModel extends DocumentTableCellModel implements ITemplateBuilderTableCellFieldModel {
    uniqueId!: string;
    headerId!: string;

    constructor(data?: ITemplateBuilderTableCellFieldModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.headerId = _data["headerId"];
        }
    }

    static fromJS(data: any): TemplateBuilderTableCellFieldModel {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateBuilderTableCellFieldModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["headerId"] = this.headerId;
        super.toJSON(data);
        return data;
    }
}

export interface ITemplateBuilderTableCellFieldModel extends IDocumentTableCellModel {
    uniqueId: string;
    headerId: string;
}

export class ResultWithCodeOfSdTaskSavedPagesViewModelAndSdTaskError implements IResultWithCodeOfSdTaskSavedPagesViewModelAndSdTaskError {
    succeeded!: boolean;
    result!: SdTaskSavedPagesViewModel | undefined;
    errors!: ErrorWithCodeOfSdTaskError[];

    constructor(data?: IResultWithCodeOfSdTaskSavedPagesViewModelAndSdTaskError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.result = _data["result"] ? SdTaskSavedPagesViewModel.fromJS(_data["result"]) : <any>undefined;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorWithCodeOfSdTaskError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultWithCodeOfSdTaskSavedPagesViewModelAndSdTaskError {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithCodeOfSdTaskSavedPagesViewModelAndSdTaskError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResultWithCodeOfSdTaskSavedPagesViewModelAndSdTaskError {
    succeeded: boolean;
    result: SdTaskSavedPagesViewModel | undefined;
    errors: ErrorWithCodeOfSdTaskError[];
}

export class SdTaskSavedPagesViewModel implements ISdTaskSavedPagesViewModel {
    unsavedPages!: number[];
    recalculatedConfidence!: SdTaskRecalculateConfidenceResult | undefined;

    constructor(data?: ISdTaskSavedPagesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["unsavedPages"])) {
                this.unsavedPages = [] as any;
                for (let item of _data["unsavedPages"])
                    this.unsavedPages!.push(item);
            }
            this.recalculatedConfidence = _data["recalculatedConfidence"] ? SdTaskRecalculateConfidenceResult.fromJS(_data["recalculatedConfidence"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SdTaskSavedPagesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdTaskSavedPagesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.unsavedPages)) {
            data["unsavedPages"] = [];
            for (let item of this.unsavedPages)
                data["unsavedPages"].push(item);
        }
        data["recalculatedConfidence"] = this.recalculatedConfidence ? this.recalculatedConfidence.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISdTaskSavedPagesViewModel {
    unsavedPages: number[];
    recalculatedConfidence: SdTaskRecalculateConfidenceResult | undefined;
}

export class SdTaskRecalculateConfidenceResult implements ISdTaskRecalculateConfidenceResult {
    averageConfidence!: number;
    smallestConfidence!: number;

    constructor(data?: ISdTaskRecalculateConfidenceResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.averageConfidence = _data["averageConfidence"];
            this.smallestConfidence = _data["smallestConfidence"];
        }
    }

    static fromJS(data: any): SdTaskRecalculateConfidenceResult {
        data = typeof data === 'object' ? data : {};
        let result = new SdTaskRecalculateConfidenceResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["averageConfidence"] = this.averageConfidence;
        data["smallestConfidence"] = this.smallestConfidence;
        return data;
    }
}

export interface ISdTaskRecalculateConfidenceResult {
    averageConfidence: number;
    smallestConfidence: number;
}

export class ErrorWithCodeOfSdTaskError implements IErrorWithCodeOfSdTaskError {
    code!: SdTaskError;
    error!: string;

    constructor(data?: IErrorWithCodeOfSdTaskError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): ErrorWithCodeOfSdTaskError {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorWithCodeOfSdTaskError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["error"] = this.error;
        return data;
    }
}

export interface IErrorWithCodeOfSdTaskError {
    code: SdTaskError;
    error: string;
}

export enum SdTaskError {
    MultipleExternalIdMatches = 2,
    CheckedOutByOtherUser = 3,
    NotReadyYet = 4,
    NoStorageConfig = 5,
    PageOutOfBounds = 6,
    CurrentUserIdNotFound = 7,
    SaveDocumentChangesFailed = 8,
    NotFound = 9,
    WorkspaceConfigError = 10,
    IntegrationQueueError = 11,
    UrlOrFileRequired = 12,
    MaximumFileSize = 13,
    BlobStorageUploadError = 14,
    BlobStorageUrlError = 15,
    ProcessTaskError = 16,
    ExportDataError = 17,
    LicenseDataExpirationError = 18,
    LicenseVolumeError = 19,
    UnsupportedExtensionsError = 20,
    WorkspacesDontMatch = 21,
    HasEmptyRequiredFields = 22,
    AutomaticFinishReview = 23,
    UnknownCheckoutError = 24,
    NoWorkspaceAccess = 25,
    IntegrationError = 26,
    HasFieldsNotMatchingRegex = 27,
    IndexIdOrIndexServiceNameRequired = 28,
    AssignedToOtherUser = 29,
    InvalidAssignmentState = 30,
    BasePathExportDataError = 31,
    HasFieldsNotMatchingComparison = 32,
    HasFieldsNotMatchingRules = 33,
    LicenseValidationError = 34,
    ValidationErrorInvalidDimensions = 400,
    PreProcessingInvalidPageRange = 410,
    ContextUnknownProperty = 1000,
    ContextInvalidUrl = 1001,
    ContextInvalidBlobPath = 1002,
    ContextInvalidBlobContainerName = 1003,
    ContextInvalidBlobServiceName = 1004,
    ContextInvalidOffsetStart = 1005,
    ContextInvalidOffsetEnd = 1006,
    ContextInvalidQrCode = 1007,
    ContextInvalidSplitTaskInChunks = 1008,
    ContextInvalidSplitSourceTaskStorageRowKey = 1009,
    ContextInvalidSplitFastMode = 1010,
    ContextInvalidSplitSilenceThresholdDb = 1011,
    ContextInvalidSplitSilenceDurationSeconds = 1012,
    ContextInvalidSplitStartTimeSeconds = 1013,
    ContextInvalidSplitEndTimeSeconds = 1014,
    ContextInvalidSplitChunkDurationMinutes = 1015,
    ContextInvalidTranscriptLanguage = 1016,
    ContextInvalidLegalDocumentsTema = 1017,
    ContextInvalidTranscriptDefaultSpeakerId = 1018,
    ContextInvalidIsTaskSplittable = 1019,
    ContextInvalidSplitChunkNumberPages = 1020,
    ContextInvalidTranslationsGlossaryUrl = 1021,
    ContextInvalidTranslationsGlossarySharepointId = 1022,
    ContextInvalidTranslationsGlossarySharepointDriveId = 1023,
    ContextInvalidTranslationsGlossarySharepointServiceName = 1024,
    ContextInvalidInputLanguage = 1025,
    ContextInvalidOutputLanguage = 1026,
    ContextInvalidPageRange = 1027,
    ContextInvalidStorageServiceName = 1028,
    ContextInvalidStorageConnectorType = 1029,
    ContextInvalidStorageItemPath = 1030,
    ContextInvalidStorageItemId = 1031,
}

export class DocumentSaveModel implements IDocumentSaveModel {
    taskId!: number;
    workspaceId!: number;
    changes!: { [key: string]: DocumentModel; };

    constructor(data?: IDocumentSaveModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.workspaceId = _data["workspaceId"];
            if (_data["changes"]) {
                this.changes = {} as any;
                for (let key in _data["changes"]) {
                    if (_data["changes"].hasOwnProperty(key))
                        (<any>this.changes)![key] = _data["changes"][key] ? DocumentModel.fromJS(_data["changes"][key]) : new DocumentModel();
                }
            }
        }
    }

    static fromJS(data: any): DocumentSaveModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentSaveModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["workspaceId"] = this.workspaceId;
        if (this.changes) {
            data["changes"] = {};
            for (let key in this.changes) {
                if (this.changes.hasOwnProperty(key))
                    (<any>data["changes"])[key] = this.changes[key] ? this.changes[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IDocumentSaveModel {
    taskId: number;
    workspaceId: number;
    changes: { [key: string]: DocumentModel; };
}

export class FieldRuleTypeConfigModel implements IFieldRuleTypeConfigModel {
    id!: string;
    isActive!: boolean;
    title!: string;
    message!: string | undefined;
    type!: RuleValidationType;
    configurationRegex!: FieldRegexRuleConfigModel | undefined;
    configurationCompare!: FieldCompareRuleConfigModel | undefined;
    isValid!: boolean;

    constructor(data?: IFieldRuleTypeConfigModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.title = _data["title"];
            this.message = _data["message"];
            this.type = _data["type"];
            this.configurationRegex = _data["configurationRegex"] ? FieldRegexRuleConfigModel.fromJS(_data["configurationRegex"]) : <any>undefined;
            this.configurationCompare = _data["configurationCompare"] ? FieldCompareRuleConfigModel.fromJS(_data["configurationCompare"]) : <any>undefined;
            this.isValid = _data["isValid"];
        }
    }

    static fromJS(data: any): FieldRuleTypeConfigModel {
        data = typeof data === 'object' ? data : {};
        let result = new FieldRuleTypeConfigModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["title"] = this.title;
        data["message"] = this.message;
        data["type"] = this.type;
        data["configurationRegex"] = this.configurationRegex ? this.configurationRegex.toJSON() : <any>undefined;
        data["configurationCompare"] = this.configurationCompare ? this.configurationCompare.toJSON() : <any>undefined;
        data["isValid"] = this.isValid;
        return data;
    }
}

export interface IFieldRuleTypeConfigModel {
    id: string;
    isActive: boolean;
    title: string;
    message: string | undefined;
    type: RuleValidationType;
    configurationRegex: FieldRegexRuleConfigModel | undefined;
    configurationCompare: FieldCompareRuleConfigModel | undefined;
    isValid: boolean;
}

export enum RuleValidationType {
    Regex = 10,
    Compare = 20,
}

export class FieldRegexRuleConfigModel implements IFieldRegexRuleConfigModel {
    fieldToCompare!: FieldRuleFieldToCompareConfigModel;
    regExp!: string;

    constructor(data?: IFieldRegexRuleConfigModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldToCompare = _data["fieldToCompare"] ? FieldRuleFieldToCompareConfigModel.fromJS(_data["fieldToCompare"]) : <any>undefined;
            this.regExp = _data["regExp"];
        }
    }

    static fromJS(data: any): FieldRegexRuleConfigModel {
        data = typeof data === 'object' ? data : {};
        let result = new FieldRegexRuleConfigModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldToCompare"] = this.fieldToCompare ? this.fieldToCompare.toJSON() : <any>undefined;
        data["regExp"] = this.regExp;
        return data;
    }
}

export interface IFieldRegexRuleConfigModel {
    fieldToCompare: FieldRuleFieldToCompareConfigModel;
    regExp: string;
}

export class FieldRuleFieldToCompareConfigModel implements IFieldRuleFieldToCompareConfigModel {
    categoryKey!: string;
    validation!: FieldRuleValidationStatus;
    fieldType!: SdcCustomFormFieldType | undefined;

    constructor(data?: IFieldRuleFieldToCompareConfigModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryKey = _data["categoryKey"];
            this.validation = _data["validation"] ? FieldRuleValidationStatus.fromJS(_data["validation"]) : <any>undefined;
            this.fieldType = _data["fieldType"];
        }
    }

    static fromJS(data: any): FieldRuleFieldToCompareConfigModel {
        data = typeof data === 'object' ? data : {};
        let result = new FieldRuleFieldToCompareConfigModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryKey"] = this.categoryKey;
        data["validation"] = this.validation ? this.validation.toJSON() : <any>undefined;
        data["fieldType"] = this.fieldType;
        return data;
    }
}

export interface IFieldRuleFieldToCompareConfigModel {
    categoryKey: string;
    validation: FieldRuleValidationStatus;
    fieldType: SdcCustomFormFieldType | undefined;
}

export class FieldRuleValidationStatus implements IFieldRuleValidationStatus {
    fieldWorkspaceNotSelected!: boolean;
    fieldTypeMismatch!: boolean;
    fieldDeleted!: boolean;
    isValid!: boolean;

    constructor(data?: IFieldRuleValidationStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldWorkspaceNotSelected = _data["fieldWorkspaceNotSelected"];
            this.fieldTypeMismatch = _data["fieldTypeMismatch"];
            this.fieldDeleted = _data["fieldDeleted"];
            this.isValid = _data["isValid"];
        }
    }

    static fromJS(data: any): FieldRuleValidationStatus {
        data = typeof data === 'object' ? data : {};
        let result = new FieldRuleValidationStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldWorkspaceNotSelected"] = this.fieldWorkspaceNotSelected;
        data["fieldTypeMismatch"] = this.fieldTypeMismatch;
        data["fieldDeleted"] = this.fieldDeleted;
        data["isValid"] = this.isValid;
        return data;
    }
}

export interface IFieldRuleValidationStatus {
    fieldWorkspaceNotSelected: boolean;
    fieldTypeMismatch: boolean;
    fieldDeleted: boolean;
    isValid: boolean;
}

export enum SdcCustomFormFieldType {
    Custom = 0,
    DatePicker = 1,
    DateRangePicker = 2,
    DateTimePicker = 3,
    EntryArea = 4,
    Entry = 5,
    File = 6,
    Numeric = 7,
    Password = 8,
    Picker = 9,
    PickerMultiple = 10,
    Switch = 11,
    TimePicker = 12,
    DataTable = 13,
    MaskedEntry = 14,
    Editor = 15,
    Picture = 16,
    Sortable = 17,
    ColorPicker = 18,
    Decimal = 19,
    Currency = 20,
    TusFile = 21,
    DynamicTable = 22,
    Checkbox = 23,
    TimeStringPicker = 24,
    ViewerChildrenEditor = 100,
    ViewerFieldEditor = 101,
}

export class FieldCompareRuleConfigModel implements IFieldCompareRuleConfigModel {
    operator!: RuleOperatorType;
    compareType!: RuleCompareType | undefined;
    fieldToCompare!: FieldRuleFieldToCompareConfigModel;
    compareWith!: FieldCompareRuleCompareWithConfigModel[];

    constructor(data?: IFieldCompareRuleConfigModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operator = _data["operator"];
            this.compareType = _data["compareType"];
            this.fieldToCompare = _data["fieldToCompare"] ? FieldRuleFieldToCompareConfigModel.fromJS(_data["fieldToCompare"]) : <any>undefined;
            if (Array.isArray(_data["compareWith"])) {
                this.compareWith = [] as any;
                for (let item of _data["compareWith"])
                    this.compareWith!.push(FieldCompareRuleCompareWithConfigModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FieldCompareRuleConfigModel {
        data = typeof data === 'object' ? data : {};
        let result = new FieldCompareRuleConfigModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operator"] = this.operator;
        data["compareType"] = this.compareType;
        data["fieldToCompare"] = this.fieldToCompare ? this.fieldToCompare.toJSON() : <any>undefined;
        if (Array.isArray(this.compareWith)) {
            data["compareWith"] = [];
            for (let item of this.compareWith)
                data["compareWith"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFieldCompareRuleConfigModel {
    operator: RuleOperatorType;
    compareType: RuleCompareType | undefined;
    fieldToCompare: FieldRuleFieldToCompareConfigModel;
    compareWith: FieldCompareRuleCompareWithConfigModel[];
}

export enum RuleOperatorType {
    Equals = 10,
    GreaterThan = 20,
    LessThan = 30,
}

export enum RuleCompareType {
    FieldToField = 10,
    FieldToValue = 20,
    ColSumToField = 30,
}

export class FieldCompareRuleCompareWithConfigModel implements IFieldCompareRuleCompareWithConfigModel {
    value!: string;
    isField!: boolean;
    validation!: FieldRuleValidationStatus | undefined;

    constructor(data?: IFieldCompareRuleCompareWithConfigModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isField = _data["isField"];
            this.validation = _data["validation"] ? FieldRuleValidationStatus.fromJS(_data["validation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FieldCompareRuleCompareWithConfigModel {
        data = typeof data === 'object' ? data : {};
        let result = new FieldCompareRuleCompareWithConfigModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isField"] = this.isField;
        data["validation"] = this.validation ? this.validation.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFieldCompareRuleCompareWithConfigModel {
    value: string;
    isField: boolean;
    validation: FieldRuleValidationStatus | undefined;
}

export class ResultWithCodeOfListOfStorageItemListEntryModelAndStorageIntegrationError implements IResultWithCodeOfListOfStorageItemListEntryModelAndStorageIntegrationError {
    succeeded!: boolean;
    result!: StorageItemListEntryModel[] | undefined;
    errors!: ErrorWithCodeOfStorageIntegrationError[];

    constructor(data?: IResultWithCodeOfListOfStorageItemListEntryModelAndStorageIntegrationError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(StorageItemListEntryModel.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorWithCodeOfStorageIntegrationError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultWithCodeOfListOfStorageItemListEntryModelAndStorageIntegrationError {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithCodeOfListOfStorageItemListEntryModelAndStorageIntegrationError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResultWithCodeOfListOfStorageItemListEntryModelAndStorageIntegrationError {
    succeeded: boolean;
    result: StorageItemListEntryModel[] | undefined;
    errors: ErrorWithCodeOfStorageIntegrationError[];
}

export class StorageItemListEntryModel implements IStorageItemListEntryModel {
    id!: string;
    name!: string;
    path!: string;
    displayFullPath!: string;
    isFolder!: boolean;
    metadata!: { [key: string]: string; };

    constructor(data?: IStorageItemListEntryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.path = _data["path"];
            this.displayFullPath = _data["displayFullPath"];
            this.isFolder = _data["isFolder"];
            if (_data["metadata"]) {
                this.metadata = {} as any;
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        (<any>this.metadata)![key] = _data["metadata"][key];
                }
            }
        }
    }

    static fromJS(data: any): StorageItemListEntryModel {
        data = typeof data === 'object' ? data : {};
        let result = new StorageItemListEntryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["path"] = this.path;
        data["displayFullPath"] = this.displayFullPath;
        data["isFolder"] = this.isFolder;
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (<any>data["metadata"])[key] = (<any>this.metadata)[key];
            }
        }
        return data;
    }
}

export interface IStorageItemListEntryModel {
    id: string;
    name: string;
    path: string;
    displayFullPath: string;
    isFolder: boolean;
    metadata: { [key: string]: string; };
}

export class ErrorWithCodeOfStorageIntegrationError implements IErrorWithCodeOfStorageIntegrationError {
    code!: StorageIntegrationError;
    error!: string;

    constructor(data?: IErrorWithCodeOfStorageIntegrationError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): ErrorWithCodeOfStorageIntegrationError {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorWithCodeOfStorageIntegrationError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["error"] = this.error;
        return data;
    }
}

export interface IErrorWithCodeOfStorageIntegrationError {
    code: StorageIntegrationError;
    error: string;
}

export enum StorageIntegrationError {
    Unsupported = 0,
    ConfigurationNotFound = 10,
    InvalidPath = 20,
    ItemNotFound = 30,
    UploadFailed = 40,
}

export enum LoadBalancedServiceType {
    FormRecognizer = 10,
    TranscriptRecognizer = 20,
    AzureBlobStorage = 30,
    PiiAnonymizer = 40,
    SharePoint = 50,
    Translator = 60,
    FormRecognizerHook = 70,
    VideoIndexer = 80,
    TranscriptChatbot = 90,
    ContentUnderstanding = 100,
    PostgresPgVector = 110,
    OpenAiCompatibleChatModel = 120,
    OpenAiCompatibleEmbeddingModel = 130,
    OneDrive = 140,
}

export class IndexLogViewModel implements IIndexLogViewModel {
    taskId!: number;
    workspaceId!: number;
    tenantId!: number;
    indexId!: string;
    indexServiceName!: string;
    indexStatus!: number;
    indexStatusText!: string;
    logMessage!: string;
    createdOn!: Date;

    constructor(data?: IIndexLogViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.workspaceId = _data["workspaceId"];
            this.tenantId = _data["tenantId"];
            this.indexId = _data["indexId"];
            this.indexServiceName = _data["indexServiceName"];
            this.indexStatus = _data["indexStatus"];
            this.indexStatusText = _data["indexStatusText"];
            this.logMessage = _data["logMessage"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): IndexLogViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new IndexLogViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["workspaceId"] = this.workspaceId;
        data["tenantId"] = this.tenantId;
        data["indexId"] = this.indexId;
        data["indexServiceName"] = this.indexServiceName;
        data["indexStatus"] = this.indexStatus;
        data["indexStatusText"] = this.indexStatusText;
        data["logMessage"] = this.logMessage;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IIndexLogViewModel {
    taskId: number;
    workspaceId: number;
    tenantId: number;
    indexId: string;
    indexServiceName: string;
    indexStatus: number;
    indexStatusText: string;
    logMessage: string;
    createdOn: Date;
}

export class PaginatedListOfSdTaskViewModel implements IPaginatedListOfSdTaskViewModel {
    items!: SdTaskViewModel[];
    pageNumber!: number;
    totalPages!: number;
    totalCount!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfSdTaskViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SdTaskViewModel.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfSdTaskViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfSdTaskViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfSdTaskViewModel {
    items: SdTaskViewModel[];
    pageNumber: number;
    totalPages: number;
    totalCount: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class SdTaskViewModel implements ISdTaskViewModel {
    transcripts!: TranscriptMatchViewModel[];
    id!: number;
    sequentialByWorkspaceId!: number | undefined;
    batchId!: number | undefined;
    batchDisplayName!: string | undefined;
    tenantId!: string;
    workspaceId!: number;
    displayName!: string;
    description!: string;
    externalId!: string;
    totalPages!: number;
    status!: SdTaskStatus;
    storageConfigRowKey!: string;
    propertiesRowKey!: string;
    lastCheckedOutBy!: number | undefined;
    lastCheckoutRowKey!: string;
    lastIntegratedByUserName!: string | undefined;
    lastIntegratedBy!: number | undefined;
    lastIntegratedOn!: Date | undefined;
    lastIntegrationStatus!: number;
    lastIntegratedQueuedOn!: Date | undefined;
    lastIntegrationRowKey!: string;
    createdOn!: Date;
    expiresOn!: Date | undefined;
    detectedFields!: { [key: string]: string; } | undefined;
    lastStuckStatus!: SdTaskStatus | undefined;
    lastStuckStatusModifiedOn!: Date | undefined;
    labellingStatus!: LabellingStatus | undefined;
    batchType!: SdBatchType | undefined;
    isSplitSourceTask!: boolean | undefined;
    languageCode!: string | undefined;
    inputLanguageCode!: string | undefined;
    outputLanguageCode!: string | undefined;
    lastFinishReviewAttemptByUserName!: string | undefined;
    lastFinishReviewAttemptBy!: number | undefined;
    lastFinishReviewAttemptOn!: Date | undefined;
    indexStatus!: IndexStatus | undefined;
    scheduleIndexTriggersOn!: Date | undefined;
    offsetStart!: number | undefined;
    assignmentOrderType!: number | undefined;
    assignmentUsers!: SdTaskAssignmentUser[] | undefined;
    useHigherQuality!: boolean | undefined;
    canBeReviewed!: boolean;
    canBeExported!: boolean;
    canBeDeleted!: boolean;
    canBeReprocessed!: boolean;

    constructor(data?: ISdTaskViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["transcripts"])) {
                this.transcripts = [] as any;
                for (let item of _data["transcripts"])
                    this.transcripts!.push(TranscriptMatchViewModel.fromJS(item));
            }
            this.id = _data["id"];
            this.sequentialByWorkspaceId = _data["sequentialByWorkspaceId"];
            this.batchId = _data["batchId"];
            this.batchDisplayName = _data["batchDisplayName"];
            this.tenantId = _data["tenantId"];
            this.workspaceId = _data["workspaceId"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.externalId = _data["externalId"];
            this.totalPages = _data["totalPages"];
            this.status = _data["status"];
            this.storageConfigRowKey = _data["storageConfigRowKey"];
            this.propertiesRowKey = _data["propertiesRowKey"];
            this.lastCheckedOutBy = _data["lastCheckedOutBy"];
            this.lastCheckoutRowKey = _data["lastCheckoutRowKey"];
            this.lastIntegratedByUserName = _data["lastIntegratedByUserName"];
            this.lastIntegratedBy = _data["lastIntegratedBy"];
            this.lastIntegratedOn = _data["lastIntegratedOn"] ? new Date(_data["lastIntegratedOn"].toString()) : <any>undefined;
            this.lastIntegrationStatus = _data["lastIntegrationStatus"];
            this.lastIntegratedQueuedOn = _data["lastIntegratedQueuedOn"] ? new Date(_data["lastIntegratedQueuedOn"].toString()) : <any>undefined;
            this.lastIntegrationRowKey = _data["lastIntegrationRowKey"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.expiresOn = _data["expiresOn"] ? new Date(_data["expiresOn"].toString()) : <any>undefined;
            if (_data["detectedFields"]) {
                this.detectedFields = {} as any;
                for (let key in _data["detectedFields"]) {
                    if (_data["detectedFields"].hasOwnProperty(key))
                        (<any>this.detectedFields)![key] = _data["detectedFields"][key];
                }
            }
            this.lastStuckStatus = _data["lastStuckStatus"];
            this.lastStuckStatusModifiedOn = _data["lastStuckStatusModifiedOn"] ? new Date(_data["lastStuckStatusModifiedOn"].toString()) : <any>undefined;
            this.labellingStatus = _data["labellingStatus"];
            this.batchType = _data["batchType"];
            this.isSplitSourceTask = _data["isSplitSourceTask"];
            this.languageCode = _data["languageCode"];
            this.inputLanguageCode = _data["inputLanguageCode"];
            this.outputLanguageCode = _data["outputLanguageCode"];
            this.lastFinishReviewAttemptByUserName = _data["lastFinishReviewAttemptByUserName"];
            this.lastFinishReviewAttemptBy = _data["lastFinishReviewAttemptBy"];
            this.lastFinishReviewAttemptOn = _data["lastFinishReviewAttemptOn"] ? new Date(_data["lastFinishReviewAttemptOn"].toString()) : <any>undefined;
            this.indexStatus = _data["indexStatus"];
            this.scheduleIndexTriggersOn = _data["scheduleIndexTriggersOn"] ? new Date(_data["scheduleIndexTriggersOn"].toString()) : <any>undefined;
            this.offsetStart = _data["offsetStart"];
            this.assignmentOrderType = _data["assignmentOrderType"];
            if (Array.isArray(_data["assignmentUsers"])) {
                this.assignmentUsers = [] as any;
                for (let item of _data["assignmentUsers"])
                    this.assignmentUsers!.push(SdTaskAssignmentUser.fromJS(item));
            }
            this.useHigherQuality = _data["useHigherQuality"];
            this.canBeReviewed = _data["canBeReviewed"];
            this.canBeExported = _data["canBeExported"];
            this.canBeDeleted = _data["canBeDeleted"];
            this.canBeReprocessed = _data["canBeReprocessed"];
        }
    }

    static fromJS(data: any): SdTaskViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdTaskViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.transcripts)) {
            data["transcripts"] = [];
            for (let item of this.transcripts)
                data["transcripts"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["sequentialByWorkspaceId"] = this.sequentialByWorkspaceId;
        data["batchId"] = this.batchId;
        data["batchDisplayName"] = this.batchDisplayName;
        data["tenantId"] = this.tenantId;
        data["workspaceId"] = this.workspaceId;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["externalId"] = this.externalId;
        data["totalPages"] = this.totalPages;
        data["status"] = this.status;
        data["storageConfigRowKey"] = this.storageConfigRowKey;
        data["propertiesRowKey"] = this.propertiesRowKey;
        data["lastCheckedOutBy"] = this.lastCheckedOutBy;
        data["lastCheckoutRowKey"] = this.lastCheckoutRowKey;
        data["lastIntegratedByUserName"] = this.lastIntegratedByUserName;
        data["lastIntegratedBy"] = this.lastIntegratedBy;
        data["lastIntegratedOn"] = this.lastIntegratedOn ? this.lastIntegratedOn.toISOString() : <any>undefined;
        data["lastIntegrationStatus"] = this.lastIntegrationStatus;
        data["lastIntegratedQueuedOn"] = this.lastIntegratedQueuedOn ? this.lastIntegratedQueuedOn.toISOString() : <any>undefined;
        data["lastIntegrationRowKey"] = this.lastIntegrationRowKey;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["expiresOn"] = this.expiresOn ? this.expiresOn.toISOString() : <any>undefined;
        if (this.detectedFields) {
            data["detectedFields"] = {};
            for (let key in this.detectedFields) {
                if (this.detectedFields.hasOwnProperty(key))
                    (<any>data["detectedFields"])[key] = (<any>this.detectedFields)[key];
            }
        }
        data["lastStuckStatus"] = this.lastStuckStatus;
        data["lastStuckStatusModifiedOn"] = this.lastStuckStatusModifiedOn ? this.lastStuckStatusModifiedOn.toISOString() : <any>undefined;
        data["labellingStatus"] = this.labellingStatus;
        data["batchType"] = this.batchType;
        data["isSplitSourceTask"] = this.isSplitSourceTask;
        data["languageCode"] = this.languageCode;
        data["inputLanguageCode"] = this.inputLanguageCode;
        data["outputLanguageCode"] = this.outputLanguageCode;
        data["lastFinishReviewAttemptByUserName"] = this.lastFinishReviewAttemptByUserName;
        data["lastFinishReviewAttemptBy"] = this.lastFinishReviewAttemptBy;
        data["lastFinishReviewAttemptOn"] = this.lastFinishReviewAttemptOn ? this.lastFinishReviewAttemptOn.toISOString() : <any>undefined;
        data["indexStatus"] = this.indexStatus;
        data["scheduleIndexTriggersOn"] = this.scheduleIndexTriggersOn ? this.scheduleIndexTriggersOn.toISOString() : <any>undefined;
        data["offsetStart"] = this.offsetStart;
        data["assignmentOrderType"] = this.assignmentOrderType;
        if (Array.isArray(this.assignmentUsers)) {
            data["assignmentUsers"] = [];
            for (let item of this.assignmentUsers)
                data["assignmentUsers"].push(item.toJSON());
        }
        data["useHigherQuality"] = this.useHigherQuality;
        data["canBeReviewed"] = this.canBeReviewed;
        data["canBeExported"] = this.canBeExported;
        data["canBeDeleted"] = this.canBeDeleted;
        data["canBeReprocessed"] = this.canBeReprocessed;
        return data;
    }
}

export interface ISdTaskViewModel {
    transcripts: TranscriptMatchViewModel[];
    id: number;
    sequentialByWorkspaceId: number | undefined;
    batchId: number | undefined;
    batchDisplayName: string | undefined;
    tenantId: string;
    workspaceId: number;
    displayName: string;
    description: string;
    externalId: string;
    totalPages: number;
    status: SdTaskStatus;
    storageConfigRowKey: string;
    propertiesRowKey: string;
    lastCheckedOutBy: number | undefined;
    lastCheckoutRowKey: string;
    lastIntegratedByUserName: string | undefined;
    lastIntegratedBy: number | undefined;
    lastIntegratedOn: Date | undefined;
    lastIntegrationStatus: number;
    lastIntegratedQueuedOn: Date | undefined;
    lastIntegrationRowKey: string;
    createdOn: Date;
    expiresOn: Date | undefined;
    detectedFields: { [key: string]: string; } | undefined;
    lastStuckStatus: SdTaskStatus | undefined;
    lastStuckStatusModifiedOn: Date | undefined;
    labellingStatus: LabellingStatus | undefined;
    batchType: SdBatchType | undefined;
    isSplitSourceTask: boolean | undefined;
    languageCode: string | undefined;
    inputLanguageCode: string | undefined;
    outputLanguageCode: string | undefined;
    lastFinishReviewAttemptByUserName: string | undefined;
    lastFinishReviewAttemptBy: number | undefined;
    lastFinishReviewAttemptOn: Date | undefined;
    indexStatus: IndexStatus | undefined;
    scheduleIndexTriggersOn: Date | undefined;
    offsetStart: number | undefined;
    assignmentOrderType: number | undefined;
    assignmentUsers: SdTaskAssignmentUser[] | undefined;
    useHigherQuality: boolean | undefined;
    canBeReviewed: boolean;
    canBeExported: boolean;
    canBeDeleted: boolean;
    canBeReprocessed: boolean;
}

export class TranscriptMatchViewModel implements ITranscriptMatchViewModel {
    startTimeSeconds!: number;
    text!: string;
    speakerName!: string;
    exactText!: string;

    constructor(data?: ITranscriptMatchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTimeSeconds = _data["startTimeSeconds"];
            this.text = _data["text"];
            this.speakerName = _data["speakerName"];
            this.exactText = _data["exactText"];
        }
    }

    static fromJS(data: any): TranscriptMatchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TranscriptMatchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTimeSeconds"] = this.startTimeSeconds;
        data["text"] = this.text;
        data["speakerName"] = this.speakerName;
        data["exactText"] = this.exactText;
        return data;
    }
}

export interface ITranscriptMatchViewModel {
    startTimeSeconds: number;
    text: string;
    speakerName: string;
    exactText: string;
}

export enum SdTaskStatus {
    Deleting = 19,
    Deleted = 20,
    QueuedForPreProcessing = 30,
    PreProcessingInProgress = 31,
    PreProcessingFailed = 32,
    PreProcessingDownloadFailed = 33,
    PreProcessingSuccessful = 34,
    PreProcessingGetPagesFailed = 35,
    PreProcessingInsufficientVolume = 36,
    PreProcessingLicenseExpired = 37,
    PreProcessingSplittingInProgress = 38,
    PreProcessingSplittingFailed = 39,
    QueuedForRecognizing = 40,
    RecognizingInProgress = 41,
    RecognizingFailed = 42,
    RecognizingSuccessful = 43,
    QueuedForPostProcessing = 50,
    PostProcessingInProgress = 51,
    PostProcessingFailed = 52,
    PostProcessingSuccessful = 53,
    PostProcessingSharePointUploadingFailedAccessLock = 54,
    ToReview = 60,
    InReview = 70,
    QueuedForExport = 90,
    ExportInProgress = 91,
    ExportFailed = 92,
    ExportSuccessful = 93,
    Processed = 100,
    SplitProcessed = 101,
    ProcessedAfterPeriodAndDeletedFiles = 110,
    ValidationErrorInvalidDimensions = 400,
    GlobalGlossaryDownloadFailedError = 401,
    GlossaryDownloadFailedError = 402,
    GlossaryInvalidError = 403,
    GlobalGlossaryInvalidError = 404,
    PreProcessingConvertToPdfFailed = 405,
    PreProcessingFileLengthCountFailed = 406,
    PreProcessingUnknownLicenseError = 407,
    PreProcessingPDFReaderError = 408,
    PreProcessingInvalidLicenseError = 409,
    PreProcessingInvalidPageRange = 410,
}

export enum LabellingStatus {
    ToClassify = 10,
    ToClassifyWithNewFields = 20,
    Classified = 30,
}

export enum SdBatchType {
    Default = 10,
    SplitTask = 20,
}

export enum IndexStatus {
    WaitingForFirstIndex = 50,
    Scheduled = 100,
    WaitingForReIndex = 150,
    Processing = 200,
    Failed = 300,
    Indexed = 400,
}

export class SdTaskAssignmentUser implements ISdTaskAssignmentUser {
    userId!: number;
    hasReviewed!: boolean;
    isValid!: boolean;
    userName!: string | undefined;
    profilePicture!: string | undefined;

    constructor(data?: ISdTaskAssignmentUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.hasReviewed = _data["hasReviewed"];
            this.isValid = _data["isValid"];
            this.userName = _data["userName"];
            this.profilePicture = _data["profilePicture"];
        }
    }

    static fromJS(data: any): SdTaskAssignmentUser {
        data = typeof data === 'object' ? data : {};
        let result = new SdTaskAssignmentUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["hasReviewed"] = this.hasReviewed;
        data["isValid"] = this.isValid;
        data["userName"] = this.userName;
        data["profilePicture"] = this.profilePicture;
        return data;
    }
}

export interface ISdTaskAssignmentUser {
    userId: number;
    hasReviewed: boolean;
    isValid: boolean;
    userName: string | undefined;
    profilePicture: string | undefined;
}

export enum TaskSource {
    MainTable = 10,
    History = 20,
}

export class ResultWithCodeOfVideoTextualSummaryViewModelAndSdTaskError implements IResultWithCodeOfVideoTextualSummaryViewModelAndSdTaskError {
    succeeded!: boolean;
    result!: VideoTextualSummaryViewModel | undefined;
    errors!: ErrorWithCodeOfSdTaskError[];

    constructor(data?: IResultWithCodeOfVideoTextualSummaryViewModelAndSdTaskError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.result = _data["result"] ? VideoTextualSummaryViewModel.fromJS(_data["result"]) : <any>undefined;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorWithCodeOfSdTaskError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultWithCodeOfVideoTextualSummaryViewModelAndSdTaskError {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithCodeOfVideoTextualSummaryViewModelAndSdTaskError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResultWithCodeOfVideoTextualSummaryViewModelAndSdTaskError {
    succeeded: boolean;
    result: VideoTextualSummaryViewModel | undefined;
    errors: ErrorWithCodeOfSdTaskError[];
}

export class VideoTextualSummaryViewModel implements IVideoTextualSummaryViewModel {
    id!: string;
    state!: VideoIndexerJobState;
    summaryStyle!: VideoIndexerSummaryStyle;
    summaryLength!: VideoIndexerSummaryLength;
    includedFrames!: VideoIndexerIncludedFrames;
    createTime!: Date;
    lastUpdateTime!: Date;
    failureMessage!: string | undefined;
    progress!: number | undefined;
    disclaimer!: string | undefined;
    summary!: string | undefined;
    sensitiveContentPercent!: number;

    constructor(data?: IVideoTextualSummaryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.state = _data["state"];
            this.summaryStyle = _data["summaryStyle"];
            this.summaryLength = _data["summaryLength"];
            this.includedFrames = _data["includedFrames"];
            this.createTime = _data["createTime"] ? new Date(_data["createTime"].toString()) : <any>undefined;
            this.lastUpdateTime = _data["lastUpdateTime"] ? new Date(_data["lastUpdateTime"].toString()) : <any>undefined;
            this.failureMessage = _data["failureMessage"];
            this.progress = _data["progress"];
            this.disclaimer = _data["disclaimer"];
            this.summary = _data["summary"];
            this.sensitiveContentPercent = _data["sensitiveContentPercent"];
        }
    }

    static fromJS(data: any): VideoTextualSummaryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new VideoTextualSummaryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["state"] = this.state;
        data["summaryStyle"] = this.summaryStyle;
        data["summaryLength"] = this.summaryLength;
        data["includedFrames"] = this.includedFrames;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["lastUpdateTime"] = this.lastUpdateTime ? this.lastUpdateTime.toISOString() : <any>undefined;
        data["failureMessage"] = this.failureMessage;
        data["progress"] = this.progress;
        data["disclaimer"] = this.disclaimer;
        data["summary"] = this.summary;
        data["sensitiveContentPercent"] = this.sensitiveContentPercent;
        return data;
    }
}

export interface IVideoTextualSummaryViewModel {
    id: string;
    state: VideoIndexerJobState;
    summaryStyle: VideoIndexerSummaryStyle;
    summaryLength: VideoIndexerSummaryLength;
    includedFrames: VideoIndexerIncludedFrames;
    createTime: Date;
    lastUpdateTime: Date;
    failureMessage: string | undefined;
    progress: number | undefined;
    disclaimer: string | undefined;
    summary: string | undefined;
    sensitiveContentPercent: number;
}

export enum VideoIndexerJobState {
    Processing = 0,
    Processed = 1,
    Failed = 2,
    Timeout = 3,
    CanceledByUser = 4,
    CanceledExternally = 5,
    Uploaded = 6,
}

export enum VideoIndexerSummaryStyle {
    Neutral = 0,
    Casual = 1,
    Formal = 2,
}

export enum VideoIndexerSummaryLength {
    Medium = 0,
    Short = 1,
    Long = 2,
}

export enum VideoIndexerIncludedFrames {
    None = 0,
    Keyframes = 1,
}

export class CreateOrUpdateVideoTextualSummaryViewModel implements ICreateOrUpdateVideoTextualSummaryViewModel {
    taskId!: number;
    length!: VideoIndexerSummaryLength | undefined;
    style!: VideoIndexerSummaryStyle | undefined;
    includedFrames!: VideoIndexerIncludedFrames | undefined;

    constructor(data?: ICreateOrUpdateVideoTextualSummaryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.length = _data["length"];
            this.style = _data["style"];
            this.includedFrames = _data["includedFrames"];
        }
    }

    static fromJS(data: any): CreateOrUpdateVideoTextualSummaryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateVideoTextualSummaryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["length"] = this.length;
        data["style"] = this.style;
        data["includedFrames"] = this.includedFrames;
        return data;
    }
}

export interface ICreateOrUpdateVideoTextualSummaryViewModel {
    taskId: number;
    length: VideoIndexerSummaryLength | undefined;
    style: VideoIndexerSummaryStyle | undefined;
    includedFrames: VideoIndexerIncludedFrames | undefined;
}

export class SummaryCostsInfoViewModel implements ISummaryCostsInfoViewModel {
    costsInCredits!: number;
    upToDate!: boolean;
    indexedDate!: Date | undefined;

    constructor(data?: ISummaryCostsInfoViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.costsInCredits = _data["costsInCredits"];
            this.upToDate = _data["upToDate"];
            this.indexedDate = _data["indexedDate"] ? new Date(_data["indexedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SummaryCostsInfoViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SummaryCostsInfoViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["costsInCredits"] = this.costsInCredits;
        data["upToDate"] = this.upToDate;
        data["indexedDate"] = this.indexedDate ? this.indexedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISummaryCostsInfoViewModel {
    costsInCredits: number;
    upToDate: boolean;
    indexedDate: Date | undefined;
}

export class LicenseViewModel implements ILicenseViewModel {
    id!: number;
    tenantId!: number;
    isTrial!: boolean;
    volume!: number;
    currentVolume!: number;
    expired!: boolean;
    activationDate!: Date;
    expirationDate!: Date | undefined;
    storeUrl!: string;

    constructor(data?: ILicenseViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.isTrial = _data["isTrial"];
            this.volume = _data["volume"];
            this.currentVolume = _data["currentVolume"];
            this.expired = _data["expired"];
            this.activationDate = _data["activationDate"] ? new Date(_data["activationDate"].toString()) : <any>undefined;
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.storeUrl = _data["storeUrl"];
        }
    }

    static fromJS(data: any): LicenseViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["isTrial"] = this.isTrial;
        data["volume"] = this.volume;
        data["currentVolume"] = this.currentVolume;
        data["expired"] = this.expired;
        data["activationDate"] = this.activationDate ? this.activationDate.toISOString() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["storeUrl"] = this.storeUrl;
        return data;
    }
}

export interface ILicenseViewModel {
    id: number;
    tenantId: number;
    isTrial: boolean;
    volume: number;
    currentVolume: number;
    expired: boolean;
    activationDate: Date;
    expirationDate: Date | undefined;
    storeUrl: string;
}

export class PaginatedTableListOfLicenseVolumeHistory implements IPaginatedTableListOfLicenseVolumeHistory {
    items!: LicenseVolumeHistory[];
    continuationToken!: string | undefined;

    constructor(data?: IPaginatedTableListOfLicenseVolumeHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LicenseVolumeHistory.fromJS(item));
            }
            this.continuationToken = _data["continuationToken"];
        }
    }

    static fromJS(data: any): PaginatedTableListOfLicenseVolumeHistory {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedTableListOfLicenseVolumeHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["continuationToken"] = this.continuationToken;
        return data;
    }
}

export interface IPaginatedTableListOfLicenseVolumeHistory {
    items: LicenseVolumeHistory[];
    continuationToken: string | undefined;
}

export abstract class AuditableEntity implements IAuditableEntity {
    createdBy!: number;
    createdOn!: Date;
    modifiedBy!: number;
    modifiedOn!: Date;

    constructor(data?: IAuditableEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AuditableEntity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'AuditableEntity' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAuditableEntity {
    createdBy: number;
    createdOn: Date;
    modifiedBy: number;
    modifiedOn: Date;
}

export class TableStorageEntity extends AuditableEntity implements ITableStorageEntity {
    partitionKey!: string;
    rowKey!: string;
    timestamp!: Date | undefined;

    constructor(data?: ITableStorageEntity) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.partitionKey = _data["partitionKey"];
            this.rowKey = _data["rowKey"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TableStorageEntity {
        data = typeof data === 'object' ? data : {};
        let result = new TableStorageEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partitionKey"] = this.partitionKey;
        data["rowKey"] = this.rowKey;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ITableStorageEntity extends IAuditableEntity {
    partitionKey: string;
    rowKey: string;
    timestamp: Date | undefined;
}

export class LicenseVolumeHistory extends TableStorageEntity implements ILicenseVolumeHistory {
    licenseId!: number;
    activationCode!: string;
    taskType!: number | undefined;
    currentVolume!: number;
    totalVolume!: number;
    totalPages!: number;
    creditsSpent!: number | undefined;
    creditsCost!: number | undefined;
    status!: string;
    tenantId!: number;
    documentName!: string;
    processDate!: Date | undefined;

    constructor(data?: ILicenseVolumeHistory) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.licenseId = _data["licenseId"];
            this.activationCode = _data["activationCode"];
            this.taskType = _data["taskType"];
            this.currentVolume = _data["currentVolume"];
            this.totalVolume = _data["totalVolume"];
            this.totalPages = _data["totalPages"];
            this.creditsSpent = _data["creditsSpent"];
            this.creditsCost = _data["creditsCost"];
            this.status = _data["status"];
            this.tenantId = _data["tenantId"];
            this.documentName = _data["documentName"];
            this.processDate = _data["processDate"] ? new Date(_data["processDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): LicenseVolumeHistory {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseVolumeHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseId"] = this.licenseId;
        data["activationCode"] = this.activationCode;
        data["taskType"] = this.taskType;
        data["currentVolume"] = this.currentVolume;
        data["totalVolume"] = this.totalVolume;
        data["totalPages"] = this.totalPages;
        data["creditsSpent"] = this.creditsSpent;
        data["creditsCost"] = this.creditsCost;
        data["status"] = this.status;
        data["tenantId"] = this.tenantId;
        data["documentName"] = this.documentName;
        data["processDate"] = this.processDate ? this.processDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ILicenseVolumeHistory extends ITableStorageEntity {
    licenseId: number;
    activationCode: string;
    taskType: number | undefined;
    currentVolume: number;
    totalVolume: number;
    totalPages: number;
    creditsSpent: number | undefined;
    creditsCost: number | undefined;
    status: string;
    tenantId: number;
    documentName: string;
    processDate: Date | undefined;
}

export class PaginatedRequestQueryFilter implements IPaginatedRequestQueryFilter {
    field!: string;
    operator!: string;
    operationType!: string;
    value!: string;
    label!: string;

    constructor(data?: IPaginatedRequestQueryFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.operator = _data["operator"];
            this.operationType = _data["operationType"];
            this.value = _data["value"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): PaginatedRequestQueryFilter {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedRequestQueryFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["operator"] = this.operator;
        data["operationType"] = this.operationType;
        data["value"] = this.value;
        data["label"] = this.label;
        return data;
    }
}

export interface IPaginatedRequestQueryFilter {
    field: string;
    operator: string;
    operationType: string;
    value: string;
    label: string;
}

export class PaginatedTableListOfLicenseHistory implements IPaginatedTableListOfLicenseHistory {
    items!: LicenseHistory[];
    continuationToken!: string | undefined;

    constructor(data?: IPaginatedTableListOfLicenseHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LicenseHistory.fromJS(item));
            }
            this.continuationToken = _data["continuationToken"];
        }
    }

    static fromJS(data: any): PaginatedTableListOfLicenseHistory {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedTableListOfLicenseHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["continuationToken"] = this.continuationToken;
        return data;
    }
}

export interface IPaginatedTableListOfLicenseHistory {
    items: LicenseHistory[];
    continuationToken: string | undefined;
}

export class LicenseHistory extends TableStorageEntity implements ILicenseHistory {
    licenseId!: number;
    isTrial!: boolean;
    activationCode!: string;
    volume!: number;
    expirationDate!: Date | undefined;
    activationDate!: Date;
    licenseData!: string | undefined;
    tenantId!: number;

    constructor(data?: ILicenseHistory) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.licenseId = _data["licenseId"];
            this.isTrial = _data["isTrial"];
            this.activationCode = _data["activationCode"];
            this.volume = _data["volume"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.activationDate = _data["activationDate"] ? new Date(_data["activationDate"].toString()) : <any>undefined;
            this.licenseData = _data["licenseData"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): LicenseHistory {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseId"] = this.licenseId;
        data["isTrial"] = this.isTrial;
        data["activationCode"] = this.activationCode;
        data["volume"] = this.volume;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["activationDate"] = this.activationDate ? this.activationDate.toISOString() : <any>undefined;
        data["licenseData"] = this.licenseData;
        data["tenantId"] = this.tenantId;
        super.toJSON(data);
        return data;
    }
}

export interface ILicenseHistory extends ITableStorageEntity {
    licenseId: number;
    isTrial: boolean;
    activationCode: string;
    volume: number;
    expirationDate: Date | undefined;
    activationDate: Date;
    licenseData: string | undefined;
    tenantId: number;
}

export class ResultWithCodeOfBooleanAndLicenseError implements IResultWithCodeOfBooleanAndLicenseError {
    succeeded!: boolean;
    result!: boolean;
    errors!: ErrorWithCodeOfLicenseError[];

    constructor(data?: IResultWithCodeOfBooleanAndLicenseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.result = _data["result"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorWithCodeOfLicenseError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultWithCodeOfBooleanAndLicenseError {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithCodeOfBooleanAndLicenseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["result"] = this.result;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResultWithCodeOfBooleanAndLicenseError {
    succeeded: boolean;
    result: boolean;
    errors: ErrorWithCodeOfLicenseError[];
}

export class ErrorWithCodeOfLicenseError implements IErrorWithCodeOfLicenseError {
    code!: LicenseError;
    error!: string;

    constructor(data?: IErrorWithCodeOfLicenseError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): ErrorWithCodeOfLicenseError {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorWithCodeOfLicenseError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["error"] = this.error;
        return data;
    }
}

export interface IErrorWithCodeOfLicenseError {
    code: LicenseError;
    error: string;
}

export enum LicenseError {
    ActivationCodeAlreadyUsed = 1,
    InvalidActivationCode = 2,
    InvalidActivationFile = 3,
    InvalidActivationData = 4,
    MaxInstancesReached = 5,
    ErrorGeneratingLicense = 6,
    CustomError = 7,
    Expires = 8,
    FeatureDataPropertyNullOrWhitespace = 9,
    FeatureDataNotDeserializable = 10,
}

export class LicenseActivateModel implements ILicenseActivateModel {
    activationCode!: string;

    constructor(data?: ILicenseActivateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activationCode = _data["activationCode"];
        }
    }

    static fromJS(data: any): LicenseActivateModel {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseActivateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activationCode"] = this.activationCode;
        return data;
    }
}

export interface ILicenseActivateModel {
    activationCode: string;
}

export class NotificationConfigFullViewModel implements INotificationConfigFullViewModel {
    language!: string;
    notificationTypeConfig!: NotificationTypeConfigViewModel[];

    constructor(data?: INotificationConfigFullViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
            if (Array.isArray(_data["notificationTypeConfig"])) {
                this.notificationTypeConfig = [] as any;
                for (let item of _data["notificationTypeConfig"])
                    this.notificationTypeConfig!.push(NotificationTypeConfigViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NotificationConfigFullViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationConfigFullViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        if (Array.isArray(this.notificationTypeConfig)) {
            data["notificationTypeConfig"] = [];
            for (let item of this.notificationTypeConfig)
                data["notificationTypeConfig"].push(item.toJSON());
        }
        return data;
    }
}

export interface INotificationConfigFullViewModel {
    language: string;
    notificationTypeConfig: NotificationTypeConfigViewModel[];
}

export class NotificationTypeConfigViewModel implements INotificationTypeConfigViewModel {
    eventType!: NotificationEventType;
    notificationEventConfig!: NotificationEventConfigViewModel[];

    constructor(data?: INotificationTypeConfigViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventType = _data["eventType"];
            if (Array.isArray(_data["notificationEventConfig"])) {
                this.notificationEventConfig = [] as any;
                for (let item of _data["notificationEventConfig"])
                    this.notificationEventConfig!.push(NotificationEventConfigViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NotificationTypeConfigViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationTypeConfigViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventType"] = this.eventType;
        if (Array.isArray(this.notificationEventConfig)) {
            data["notificationEventConfig"] = [];
            for (let item of this.notificationEventConfig)
                data["notificationEventConfig"].push(item.toJSON());
        }
        return data;
    }
}

export interface INotificationTypeConfigViewModel {
    eventType: NotificationEventType;
    notificationEventConfig: NotificationEventConfigViewModel[];
}

export enum NotificationEventType {
    TaskReadyToReview = 10,
    TaskSentToHistory = 20,
}

export class NotificationEventConfigViewModel implements INotificationEventConfigViewModel {
    notificationType!: NotificationType;
    notifyCreator!: boolean;
    notifyReviewers!: boolean;
    customRecipients!: GenericUserViewModel[];

    constructor(data?: INotificationEventConfigViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationType = _data["notificationType"];
            this.notifyCreator = _data["notifyCreator"];
            this.notifyReviewers = _data["notifyReviewers"];
            if (Array.isArray(_data["customRecipients"])) {
                this.customRecipients = [] as any;
                for (let item of _data["customRecipients"])
                    this.customRecipients!.push(GenericUserViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NotificationEventConfigViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationEventConfigViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationType"] = this.notificationType;
        data["notifyCreator"] = this.notifyCreator;
        data["notifyReviewers"] = this.notifyReviewers;
        if (Array.isArray(this.customRecipients)) {
            data["customRecipients"] = [];
            for (let item of this.customRecipients)
                data["customRecipients"].push(item.toJSON());
        }
        return data;
    }
}

export interface INotificationEventConfigViewModel {
    notificationType: NotificationType;
    notifyCreator: boolean;
    notifyReviewers: boolean;
    customRecipients: GenericUserViewModel[];
}

export enum NotificationType {
    Email = 10,
}

export class GenericUserViewModel implements IGenericUserViewModel {
    userId!: number;
    minimumRoleId!: number;
    roleId!: number;
    name!: string;
    userName!: string;
    email!: string;
    joinedOn!: Date;
    userStatus!: UserStatus;
    isDefault!: boolean;
    tenantId!: number;
    emailConfirmed!: boolean;
    profilePicture!: string | undefined;
    isTenantOwner!: boolean;

    constructor(data?: IGenericUserViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.minimumRoleId = _data["minimumRoleId"];
            this.roleId = _data["roleId"];
            this.name = _data["name"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.joinedOn = _data["joinedOn"] ? new Date(_data["joinedOn"].toString()) : <any>undefined;
            this.userStatus = _data["userStatus"];
            this.isDefault = _data["isDefault"];
            this.tenantId = _data["tenantId"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.profilePicture = _data["profilePicture"];
            this.isTenantOwner = _data["isTenantOwner"];
        }
    }

    static fromJS(data: any): GenericUserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GenericUserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["minimumRoleId"] = this.minimumRoleId;
        data["roleId"] = this.roleId;
        data["name"] = this.name;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["joinedOn"] = this.joinedOn ? this.joinedOn.toISOString() : <any>undefined;
        data["userStatus"] = this.userStatus;
        data["isDefault"] = this.isDefault;
        data["tenantId"] = this.tenantId;
        data["emailConfirmed"] = this.emailConfirmed;
        data["profilePicture"] = this.profilePicture;
        data["isTenantOwner"] = this.isTenantOwner;
        return data;
    }
}

export interface IGenericUserViewModel {
    userId: number;
    minimumRoleId: number;
    roleId: number;
    name: string;
    userName: string;
    email: string;
    joinedOn: Date;
    userStatus: UserStatus;
    isDefault: boolean;
    tenantId: number;
    emailConfirmed: boolean;
    profilePicture: string | undefined;
    isTenantOwner: boolean;
}

export enum UserStatus {
    Active = 10,
    Inactive = 20,
}

export class CartProductCreateModel implements ICartProductCreateModel {
    quantity!: number;
    duration!: StorePaymentRecurrencyTypeEnum | undefined;
    planCode!: string | undefined;
    featureCode!: string | undefined;

    constructor(data?: ICartProductCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["quantity"];
            this.duration = _data["duration"];
            this.planCode = _data["planCode"];
            this.featureCode = _data["featureCode"];
        }
    }

    static fromJS(data: any): CartProductCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new CartProductCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity;
        data["duration"] = this.duration;
        data["planCode"] = this.planCode;
        data["featureCode"] = this.featureCode;
        return data;
    }
}

export interface ICartProductCreateModel {
    quantity: number;
    duration: StorePaymentRecurrencyTypeEnum | undefined;
    planCode: string | undefined;
    featureCode: string | undefined;
}

export enum StorePaymentRecurrencyTypeEnum {
    None = 0,
    Monthly = 1,
    Annual = 2,
}

export class PipelineMaterializedFieldsViewModel implements IPipelineMaterializedFieldsViewModel {
    detectableFields!: SdFieldViewModel[];
    customFormValuesCustomForm!: SdcCustomForm | undefined;
    customFormValuesDefaultsCustomForm!: SdcCustomForm | undefined;
    contextCustomForm!: SdcCustomForm | undefined;
    externalIdRequired!: boolean | undefined;
    suggestAdvancedEditingMode!: boolean | undefined;
    supportedFileTypes!: string[];
    forceSingleChunk!: boolean | undefined;
    taskType!: TaskType;
    maxFileSizeBytes!: number | undefined;

    constructor(data?: IPipelineMaterializedFieldsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["detectableFields"])) {
                this.detectableFields = [] as any;
                for (let item of _data["detectableFields"])
                    this.detectableFields!.push(SdFieldViewModel.fromJS(item));
            }
            this.customFormValuesCustomForm = _data["customFormValuesCustomForm"] ? SdcCustomForm.fromJS(_data["customFormValuesCustomForm"]) : <any>undefined;
            this.customFormValuesDefaultsCustomForm = _data["customFormValuesDefaultsCustomForm"] ? SdcCustomForm.fromJS(_data["customFormValuesDefaultsCustomForm"]) : <any>undefined;
            this.contextCustomForm = _data["contextCustomForm"] ? SdcCustomForm.fromJS(_data["contextCustomForm"]) : <any>undefined;
            this.externalIdRequired = _data["externalIdRequired"];
            this.suggestAdvancedEditingMode = _data["suggestAdvancedEditingMode"];
            if (Array.isArray(_data["supportedFileTypes"])) {
                this.supportedFileTypes = [] as any;
                for (let item of _data["supportedFileTypes"])
                    this.supportedFileTypes!.push(item);
            }
            this.forceSingleChunk = _data["forceSingleChunk"];
            this.taskType = _data["taskType"];
            this.maxFileSizeBytes = _data["maxFileSizeBytes"];
        }
    }

    static fromJS(data: any): PipelineMaterializedFieldsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PipelineMaterializedFieldsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.detectableFields)) {
            data["detectableFields"] = [];
            for (let item of this.detectableFields)
                data["detectableFields"].push(item.toJSON());
        }
        data["customFormValuesCustomForm"] = this.customFormValuesCustomForm ? this.customFormValuesCustomForm.toJSON() : <any>undefined;
        data["customFormValuesDefaultsCustomForm"] = this.customFormValuesDefaultsCustomForm ? this.customFormValuesDefaultsCustomForm.toJSON() : <any>undefined;
        data["contextCustomForm"] = this.contextCustomForm ? this.contextCustomForm.toJSON() : <any>undefined;
        data["externalIdRequired"] = this.externalIdRequired;
        data["suggestAdvancedEditingMode"] = this.suggestAdvancedEditingMode;
        if (Array.isArray(this.supportedFileTypes)) {
            data["supportedFileTypes"] = [];
            for (let item of this.supportedFileTypes)
                data["supportedFileTypes"].push(item);
        }
        data["forceSingleChunk"] = this.forceSingleChunk;
        data["taskType"] = this.taskType;
        data["maxFileSizeBytes"] = this.maxFileSizeBytes;
        return data;
    }
}

export interface IPipelineMaterializedFieldsViewModel {
    detectableFields: SdFieldViewModel[];
    customFormValuesCustomForm: SdcCustomForm | undefined;
    customFormValuesDefaultsCustomForm: SdcCustomForm | undefined;
    contextCustomForm: SdcCustomForm | undefined;
    externalIdRequired: boolean | undefined;
    suggestAdvancedEditingMode: boolean | undefined;
    supportedFileTypes: string[];
    forceSingleChunk: boolean | undefined;
    taskType: TaskType;
    maxFileSizeBytes: number | undefined;
}

export class PipelineModel extends PipelineMaterializedFieldsViewModel implements IPipelineModel {
    pipelineId!: string;
    tenantCode!: string;
    workspaceId!: number;
    preProcessingStepIds!: string[];
    recognizerStepId!: string;
    postProcessingStepIds!: string[];
    integrationStepIds!: string[];

    constructor(data?: IPipelineModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pipelineId = _data["pipelineId"];
            this.tenantCode = _data["tenantCode"];
            this.workspaceId = _data["workspaceId"];
            if (Array.isArray(_data["preProcessingStepIds"])) {
                this.preProcessingStepIds = [] as any;
                for (let item of _data["preProcessingStepIds"])
                    this.preProcessingStepIds!.push(item);
            }
            this.recognizerStepId = _data["recognizerStepId"];
            if (Array.isArray(_data["postProcessingStepIds"])) {
                this.postProcessingStepIds = [] as any;
                for (let item of _data["postProcessingStepIds"])
                    this.postProcessingStepIds!.push(item);
            }
            if (Array.isArray(_data["integrationStepIds"])) {
                this.integrationStepIds = [] as any;
                for (let item of _data["integrationStepIds"])
                    this.integrationStepIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PipelineModel {
        data = typeof data === 'object' ? data : {};
        let result = new PipelineModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pipelineId"] = this.pipelineId;
        data["tenantCode"] = this.tenantCode;
        data["workspaceId"] = this.workspaceId;
        if (Array.isArray(this.preProcessingStepIds)) {
            data["preProcessingStepIds"] = [];
            for (let item of this.preProcessingStepIds)
                data["preProcessingStepIds"].push(item);
        }
        data["recognizerStepId"] = this.recognizerStepId;
        if (Array.isArray(this.postProcessingStepIds)) {
            data["postProcessingStepIds"] = [];
            for (let item of this.postProcessingStepIds)
                data["postProcessingStepIds"].push(item);
        }
        if (Array.isArray(this.integrationStepIds)) {
            data["integrationStepIds"] = [];
            for (let item of this.integrationStepIds)
                data["integrationStepIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPipelineModel extends IPipelineMaterializedFieldsViewModel {
    pipelineId: string;
    tenantCode: string;
    workspaceId: number;
    preProcessingStepIds: string[];
    recognizerStepId: string;
    postProcessingStepIds: string[];
    integrationStepIds: string[];
}

export class SdFieldViewModel implements ISdFieldViewModel {
    parentCategoryKey!: string | undefined;
    categoryKey!: string;
    alternativeCategoryKeys!: string | undefined;
    displayName!: string;
    description!: string;
    fillColor!: string;
    strokeColor!: string;
    groupType!: FieldGroupType | undefined;
    fieldConfig!: SdcCustomFormField | undefined;
    hideInColSelect!: boolean | undefined;
    editLocked!: boolean | undefined;
    tableField!: SdTableFieldViewModel | undefined;
    generationMethod!: string | undefined;
    associatedFieldKey!: string | undefined;

    constructor(data?: ISdFieldViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentCategoryKey = _data["parentCategoryKey"];
            this.categoryKey = _data["categoryKey"];
            this.alternativeCategoryKeys = _data["alternativeCategoryKeys"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.fillColor = _data["fillColor"];
            this.strokeColor = _data["strokeColor"];
            this.groupType = _data["groupType"];
            this.fieldConfig = _data["fieldConfig"] ? SdcCustomFormField.fromJS(_data["fieldConfig"]) : <any>undefined;
            this.hideInColSelect = _data["hideInColSelect"];
            this.editLocked = _data["editLocked"];
            this.tableField = _data["tableField"] ? SdTableFieldViewModel.fromJS(_data["tableField"]) : <any>undefined;
            this.generationMethod = _data["generationMethod"];
            this.associatedFieldKey = _data["associatedFieldKey"];
        }
    }

    static fromJS(data: any): SdFieldViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdFieldViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentCategoryKey"] = this.parentCategoryKey;
        data["categoryKey"] = this.categoryKey;
        data["alternativeCategoryKeys"] = this.alternativeCategoryKeys;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["fillColor"] = this.fillColor;
        data["strokeColor"] = this.strokeColor;
        data["groupType"] = this.groupType;
        data["fieldConfig"] = this.fieldConfig ? this.fieldConfig.toJSON() : <any>undefined;
        data["hideInColSelect"] = this.hideInColSelect;
        data["editLocked"] = this.editLocked;
        data["tableField"] = this.tableField ? this.tableField.toJSON() : <any>undefined;
        data["generationMethod"] = this.generationMethod;
        data["associatedFieldKey"] = this.associatedFieldKey;
        return data;
    }
}

export interface ISdFieldViewModel {
    parentCategoryKey: string | undefined;
    categoryKey: string;
    alternativeCategoryKeys: string | undefined;
    displayName: string;
    description: string;
    fillColor: string;
    strokeColor: string;
    groupType: FieldGroupType | undefined;
    fieldConfig: SdcCustomFormField | undefined;
    hideInColSelect: boolean | undefined;
    editLocked: boolean | undefined;
    tableField: SdTableFieldViewModel | undefined;
    generationMethod: string | undefined;
    associatedFieldKey: string | undefined;
}

export enum FieldGroupType {
    QrCodePt = 90,
    Table = 100,
}

export class SdcCustomFormField implements ISdcCustomFormField {
    id!: number;
    title!: string;
    md!: number;
    sm!: number;
    name!: string;
    type!: SdcCustomFormFieldType;
    tooltip!: string | undefined;
    minWidth!: string | undefined;
    maxWidth!: string | undefined;
    placeholder!: string | undefined;
    classes!: string | undefined;
    isRequired!: boolean | undefined;
    defaultValue!: any | undefined;
    hidden!: boolean | undefined;
    readonly!: boolean | undefined;
    disabled!: boolean | undefined;
    printOnSuccess!: boolean | undefined;
    configurations!: SdcCustomFormFieldEntryConfiguration | undefined;
    previewable!: boolean | undefined;

    constructor(data?: ISdcCustomFormField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.md = _data["md"];
            this.sm = _data["sm"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.tooltip = _data["tooltip"];
            this.minWidth = _data["minWidth"];
            this.maxWidth = _data["maxWidth"];
            this.placeholder = _data["placeholder"];
            this.classes = _data["classes"];
            this.isRequired = _data["isRequired"];
            this.defaultValue = _data["defaultValue"];
            this.hidden = _data["hidden"];
            this.readonly = _data["readonly"];
            this.disabled = _data["disabled"];
            this.printOnSuccess = _data["printOnSuccess"];
            this.configurations = _data["configurations"] ? SdcCustomFormFieldEntryConfiguration.fromJS(_data["configurations"]) : <any>undefined;
            this.previewable = _data["previewable"];
        }
    }

    static fromJS(data: any): SdcCustomFormField {
        data = typeof data === 'object' ? data : {};
        let result = new SdcCustomFormField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["md"] = this.md;
        data["sm"] = this.sm;
        data["name"] = this.name;
        data["type"] = this.type;
        data["tooltip"] = this.tooltip;
        data["minWidth"] = this.minWidth;
        data["maxWidth"] = this.maxWidth;
        data["placeholder"] = this.placeholder;
        data["classes"] = this.classes;
        data["isRequired"] = this.isRequired;
        data["defaultValue"] = this.defaultValue;
        data["hidden"] = this.hidden;
        data["readonly"] = this.readonly;
        data["disabled"] = this.disabled;
        data["printOnSuccess"] = this.printOnSuccess;
        data["configurations"] = this.configurations ? this.configurations.toJSON() : <any>undefined;
        data["previewable"] = this.previewable;
        return data;
    }
}

export interface ISdcCustomFormField {
    id: number;
    title: string;
    md: number;
    sm: number;
    name: string;
    type: SdcCustomFormFieldType;
    tooltip: string | undefined;
    minWidth: string | undefined;
    maxWidth: string | undefined;
    placeholder: string | undefined;
    classes: string | undefined;
    isRequired: boolean | undefined;
    defaultValue: any | undefined;
    hidden: boolean | undefined;
    readonly: boolean | undefined;
    disabled: boolean | undefined;
    printOnSuccess: boolean | undefined;
    configurations: SdcCustomFormFieldEntryConfiguration | undefined;
    previewable: boolean | undefined;
}

export class SdcCustomFormFieldEntryConfiguration implements ISdcCustomFormFieldEntryConfiguration {
    min!: number | undefined;
    max!: number | undefined;
    matches!: SdcCustomFormFieldMatches | undefined;
    isDecimal!: boolean | undefined;
    propertyLabel!: string | undefined;
    useCache!: boolean | undefined;
    options!: SdcCustomFormFieldList[];
    rows!: number | undefined;

    constructor(data?: ISdcCustomFormFieldEntryConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.min = _data["min"];
            this.max = _data["max"];
            this.matches = _data["matches"] ? SdcCustomFormFieldMatches.fromJS(_data["matches"]) : <any>undefined;
            this.isDecimal = _data["isDecimal"];
            this.propertyLabel = _data["propertyLabel"];
            this.useCache = _data["useCache"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(SdcCustomFormFieldList.fromJS(item));
            }
            this.rows = _data["rows"];
        }
    }

    static fromJS(data: any): SdcCustomFormFieldEntryConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new SdcCustomFormFieldEntryConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min;
        data["max"] = this.max;
        data["matches"] = this.matches ? this.matches.toJSON() : <any>undefined;
        data["isDecimal"] = this.isDecimal;
        data["propertyLabel"] = this.propertyLabel;
        data["useCache"] = this.useCache;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        data["rows"] = this.rows;
        return data;
    }
}

export interface ISdcCustomFormFieldEntryConfiguration {
    min: number | undefined;
    max: number | undefined;
    matches: SdcCustomFormFieldMatches | undefined;
    isDecimal: boolean | undefined;
    propertyLabel: string | undefined;
    useCache: boolean | undefined;
    options: SdcCustomFormFieldList[];
    rows: number | undefined;
}

export class SdcCustomFormFieldMatches implements ISdcCustomFormFieldMatches {
    regExp!: string;
    message!: string;

    constructor(data?: ISdcCustomFormFieldMatches) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.regExp = _data["regExp"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SdcCustomFormFieldMatches {
        data = typeof data === 'object' ? data : {};
        let result = new SdcCustomFormFieldMatches();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regExp"] = this.regExp;
        data["message"] = this.message;
        return data;
    }
}

export interface ISdcCustomFormFieldMatches {
    regExp: string;
    message: string;
}

export class SdcCustomFormFieldList implements ISdcCustomFormFieldList {
    label!: string | undefined;
    options!: SdcCustomFormFieldListItem[];

    constructor(data?: ISdcCustomFormFieldList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(SdcCustomFormFieldListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SdcCustomFormFieldList {
        data = typeof data === 'object' ? data : {};
        let result = new SdcCustomFormFieldList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISdcCustomFormFieldList {
    label: string | undefined;
    options: SdcCustomFormFieldListItem[];
}

export class SdcCustomFormFieldListItem implements ISdcCustomFormFieldListItem {
    value!: any;
    label!: string;
    color!: string | undefined;
    isFixed!: boolean | undefined;

    constructor(data?: ISdcCustomFormFieldListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
            this.color = _data["color"];
            this.isFixed = _data["isFixed"];
        }
    }

    static fromJS(data: any): SdcCustomFormFieldListItem {
        data = typeof data === 'object' ? data : {};
        let result = new SdcCustomFormFieldListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        data["color"] = this.color;
        data["isFixed"] = this.isFixed;
        return data;
    }
}

export interface ISdcCustomFormFieldListItem {
    value: any;
    label: string;
    color: string | undefined;
    isFixed: boolean | undefined;
}

export class SdTableFieldViewModel implements ISdTableFieldViewModel {
    columns!: { [key: string]: SdFieldViewModel; };

    constructor(data?: ISdTableFieldViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["columns"]) {
                this.columns = {} as any;
                for (let key in _data["columns"]) {
                    if (_data["columns"].hasOwnProperty(key))
                        (<any>this.columns)![key] = _data["columns"][key] ? SdFieldViewModel.fromJS(_data["columns"][key]) : new SdFieldViewModel();
                }
            }
        }
    }

    static fromJS(data: any): SdTableFieldViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdTableFieldViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.columns) {
            data["columns"] = {};
            for (let key in this.columns) {
                if (this.columns.hasOwnProperty(key))
                    (<any>data["columns"])[key] = this.columns[key] ? this.columns[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface ISdTableFieldViewModel {
    columns: { [key: string]: SdFieldViewModel; };
}

export class SdcCustomForm implements ISdcCustomForm {
    sections!: SdcCustomFormSection[];

    constructor(data?: ISdcCustomForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(SdcCustomFormSection.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SdcCustomForm {
        data = typeof data === 'object' ? data : {};
        let result = new SdcCustomForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISdcCustomForm {
    sections: SdcCustomFormSection[];
}

export class SdcCustomFormSection implements ISdcCustomFormSection {
    id!: number;
    md!: number;
    sm!: number;
    fields!: SdcCustomFormField[];
    title!: string | undefined;
    description!: string | undefined;

    constructor(data?: ISdcCustomFormSection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.md = _data["md"];
            this.sm = _data["sm"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(SdcCustomFormField.fromJS(item));
            }
            this.title = _data["title"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): SdcCustomFormSection {
        data = typeof data === 'object' ? data : {};
        let result = new SdcCustomFormSection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["md"] = this.md;
        data["sm"] = this.sm;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        data["title"] = this.title;
        data["description"] = this.description;
        return data;
    }
}

export interface ISdcCustomFormSection {
    id: number;
    md: number;
    sm: number;
    fields: SdcCustomFormField[];
    title: string | undefined;
    description: string | undefined;
}

export enum TaskType {
    Invoice = 10,
    Receipt = 20,
    LegalDocument = 30,
    Transcript = 40,
    Labelling = 50,
    Custom = 60,
    Subtitles = 70,
    DocumentAnonymization = 80,
    ImageAnonymization = 90,
    IdDocument = 100,
    Layout = 110,
    CustomTrainTemplate = 120,
    CustomTrainNeural = 130,
    Translation = 140,
    TranscriptSummarization = 150,
    DocumentContentUnderstanding = 160,
}

export class SdBatchViewModel implements ISdBatchViewModel {
    id!: number;
    batchId!: number;
    workspaceId!: number;
    displayName!: string;
    description!: string | undefined;
    createdOn!: Date;
    totalTasks!: number;
    totalTasksInHistory!: number;
    isOpen!: boolean;
    status!: SdBatchStatus | undefined;
    batchType!: SdBatchType;
    anyBatchTaskId!: number | undefined;
    useHigherQuality!: boolean | undefined;
    canBeDeleted!: boolean;

    constructor(data?: ISdBatchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.batchId = _data["batchId"];
            this.workspaceId = _data["workspaceId"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.totalTasks = _data["totalTasks"];
            this.totalTasksInHistory = _data["totalTasksInHistory"];
            this.isOpen = _data["isOpen"];
            this.status = _data["status"];
            this.batchType = _data["batchType"];
            this.anyBatchTaskId = _data["anyBatchTaskId"];
            this.useHigherQuality = _data["useHigherQuality"];
            this.canBeDeleted = _data["canBeDeleted"];
        }
    }

    static fromJS(data: any): SdBatchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdBatchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["batchId"] = this.batchId;
        data["workspaceId"] = this.workspaceId;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["totalTasks"] = this.totalTasks;
        data["totalTasksInHistory"] = this.totalTasksInHistory;
        data["isOpen"] = this.isOpen;
        data["status"] = this.status;
        data["batchType"] = this.batchType;
        data["anyBatchTaskId"] = this.anyBatchTaskId;
        data["useHigherQuality"] = this.useHigherQuality;
        data["canBeDeleted"] = this.canBeDeleted;
        return data;
    }
}

export interface ISdBatchViewModel {
    id: number;
    batchId: number;
    workspaceId: number;
    displayName: string;
    description: string | undefined;
    createdOn: Date;
    totalTasks: number;
    totalTasksInHistory: number;
    isOpen: boolean;
    status: SdBatchStatus | undefined;
    batchType: SdBatchType;
    anyBatchTaskId: number | undefined;
    useHigherQuality: boolean | undefined;
    canBeDeleted: boolean;
}

export enum SdBatchStatus {
    Deleted = 20,
    QueuedForPreProcessing = 30,
    PreProcessingSplittingInProgress = 38,
    PreProcessingSplittingFailed = 39,
    ToReview = 60,
    QueuedForExport = 90,
    ExportInProgress = 91,
    ExportFailed = 93,
    ExportSuccessful = 94,
    Processed = 100,
}

export class CreateSdBatchModel implements ICreateSdBatchModel {
    displayName!: string;
    description!: string | undefined;
    workspaceId!: number | undefined;
    isOpen!: boolean | undefined;

    constructor(data?: ICreateSdBatchModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.workspaceId = _data["workspaceId"];
            this.isOpen = _data["isOpen"];
        }
    }

    static fromJS(data: any): CreateSdBatchModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSdBatchModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["workspaceId"] = this.workspaceId;
        data["isOpen"] = this.isOpen;
        return data;
    }
}

export interface ICreateSdBatchModel {
    displayName: string;
    description: string | undefined;
    workspaceId: number | undefined;
    isOpen: boolean | undefined;
}

export class PaginatedListOfSdBatchViewModel implements IPaginatedListOfSdBatchViewModel {
    items!: SdBatchViewModel[];
    pageNumber!: number;
    totalPages!: number;
    totalCount!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfSdBatchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SdBatchViewModel.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfSdBatchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfSdBatchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfSdBatchViewModel {
    items: SdBatchViewModel[];
    pageNumber: number;
    totalPages: number;
    totalCount: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class RequestQuery implements IRequestQuery {
    filter!: string;
    filters!: PaginatedRequestQueryFilter[];
    sort!: string[];

    constructor(data?: IRequestQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(PaginatedRequestQueryFilter.fromJS(item));
            }
            if (Array.isArray(_data["sort"])) {
                this.sort = [] as any;
                for (let item of _data["sort"])
                    this.sort!.push(item);
            }
        }
    }

    static fromJS(data: any): RequestQuery {
        data = typeof data === 'object' ? data : {};
        let result = new RequestQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.sort)) {
            data["sort"] = [];
            for (let item of this.sort)
                data["sort"].push(item);
        }
        return data;
    }
}

export interface IRequestQuery {
    filter: string;
    filters: PaginatedRequestQueryFilter[];
    sort: string[];
}

export class PaginatedRequestQuery extends RequestQuery implements IPaginatedRequestQuery {
    pageNumber!: number;
    pageSize!: number;

    constructor(data?: IPaginatedRequestQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): PaginatedRequestQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedRequestQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedRequestQuery extends IRequestQuery {
    pageNumber: number;
    pageSize: number;
}

export class MultipleBatchSelectionModel implements IMultipleBatchSelectionModel {
    workspaceId!: number;
    batchIdList!: number[];
    filters!: PaginatedRequestQueryFilter[];

    constructor(data?: IMultipleBatchSelectionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workspaceId = _data["workspaceId"];
            if (Array.isArray(_data["batchIdList"])) {
                this.batchIdList = [] as any;
                for (let item of _data["batchIdList"])
                    this.batchIdList!.push(item);
            }
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(PaginatedRequestQueryFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MultipleBatchSelectionModel {
        data = typeof data === 'object' ? data : {};
        let result = new MultipleBatchSelectionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workspaceId"] = this.workspaceId;
        if (Array.isArray(this.batchIdList)) {
            data["batchIdList"] = [];
            for (let item of this.batchIdList)
                data["batchIdList"].push(item);
        }
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMultipleBatchSelectionModel {
    workspaceId: number;
    batchIdList: number[];
    filters: PaginatedRequestQueryFilter[];
}

export class TotalTasksToReviewModel implements ITotalTasksToReviewModel {
    workSpaceId!: number;
    totalTasksToReview!: number;

    constructor(data?: ITotalTasksToReviewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workSpaceId = _data["workSpaceId"];
            this.totalTasksToReview = _data["totalTasksToReview"];
        }
    }

    static fromJS(data: any): TotalTasksToReviewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TotalTasksToReviewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workSpaceId"] = this.workSpaceId;
        data["totalTasksToReview"] = this.totalTasksToReview;
        return data;
    }
}

export interface ITotalTasksToReviewModel {
    workSpaceId: number;
    totalTasksToReview: number;
}

export class SdTaskIntegrationDetailsModel implements ISdTaskIntegrationDetailsModel {
    queuedOn!: Date;
    integratedOn!: Date | undefined;
    queuedByUserName!: string | undefined;
    queuedBy!: number;
    result!: SdTaskIntegrationResultViewModel | undefined;

    constructor(data?: ISdTaskIntegrationDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.queuedOn = _data["queuedOn"] ? new Date(_data["queuedOn"].toString()) : <any>undefined;
            this.integratedOn = _data["integratedOn"] ? new Date(_data["integratedOn"].toString()) : <any>undefined;
            this.queuedByUserName = _data["queuedByUserName"];
            this.queuedBy = _data["queuedBy"];
            this.result = _data["result"] ? SdTaskIntegrationResultViewModel.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SdTaskIntegrationDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdTaskIntegrationDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["queuedOn"] = this.queuedOn ? this.queuedOn.toISOString() : <any>undefined;
        data["integratedOn"] = this.integratedOn ? this.integratedOn.toISOString() : <any>undefined;
        data["queuedByUserName"] = this.queuedByUserName;
        data["queuedBy"] = this.queuedBy;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISdTaskIntegrationDetailsModel {
    queuedOn: Date;
    integratedOn: Date | undefined;
    queuedByUserName: string | undefined;
    queuedBy: number;
    result: SdTaskIntegrationResultViewModel | undefined;
}

export class SdTaskIntegrationResultViewModel implements ISdTaskIntegrationResultViewModel {
    success!: boolean;
    pageIndexesWithErrors!: number[];
    pageUploadErrors!: { [key: string]: string; };
    workerErrorDetails!: string | undefined;
    skipFinishIntegration!: boolean | undefined;

    constructor(data?: ISdTaskIntegrationResultViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["pageIndexesWithErrors"])) {
                this.pageIndexesWithErrors = [] as any;
                for (let item of _data["pageIndexesWithErrors"])
                    this.pageIndexesWithErrors!.push(item);
            }
            if (_data["pageUploadErrors"]) {
                this.pageUploadErrors = {} as any;
                for (let key in _data["pageUploadErrors"]) {
                    if (_data["pageUploadErrors"].hasOwnProperty(key))
                        (<any>this.pageUploadErrors)![key] = _data["pageUploadErrors"][key];
                }
            }
            this.workerErrorDetails = _data["workerErrorDetails"];
            this.skipFinishIntegration = _data["skipFinishIntegration"];
        }
    }

    static fromJS(data: any): SdTaskIntegrationResultViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdTaskIntegrationResultViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.pageIndexesWithErrors)) {
            data["pageIndexesWithErrors"] = [];
            for (let item of this.pageIndexesWithErrors)
                data["pageIndexesWithErrors"].push(item);
        }
        if (this.pageUploadErrors) {
            data["pageUploadErrors"] = {};
            for (let key in this.pageUploadErrors) {
                if (this.pageUploadErrors.hasOwnProperty(key))
                    (<any>data["pageUploadErrors"])[key] = (<any>this.pageUploadErrors)[key];
            }
        }
        data["workerErrorDetails"] = this.workerErrorDetails;
        data["skipFinishIntegration"] = this.skipFinishIntegration;
        return data;
    }
}

export interface ISdTaskIntegrationResultViewModel {
    success: boolean;
    pageIndexesWithErrors: number[];
    pageUploadErrors: { [key: string]: string; };
    workerErrorDetails: string | undefined;
    skipFinishIntegration: boolean | undefined;
}

export class PaginatedTableListOfSdArchivedTask implements IPaginatedTableListOfSdArchivedTask {
    items!: SdArchivedTask[];
    continuationToken!: string | undefined;

    constructor(data?: IPaginatedTableListOfSdArchivedTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SdArchivedTask.fromJS(item));
            }
            this.continuationToken = _data["continuationToken"];
        }
    }

    static fromJS(data: any): PaginatedTableListOfSdArchivedTask {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedTableListOfSdArchivedTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["continuationToken"] = this.continuationToken;
        return data;
    }
}

export interface IPaginatedTableListOfSdArchivedTask {
    items: SdArchivedTask[];
    continuationToken: string | undefined;
}

export class SdArchivedTask extends TableStorageEntity implements ISdArchivedTask {
    taskId!: number;
    workspaceId!: number;
    tenantId!: number;
    batchId!: number | undefined;
    displayName!: string;
    description!: string | undefined;
    sequentialByWorkspaceId!: number | undefined;
    externalId!: string | undefined;
    requestId!: string;
    cleanEntitiesRequestId!: string | undefined;
    pipelineId!: string;
    totalPages!: number;
    totalCreditsSpent!: number | undefined;
    totalCreditsCost!: number | undefined;
    status!: number;
    labellingStatus!: number | undefined;
    restartCount!: number | undefined;
    preProcessingStartedOn!: Date | undefined;
    lastCheckoutByUserName!: string | undefined;
    lastCheckedOutBy!: number | undefined;
    lastCheckedOutUntil!: Date | undefined;
    storageConfigRowKey!: string | undefined;
    propertiesRowKey!: string | undefined;
    lastCheckoutRowKey!: string | undefined;
    lastIntegratedByUserName!: string | undefined;
    lastIntegratedBy!: number | undefined;
    lastIntegratedOn!: Date | undefined;
    lastIntegratedQueuedOn!: Date | undefined;
    lastIntegrationStatus!: number;
    lastIntegrationRowKey!: string | undefined;
    lastStuckStatus!: number | undefined;
    lastStuckStatusModifiedOn!: Date | undefined;
    processingType!: number;
    expiresOn!: Date | undefined;
    scheduleDeleteSequenceId!: number | undefined;
    originalCreatedBy!: number;
    originalCreatedOn!: Date;
    originalModifiedBy!: number;
    originalModifiedOn!: Date;
    offsetStart!: number | undefined;
    offsetEnd!: number | undefined;
    isSplitSourceTask!: boolean | undefined;
    languageCode!: string | undefined;
    inputLanguageCode!: string | undefined;
    outputLanguageCode!: string | undefined;
    lastFinishReviewAttemptByUserName!: string | undefined;
    lastFinishReviewAttemptBy!: number | undefined;
    lastFinishReviewAttemptOn!: Date | undefined;
    indexId!: string | undefined;
    indexServiceName!: string | undefined;
    indexStatus!: number | undefined;
    lastIndexedOn!: Date | undefined;
    scheduleIndexSequenceId!: number | undefined;
    scheduleIndexTriggersOn!: Date | undefined;
    summaryId!: string | undefined;
    chatbotServiceName!: string | undefined;
    assignmentOrderType!: number | undefined;

    constructor(data?: ISdArchivedTask) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.taskId = _data["taskId"];
            this.workspaceId = _data["workspaceId"];
            this.tenantId = _data["tenantId"];
            this.batchId = _data["batchId"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.sequentialByWorkspaceId = _data["sequentialByWorkspaceId"];
            this.externalId = _data["externalId"];
            this.requestId = _data["requestId"];
            this.cleanEntitiesRequestId = _data["cleanEntitiesRequestId"];
            this.pipelineId = _data["pipelineId"];
            this.totalPages = _data["totalPages"];
            this.totalCreditsSpent = _data["totalCreditsSpent"];
            this.totalCreditsCost = _data["totalCreditsCost"];
            this.status = _data["status"];
            this.labellingStatus = _data["labellingStatus"];
            this.restartCount = _data["restartCount"];
            this.preProcessingStartedOn = _data["preProcessingStartedOn"] ? new Date(_data["preProcessingStartedOn"].toString()) : <any>undefined;
            this.lastCheckoutByUserName = _data["lastCheckoutByUserName"];
            this.lastCheckedOutBy = _data["lastCheckedOutBy"];
            this.lastCheckedOutUntil = _data["lastCheckedOutUntil"] ? new Date(_data["lastCheckedOutUntil"].toString()) : <any>undefined;
            this.storageConfigRowKey = _data["storageConfigRowKey"];
            this.propertiesRowKey = _data["propertiesRowKey"];
            this.lastCheckoutRowKey = _data["lastCheckoutRowKey"];
            this.lastIntegratedByUserName = _data["lastIntegratedByUserName"];
            this.lastIntegratedBy = _data["lastIntegratedBy"];
            this.lastIntegratedOn = _data["lastIntegratedOn"] ? new Date(_data["lastIntegratedOn"].toString()) : <any>undefined;
            this.lastIntegratedQueuedOn = _data["lastIntegratedQueuedOn"] ? new Date(_data["lastIntegratedQueuedOn"].toString()) : <any>undefined;
            this.lastIntegrationStatus = _data["lastIntegrationStatus"];
            this.lastIntegrationRowKey = _data["lastIntegrationRowKey"];
            this.lastStuckStatus = _data["lastStuckStatus"];
            this.lastStuckStatusModifiedOn = _data["lastStuckStatusModifiedOn"] ? new Date(_data["lastStuckStatusModifiedOn"].toString()) : <any>undefined;
            this.processingType = _data["processingType"];
            this.expiresOn = _data["expiresOn"] ? new Date(_data["expiresOn"].toString()) : <any>undefined;
            this.scheduleDeleteSequenceId = _data["scheduleDeleteSequenceId"];
            this.originalCreatedBy = _data["originalCreatedBy"];
            this.originalCreatedOn = _data["originalCreatedOn"] ? new Date(_data["originalCreatedOn"].toString()) : <any>undefined;
            this.originalModifiedBy = _data["originalModifiedBy"];
            this.originalModifiedOn = _data["originalModifiedOn"] ? new Date(_data["originalModifiedOn"].toString()) : <any>undefined;
            this.offsetStart = _data["offsetStart"];
            this.offsetEnd = _data["offsetEnd"];
            this.isSplitSourceTask = _data["isSplitSourceTask"];
            this.languageCode = _data["languageCode"];
            this.inputLanguageCode = _data["inputLanguageCode"];
            this.outputLanguageCode = _data["outputLanguageCode"];
            this.lastFinishReviewAttemptByUserName = _data["lastFinishReviewAttemptByUserName"];
            this.lastFinishReviewAttemptBy = _data["lastFinishReviewAttemptBy"];
            this.lastFinishReviewAttemptOn = _data["lastFinishReviewAttemptOn"] ? new Date(_data["lastFinishReviewAttemptOn"].toString()) : <any>undefined;
            this.indexId = _data["indexId"];
            this.indexServiceName = _data["indexServiceName"];
            this.indexStatus = _data["indexStatus"];
            this.lastIndexedOn = _data["lastIndexedOn"] ? new Date(_data["lastIndexedOn"].toString()) : <any>undefined;
            this.scheduleIndexSequenceId = _data["scheduleIndexSequenceId"];
            this.scheduleIndexTriggersOn = _data["scheduleIndexTriggersOn"] ? new Date(_data["scheduleIndexTriggersOn"].toString()) : <any>undefined;
            this.summaryId = _data["summaryId"];
            this.chatbotServiceName = _data["chatbotServiceName"];
            this.assignmentOrderType = _data["assignmentOrderType"];
        }
    }

    static fromJS(data: any): SdArchivedTask {
        data = typeof data === 'object' ? data : {};
        let result = new SdArchivedTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["workspaceId"] = this.workspaceId;
        data["tenantId"] = this.tenantId;
        data["batchId"] = this.batchId;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["sequentialByWorkspaceId"] = this.sequentialByWorkspaceId;
        data["externalId"] = this.externalId;
        data["requestId"] = this.requestId;
        data["cleanEntitiesRequestId"] = this.cleanEntitiesRequestId;
        data["pipelineId"] = this.pipelineId;
        data["totalPages"] = this.totalPages;
        data["totalCreditsSpent"] = this.totalCreditsSpent;
        data["totalCreditsCost"] = this.totalCreditsCost;
        data["status"] = this.status;
        data["labellingStatus"] = this.labellingStatus;
        data["restartCount"] = this.restartCount;
        data["preProcessingStartedOn"] = this.preProcessingStartedOn ? this.preProcessingStartedOn.toISOString() : <any>undefined;
        data["lastCheckoutByUserName"] = this.lastCheckoutByUserName;
        data["lastCheckedOutBy"] = this.lastCheckedOutBy;
        data["lastCheckedOutUntil"] = this.lastCheckedOutUntil ? this.lastCheckedOutUntil.toISOString() : <any>undefined;
        data["storageConfigRowKey"] = this.storageConfigRowKey;
        data["propertiesRowKey"] = this.propertiesRowKey;
        data["lastCheckoutRowKey"] = this.lastCheckoutRowKey;
        data["lastIntegratedByUserName"] = this.lastIntegratedByUserName;
        data["lastIntegratedBy"] = this.lastIntegratedBy;
        data["lastIntegratedOn"] = this.lastIntegratedOn ? this.lastIntegratedOn.toISOString() : <any>undefined;
        data["lastIntegratedQueuedOn"] = this.lastIntegratedQueuedOn ? this.lastIntegratedQueuedOn.toISOString() : <any>undefined;
        data["lastIntegrationStatus"] = this.lastIntegrationStatus;
        data["lastIntegrationRowKey"] = this.lastIntegrationRowKey;
        data["lastStuckStatus"] = this.lastStuckStatus;
        data["lastStuckStatusModifiedOn"] = this.lastStuckStatusModifiedOn ? this.lastStuckStatusModifiedOn.toISOString() : <any>undefined;
        data["processingType"] = this.processingType;
        data["expiresOn"] = this.expiresOn ? this.expiresOn.toISOString() : <any>undefined;
        data["scheduleDeleteSequenceId"] = this.scheduleDeleteSequenceId;
        data["originalCreatedBy"] = this.originalCreatedBy;
        data["originalCreatedOn"] = this.originalCreatedOn ? this.originalCreatedOn.toISOString() : <any>undefined;
        data["originalModifiedBy"] = this.originalModifiedBy;
        data["originalModifiedOn"] = this.originalModifiedOn ? this.originalModifiedOn.toISOString() : <any>undefined;
        data["offsetStart"] = this.offsetStart;
        data["offsetEnd"] = this.offsetEnd;
        data["isSplitSourceTask"] = this.isSplitSourceTask;
        data["languageCode"] = this.languageCode;
        data["inputLanguageCode"] = this.inputLanguageCode;
        data["outputLanguageCode"] = this.outputLanguageCode;
        data["lastFinishReviewAttemptByUserName"] = this.lastFinishReviewAttemptByUserName;
        data["lastFinishReviewAttemptBy"] = this.lastFinishReviewAttemptBy;
        data["lastFinishReviewAttemptOn"] = this.lastFinishReviewAttemptOn ? this.lastFinishReviewAttemptOn.toISOString() : <any>undefined;
        data["indexId"] = this.indexId;
        data["indexServiceName"] = this.indexServiceName;
        data["indexStatus"] = this.indexStatus;
        data["lastIndexedOn"] = this.lastIndexedOn ? this.lastIndexedOn.toISOString() : <any>undefined;
        data["scheduleIndexSequenceId"] = this.scheduleIndexSequenceId;
        data["scheduleIndexTriggersOn"] = this.scheduleIndexTriggersOn ? this.scheduleIndexTriggersOn.toISOString() : <any>undefined;
        data["summaryId"] = this.summaryId;
        data["chatbotServiceName"] = this.chatbotServiceName;
        data["assignmentOrderType"] = this.assignmentOrderType;
        super.toJSON(data);
        return data;
    }
}

export interface ISdArchivedTask extends ITableStorageEntity {
    taskId: number;
    workspaceId: number;
    tenantId: number;
    batchId: number | undefined;
    displayName: string;
    description: string | undefined;
    sequentialByWorkspaceId: number | undefined;
    externalId: string | undefined;
    requestId: string;
    cleanEntitiesRequestId: string | undefined;
    pipelineId: string;
    totalPages: number;
    totalCreditsSpent: number | undefined;
    totalCreditsCost: number | undefined;
    status: number;
    labellingStatus: number | undefined;
    restartCount: number | undefined;
    preProcessingStartedOn: Date | undefined;
    lastCheckoutByUserName: string | undefined;
    lastCheckedOutBy: number | undefined;
    lastCheckedOutUntil: Date | undefined;
    storageConfigRowKey: string | undefined;
    propertiesRowKey: string | undefined;
    lastCheckoutRowKey: string | undefined;
    lastIntegratedByUserName: string | undefined;
    lastIntegratedBy: number | undefined;
    lastIntegratedOn: Date | undefined;
    lastIntegratedQueuedOn: Date | undefined;
    lastIntegrationStatus: number;
    lastIntegrationRowKey: string | undefined;
    lastStuckStatus: number | undefined;
    lastStuckStatusModifiedOn: Date | undefined;
    processingType: number;
    expiresOn: Date | undefined;
    scheduleDeleteSequenceId: number | undefined;
    originalCreatedBy: number;
    originalCreatedOn: Date;
    originalModifiedBy: number;
    originalModifiedOn: Date;
    offsetStart: number | undefined;
    offsetEnd: number | undefined;
    isSplitSourceTask: boolean | undefined;
    languageCode: string | undefined;
    inputLanguageCode: string | undefined;
    outputLanguageCode: string | undefined;
    lastFinishReviewAttemptByUserName: string | undefined;
    lastFinishReviewAttemptBy: number | undefined;
    lastFinishReviewAttemptOn: Date | undefined;
    indexId: string | undefined;
    indexServiceName: string | undefined;
    indexStatus: number | undefined;
    lastIndexedOn: Date | undefined;
    scheduleIndexSequenceId: number | undefined;
    scheduleIndexTriggersOn: Date | undefined;
    summaryId: string | undefined;
    chatbotServiceName: string | undefined;
    assignmentOrderType: number | undefined;
}

export class PaginatedRequest implements IPaginatedRequest {
    pageNumber!: number;
    pageSize!: number;

    constructor(data?: IPaginatedRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): PaginatedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IPaginatedRequest {
    pageNumber: number;
    pageSize: number;
}

export class ResultWithCodeOfSdTaskReprocessTaskViewModelAndSdTaskError implements IResultWithCodeOfSdTaskReprocessTaskViewModelAndSdTaskError {
    succeeded!: boolean;
    result!: SdTaskReprocessTaskViewModel | undefined;
    errors!: ErrorWithCodeOfSdTaskError[];

    constructor(data?: IResultWithCodeOfSdTaskReprocessTaskViewModelAndSdTaskError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.result = _data["result"] ? SdTaskReprocessTaskViewModel.fromJS(_data["result"]) : <any>undefined;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorWithCodeOfSdTaskError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultWithCodeOfSdTaskReprocessTaskViewModelAndSdTaskError {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithCodeOfSdTaskReprocessTaskViewModelAndSdTaskError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResultWithCodeOfSdTaskReprocessTaskViewModelAndSdTaskError {
    succeeded: boolean;
    result: SdTaskReprocessTaskViewModel | undefined;
    errors: ErrorWithCodeOfSdTaskError[];
}

export class SdTaskReprocessTaskViewModel implements ISdTaskReprocessTaskViewModel {
    externalId!: string | undefined;
    taskId!: number | undefined;

    constructor(data?: ISdTaskReprocessTaskViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.taskId = _data["taskId"];
        }
    }

    static fromJS(data: any): SdTaskReprocessTaskViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdTaskReprocessTaskViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["taskId"] = this.taskId;
        return data;
    }
}

export interface ISdTaskReprocessTaskViewModel {
    externalId: string | undefined;
    taskId: number | undefined;
}

export class MultipleTaskSelectionModel implements IMultipleTaskSelectionModel {
    workspaceId!: number;
    taskIdList!: number[];
    filters!: PaginatedRequestQueryFilter[];

    constructor(data?: IMultipleTaskSelectionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workspaceId = _data["workspaceId"];
            if (Array.isArray(_data["taskIdList"])) {
                this.taskIdList = [] as any;
                for (let item of _data["taskIdList"])
                    this.taskIdList!.push(item);
            }
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(PaginatedRequestQueryFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MultipleTaskSelectionModel {
        data = typeof data === 'object' ? data : {};
        let result = new MultipleTaskSelectionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workspaceId"] = this.workspaceId;
        if (Array.isArray(this.taskIdList)) {
            data["taskIdList"] = [];
            for (let item of this.taskIdList)
                data["taskIdList"].push(item);
        }
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMultipleTaskSelectionModel {
    workspaceId: number;
    taskIdList: number[];
    filters: PaginatedRequestQueryFilter[];
}

export class SdTaskProcessCreateViewModel implements ISdTaskProcessCreateViewModel {
    taskId!: number;
    displayName!: string;
    description!: string | undefined;
    externalId!: string | undefined;
    taskStatus!: number;
    totalPages!: number;
    taskStatusText!: string;
    integrationStatus!: number;
    integrationStatusText!: string;
    workspaceId!: number;
    requestId!: string;
    batchId!: number | undefined;
    languageCode!: string | undefined;
    taskAssignment!: TaskAssignment | undefined;

    constructor(data?: ISdTaskProcessCreateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.externalId = _data["externalId"];
            this.taskStatus = _data["taskStatus"];
            this.totalPages = _data["totalPages"];
            this.taskStatusText = _data["taskStatusText"];
            this.integrationStatus = _data["integrationStatus"];
            this.integrationStatusText = _data["integrationStatusText"];
            this.workspaceId = _data["workspaceId"];
            this.requestId = _data["requestId"];
            this.batchId = _data["batchId"];
            this.languageCode = _data["languageCode"];
            this.taskAssignment = _data["taskAssignment"] ? TaskAssignment.fromJS(_data["taskAssignment"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SdTaskProcessCreateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdTaskProcessCreateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["externalId"] = this.externalId;
        data["taskStatus"] = this.taskStatus;
        data["totalPages"] = this.totalPages;
        data["taskStatusText"] = this.taskStatusText;
        data["integrationStatus"] = this.integrationStatus;
        data["integrationStatusText"] = this.integrationStatusText;
        data["workspaceId"] = this.workspaceId;
        data["requestId"] = this.requestId;
        data["batchId"] = this.batchId;
        data["languageCode"] = this.languageCode;
        data["taskAssignment"] = this.taskAssignment ? this.taskAssignment.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISdTaskProcessCreateViewModel {
    taskId: number;
    displayName: string;
    description: string | undefined;
    externalId: string | undefined;
    taskStatus: number;
    totalPages: number;
    taskStatusText: string;
    integrationStatus: number;
    integrationStatusText: string;
    workspaceId: number;
    requestId: string;
    batchId: number | undefined;
    languageCode: string | undefined;
    taskAssignment: TaskAssignment | undefined;
}

export class TaskAssignment implements ITaskAssignment {
    assignedUsers!: string[];
    order!: TaskAssignmentOrderType;

    constructor(data?: ITaskAssignment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assignedUsers"])) {
                this.assignedUsers = [] as any;
                for (let item of _data["assignedUsers"])
                    this.assignedUsers!.push(item);
            }
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): TaskAssignment {
        data = typeof data === 'object' ? data : {};
        let result = new TaskAssignment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assignedUsers)) {
            data["assignedUsers"] = [];
            for (let item of this.assignedUsers)
                data["assignedUsers"].push(item);
        }
        data["order"] = this.order;
        return data;
    }
}

export interface ITaskAssignment {
    assignedUsers: string[];
    order: TaskAssignmentOrderType;
}

export enum TaskAssignmentOrderType {
    AnyUser = 10,
    AnyOrder = 20,
    Sequence = 30,
}

export class ReturnWithCode implements IReturnWithCode {
    code!: string;
    message!: string;

    constructor(data?: IReturnWithCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ReturnWithCode {
        data = typeof data === 'object' ? data : {};
        let result = new ReturnWithCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        return data;
    }
}

export interface IReturnWithCode {
    code: string;
    message: string;
}

export class SdTaskProcessCreateModel implements ISdTaskProcessCreateModel {
    externalId!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    workspaceId!: number | undefined;
    batchId!: number | undefined;
    forceAddToBatch!: boolean | undefined;
    priority!: number;
    context!: any | undefined;
    customFormValues!: any | undefined;
    id!: string;
    taskAssignment!: TaskAssignment | undefined;
    metadata!: any | undefined;
    isImportedViaWeb!: boolean | undefined;
    useHigherQuality!: boolean | undefined;

    constructor(data?: ISdTaskProcessCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.workspaceId = _data["workspaceId"];
            this.batchId = _data["batchId"];
            this.forceAddToBatch = _data["forceAddToBatch"];
            this.priority = _data["priority"];
            this.context = _data["context"];
            this.customFormValues = _data["customFormValues"];
            this.id = _data["id"];
            this.taskAssignment = _data["taskAssignment"] ? TaskAssignment.fromJS(_data["taskAssignment"]) : <any>undefined;
            this.metadata = _data["metadata"];
            this.isImportedViaWeb = _data["isImportedViaWeb"];
            this.useHigherQuality = _data["useHigherQuality"];
        }
    }

    static fromJS(data: any): SdTaskProcessCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdTaskProcessCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["workspaceId"] = this.workspaceId;
        data["batchId"] = this.batchId;
        data["forceAddToBatch"] = this.forceAddToBatch;
        data["priority"] = this.priority;
        data["context"] = this.context;
        data["customFormValues"] = this.customFormValues;
        data["id"] = this.id;
        data["taskAssignment"] = this.taskAssignment ? this.taskAssignment.toJSON() : <any>undefined;
        data["metadata"] = this.metadata;
        data["isImportedViaWeb"] = this.isImportedViaWeb;
        data["useHigherQuality"] = this.useHigherQuality;
        return data;
    }
}

export interface ISdTaskProcessCreateModel {
    externalId: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    workspaceId: number | undefined;
    batchId: number | undefined;
    forceAddToBatch: boolean | undefined;
    priority: number;
    context: any | undefined;
    customFormValues: any | undefined;
    id: string;
    taskAssignment: TaskAssignment | undefined;
    metadata: any | undefined;
    isImportedViaWeb: boolean | undefined;
    useHigherQuality: boolean | undefined;
}

export class SdTaskCountViewModel implements ISdTaskCountViewModel {
    processingCount!: number;
    toReviewCount!: number;
    inReviewCount!: number;
    processedCount!: number;
    totalCount!: number;

    constructor(data?: ISdTaskCountViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.processingCount = _data["processingCount"];
            this.toReviewCount = _data["toReviewCount"];
            this.inReviewCount = _data["inReviewCount"];
            this.processedCount = _data["processedCount"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SdTaskCountViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdTaskCountViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processingCount"] = this.processingCount;
        data["toReviewCount"] = this.toReviewCount;
        data["inReviewCount"] = this.inReviewCount;
        data["processedCount"] = this.processedCount;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface ISdTaskCountViewModel {
    processingCount: number;
    toReviewCount: number;
    inReviewCount: number;
    processedCount: number;
    totalCount: number;
}

export class SdTaskCountReviewedDocumentsViewModel implements ISdTaskCountReviewedDocumentsViewModel {
    reviewedDocuments!: CountReviewedDocument[];

    constructor(data?: ISdTaskCountReviewedDocumentsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["reviewedDocuments"])) {
                this.reviewedDocuments = [] as any;
                for (let item of _data["reviewedDocuments"])
                    this.reviewedDocuments!.push(CountReviewedDocument.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SdTaskCountReviewedDocumentsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdTaskCountReviewedDocumentsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reviewedDocuments)) {
            data["reviewedDocuments"] = [];
            for (let item of this.reviewedDocuments)
                data["reviewedDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISdTaskCountReviewedDocumentsViewModel {
    reviewedDocuments: CountReviewedDocument[];
}

export class CountReviewedDocument implements ICountReviewedDocument {
    lastIntegratedBy!: string;
    count!: number;

    constructor(data?: ICountReviewedDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastIntegratedBy = _data["lastIntegratedBy"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): CountReviewedDocument {
        data = typeof data === 'object' ? data : {};
        let result = new CountReviewedDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastIntegratedBy"] = this.lastIntegratedBy;
        data["count"] = this.count;
        return data;
    }
}

export interface ICountReviewedDocument {
    lastIntegratedBy: string;
    count: number;
}

export class SdTaskTimestampByStatusViewModel implements ISdTaskTimestampByStatusViewModel {
    times!: TimestampByStatus[];

    constructor(data?: ISdTaskTimestampByStatusViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["times"])) {
                this.times = [] as any;
                for (let item of _data["times"])
                    this.times!.push(TimestampByStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SdTaskTimestampByStatusViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdTaskTimestampByStatusViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.times)) {
            data["times"] = [];
            for (let item of this.times)
                data["times"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISdTaskTimestampByStatusViewModel {
    times: TimestampByStatus[];
}

export class TimestampByStatus implements ITimestampByStatus {
    status!: SdTaskStatus;
    timeAvgInMilliseconds!: number;

    constructor(data?: ITimestampByStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.timeAvgInMilliseconds = _data["timeAvgInMilliseconds"];
        }
    }

    static fromJS(data: any): TimestampByStatus {
        data = typeof data === 'object' ? data : {};
        let result = new TimestampByStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["timeAvgInMilliseconds"] = this.timeAvgInMilliseconds;
        return data;
    }
}

export interface ITimestampByStatus {
    status: SdTaskStatus;
    timeAvgInMilliseconds: number;
}

export class ResultWithCodeOfExportDataViewModelAndSdTaskError implements IResultWithCodeOfExportDataViewModelAndSdTaskError {
    succeeded!: boolean;
    result!: ExportDataViewModel | undefined;
    errors!: ErrorWithCodeOfSdTaskError[];

    constructor(data?: IResultWithCodeOfExportDataViewModelAndSdTaskError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.result = _data["result"] ? ExportDataViewModel.fromJS(_data["result"]) : <any>undefined;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorWithCodeOfSdTaskError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultWithCodeOfExportDataViewModelAndSdTaskError {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithCodeOfExportDataViewModelAndSdTaskError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResultWithCodeOfExportDataViewModelAndSdTaskError {
    succeeded: boolean;
    result: ExportDataViewModel | undefined;
    errors: ErrorWithCodeOfSdTaskError[];
}

export class ExportDataViewModel implements IExportDataViewModel {
    fileName!: string;
    contentType!: string;
    content!: string;
    requestId!: string | undefined;

    constructor(data?: IExportDataViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
            this.content = _data["content"];
            this.requestId = _data["requestId"];
        }
    }

    static fromJS(data: any): ExportDataViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExportDataViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["content"] = this.content;
        data["requestId"] = this.requestId;
        return data;
    }
}

export interface IExportDataViewModel {
    fileName: string;
    contentType: string;
    content: string;
    requestId: string | undefined;
}

export class MultipleExportDataModel implements IMultipleExportDataModel {
    workspaceId!: number;
    taskIdList!: number[];
    type!: ExportType;
    filters!: PaginatedRequestQueryFilter[];
    allSelected!: boolean;

    constructor(data?: IMultipleExportDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workspaceId = _data["workspaceId"];
            if (Array.isArray(_data["taskIdList"])) {
                this.taskIdList = [] as any;
                for (let item of _data["taskIdList"])
                    this.taskIdList!.push(item);
            }
            this.type = _data["type"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(PaginatedRequestQueryFilter.fromJS(item));
            }
            this.allSelected = _data["allSelected"];
        }
    }

    static fromJS(data: any): MultipleExportDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new MultipleExportDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workspaceId"] = this.workspaceId;
        if (Array.isArray(this.taskIdList)) {
            data["taskIdList"] = [];
            for (let item of this.taskIdList)
                data["taskIdList"].push(item);
        }
        data["type"] = this.type;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        data["allSelected"] = this.allSelected;
        return data;
    }
}

export interface IMultipleExportDataModel {
    workspaceId: number;
    taskIdList: number[];
    type: ExportType;
    filters: PaginatedRequestQueryFilter[];
    allSelected: boolean;
}

export enum ExportType {
    Excel = 0,
    Csv = 1,
    Json = 2,
    Xml = 3,
    Word = 4,
    AnonymizedPng = 5,
    AnonymizedJpeg = 6,
    AnonymizedPdf = 7,
}

export class ProcessedTasksCountQuery implements IProcessedTasksCountQuery {
    workspaceId!: number;
    filters!: PaginatedRequestQueryFilter[];

    constructor(data?: IProcessedTasksCountQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workspaceId = _data["workspaceId"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(PaginatedRequestQueryFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProcessedTasksCountQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessedTasksCountQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workspaceId"] = this.workspaceId;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProcessedTasksCountQuery {
    workspaceId: number;
    filters: PaginatedRequestQueryFilter[];
}

export class RenderFarmEventAllInfoViewModel implements IRenderFarmEventAllInfoViewModel {
    event!: RenderFarmEventViewModel | undefined;
    eventType!: string | undefined;
    stepDisplayName!: string | undefined;

    constructor(data?: IRenderFarmEventAllInfoViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.event = _data["event"] ? RenderFarmEventViewModel.fromJS(_data["event"]) : <any>undefined;
            this.eventType = _data["eventType"];
            this.stepDisplayName = _data["stepDisplayName"];
        }
    }

    static fromJS(data: any): RenderFarmEventAllInfoViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RenderFarmEventAllInfoViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["eventType"] = this.eventType;
        data["stepDisplayName"] = this.stepDisplayName;
        return data;
    }
}

export interface IRenderFarmEventAllInfoViewModel {
    event: RenderFarmEventViewModel | undefined;
    eventType: string | undefined;
    stepDisplayName: string | undefined;
}

export class RenderFarmEventViewModel implements IRenderFarmEventViewModel {
    createdOn!: Date;
    eventDescription!: string | undefined;
    payload!: any | undefined;
    requestId!: string | undefined;
    entityId!: string | undefined;
    entityTypeText!: string;
    eventSourceText!: string;

    constructor(data?: IRenderFarmEventViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.eventDescription = _data["eventDescription"];
            this.payload = _data["payload"];
            this.requestId = _data["requestId"];
            this.entityId = _data["entityId"];
            this.entityTypeText = _data["entityTypeText"];
            this.eventSourceText = _data["eventSourceText"];
        }
    }

    static fromJS(data: any): RenderFarmEventViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RenderFarmEventViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["eventDescription"] = this.eventDescription;
        data["payload"] = this.payload;
        data["requestId"] = this.requestId;
        data["entityId"] = this.entityId;
        data["entityTypeText"] = this.entityTypeText;
        data["eventSourceText"] = this.eventSourceText;
        return data;
    }
}

export interface IRenderFarmEventViewModel {
    createdOn: Date;
    eventDescription: string | undefined;
    payload: any | undefined;
    requestId: string | undefined;
    entityId: string | undefined;
    entityTypeText: string;
    eventSourceText: string;
}

export class ShareTaskWithUsersModel implements IShareTaskWithUsersModel {
    users!: GenericInviteUserModel[];
    taskId!: number;
    workspaceId!: number;
    description!: string | undefined;

    constructor(data?: IShareTaskWithUsersModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(GenericInviteUserModel.fromJS(item));
            }
            this.taskId = _data["taskId"];
            this.workspaceId = _data["workspaceId"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ShareTaskWithUsersModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShareTaskWithUsersModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        data["taskId"] = this.taskId;
        data["workspaceId"] = this.workspaceId;
        data["description"] = this.description;
        return data;
    }
}

export interface IShareTaskWithUsersModel {
    users: GenericInviteUserModel[];
    taskId: number;
    workspaceId: number;
    description: string | undefined;
}

export class GenericInviteUserBaseModel implements IGenericInviteUserBaseModel {
    email!: string;
    name!: string | undefined;
    workspaceId!: number | undefined;
    tenantRoleId!: number;

    constructor(data?: IGenericInviteUserBaseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.name = _data["name"];
            this.workspaceId = _data["workspaceId"];
            this.tenantRoleId = _data["tenantRoleId"];
        }
    }

    static fromJS(data: any): GenericInviteUserBaseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GenericInviteUserBaseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["name"] = this.name;
        data["workspaceId"] = this.workspaceId;
        data["tenantRoleId"] = this.tenantRoleId;
        return data;
    }
}

export interface IGenericInviteUserBaseModel {
    email: string;
    name: string | undefined;
    workspaceId: number | undefined;
    tenantRoleId: number;
}

export class GenericInviteUserModel extends GenericInviteUserBaseModel implements IGenericInviteUserModel {
    inviteToAllWorkspaces!: boolean;

    constructor(data?: IGenericInviteUserModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.inviteToAllWorkspaces = _data["inviteToAllWorkspaces"];
        }
    }

    static fromJS(data: any): GenericInviteUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new GenericInviteUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inviteToAllWorkspaces"] = this.inviteToAllWorkspaces;
        super.toJSON(data);
        return data;
    }
}

export interface IGenericInviteUserModel extends IGenericInviteUserBaseModel {
    inviteToAllWorkspaces: boolean;
}

export class GenericUserTaskSharingViewModel extends GenericUserViewModel implements IGenericUserTaskSharingViewModel {
    isValidForTaskSharing!: boolean;

    constructor(data?: IGenericUserTaskSharingViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isValidForTaskSharing = _data["isValidForTaskSharing"];
        }
    }

    static fromJS(data: any): GenericUserTaskSharingViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GenericUserTaskSharingViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValidForTaskSharing"] = this.isValidForTaskSharing;
        super.toJSON(data);
        return data;
    }
}

export interface IGenericUserTaskSharingViewModel extends IGenericUserViewModel {
    isValidForTaskSharing: boolean;
}

export abstract class BaseEntityOfInteger extends AuditableEntity implements IBaseEntityOfInteger {
    id!: number;

    constructor(data?: IBaseEntityOfInteger) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BaseEntityOfInteger {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseEntityOfInteger' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IBaseEntityOfInteger extends IAuditableEntity {
    id: number;
}

export abstract class TenantIntEntity extends BaseEntityOfInteger implements ITenantIntEntity {
    tenantId!: number;
    tenant!: Tenant;

    constructor(data?: ITenantIntEntity) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantIntEntity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'TenantIntEntity' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ITenantIntEntity extends IBaseEntityOfInteger {
    tenantId: number;
    tenant: Tenant;
}

export class SdMetaField extends TenantIntEntity implements ISdMetaField {
    taskId!: number;
    key!: string;
    value!: string;

    constructor(data?: ISdMetaField) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.taskId = _data["taskId"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SdMetaField {
        data = typeof data === 'object' ? data : {};
        let result = new SdMetaField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["key"] = this.key;
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface ISdMetaField extends ITenantIntEntity {
    taskId: number;
    key: string;
    value: string;
}

export class Tenant extends BaseEntityOfInteger implements ITenant {
    code!: string;
    name!: string | undefined;
    isSingleTenant!: boolean;
    softDeleted!: boolean;

    constructor(data?: ITenant) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.isSingleTenant = _data["isSingleTenant"];
            this.softDeleted = _data["softDeleted"];
        }
    }

    static fromJS(data: any): Tenant {
        data = typeof data === 'object' ? data : {};
        let result = new Tenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["isSingleTenant"] = this.isSingleTenant;
        data["softDeleted"] = this.softDeleted;
        super.toJSON(data);
        return data;
    }
}

export interface ITenant extends IBaseEntityOfInteger {
    code: string;
    name: string | undefined;
    isSingleTenant: boolean;
    softDeleted: boolean;
}

export class SdTaskExportResultModel implements ISdTaskExportResultModel {
    requestId!: string | undefined;
    status!: SdTaskExportStatus;
    fileModel!: ExportFileToUrlPageModel | undefined;

    constructor(data?: ISdTaskExportResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.status = _data["status"];
            this.fileModel = _data["fileModel"] ? ExportFileToUrlPageModel.fromJS(_data["fileModel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SdTaskExportResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdTaskExportResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["status"] = this.status;
        data["fileModel"] = this.fileModel ? this.fileModel.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISdTaskExportResultModel {
    requestId: string | undefined;
    status: SdTaskExportStatus;
    fileModel: ExportFileToUrlPageModel | undefined;
}

export enum SdTaskExportStatus {
    Exporting = 10,
    Failed = 20,
    Success = 30,
}

export class ExportFileToUrlModel implements IExportFileToUrlModel {
    taskId!: number;
    exportedFileUrl!: string;
    exportedFileContentType!: string;
    exportedFileExpiresOn!: Date;
    taskNumber!: number | undefined;
    workspaceId!: number;
    batchId!: number | undefined;
    externalId!: string | undefined;
    displayName!: string;
    description!: string | undefined;
    lastCheckoutByUserName!: string | undefined;
    lastCheckedOutBy!: number | undefined;
    lastCheckedOutUntil!: Date | undefined;
    lastIntegratedBy!: number | undefined;
    lastIntegratedByUserName!: string | undefined;
    lastIntegratedOn!: Date | undefined;
    metadata!: { [key: string]: string; } | undefined;

    constructor(data?: IExportFileToUrlModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.exportedFileUrl = _data["exportedFileUrl"];
            this.exportedFileContentType = _data["exportedFileContentType"];
            this.exportedFileExpiresOn = _data["exportedFileExpiresOn"] ? new Date(_data["exportedFileExpiresOn"].toString()) : <any>undefined;
            this.taskNumber = _data["taskNumber"];
            this.workspaceId = _data["workspaceId"];
            this.batchId = _data["batchId"];
            this.externalId = _data["externalId"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.lastCheckoutByUserName = _data["lastCheckoutByUserName"];
            this.lastCheckedOutBy = _data["lastCheckedOutBy"];
            this.lastCheckedOutUntil = _data["lastCheckedOutUntil"] ? new Date(_data["lastCheckedOutUntil"].toString()) : <any>undefined;
            this.lastIntegratedBy = _data["lastIntegratedBy"];
            this.lastIntegratedByUserName = _data["lastIntegratedByUserName"];
            this.lastIntegratedOn = _data["lastIntegratedOn"] ? new Date(_data["lastIntegratedOn"].toString()) : <any>undefined;
            if (_data["metadata"]) {
                this.metadata = {} as any;
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        (<any>this.metadata)![key] = _data["metadata"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExportFileToUrlModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExportFileToUrlModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["exportedFileUrl"] = this.exportedFileUrl;
        data["exportedFileContentType"] = this.exportedFileContentType;
        data["exportedFileExpiresOn"] = this.exportedFileExpiresOn ? this.exportedFileExpiresOn.toISOString() : <any>undefined;
        data["taskNumber"] = this.taskNumber;
        data["workspaceId"] = this.workspaceId;
        data["batchId"] = this.batchId;
        data["externalId"] = this.externalId;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["lastCheckoutByUserName"] = this.lastCheckoutByUserName;
        data["lastCheckedOutBy"] = this.lastCheckedOutBy;
        data["lastCheckedOutUntil"] = this.lastCheckedOutUntil ? this.lastCheckedOutUntil.toISOString() : <any>undefined;
        data["lastIntegratedBy"] = this.lastIntegratedBy;
        data["lastIntegratedByUserName"] = this.lastIntegratedByUserName;
        data["lastIntegratedOn"] = this.lastIntegratedOn ? this.lastIntegratedOn.toISOString() : <any>undefined;
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (<any>data["metadata"])[key] = (<any>this.metadata)[key];
            }
        }
        return data;
    }
}

export interface IExportFileToUrlModel {
    taskId: number;
    exportedFileUrl: string;
    exportedFileContentType: string;
    exportedFileExpiresOn: Date;
    taskNumber: number | undefined;
    workspaceId: number;
    batchId: number | undefined;
    externalId: string | undefined;
    displayName: string;
    description: string | undefined;
    lastCheckoutByUserName: string | undefined;
    lastCheckedOutBy: number | undefined;
    lastCheckedOutUntil: Date | undefined;
    lastIntegratedBy: number | undefined;
    lastIntegratedByUserName: string | undefined;
    lastIntegratedOn: Date | undefined;
    metadata: { [key: string]: string; } | undefined;
}

export class ExportFileToUrlPageModel extends ExportFileToUrlModel implements IExportFileToUrlPageModel {
    totalPages!: number;

    constructor(data?: IExportFileToUrlPageModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): ExportFileToUrlPageModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExportFileToUrlPageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPages"] = this.totalPages;
        super.toJSON(data);
        return data;
    }
}

export interface IExportFileToUrlPageModel extends IExportFileToUrlModel {
    totalPages: number;
}

export class BaseMaterializedEventDTO implements IBaseMaterializedEventDTO {
    tenantId!: string;
    createdBy!: string;
    createdOn!: Date;
    eventType!: string | undefined;
    eventDescription!: string | undefined;
    payload!: string | undefined;

    constructor(data?: IBaseMaterializedEventDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.eventType = _data["eventType"];
            this.eventDescription = _data["eventDescription"];
            this.payload = _data["payload"];
        }
    }

    static fromJS(data: any): BaseMaterializedEventDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BaseMaterializedEventDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["eventType"] = this.eventType;
        data["eventDescription"] = this.eventDescription;
        data["payload"] = this.payload;
        return data;
    }
}

export interface IBaseMaterializedEventDTO {
    tenantId: string;
    createdBy: string;
    createdOn: Date;
    eventType: string | undefined;
    eventDescription: string | undefined;
    payload: string | undefined;
}

export class MaterializedRequestEventDTO extends BaseMaterializedEventDTO implements IMaterializedRequestEventDTO {
    requestId!: string | undefined;
    entityId!: string | undefined;
    entityType!: number;
    eventSource!: number;
    entityTypeText!: string;
    eventSourceText!: string;

    constructor(data?: IMaterializedRequestEventDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.requestId = _data["requestId"];
            this.entityId = _data["entityId"];
            this.entityType = _data["entityType"];
            this.eventSource = _data["eventSource"];
            this.entityTypeText = _data["entityTypeText"];
            this.eventSourceText = _data["eventSourceText"];
        }
    }

    static fromJS(data: any): MaterializedRequestEventDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MaterializedRequestEventDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["entityId"] = this.entityId;
        data["entityType"] = this.entityType;
        data["eventSource"] = this.eventSource;
        data["entityTypeText"] = this.entityTypeText;
        data["eventSourceText"] = this.eventSourceText;
        super.toJSON(data);
        return data;
    }
}

export interface IMaterializedRequestEventDTO extends IBaseMaterializedEventDTO {
    requestId: string | undefined;
    entityId: string | undefined;
    entityType: number;
    eventSource: number;
    entityTypeText: string;
    eventSourceText: string;
}

export class CallbackMaterializedRequestEventDTO extends MaterializedRequestEventDTO implements ICallbackMaterializedRequestEventDTO {
    sentOn!: Date;

    constructor(data?: ICallbackMaterializedRequestEventDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sentOn = _data["sentOn"] ? new Date(_data["sentOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CallbackMaterializedRequestEventDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CallbackMaterializedRequestEventDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sentOn"] = this.sentOn ? this.sentOn.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICallbackMaterializedRequestEventDTO extends IMaterializedRequestEventDTO {
    sentOn: Date;
}

export class RenderFarmEventContext extends CallbackMaterializedRequestEventDTO implements IRenderFarmEventContext {

    constructor(data?: IRenderFarmEventContext) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): RenderFarmEventContext {
        data = typeof data === 'object' ? data : {};
        let result = new RenderFarmEventContext();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IRenderFarmEventContext extends ICallbackMaterializedRequestEventDTO {
}

export class SdTaskIntegrationStatusViewModel implements ISdTaskIntegrationStatusViewModel {
    taskId!: number;
    workspaceId!: number;
    batchId!: number | undefined;
    taskNumber!: number | undefined;
    externalId!: string | undefined;
    displayName!: string;
    description!: string | undefined;
    createdOn!: Date | undefined;
    taskStatus!: SdTaskStatus | undefined;
    externalIntegrationStatus!: string;
    totalPages!: number;
    restartCount!: number | undefined;
    integrationStatus!: SdTaskIntegrationStatus | undefined;
    taskStatusText!: string | undefined;
    integrationStatusText!: string | undefined;
    preProcessingStartedOn!: Date | undefined;
    languageCode!: string | undefined;

    constructor(data?: ISdTaskIntegrationStatusViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.workspaceId = _data["workspaceId"];
            this.batchId = _data["batchId"];
            this.taskNumber = _data["taskNumber"];
            this.externalId = _data["externalId"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.taskStatus = _data["taskStatus"];
            this.externalIntegrationStatus = _data["externalIntegrationStatus"];
            this.totalPages = _data["totalPages"];
            this.restartCount = _data["restartCount"];
            this.integrationStatus = _data["integrationStatus"];
            this.taskStatusText = _data["taskStatusText"];
            this.integrationStatusText = _data["integrationStatusText"];
            this.preProcessingStartedOn = _data["preProcessingStartedOn"] ? new Date(_data["preProcessingStartedOn"].toString()) : <any>undefined;
            this.languageCode = _data["languageCode"];
        }
    }

    static fromJS(data: any): SdTaskIntegrationStatusViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdTaskIntegrationStatusViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["workspaceId"] = this.workspaceId;
        data["batchId"] = this.batchId;
        data["taskNumber"] = this.taskNumber;
        data["externalId"] = this.externalId;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["taskStatus"] = this.taskStatus;
        data["externalIntegrationStatus"] = this.externalIntegrationStatus;
        data["totalPages"] = this.totalPages;
        data["restartCount"] = this.restartCount;
        data["integrationStatus"] = this.integrationStatus;
        data["taskStatusText"] = this.taskStatusText;
        data["integrationStatusText"] = this.integrationStatusText;
        data["preProcessingStartedOn"] = this.preProcessingStartedOn ? this.preProcessingStartedOn.toISOString() : <any>undefined;
        data["languageCode"] = this.languageCode;
        return data;
    }
}

export interface ISdTaskIntegrationStatusViewModel {
    taskId: number;
    workspaceId: number;
    batchId: number | undefined;
    taskNumber: number | undefined;
    externalId: string | undefined;
    displayName: string;
    description: string | undefined;
    createdOn: Date | undefined;
    taskStatus: SdTaskStatus | undefined;
    externalIntegrationStatus: string;
    totalPages: number;
    restartCount: number | undefined;
    integrationStatus: SdTaskIntegrationStatus | undefined;
    taskStatusText: string | undefined;
    integrationStatusText: string | undefined;
    preProcessingStartedOn: Date | undefined;
    languageCode: string | undefined;
}

export enum SdTaskIntegrationStatus {
    Never = 1,
    Queued = 2,
    Successful = 3,
    Failed = 4,
}

export class PaginatedListOfSdTaskIntegrationStatusViewModel implements IPaginatedListOfSdTaskIntegrationStatusViewModel {
    items!: SdTaskIntegrationStatusViewModel[];
    pageNumber!: number;
    totalPages!: number;
    totalCount!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfSdTaskIntegrationStatusViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SdTaskIntegrationStatusViewModel.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfSdTaskIntegrationStatusViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfSdTaskIntegrationStatusViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfSdTaskIntegrationStatusViewModel {
    items: SdTaskIntegrationStatusViewModel[];
    pageNumber: number;
    totalPages: number;
    totalCount: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class ShareMediaSegmentUrlResult implements IShareMediaSegmentUrlResult {
    shareUrl!: string;

    constructor(data?: IShareMediaSegmentUrlResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shareUrl = _data["shareUrl"];
        }
    }

    static fromJS(data: any): ShareMediaSegmentUrlResult {
        data = typeof data === 'object' ? data : {};
        let result = new ShareMediaSegmentUrlResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shareUrl"] = this.shareUrl;
        return data;
    }
}

export interface IShareMediaSegmentUrlResult {
    shareUrl: string;
}

export class ShareInputConfig implements IShareInputConfig {
    taskId!: number;
    language!: string;
    recipientEmails!: string[];
    shareDescription!: string | undefined;
    expiresHours!: number;
    segmentStartSeconds!: number;
    segmentEndSeconds!: number;

    constructor(data?: IShareInputConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.language = _data["language"];
            if (Array.isArray(_data["recipientEmails"])) {
                this.recipientEmails = [] as any;
                for (let item of _data["recipientEmails"])
                    this.recipientEmails!.push(item);
            }
            this.shareDescription = _data["shareDescription"];
            this.expiresHours = _data["expiresHours"];
            this.segmentStartSeconds = _data["segmentStartSeconds"];
            this.segmentEndSeconds = _data["segmentEndSeconds"];
        }
    }

    static fromJS(data: any): ShareInputConfig {
        data = typeof data === 'object' ? data : {};
        let result = new ShareInputConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["language"] = this.language;
        if (Array.isArray(this.recipientEmails)) {
            data["recipientEmails"] = [];
            for (let item of this.recipientEmails)
                data["recipientEmails"].push(item);
        }
        data["shareDescription"] = this.shareDescription;
        data["expiresHours"] = this.expiresHours;
        data["segmentStartSeconds"] = this.segmentStartSeconds;
        data["segmentEndSeconds"] = this.segmentEndSeconds;
        return data;
    }
}

export interface IShareInputConfig {
    taskId: number;
    language: string;
    recipientEmails: string[];
    shareDescription: string | undefined;
    expiresHours: number;
    segmentStartSeconds: number;
    segmentEndSeconds: number;
}

export class TaskShareHistoryDetailsModel implements ITaskShareHistoryDetailsModel {
    taskShareList!: SdTaskShareViewModel[] | undefined;

    constructor(data?: ITaskShareHistoryDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["taskShareList"])) {
                this.taskShareList = [] as any;
                for (let item of _data["taskShareList"])
                    this.taskShareList!.push(SdTaskShareViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskShareHistoryDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskShareHistoryDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.taskShareList)) {
            data["taskShareList"] = [];
            for (let item of this.taskShareList)
                data["taskShareList"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITaskShareHistoryDetailsModel {
    taskShareList: SdTaskShareViewModel[] | undefined;
}

export class SdTaskShareViewModel implements ISdTaskShareViewModel {
    partitionKey!: string;
    rowKey!: string;
    timestamp!: Date | undefined;
    createdBy!: number;
    createdByUserName!: string;
    createdByUserEmail!: string;
    createdOn!: Date;
    modifiedBy!: number;
    modifiedByUserName!: string;
    modifiedByUserEmail!: string;
    modifiedOn!: Date;
    tenantId!: number;
    workspaceId!: number;
    taskId!: number;
    requestId!: string | undefined;
    shareType!: SdTaskShareType;
    shareStatus!: SdTaskShareStatus;
    inputConfig!: ShareInputConfig | undefined;
    outputConfig!: ShareMediaSegmentOutputConfig | undefined;
    expiresOn!: Date | undefined;

    constructor(data?: ISdTaskShareViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partitionKey = _data["partitionKey"];
            this.rowKey = _data["rowKey"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.createdByUserName = _data["createdByUserName"];
            this.createdByUserEmail = _data["createdByUserEmail"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedByUserName = _data["modifiedByUserName"];
            this.modifiedByUserEmail = _data["modifiedByUserEmail"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.workspaceId = _data["workspaceId"];
            this.taskId = _data["taskId"];
            this.requestId = _data["requestId"];
            this.shareType = _data["shareType"];
            this.shareStatus = _data["shareStatus"];
            this.inputConfig = _data["inputConfig"] ? ShareInputConfig.fromJS(_data["inputConfig"]) : <any>undefined;
            this.outputConfig = _data["outputConfig"] ? ShareMediaSegmentOutputConfig.fromJS(_data["outputConfig"]) : <any>undefined;
            this.expiresOn = _data["expiresOn"] ? new Date(_data["expiresOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SdTaskShareViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdTaskShareViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partitionKey"] = this.partitionKey;
        data["rowKey"] = this.rowKey;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["createdByUserName"] = this.createdByUserName;
        data["createdByUserEmail"] = this.createdByUserEmail;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedByUserName"] = this.modifiedByUserName;
        data["modifiedByUserEmail"] = this.modifiedByUserEmail;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["workspaceId"] = this.workspaceId;
        data["taskId"] = this.taskId;
        data["requestId"] = this.requestId;
        data["shareType"] = this.shareType;
        data["shareStatus"] = this.shareStatus;
        data["inputConfig"] = this.inputConfig ? this.inputConfig.toJSON() : <any>undefined;
        data["outputConfig"] = this.outputConfig ? this.outputConfig.toJSON() : <any>undefined;
        data["expiresOn"] = this.expiresOn ? this.expiresOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISdTaskShareViewModel {
    partitionKey: string;
    rowKey: string;
    timestamp: Date | undefined;
    createdBy: number;
    createdByUserName: string;
    createdByUserEmail: string;
    createdOn: Date;
    modifiedBy: number;
    modifiedByUserName: string;
    modifiedByUserEmail: string;
    modifiedOn: Date;
    tenantId: number;
    workspaceId: number;
    taskId: number;
    requestId: string | undefined;
    shareType: SdTaskShareType;
    shareStatus: SdTaskShareStatus;
    inputConfig: ShareInputConfig | undefined;
    outputConfig: ShareMediaSegmentOutputConfig | undefined;
    expiresOn: Date | undefined;
}

export enum SdTaskShareType {
    Task = 10,
    MediaSegment = 20,
}

export enum SdTaskShareStatus {
    Generating = 10,
    Failed = 20,
    Success = 30,
    Expired = 40,
}

export class ShareMediaSegmentOutputConfig implements IShareMediaSegmentOutputConfig {
    serviceName!: string;
    containerName!: string;
    basePath!: string;
    mediaPath!: string;
    thumbnailPath!: string | undefined;
    htmlPath!: string;

    constructor(data?: IShareMediaSegmentOutputConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceName = _data["serviceName"];
            this.containerName = _data["containerName"];
            this.basePath = _data["basePath"];
            this.mediaPath = _data["mediaPath"];
            this.thumbnailPath = _data["thumbnailPath"];
            this.htmlPath = _data["htmlPath"];
        }
    }

    static fromJS(data: any): ShareMediaSegmentOutputConfig {
        data = typeof data === 'object' ? data : {};
        let result = new ShareMediaSegmentOutputConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceName"] = this.serviceName;
        data["containerName"] = this.containerName;
        data["basePath"] = this.basePath;
        data["mediaPath"] = this.mediaPath;
        data["thumbnailPath"] = this.thumbnailPath;
        data["htmlPath"] = this.htmlPath;
        return data;
    }
}

export interface IShareMediaSegmentOutputConfig {
    serviceName: string;
    containerName: string;
    basePath: string;
    mediaPath: string;
    thumbnailPath: string | undefined;
    htmlPath: string;
}

export class WorkspaceUserGetViewModel implements IWorkspaceUserGetViewModel {
    userId!: number;
    workspaceId!: number;
    roleId!: number;
    userStatus!: UserStatus;
    tenantId!: number;
    workspaceName!: string;
    workspaceDescription!: string;
    isDefault!: boolean;
    isConfigured!: boolean;
    taskType!: TaskType;
    workspaceType!: WorkspaceType;
    templateType!: TemplateType;
    workspaceTemplateName!: string | undefined;
    workspaceTemplateIconSource!: string | undefined;
    workspaceTemplateColor!: string | undefined;
    pipelineId!: string | undefined;
    workspaceTemplateRowKey!: string | undefined;
    workspaceTemplatePartitionKey!: string | undefined;

    constructor(data?: IWorkspaceUserGetViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.workspaceId = _data["workspaceId"];
            this.roleId = _data["roleId"];
            this.userStatus = _data["userStatus"];
            this.tenantId = _data["tenantId"];
            this.workspaceName = _data["workspaceName"];
            this.workspaceDescription = _data["workspaceDescription"];
            this.isDefault = _data["isDefault"];
            this.isConfigured = _data["isConfigured"];
            this.taskType = _data["taskType"];
            this.workspaceType = _data["workspaceType"];
            this.templateType = _data["templateType"];
            this.workspaceTemplateName = _data["workspaceTemplateName"];
            this.workspaceTemplateIconSource = _data["workspaceTemplateIconSource"];
            this.workspaceTemplateColor = _data["workspaceTemplateColor"];
            this.pipelineId = _data["pipelineId"];
            this.workspaceTemplateRowKey = _data["workspaceTemplateRowKey"];
            this.workspaceTemplatePartitionKey = _data["workspaceTemplatePartitionKey"];
        }
    }

    static fromJS(data: any): WorkspaceUserGetViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkspaceUserGetViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["workspaceId"] = this.workspaceId;
        data["roleId"] = this.roleId;
        data["userStatus"] = this.userStatus;
        data["tenantId"] = this.tenantId;
        data["workspaceName"] = this.workspaceName;
        data["workspaceDescription"] = this.workspaceDescription;
        data["isDefault"] = this.isDefault;
        data["isConfigured"] = this.isConfigured;
        data["taskType"] = this.taskType;
        data["workspaceType"] = this.workspaceType;
        data["templateType"] = this.templateType;
        data["workspaceTemplateName"] = this.workspaceTemplateName;
        data["workspaceTemplateIconSource"] = this.workspaceTemplateIconSource;
        data["workspaceTemplateColor"] = this.workspaceTemplateColor;
        data["pipelineId"] = this.pipelineId;
        data["workspaceTemplateRowKey"] = this.workspaceTemplateRowKey;
        data["workspaceTemplatePartitionKey"] = this.workspaceTemplatePartitionKey;
        return data;
    }
}

export interface IWorkspaceUserGetViewModel {
    userId: number;
    workspaceId: number;
    roleId: number;
    userStatus: UserStatus;
    tenantId: number;
    workspaceName: string;
    workspaceDescription: string;
    isDefault: boolean;
    isConfigured: boolean;
    taskType: TaskType;
    workspaceType: WorkspaceType;
    templateType: TemplateType;
    workspaceTemplateName: string | undefined;
    workspaceTemplateIconSource: string | undefined;
    workspaceTemplateColor: string | undefined;
    pipelineId: string | undefined;
    workspaceTemplateRowKey: string | undefined;
    workspaceTemplatePartitionKey: string | undefined;
}

export enum WorkspaceType {
    Standard = 10,
    LabelingAndTraining = 20,
}

export enum TemplateType {
    BuiltIn = 10,
    Template = 20,
    TrainTemplate = 30,
    Neural = 40,
    TrainNeural = 50,
}

export class GenericUpdateUserStatusModel implements IGenericUpdateUserStatusModel {
    userId!: number;
    workspaceId!: number | undefined;
    userStatus!: UserStatus;

    constructor(data?: IGenericUpdateUserStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.workspaceId = _data["workspaceId"];
            this.userStatus = _data["userStatus"];
        }
    }

    static fromJS(data: any): GenericUpdateUserStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new GenericUpdateUserStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["workspaceId"] = this.workspaceId;
        data["userStatus"] = this.userStatus;
        return data;
    }
}

export interface IGenericUpdateUserStatusModel {
    userId: number;
    workspaceId: number | undefined;
    userStatus: UserStatus;
}

export class GenericInviteUserViewModel extends GenericInviteUserBaseModel implements IGenericInviteUserViewModel {
    inviteCheckStatus!: InviteCheckStatus;

    constructor(data?: IGenericInviteUserViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.inviteCheckStatus = _data["inviteCheckStatus"];
        }
    }

    static fromJS(data: any): GenericInviteUserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GenericInviteUserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inviteCheckStatus"] = this.inviteCheckStatus;
        super.toJSON(data);
        return data;
    }
}

export interface IGenericInviteUserViewModel extends IGenericInviteUserBaseModel {
    inviteCheckStatus: InviteCheckStatus;
}

export enum InviteCheckStatus {
    NotFound = 1,
    NotFoundInTenant = 2,
    ExistsInTenant = 3,
    NotFoundInWorkspace = 4,
    ExistsInWorkspace = 5,
}

export class SdWorkspaceCustomConfigModel implements ISdWorkspaceCustomConfigModel {
    workspaceName!: string;
    workspaceId!: number;
    tenantId!: number;
    pipelineId!: string;
    categories!: SdFieldViewModel[];
    fieldsToDetect!: string[];
    fieldOrder!: string[];
    requiredFields!: string[];
    customForm!: SdcCustomForm | undefined;
    contextCustomForm!: SdcCustomForm | undefined;
    customFormValuesDefaultsCustomForm!: SdcCustomForm | undefined;
    groupNameKey!: string | undefined;
    allowGroups!: boolean | undefined;
    showSummaryTab!: boolean | undefined;
    allowEditableCategory!: boolean | undefined;
    allowAddingEntities!: boolean | undefined;
    allowSelectingTextWithOcr!: boolean | undefined;
    showNotNormalizedTableFields!: boolean | undefined;
    suggestAdvancedEditingMode!: boolean | undefined;
    showModalFinishReview!: boolean | undefined;
    globalAverageConfidenceRateCheck!: boolean | undefined;
    globalAverageConfidenceRateEntry!: number | undefined;
    fieldsConfidenceRateCheck!: boolean | undefined;
    fieldsConfidenceRateEntry!: number | undefined;
    showConfidenceInViewer!: boolean | undefined;
    showViewerAndTaskListSideBySide!: boolean | undefined;
    dropSmallTablesAutomatically!: boolean | undefined;
    supportedFileTypes!: string[];
    forceSingleChunk!: boolean | undefined;
    externalIdRequired!: boolean | undefined;
    taskType!: TaskType;
    workspaceType!: WorkspaceType;
    templateType!: TemplateType;
    workspaceTemplateRowKey!: string | undefined;
    workspaceTemplatePartitionKey!: string | undefined;
    customModelId!: number | undefined;
    customModelVersionNumber!: number | undefined;
    customModelLastActiveVersionAvailable!: number | undefined;
    customModelCreatedOn!: Date | undefined;
    customModelName!: string | undefined;
    customModelAverageConfidence!: number | undefined;
    workspaceTemplateName!: string | undefined;
    workspaceTemplateDescription!: string | undefined;
    formRecognizerServiceName!: string | undefined;
    contentUnderstandingServiceName!: string | undefined;
    videoIndexerServiceName!: string | undefined;
    transcriptsChatBotServiceName!: string | undefined;
    checkoutExpireMinutes!: number | undefined;
    allowGlobalSave!: boolean | undefined;
    predefinedTexts!: PredefinedText[];
    maxFileSizeBytes!: number;
    transcriptLanguage!: string | undefined;
    inputLanguage!: string | undefined;
    outputLanguage!: string | undefined;
    daysUntilHistoryRemoval!: number;
    isToDelAfterExport!: boolean;
    maxRestartCount!: number;
    hoursUntilTasksConsideredStuck!: number;
    anonymizationFillColor!: string | undefined;
    creditsMultiplierPerUnit!: number | undefined;
    creditsTrainingMultiplierPerUnit!: number | undefined;
    storageConfig!: SdWorkspaceStorageConfigModel | undefined;
    sdStorageConfig!: SdStorageConfigModel | undefined;
    contentUnderstandingConfig!: SdWorkspaceContentUnderstandingConfigModel | undefined;
    fileTypesToSkipReview!: string[];
    recognizerHooks!: string[];
    isExpirationDisabled!: boolean;
    pageRange!: string | undefined;
    ignoreQRCodeErrorsOnAutomaticFinish!: boolean;
    emailReceivingEnabled!: boolean;
    emailSendingEnabled!: boolean;
    nif!: string | undefined;

    constructor(data?: ISdWorkspaceCustomConfigModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workspaceName = _data["workspaceName"];
            this.workspaceId = _data["workspaceId"];
            this.tenantId = _data["tenantId"];
            this.pipelineId = _data["pipelineId"];
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(SdFieldViewModel.fromJS(item));
            }
            if (Array.isArray(_data["fieldsToDetect"])) {
                this.fieldsToDetect = [] as any;
                for (let item of _data["fieldsToDetect"])
                    this.fieldsToDetect!.push(item);
            }
            if (Array.isArray(_data["fieldOrder"])) {
                this.fieldOrder = [] as any;
                for (let item of _data["fieldOrder"])
                    this.fieldOrder!.push(item);
            }
            if (Array.isArray(_data["requiredFields"])) {
                this.requiredFields = [] as any;
                for (let item of _data["requiredFields"])
                    this.requiredFields!.push(item);
            }
            this.customForm = _data["customForm"] ? SdcCustomForm.fromJS(_data["customForm"]) : <any>undefined;
            this.contextCustomForm = _data["contextCustomForm"] ? SdcCustomForm.fromJS(_data["contextCustomForm"]) : <any>undefined;
            this.customFormValuesDefaultsCustomForm = _data["customFormValuesDefaultsCustomForm"] ? SdcCustomForm.fromJS(_data["customFormValuesDefaultsCustomForm"]) : <any>undefined;
            this.groupNameKey = _data["groupNameKey"];
            this.allowGroups = _data["allowGroups"];
            this.showSummaryTab = _data["showSummaryTab"];
            this.allowEditableCategory = _data["allowEditableCategory"];
            this.allowAddingEntities = _data["allowAddingEntities"];
            this.allowSelectingTextWithOcr = _data["allowSelectingTextWithOcr"];
            this.showNotNormalizedTableFields = _data["showNotNormalizedTableFields"];
            this.suggestAdvancedEditingMode = _data["suggestAdvancedEditingMode"];
            this.showModalFinishReview = _data["showModalFinishReview"];
            this.globalAverageConfidenceRateCheck = _data["globalAverageConfidenceRateCheck"];
            this.globalAverageConfidenceRateEntry = _data["globalAverageConfidenceRateEntry"];
            this.fieldsConfidenceRateCheck = _data["fieldsConfidenceRateCheck"];
            this.fieldsConfidenceRateEntry = _data["fieldsConfidenceRateEntry"];
            this.showConfidenceInViewer = _data["showConfidenceInViewer"];
            this.showViewerAndTaskListSideBySide = _data["showViewerAndTaskListSideBySide"];
            this.dropSmallTablesAutomatically = _data["dropSmallTablesAutomatically"];
            if (Array.isArray(_data["supportedFileTypes"])) {
                this.supportedFileTypes = [] as any;
                for (let item of _data["supportedFileTypes"])
                    this.supportedFileTypes!.push(item);
            }
            this.forceSingleChunk = _data["forceSingleChunk"];
            this.externalIdRequired = _data["externalIdRequired"];
            this.taskType = _data["taskType"];
            this.workspaceType = _data["workspaceType"];
            this.templateType = _data["templateType"];
            this.workspaceTemplateRowKey = _data["workspaceTemplateRowKey"];
            this.workspaceTemplatePartitionKey = _data["workspaceTemplatePartitionKey"];
            this.customModelId = _data["customModelId"];
            this.customModelVersionNumber = _data["customModelVersionNumber"];
            this.customModelLastActiveVersionAvailable = _data["customModelLastActiveVersionAvailable"];
            this.customModelCreatedOn = _data["customModelCreatedOn"] ? new Date(_data["customModelCreatedOn"].toString()) : <any>undefined;
            this.customModelName = _data["customModelName"];
            this.customModelAverageConfidence = _data["customModelAverageConfidence"];
            this.workspaceTemplateName = _data["workspaceTemplateName"];
            this.workspaceTemplateDescription = _data["workspaceTemplateDescription"];
            this.formRecognizerServiceName = _data["formRecognizerServiceName"];
            this.contentUnderstandingServiceName = _data["contentUnderstandingServiceName"];
            this.videoIndexerServiceName = _data["videoIndexerServiceName"];
            this.transcriptsChatBotServiceName = _data["transcriptsChatBotServiceName"];
            this.checkoutExpireMinutes = _data["checkoutExpireMinutes"];
            this.allowGlobalSave = _data["allowGlobalSave"];
            if (Array.isArray(_data["predefinedTexts"])) {
                this.predefinedTexts = [] as any;
                for (let item of _data["predefinedTexts"])
                    this.predefinedTexts!.push(PredefinedText.fromJS(item));
            }
            this.maxFileSizeBytes = _data["maxFileSizeBytes"];
            this.transcriptLanguage = _data["transcriptLanguage"];
            this.inputLanguage = _data["inputLanguage"];
            this.outputLanguage = _data["outputLanguage"];
            this.daysUntilHistoryRemoval = _data["daysUntilHistoryRemoval"];
            this.isToDelAfterExport = _data["isToDelAfterExport"];
            this.maxRestartCount = _data["maxRestartCount"];
            this.hoursUntilTasksConsideredStuck = _data["hoursUntilTasksConsideredStuck"];
            this.anonymizationFillColor = _data["anonymizationFillColor"];
            this.creditsMultiplierPerUnit = _data["creditsMultiplierPerUnit"];
            this.creditsTrainingMultiplierPerUnit = _data["creditsTrainingMultiplierPerUnit"];
            this.storageConfig = _data["storageConfig"] ? SdWorkspaceStorageConfigModel.fromJS(_data["storageConfig"]) : <any>undefined;
            this.sdStorageConfig = _data["sdStorageConfig"] ? SdStorageConfigModel.fromJS(_data["sdStorageConfig"]) : <any>undefined;
            this.contentUnderstandingConfig = _data["contentUnderstandingConfig"] ? SdWorkspaceContentUnderstandingConfigModel.fromJS(_data["contentUnderstandingConfig"]) : <any>undefined;
            if (Array.isArray(_data["fileTypesToSkipReview"])) {
                this.fileTypesToSkipReview = [] as any;
                for (let item of _data["fileTypesToSkipReview"])
                    this.fileTypesToSkipReview!.push(item);
            }
            if (Array.isArray(_data["recognizerHooks"])) {
                this.recognizerHooks = [] as any;
                for (let item of _data["recognizerHooks"])
                    this.recognizerHooks!.push(item);
            }
            this.isExpirationDisabled = _data["isExpirationDisabled"];
            this.pageRange = _data["pageRange"];
            this.ignoreQRCodeErrorsOnAutomaticFinish = _data["ignoreQRCodeErrorsOnAutomaticFinish"];
            this.emailReceivingEnabled = _data["emailReceivingEnabled"];
            this.emailSendingEnabled = _data["emailSendingEnabled"];
            this.nif = _data["nif"];
        }
    }

    static fromJS(data: any): SdWorkspaceCustomConfigModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdWorkspaceCustomConfigModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workspaceName"] = this.workspaceName;
        data["workspaceId"] = this.workspaceId;
        data["tenantId"] = this.tenantId;
        data["pipelineId"] = this.pipelineId;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        if (Array.isArray(this.fieldsToDetect)) {
            data["fieldsToDetect"] = [];
            for (let item of this.fieldsToDetect)
                data["fieldsToDetect"].push(item);
        }
        if (Array.isArray(this.fieldOrder)) {
            data["fieldOrder"] = [];
            for (let item of this.fieldOrder)
                data["fieldOrder"].push(item);
        }
        if (Array.isArray(this.requiredFields)) {
            data["requiredFields"] = [];
            for (let item of this.requiredFields)
                data["requiredFields"].push(item);
        }
        data["customForm"] = this.customForm ? this.customForm.toJSON() : <any>undefined;
        data["contextCustomForm"] = this.contextCustomForm ? this.contextCustomForm.toJSON() : <any>undefined;
        data["customFormValuesDefaultsCustomForm"] = this.customFormValuesDefaultsCustomForm ? this.customFormValuesDefaultsCustomForm.toJSON() : <any>undefined;
        data["groupNameKey"] = this.groupNameKey;
        data["allowGroups"] = this.allowGroups;
        data["showSummaryTab"] = this.showSummaryTab;
        data["allowEditableCategory"] = this.allowEditableCategory;
        data["allowAddingEntities"] = this.allowAddingEntities;
        data["allowSelectingTextWithOcr"] = this.allowSelectingTextWithOcr;
        data["showNotNormalizedTableFields"] = this.showNotNormalizedTableFields;
        data["suggestAdvancedEditingMode"] = this.suggestAdvancedEditingMode;
        data["showModalFinishReview"] = this.showModalFinishReview;
        data["globalAverageConfidenceRateCheck"] = this.globalAverageConfidenceRateCheck;
        data["globalAverageConfidenceRateEntry"] = this.globalAverageConfidenceRateEntry;
        data["fieldsConfidenceRateCheck"] = this.fieldsConfidenceRateCheck;
        data["fieldsConfidenceRateEntry"] = this.fieldsConfidenceRateEntry;
        data["showConfidenceInViewer"] = this.showConfidenceInViewer;
        data["showViewerAndTaskListSideBySide"] = this.showViewerAndTaskListSideBySide;
        data["dropSmallTablesAutomatically"] = this.dropSmallTablesAutomatically;
        if (Array.isArray(this.supportedFileTypes)) {
            data["supportedFileTypes"] = [];
            for (let item of this.supportedFileTypes)
                data["supportedFileTypes"].push(item);
        }
        data["forceSingleChunk"] = this.forceSingleChunk;
        data["externalIdRequired"] = this.externalIdRequired;
        data["taskType"] = this.taskType;
        data["workspaceType"] = this.workspaceType;
        data["templateType"] = this.templateType;
        data["workspaceTemplateRowKey"] = this.workspaceTemplateRowKey;
        data["workspaceTemplatePartitionKey"] = this.workspaceTemplatePartitionKey;
        data["customModelId"] = this.customModelId;
        data["customModelVersionNumber"] = this.customModelVersionNumber;
        data["customModelLastActiveVersionAvailable"] = this.customModelLastActiveVersionAvailable;
        data["customModelCreatedOn"] = this.customModelCreatedOn ? this.customModelCreatedOn.toISOString() : <any>undefined;
        data["customModelName"] = this.customModelName;
        data["customModelAverageConfidence"] = this.customModelAverageConfidence;
        data["workspaceTemplateName"] = this.workspaceTemplateName;
        data["workspaceTemplateDescription"] = this.workspaceTemplateDescription;
        data["formRecognizerServiceName"] = this.formRecognizerServiceName;
        data["contentUnderstandingServiceName"] = this.contentUnderstandingServiceName;
        data["videoIndexerServiceName"] = this.videoIndexerServiceName;
        data["transcriptsChatBotServiceName"] = this.transcriptsChatBotServiceName;
        data["checkoutExpireMinutes"] = this.checkoutExpireMinutes;
        data["allowGlobalSave"] = this.allowGlobalSave;
        if (Array.isArray(this.predefinedTexts)) {
            data["predefinedTexts"] = [];
            for (let item of this.predefinedTexts)
                data["predefinedTexts"].push(item.toJSON());
        }
        data["maxFileSizeBytes"] = this.maxFileSizeBytes;
        data["transcriptLanguage"] = this.transcriptLanguage;
        data["inputLanguage"] = this.inputLanguage;
        data["outputLanguage"] = this.outputLanguage;
        data["daysUntilHistoryRemoval"] = this.daysUntilHistoryRemoval;
        data["isToDelAfterExport"] = this.isToDelAfterExport;
        data["maxRestartCount"] = this.maxRestartCount;
        data["hoursUntilTasksConsideredStuck"] = this.hoursUntilTasksConsideredStuck;
        data["anonymizationFillColor"] = this.anonymizationFillColor;
        data["creditsMultiplierPerUnit"] = this.creditsMultiplierPerUnit;
        data["creditsTrainingMultiplierPerUnit"] = this.creditsTrainingMultiplierPerUnit;
        data["storageConfig"] = this.storageConfig ? this.storageConfig.toJSON() : <any>undefined;
        data["sdStorageConfig"] = this.sdStorageConfig ? this.sdStorageConfig.toJSON() : <any>undefined;
        data["contentUnderstandingConfig"] = this.contentUnderstandingConfig ? this.contentUnderstandingConfig.toJSON() : <any>undefined;
        if (Array.isArray(this.fileTypesToSkipReview)) {
            data["fileTypesToSkipReview"] = [];
            for (let item of this.fileTypesToSkipReview)
                data["fileTypesToSkipReview"].push(item);
        }
        if (Array.isArray(this.recognizerHooks)) {
            data["recognizerHooks"] = [];
            for (let item of this.recognizerHooks)
                data["recognizerHooks"].push(item);
        }
        data["isExpirationDisabled"] = this.isExpirationDisabled;
        data["pageRange"] = this.pageRange;
        data["ignoreQRCodeErrorsOnAutomaticFinish"] = this.ignoreQRCodeErrorsOnAutomaticFinish;
        data["emailReceivingEnabled"] = this.emailReceivingEnabled;
        data["emailSendingEnabled"] = this.emailSendingEnabled;
        data["nif"] = this.nif;
        return data;
    }
}

export interface ISdWorkspaceCustomConfigModel {
    workspaceName: string;
    workspaceId: number;
    tenantId: number;
    pipelineId: string;
    categories: SdFieldViewModel[];
    fieldsToDetect: string[];
    fieldOrder: string[];
    requiredFields: string[];
    customForm: SdcCustomForm | undefined;
    contextCustomForm: SdcCustomForm | undefined;
    customFormValuesDefaultsCustomForm: SdcCustomForm | undefined;
    groupNameKey: string | undefined;
    allowGroups: boolean | undefined;
    showSummaryTab: boolean | undefined;
    allowEditableCategory: boolean | undefined;
    allowAddingEntities: boolean | undefined;
    allowSelectingTextWithOcr: boolean | undefined;
    showNotNormalizedTableFields: boolean | undefined;
    suggestAdvancedEditingMode: boolean | undefined;
    showModalFinishReview: boolean | undefined;
    globalAverageConfidenceRateCheck: boolean | undefined;
    globalAverageConfidenceRateEntry: number | undefined;
    fieldsConfidenceRateCheck: boolean | undefined;
    fieldsConfidenceRateEntry: number | undefined;
    showConfidenceInViewer: boolean | undefined;
    showViewerAndTaskListSideBySide: boolean | undefined;
    dropSmallTablesAutomatically: boolean | undefined;
    supportedFileTypes: string[];
    forceSingleChunk: boolean | undefined;
    externalIdRequired: boolean | undefined;
    taskType: TaskType;
    workspaceType: WorkspaceType;
    templateType: TemplateType;
    workspaceTemplateRowKey: string | undefined;
    workspaceTemplatePartitionKey: string | undefined;
    customModelId: number | undefined;
    customModelVersionNumber: number | undefined;
    customModelLastActiveVersionAvailable: number | undefined;
    customModelCreatedOn: Date | undefined;
    customModelName: string | undefined;
    customModelAverageConfidence: number | undefined;
    workspaceTemplateName: string | undefined;
    workspaceTemplateDescription: string | undefined;
    formRecognizerServiceName: string | undefined;
    contentUnderstandingServiceName: string | undefined;
    videoIndexerServiceName: string | undefined;
    transcriptsChatBotServiceName: string | undefined;
    checkoutExpireMinutes: number | undefined;
    allowGlobalSave: boolean | undefined;
    predefinedTexts: PredefinedText[];
    maxFileSizeBytes: number;
    transcriptLanguage: string | undefined;
    inputLanguage: string | undefined;
    outputLanguage: string | undefined;
    daysUntilHistoryRemoval: number;
    isToDelAfterExport: boolean;
    maxRestartCount: number;
    hoursUntilTasksConsideredStuck: number;
    anonymizationFillColor: string | undefined;
    creditsMultiplierPerUnit: number | undefined;
    creditsTrainingMultiplierPerUnit: number | undefined;
    storageConfig: SdWorkspaceStorageConfigModel | undefined;
    sdStorageConfig: SdStorageConfigModel | undefined;
    contentUnderstandingConfig: SdWorkspaceContentUnderstandingConfigModel | undefined;
    fileTypesToSkipReview: string[];
    recognizerHooks: string[];
    isExpirationDisabled: boolean;
    pageRange: string | undefined;
    ignoreQRCodeErrorsOnAutomaticFinish: boolean;
    emailReceivingEnabled: boolean;
    emailSendingEnabled: boolean;
    nif: string | undefined;
}

export class PredefinedText implements IPredefinedText {
    id!: string;
    text!: string;

    constructor(data?: IPredefinedText) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): PredefinedText {
        data = typeof data === 'object' ? data : {};
        let result = new PredefinedText();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        return data;
    }
}

export interface IPredefinedText {
    id: string;
    text: string;
}

export class SdWorkspaceStorageConfigModel implements ISdWorkspaceStorageConfigModel {
    serviceName!: string;
    glossaryDirectoryPath!: string | undefined;
    exportDirectoryPath!: string | undefined;
    globalGlossaryPath!: string | undefined;
    globalGlossaryId!: string | undefined;
    siteId!: string | undefined;
    driveId!: string | undefined;

    constructor(data?: ISdWorkspaceStorageConfigModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceName = _data["serviceName"];
            this.glossaryDirectoryPath = _data["glossaryDirectoryPath"];
            this.exportDirectoryPath = _data["exportDirectoryPath"];
            this.globalGlossaryPath = _data["globalGlossaryPath"];
            this.globalGlossaryId = _data["globalGlossaryId"];
            this.siteId = _data["siteId"];
            this.driveId = _data["driveId"];
        }
    }

    static fromJS(data: any): SdWorkspaceStorageConfigModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdWorkspaceStorageConfigModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceName"] = this.serviceName;
        data["glossaryDirectoryPath"] = this.glossaryDirectoryPath;
        data["exportDirectoryPath"] = this.exportDirectoryPath;
        data["globalGlossaryPath"] = this.globalGlossaryPath;
        data["globalGlossaryId"] = this.globalGlossaryId;
        data["siteId"] = this.siteId;
        data["driveId"] = this.driveId;
        return data;
    }
}

export interface ISdWorkspaceStorageConfigModel {
    serviceName: string;
    glossaryDirectoryPath: string | undefined;
    exportDirectoryPath: string | undefined;
    globalGlossaryPath: string | undefined;
    globalGlossaryId: string | undefined;
    siteId: string | undefined;
    driveId: string | undefined;
}

export class SdStorageConfigModel implements ISdStorageConfigModel {
    serviceName!: string;
    connectorType!: LoadBalancedServiceType;
    exportPath!: string | undefined;
    importPath!: string | undefined;
    connectorMetadata!: { [key: string]: string; } | undefined;

    constructor(data?: ISdStorageConfigModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceName = _data["serviceName"];
            this.connectorType = _data["connectorType"];
            this.exportPath = _data["exportPath"];
            this.importPath = _data["importPath"];
            if (_data["connectorMetadata"]) {
                this.connectorMetadata = {} as any;
                for (let key in _data["connectorMetadata"]) {
                    if (_data["connectorMetadata"].hasOwnProperty(key))
                        (<any>this.connectorMetadata)![key] = _data["connectorMetadata"][key];
                }
            }
        }
    }

    static fromJS(data: any): SdStorageConfigModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdStorageConfigModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceName"] = this.serviceName;
        data["connectorType"] = this.connectorType;
        data["exportPath"] = this.exportPath;
        data["importPath"] = this.importPath;
        if (this.connectorMetadata) {
            data["connectorMetadata"] = {};
            for (let key in this.connectorMetadata) {
                if (this.connectorMetadata.hasOwnProperty(key))
                    (<any>data["connectorMetadata"])[key] = (<any>this.connectorMetadata)[key];
            }
        }
        return data;
    }
}

export interface ISdStorageConfigModel {
    serviceName: string;
    connectorType: LoadBalancedServiceType;
    exportPath: string | undefined;
    importPath: string | undefined;
    connectorMetadata: { [key: string]: string; } | undefined;
}

export class SdWorkspaceContentUnderstandingConfigModel implements ISdWorkspaceContentUnderstandingConfigModel {
    baseAnalyzerId!: string;
    analyzerId!: string;
    description!: string;
    contentAnalyzer!: ContentAnalyzer | undefined;

    constructor(data?: ISdWorkspaceContentUnderstandingConfigModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseAnalyzerId = _data["baseAnalyzerId"];
            this.analyzerId = _data["analyzerId"];
            this.description = _data["description"];
            this.contentAnalyzer = _data["contentAnalyzer"] ? ContentAnalyzer.fromJS(_data["contentAnalyzer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SdWorkspaceContentUnderstandingConfigModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdWorkspaceContentUnderstandingConfigModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseAnalyzerId"] = this.baseAnalyzerId;
        data["analyzerId"] = this.analyzerId;
        data["description"] = this.description;
        data["contentAnalyzer"] = this.contentAnalyzer ? this.contentAnalyzer.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISdWorkspaceContentUnderstandingConfigModel {
    baseAnalyzerId: string;
    analyzerId: string;
    description: string;
    contentAnalyzer: ContentAnalyzer | undefined;
}

export class ContentAnalyzer implements IContentAnalyzer {
    analyzerId!: string;
    baseAnalyzerId!: string;
    config!: ContentAnalyzerConfig;
    createdAt!: Date;
    description!: string;
    fieldSchema!: FieldSchema;
    knowledgeSources!: ReferenceKnowledgeSource[] | undefined;
    lastModifiedAt!: Date;
    processingLocation!: ProcessingLocation;
    status!: ResourceStatus;
    tags!: { [key: string]: string; } | undefined;
    warnings!: ErrorDto[];
    models!: Models;

    constructor(data?: IContentAnalyzer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.analyzerId = _data["analyzerId"];
            this.baseAnalyzerId = _data["baseAnalyzerId"];
            this.config = _data["config"] ? ContentAnalyzerConfig.fromJS(_data["config"]) : <any>undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.fieldSchema = _data["fieldSchema"] ? FieldSchema.fromJS(_data["fieldSchema"]) : <any>undefined;
            if (Array.isArray(_data["knowledgeSources"])) {
                this.knowledgeSources = [] as any;
                for (let item of _data["knowledgeSources"])
                    this.knowledgeSources!.push(ReferenceKnowledgeSource.fromJS(item));
            }
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : <any>undefined;
            this.processingLocation = _data["processingLocation"];
            this.status = _data["status"];
            if (_data["tags"]) {
                this.tags = {} as any;
                for (let key in _data["tags"]) {
                    if (_data["tags"].hasOwnProperty(key))
                        (<any>this.tags)![key] = _data["tags"][key];
                }
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(ErrorDto.fromJS(item));
            }
            this.models = _data["models"] ? Models.fromJS(_data["models"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ContentAnalyzer {
        data = typeof data === 'object' ? data : {};
        let result = new ContentAnalyzer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["analyzerId"] = this.analyzerId;
        data["baseAnalyzerId"] = this.baseAnalyzerId;
        data["config"] = this.config ? this.config.toJSON() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["fieldSchema"] = this.fieldSchema ? this.fieldSchema.toJSON() : <any>undefined;
        if (Array.isArray(this.knowledgeSources)) {
            data["knowledgeSources"] = [];
            for (let item of this.knowledgeSources)
                data["knowledgeSources"].push(item.toJSON());
        }
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : <any>undefined;
        data["processingLocation"] = this.processingLocation;
        data["status"] = this.status;
        if (this.tags) {
            data["tags"] = {};
            for (let key in this.tags) {
                if (this.tags.hasOwnProperty(key))
                    (<any>data["tags"])[key] = (<any>this.tags)[key];
            }
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item.toJSON());
        }
        data["models"] = this.models ? this.models.toJSON() : <any>undefined;
        return data;
    }
}

export interface IContentAnalyzer {
    analyzerId: string;
    baseAnalyzerId: string;
    config: ContentAnalyzerConfig;
    createdAt: Date;
    description: string;
    fieldSchema: FieldSchema;
    knowledgeSources: ReferenceKnowledgeSource[] | undefined;
    lastModifiedAt: Date;
    processingLocation: ProcessingLocation;
    status: ResourceStatus;
    tags: { [key: string]: string; } | undefined;
    warnings: ErrorDto[];
    models: Models;
}

export class ContentAnalyzerConfig implements IContentAnalyzerConfig {
    disableContentFiltering!: boolean;
    disableFaceBlurring!: boolean;
    enableFace!: boolean;
    enableFormula!: boolean;
    enableLayout!: boolean;
    enableOcr!: boolean;
    enableBarcode!: boolean;
    estimateFieldSourceAndConfidence!: boolean;
    locales!: string[] | undefined;
    personDirectoryId!: string | undefined;
    returnDetails!: boolean;
    segmentationDefinition!: string | undefined;
    segmentationMode!: SegmentationMode | undefined;
    tableFormat!: TableFormat | undefined;

    constructor(data?: IContentAnalyzerConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.disableContentFiltering = _data["disableContentFiltering"];
            this.disableFaceBlurring = _data["disableFaceBlurring"];
            this.enableFace = _data["enableFace"];
            this.enableFormula = _data["enableFormula"];
            this.enableLayout = _data["enableLayout"];
            this.enableOcr = _data["enableOcr"];
            this.enableBarcode = _data["enableBarcode"];
            this.estimateFieldSourceAndConfidence = _data["estimateFieldSourceAndConfidence"];
            if (Array.isArray(_data["locales"])) {
                this.locales = [] as any;
                for (let item of _data["locales"])
                    this.locales!.push(item);
            }
            this.personDirectoryId = _data["personDirectoryId"];
            this.returnDetails = _data["returnDetails"];
            this.segmentationDefinition = _data["segmentationDefinition"];
            this.segmentationMode = _data["segmentationMode"];
            this.tableFormat = _data["tableFormat"];
        }
    }

    static fromJS(data: any): ContentAnalyzerConfig {
        data = typeof data === 'object' ? data : {};
        let result = new ContentAnalyzerConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["disableContentFiltering"] = this.disableContentFiltering;
        data["disableFaceBlurring"] = this.disableFaceBlurring;
        data["enableFace"] = this.enableFace;
        data["enableFormula"] = this.enableFormula;
        data["enableLayout"] = this.enableLayout;
        data["enableOcr"] = this.enableOcr;
        data["enableBarcode"] = this.enableBarcode;
        data["estimateFieldSourceAndConfidence"] = this.estimateFieldSourceAndConfidence;
        if (Array.isArray(this.locales)) {
            data["locales"] = [];
            for (let item of this.locales)
                data["locales"].push(item);
        }
        data["personDirectoryId"] = this.personDirectoryId;
        data["returnDetails"] = this.returnDetails;
        data["segmentationDefinition"] = this.segmentationDefinition;
        data["segmentationMode"] = this.segmentationMode;
        data["tableFormat"] = this.tableFormat;
        return data;
    }
}

export interface IContentAnalyzerConfig {
    disableContentFiltering: boolean;
    disableFaceBlurring: boolean;
    enableFace: boolean;
    enableFormula: boolean;
    enableLayout: boolean;
    enableOcr: boolean;
    enableBarcode: boolean;
    estimateFieldSourceAndConfidence: boolean;
    locales: string[] | undefined;
    personDirectoryId: string | undefined;
    returnDetails: boolean;
    segmentationDefinition: string | undefined;
    segmentationMode: SegmentationMode | undefined;
    tableFormat: TableFormat | undefined;
}

export enum SegmentationMode {
    NoSegmentation = "NoSegmentation",
    Auto = "Auto",
    Custom = "Custom",
}

export enum TableFormat {
    Html = "Html",
}

export class FieldSchema implements IFieldSchema {
    definitions!: { [key: string]: FieldDefinition; } | undefined;
    description!: string | undefined;
    fields!: { [key: string]: FieldDefinition; } | undefined;
    name!: string | undefined;

    constructor(data?: IFieldSchema) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["definitions"]) {
                this.definitions = {} as any;
                for (let key in _data["definitions"]) {
                    if (_data["definitions"].hasOwnProperty(key))
                        (<any>this.definitions)![key] = _data["definitions"][key] ? FieldDefinition.fromJS(_data["definitions"][key]) : new FieldDefinition();
                }
            }
            this.description = _data["description"];
            if (_data["fields"]) {
                this.fields = {} as any;
                for (let key in _data["fields"]) {
                    if (_data["fields"].hasOwnProperty(key))
                        (<any>this.fields)![key] = _data["fields"][key] ? FieldDefinition.fromJS(_data["fields"][key]) : new FieldDefinition();
                }
            }
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): FieldSchema {
        data = typeof data === 'object' ? data : {};
        let result = new FieldSchema();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.definitions) {
            data["definitions"] = {};
            for (let key in this.definitions) {
                if (this.definitions.hasOwnProperty(key))
                    (<any>data["definitions"])[key] = this.definitions[key] ? this.definitions[key].toJSON() : <any>undefined;
            }
        }
        data["description"] = this.description;
        if (this.fields) {
            data["fields"] = {};
            for (let key in this.fields) {
                if (this.fields.hasOwnProperty(key))
                    (<any>data["fields"])[key] = this.fields[key] ? this.fields[key].toJSON() : <any>undefined;
            }
        }
        data["name"] = this.name;
        return data;
    }
}

export interface IFieldSchema {
    definitions: { [key: string]: FieldDefinition; } | undefined;
    description: string | undefined;
    fields: { [key: string]: FieldDefinition; } | undefined;
    name: string | undefined;
}

export class FieldDefinition implements IFieldDefinition {
    ref!: string | undefined;
    description!: string | undefined;
    enum!: string[] | undefined;
    enumDescriptions!: { [key: string]: string; } | undefined;
    examples!: string[] | undefined;
    items!: FieldDefinition | undefined;
    method!: GenerationMethod | undefined;
    properties!: { [key: string]: FieldDefinition; } | undefined;
    type!: FieldType | undefined;

    constructor(data?: IFieldDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ref = _data["ref"];
            this.description = _data["description"];
            if (Array.isArray(_data["enum"])) {
                this.enum = [] as any;
                for (let item of _data["enum"])
                    this.enum!.push(item);
            }
            if (_data["enumDescriptions"]) {
                this.enumDescriptions = {} as any;
                for (let key in _data["enumDescriptions"]) {
                    if (_data["enumDescriptions"].hasOwnProperty(key))
                        (<any>this.enumDescriptions)![key] = _data["enumDescriptions"][key];
                }
            }
            if (Array.isArray(_data["examples"])) {
                this.examples = [] as any;
                for (let item of _data["examples"])
                    this.examples!.push(item);
            }
            this.items = _data["items"] ? FieldDefinition.fromJS(_data["items"]) : <any>undefined;
            this.method = _data["method"];
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key] ? FieldDefinition.fromJS(_data["properties"][key]) : new FieldDefinition();
                }
            }
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): FieldDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new FieldDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ref"] = this.ref;
        data["description"] = this.description;
        if (Array.isArray(this.enum)) {
            data["enum"] = [];
            for (let item of this.enum)
                data["enum"].push(item);
        }
        if (this.enumDescriptions) {
            data["enumDescriptions"] = {};
            for (let key in this.enumDescriptions) {
                if (this.enumDescriptions.hasOwnProperty(key))
                    (<any>data["enumDescriptions"])[key] = (<any>this.enumDescriptions)[key];
            }
        }
        if (Array.isArray(this.examples)) {
            data["examples"] = [];
            for (let item of this.examples)
                data["examples"].push(item);
        }
        data["items"] = this.items ? this.items.toJSON() : <any>undefined;
        data["method"] = this.method;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key] ? this.properties[key].toJSON() : <any>undefined;
            }
        }
        data["type"] = this.type;
        return data;
    }
}

export interface IFieldDefinition {
    ref: string | undefined;
    description: string | undefined;
    enum: string[] | undefined;
    enumDescriptions: { [key: string]: string; } | undefined;
    examples: string[] | undefined;
    items: FieldDefinition | undefined;
    method: GenerationMethod | undefined;
    properties: { [key: string]: FieldDefinition; } | undefined;
    type: FieldType | undefined;
}

export enum GenerationMethod {
    Generate = "Generate",
    Extract = "Extract",
    Classify = "Classify",
}

export enum FieldType {
    String = "String",
    Date = "Date",
    Time = "Time",
    Number = "Number",
    Integer = "Integer",
    Boolean = "Boolean",
    Picker = "Picker",
    Array = "Array",
    Object = "Object",
}

export class ReferenceKnowledgeSource implements IReferenceKnowledgeSource {
    containerUrl!: string;
    fileListPath!: string;
    kind!: DataSourceKind;
    prefix!: string;

    constructor(data?: IReferenceKnowledgeSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.containerUrl = _data["containerUrl"];
            this.fileListPath = _data["fileListPath"];
            this.kind = _data["kind"];
            this.prefix = _data["prefix"];
        }
    }

    static fromJS(data: any): ReferenceKnowledgeSource {
        data = typeof data === 'object' ? data : {};
        let result = new ReferenceKnowledgeSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["containerUrl"] = this.containerUrl;
        data["fileListPath"] = this.fileListPath;
        data["kind"] = this.kind;
        data["prefix"] = this.prefix;
        return data;
    }
}

export interface IReferenceKnowledgeSource {
    containerUrl: string;
    fileListPath: string;
    kind: DataSourceKind;
    prefix: string;
}

export enum DataSourceKind {
    Blob = "Blob",
    Reference = "Reference",
}

export enum ProcessingLocation {
    Geography = "Geography",
    DataZone = "DataZone",
    Global = "Global",
}

export enum ResourceStatus {
    Creating = "Creating",
    Ready = "Ready",
    Deleting = "Deleting",
    Failed = "Failed",
}

export class ErrorDto implements IErrorDto {
    code!: string;
    message!: string | undefined;
    target!: string | undefined;
    details!: ErrorDto[] | undefined;
    innerError!: ErrorDto | undefined;

    constructor(data?: IErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
            this.target = _data["target"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(ErrorDto.fromJS(item));
            }
            this.innerError = _data["innerError"] ? ErrorDto.fromJS(_data["innerError"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        data["target"] = this.target;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["innerError"] = this.innerError ? this.innerError.toJSON() : <any>undefined;
        return data;
    }
}

export interface IErrorDto {
    code: string;
    message: string | undefined;
    target: string | undefined;
    details: ErrorDto[] | undefined;
    innerError: ErrorDto | undefined;
}

export class Models implements IModels {
    completion!: string;
    embedding!: string;

    constructor(data?: IModels) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.completion = _data["completion"];
            this.embedding = _data["embedding"];
        }
    }

    static fromJS(data: any): Models {
        data = typeof data === 'object' ? data : {};
        let result = new Models();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["completion"] = this.completion;
        data["embedding"] = this.embedding;
        return data;
    }
}

export interface IModels {
    completion: string;
    embedding: string;
}

export class SdWorkspaceAdvancedSettingsViewModel implements ISdWorkspaceAdvancedSettingsViewModel {
    fieldsToDetect!: string[];
    groupNameKey!: string | undefined;
    allowGroups!: boolean | undefined;
    allowAddingEntities!: boolean | undefined;
    showSummaryTab!: boolean | undefined;
    detectableFields!: SdFieldViewModel[];
    showModalFinishReview!: boolean | undefined;
    globalAverageConfidenceRateCheck!: boolean | undefined;
    globalAverageConfidenceRateEntry!: number | undefined;
    fieldsConfidenceRateCheck!: boolean | undefined;
    fieldsConfidenceRateEntry!: number | undefined;
    showConfidenceInViewer!: boolean | undefined;
    showViewerAndTaskListSideBySide!: boolean | undefined;
    dropSmallTablesAutomatically!: boolean | undefined;
    checkoutExpireMinutes!: number | undefined;
    allowGlobalSave!: boolean | undefined;
    daysUntilRemoval!: number | undefined;
    isToDelAfterExport!: boolean | undefined;
    maxRestartCount!: number;
    hoursUntilTasksConsideredStuck!: number;
    anonymizationFillColor!: string | undefined;
    fileTypesToSkipReview!: string[] | undefined;
    isExpirationDisabled!: boolean | undefined;
    pageRange!: string | undefined;
    ignoreQRCodeErrorsOnAutomaticFinish!: boolean | undefined;
    nif!: string | undefined;
    isNifResolverEnabled!: boolean;

    constructor(data?: ISdWorkspaceAdvancedSettingsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fieldsToDetect"])) {
                this.fieldsToDetect = [] as any;
                for (let item of _data["fieldsToDetect"])
                    this.fieldsToDetect!.push(item);
            }
            this.groupNameKey = _data["groupNameKey"];
            this.allowGroups = _data["allowGroups"];
            this.allowAddingEntities = _data["allowAddingEntities"];
            this.showSummaryTab = _data["showSummaryTab"];
            if (Array.isArray(_data["detectableFields"])) {
                this.detectableFields = [] as any;
                for (let item of _data["detectableFields"])
                    this.detectableFields!.push(SdFieldViewModel.fromJS(item));
            }
            this.showModalFinishReview = _data["showModalFinishReview"];
            this.globalAverageConfidenceRateCheck = _data["globalAverageConfidenceRateCheck"];
            this.globalAverageConfidenceRateEntry = _data["globalAverageConfidenceRateEntry"];
            this.fieldsConfidenceRateCheck = _data["fieldsConfidenceRateCheck"];
            this.fieldsConfidenceRateEntry = _data["fieldsConfidenceRateEntry"];
            this.showConfidenceInViewer = _data["showConfidenceInViewer"];
            this.showViewerAndTaskListSideBySide = _data["showViewerAndTaskListSideBySide"];
            this.dropSmallTablesAutomatically = _data["dropSmallTablesAutomatically"];
            this.checkoutExpireMinutes = _data["checkoutExpireMinutes"];
            this.allowGlobalSave = _data["allowGlobalSave"];
            this.daysUntilRemoval = _data["daysUntilRemoval"];
            this.isToDelAfterExport = _data["isToDelAfterExport"];
            this.maxRestartCount = _data["maxRestartCount"];
            this.hoursUntilTasksConsideredStuck = _data["hoursUntilTasksConsideredStuck"];
            this.anonymizationFillColor = _data["anonymizationFillColor"];
            if (Array.isArray(_data["fileTypesToSkipReview"])) {
                this.fileTypesToSkipReview = [] as any;
                for (let item of _data["fileTypesToSkipReview"])
                    this.fileTypesToSkipReview!.push(item);
            }
            this.isExpirationDisabled = _data["isExpirationDisabled"];
            this.pageRange = _data["pageRange"];
            this.ignoreQRCodeErrorsOnAutomaticFinish = _data["ignoreQRCodeErrorsOnAutomaticFinish"];
            this.nif = _data["nif"];
            this.isNifResolverEnabled = _data["isNifResolverEnabled"];
        }
    }

    static fromJS(data: any): SdWorkspaceAdvancedSettingsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdWorkspaceAdvancedSettingsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fieldsToDetect)) {
            data["fieldsToDetect"] = [];
            for (let item of this.fieldsToDetect)
                data["fieldsToDetect"].push(item);
        }
        data["groupNameKey"] = this.groupNameKey;
        data["allowGroups"] = this.allowGroups;
        data["allowAddingEntities"] = this.allowAddingEntities;
        data["showSummaryTab"] = this.showSummaryTab;
        if (Array.isArray(this.detectableFields)) {
            data["detectableFields"] = [];
            for (let item of this.detectableFields)
                data["detectableFields"].push(item.toJSON());
        }
        data["showModalFinishReview"] = this.showModalFinishReview;
        data["globalAverageConfidenceRateCheck"] = this.globalAverageConfidenceRateCheck;
        data["globalAverageConfidenceRateEntry"] = this.globalAverageConfidenceRateEntry;
        data["fieldsConfidenceRateCheck"] = this.fieldsConfidenceRateCheck;
        data["fieldsConfidenceRateEntry"] = this.fieldsConfidenceRateEntry;
        data["showConfidenceInViewer"] = this.showConfidenceInViewer;
        data["showViewerAndTaskListSideBySide"] = this.showViewerAndTaskListSideBySide;
        data["dropSmallTablesAutomatically"] = this.dropSmallTablesAutomatically;
        data["checkoutExpireMinutes"] = this.checkoutExpireMinutes;
        data["allowGlobalSave"] = this.allowGlobalSave;
        data["daysUntilRemoval"] = this.daysUntilRemoval;
        data["isToDelAfterExport"] = this.isToDelAfterExport;
        data["maxRestartCount"] = this.maxRestartCount;
        data["hoursUntilTasksConsideredStuck"] = this.hoursUntilTasksConsideredStuck;
        data["anonymizationFillColor"] = this.anonymizationFillColor;
        if (Array.isArray(this.fileTypesToSkipReview)) {
            data["fileTypesToSkipReview"] = [];
            for (let item of this.fileTypesToSkipReview)
                data["fileTypesToSkipReview"].push(item);
        }
        data["isExpirationDisabled"] = this.isExpirationDisabled;
        data["pageRange"] = this.pageRange;
        data["ignoreQRCodeErrorsOnAutomaticFinish"] = this.ignoreQRCodeErrorsOnAutomaticFinish;
        data["nif"] = this.nif;
        data["isNifResolverEnabled"] = this.isNifResolverEnabled;
        return data;
    }
}

export interface ISdWorkspaceAdvancedSettingsViewModel {
    fieldsToDetect: string[];
    groupNameKey: string | undefined;
    allowGroups: boolean | undefined;
    allowAddingEntities: boolean | undefined;
    showSummaryTab: boolean | undefined;
    detectableFields: SdFieldViewModel[];
    showModalFinishReview: boolean | undefined;
    globalAverageConfidenceRateCheck: boolean | undefined;
    globalAverageConfidenceRateEntry: number | undefined;
    fieldsConfidenceRateCheck: boolean | undefined;
    fieldsConfidenceRateEntry: number | undefined;
    showConfidenceInViewer: boolean | undefined;
    showViewerAndTaskListSideBySide: boolean | undefined;
    dropSmallTablesAutomatically: boolean | undefined;
    checkoutExpireMinutes: number | undefined;
    allowGlobalSave: boolean | undefined;
    daysUntilRemoval: number | undefined;
    isToDelAfterExport: boolean | undefined;
    maxRestartCount: number;
    hoursUntilTasksConsideredStuck: number;
    anonymizationFillColor: string | undefined;
    fileTypesToSkipReview: string[] | undefined;
    isExpirationDisabled: boolean | undefined;
    pageRange: string | undefined;
    ignoreQRCodeErrorsOnAutomaticFinish: boolean | undefined;
    nif: string | undefined;
    isNifResolverEnabled: boolean;
}

export class NifConflictResponse implements INifConflictResponse {
    code!: string;
    conflicts!: NifConflictDetail[];

    constructor(data?: INifConflictResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            if (Array.isArray(_data["conflicts"])) {
                this.conflicts = [] as any;
                for (let item of _data["conflicts"])
                    this.conflicts!.push(NifConflictDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NifConflictResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NifConflictResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (Array.isArray(this.conflicts)) {
            data["conflicts"] = [];
            for (let item of this.conflicts)
                data["conflicts"].push(item.toJSON());
        }
        return data;
    }
}

export interface INifConflictResponse {
    code: string;
    conflicts: NifConflictDetail[];
}

export class NifConflictDetail implements INifConflictDetail {
    nif!: string;
    workspaceId!: number;
    workspaceDisplayName!: string;

    constructor(data?: INifConflictDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nif = _data["nif"];
            this.workspaceId = _data["workspaceId"];
            this.workspaceDisplayName = _data["workspaceDisplayName"];
        }
    }

    static fromJS(data: any): NifConflictDetail {
        data = typeof data === 'object' ? data : {};
        let result = new NifConflictDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nif"] = this.nif;
        data["workspaceId"] = this.workspaceId;
        data["workspaceDisplayName"] = this.workspaceDisplayName;
        return data;
    }
}

export interface INifConflictDetail {
    nif: string;
    workspaceId: number;
    workspaceDisplayName: string;
}

export class SdWorkspaceAdvancedSettingsModel implements ISdWorkspaceAdvancedSettingsModel {
    groupNameKey!: string | undefined;
    allowGroups!: boolean | undefined;
    allowAddingEntities!: boolean | undefined;
    showSummaryTab!: boolean | undefined;
    showModalFinishReview!: boolean | undefined;
    globalAverageConfidenceRateCheck!: boolean | undefined;
    globalAverageConfidenceRateEntry!: number | undefined;
    fieldsConfidenceRateCheck!: boolean | undefined;
    fieldsConfidenceRateEntry!: number | undefined;
    showConfidenceInViewer!: boolean | undefined;
    showViewerAndTaskListSideBySide!: boolean | undefined;
    dropSmallTablesAutomatically!: boolean | undefined;
    pageRange!: string | undefined;
    checkoutExpireMinutes!: number | undefined;
    allowGlobalSave!: boolean | undefined;
    daysUntilRemoval!: number | undefined;
    isToDelAfterExport!: boolean | undefined;
    maxRestartCount!: number;
    hoursUntilTasksConsideredStuck!: number;
    anonymizationFillColor!: string | undefined;
    fileTypesToSkipReview!: string[] | undefined;
    isExpirationDisabled!: boolean | undefined;
    ignoreQRCodeErrorsOnAutomaticFinish!: boolean | undefined;
    nif!: string | undefined;

    constructor(data?: ISdWorkspaceAdvancedSettingsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupNameKey = _data["groupNameKey"];
            this.allowGroups = _data["allowGroups"];
            this.allowAddingEntities = _data["allowAddingEntities"];
            this.showSummaryTab = _data["showSummaryTab"];
            this.showModalFinishReview = _data["showModalFinishReview"];
            this.globalAverageConfidenceRateCheck = _data["globalAverageConfidenceRateCheck"];
            this.globalAverageConfidenceRateEntry = _data["globalAverageConfidenceRateEntry"];
            this.fieldsConfidenceRateCheck = _data["fieldsConfidenceRateCheck"];
            this.fieldsConfidenceRateEntry = _data["fieldsConfidenceRateEntry"];
            this.showConfidenceInViewer = _data["showConfidenceInViewer"];
            this.showViewerAndTaskListSideBySide = _data["showViewerAndTaskListSideBySide"];
            this.dropSmallTablesAutomatically = _data["dropSmallTablesAutomatically"];
            this.pageRange = _data["pageRange"];
            this.checkoutExpireMinutes = _data["checkoutExpireMinutes"];
            this.allowGlobalSave = _data["allowGlobalSave"];
            this.daysUntilRemoval = _data["daysUntilRemoval"];
            this.isToDelAfterExport = _data["isToDelAfterExport"];
            this.maxRestartCount = _data["maxRestartCount"];
            this.hoursUntilTasksConsideredStuck = _data["hoursUntilTasksConsideredStuck"];
            this.anonymizationFillColor = _data["anonymizationFillColor"];
            if (Array.isArray(_data["fileTypesToSkipReview"])) {
                this.fileTypesToSkipReview = [] as any;
                for (let item of _data["fileTypesToSkipReview"])
                    this.fileTypesToSkipReview!.push(item);
            }
            this.isExpirationDisabled = _data["isExpirationDisabled"];
            this.ignoreQRCodeErrorsOnAutomaticFinish = _data["ignoreQRCodeErrorsOnAutomaticFinish"];
            this.nif = _data["nif"];
        }
    }

    static fromJS(data: any): SdWorkspaceAdvancedSettingsModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdWorkspaceAdvancedSettingsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupNameKey"] = this.groupNameKey;
        data["allowGroups"] = this.allowGroups;
        data["allowAddingEntities"] = this.allowAddingEntities;
        data["showSummaryTab"] = this.showSummaryTab;
        data["showModalFinishReview"] = this.showModalFinishReview;
        data["globalAverageConfidenceRateCheck"] = this.globalAverageConfidenceRateCheck;
        data["globalAverageConfidenceRateEntry"] = this.globalAverageConfidenceRateEntry;
        data["fieldsConfidenceRateCheck"] = this.fieldsConfidenceRateCheck;
        data["fieldsConfidenceRateEntry"] = this.fieldsConfidenceRateEntry;
        data["showConfidenceInViewer"] = this.showConfidenceInViewer;
        data["showViewerAndTaskListSideBySide"] = this.showViewerAndTaskListSideBySide;
        data["dropSmallTablesAutomatically"] = this.dropSmallTablesAutomatically;
        data["pageRange"] = this.pageRange;
        data["checkoutExpireMinutes"] = this.checkoutExpireMinutes;
        data["allowGlobalSave"] = this.allowGlobalSave;
        data["daysUntilRemoval"] = this.daysUntilRemoval;
        data["isToDelAfterExport"] = this.isToDelAfterExport;
        data["maxRestartCount"] = this.maxRestartCount;
        data["hoursUntilTasksConsideredStuck"] = this.hoursUntilTasksConsideredStuck;
        data["anonymizationFillColor"] = this.anonymizationFillColor;
        if (Array.isArray(this.fileTypesToSkipReview)) {
            data["fileTypesToSkipReview"] = [];
            for (let item of this.fileTypesToSkipReview)
                data["fileTypesToSkipReview"].push(item);
        }
        data["isExpirationDisabled"] = this.isExpirationDisabled;
        data["ignoreQRCodeErrorsOnAutomaticFinish"] = this.ignoreQRCodeErrorsOnAutomaticFinish;
        data["nif"] = this.nif;
        return data;
    }
}

export interface ISdWorkspaceAdvancedSettingsModel {
    groupNameKey: string | undefined;
    allowGroups: boolean | undefined;
    allowAddingEntities: boolean | undefined;
    showSummaryTab: boolean | undefined;
    showModalFinishReview: boolean | undefined;
    globalAverageConfidenceRateCheck: boolean | undefined;
    globalAverageConfidenceRateEntry: number | undefined;
    fieldsConfidenceRateCheck: boolean | undefined;
    fieldsConfidenceRateEntry: number | undefined;
    showConfidenceInViewer: boolean | undefined;
    showViewerAndTaskListSideBySide: boolean | undefined;
    dropSmallTablesAutomatically: boolean | undefined;
    pageRange: string | undefined;
    checkoutExpireMinutes: number | undefined;
    allowGlobalSave: boolean | undefined;
    daysUntilRemoval: number | undefined;
    isToDelAfterExport: boolean | undefined;
    maxRestartCount: number;
    hoursUntilTasksConsideredStuck: number;
    anonymizationFillColor: string | undefined;
    fileTypesToSkipReview: string[] | undefined;
    isExpirationDisabled: boolean | undefined;
    ignoreQRCodeErrorsOnAutomaticFinish: boolean | undefined;
    nif: string | undefined;
}

export class SdWorkspaceFieldsModel implements ISdWorkspaceFieldsModel {
    fieldsToDetect!: string[];
    fieldOrder!: string[];
    addedFields!: SdFieldViewModel[];
    editedFields!: SdFieldViewModel[];
    showNotNormalizedTableFields!: boolean | undefined;
    analyzerId!: string | undefined;
    baseAnalyzerId!: string | undefined;
    description!: string | undefined;

    constructor(data?: ISdWorkspaceFieldsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fieldsToDetect"])) {
                this.fieldsToDetect = [] as any;
                for (let item of _data["fieldsToDetect"])
                    this.fieldsToDetect!.push(item);
            }
            if (Array.isArray(_data["fieldOrder"])) {
                this.fieldOrder = [] as any;
                for (let item of _data["fieldOrder"])
                    this.fieldOrder!.push(item);
            }
            if (Array.isArray(_data["addedFields"])) {
                this.addedFields = [] as any;
                for (let item of _data["addedFields"])
                    this.addedFields!.push(SdFieldViewModel.fromJS(item));
            }
            if (Array.isArray(_data["editedFields"])) {
                this.editedFields = [] as any;
                for (let item of _data["editedFields"])
                    this.editedFields!.push(SdFieldViewModel.fromJS(item));
            }
            this.showNotNormalizedTableFields = _data["showNotNormalizedTableFields"];
            this.analyzerId = _data["analyzerId"];
            this.baseAnalyzerId = _data["baseAnalyzerId"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): SdWorkspaceFieldsModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdWorkspaceFieldsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fieldsToDetect)) {
            data["fieldsToDetect"] = [];
            for (let item of this.fieldsToDetect)
                data["fieldsToDetect"].push(item);
        }
        if (Array.isArray(this.fieldOrder)) {
            data["fieldOrder"] = [];
            for (let item of this.fieldOrder)
                data["fieldOrder"].push(item);
        }
        if (Array.isArray(this.addedFields)) {
            data["addedFields"] = [];
            for (let item of this.addedFields)
                data["addedFields"].push(item.toJSON());
        }
        if (Array.isArray(this.editedFields)) {
            data["editedFields"] = [];
            for (let item of this.editedFields)
                data["editedFields"].push(item.toJSON());
        }
        data["showNotNormalizedTableFields"] = this.showNotNormalizedTableFields;
        data["analyzerId"] = this.analyzerId;
        data["baseAnalyzerId"] = this.baseAnalyzerId;
        data["description"] = this.description;
        return data;
    }
}

export interface ISdWorkspaceFieldsModel {
    fieldsToDetect: string[];
    fieldOrder: string[];
    addedFields: SdFieldViewModel[];
    editedFields: SdFieldViewModel[];
    showNotNormalizedTableFields: boolean | undefined;
    analyzerId: string | undefined;
    baseAnalyzerId: string | undefined;
    description: string | undefined;
}

export class SdWorkspaceFieldsViewModel extends SdWorkspaceFieldsModel implements ISdWorkspaceFieldsViewModel {
    baseFields!: SdFieldViewModel[];

    constructor(data?: ISdWorkspaceFieldsViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["baseFields"])) {
                this.baseFields = [] as any;
                for (let item of _data["baseFields"])
                    this.baseFields!.push(SdFieldViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SdWorkspaceFieldsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdWorkspaceFieldsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.baseFields)) {
            data["baseFields"] = [];
            for (let item of this.baseFields)
                data["baseFields"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISdWorkspaceFieldsViewModel extends ISdWorkspaceFieldsModel {
    baseFields: SdFieldViewModel[];
}

export class SdWorkspaceFieldsPresetsViewModel implements ISdWorkspaceFieldsPresetsViewModel {
    displayName!: string;
    taskType!: number | undefined;
    isCustomPreset!: boolean;
    baseFields!: SdFieldViewModel[];

    constructor(data?: ISdWorkspaceFieldsPresetsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.taskType = _data["taskType"];
            this.isCustomPreset = _data["isCustomPreset"];
            if (Array.isArray(_data["baseFields"])) {
                this.baseFields = [] as any;
                for (let item of _data["baseFields"])
                    this.baseFields!.push(SdFieldViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SdWorkspaceFieldsPresetsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdWorkspaceFieldsPresetsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["taskType"] = this.taskType;
        data["isCustomPreset"] = this.isCustomPreset;
        if (Array.isArray(this.baseFields)) {
            data["baseFields"] = [];
            for (let item of this.baseFields)
                data["baseFields"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISdWorkspaceFieldsPresetsViewModel {
    displayName: string;
    taskType: number | undefined;
    isCustomPreset: boolean;
    baseFields: SdFieldViewModel[];
}

export class SelectProps implements ISelectProps {
    associatedFieldKey!: string | undefined;
    options!: SelectOption[];

    constructor(data?: ISelectProps) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.associatedFieldKey = _data["associatedFieldKey"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(SelectOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SelectProps {
        data = typeof data === 'object' ? data : {};
        let result = new SelectProps();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["associatedFieldKey"] = this.associatedFieldKey;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISelectProps {
    associatedFieldKey: string | undefined;
    options: SelectOption[];
}

export class SelectOption implements ISelectOption {
    key!: string;
    value!: string;
    displayName!: string;

    constructor(data?: ISelectOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): SelectOption {
        data = typeof data === 'object' ? data : {};
        let result = new SelectOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISelectOption {
    key: string;
    value: string;
    displayName: string;
}

export class SdWorkspacePredefinedTextsViewModel implements ISdWorkspacePredefinedTextsViewModel {
    predefinedTexts!: PredefinedText[];

    constructor(data?: ISdWorkspacePredefinedTextsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["predefinedTexts"])) {
                this.predefinedTexts = [] as any;
                for (let item of _data["predefinedTexts"])
                    this.predefinedTexts!.push(PredefinedText.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SdWorkspacePredefinedTextsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdWorkspacePredefinedTextsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.predefinedTexts)) {
            data["predefinedTexts"] = [];
            for (let item of this.predefinedTexts)
                data["predefinedTexts"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISdWorkspacePredefinedTextsViewModel {
    predefinedTexts: PredefinedText[];
}

export class SdWorkspacePredefinedTextsModel implements ISdWorkspacePredefinedTextsModel {
    predefinedTexts!: PredefinedText[];

    constructor(data?: ISdWorkspacePredefinedTextsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["predefinedTexts"])) {
                this.predefinedTexts = [] as any;
                for (let item of _data["predefinedTexts"])
                    this.predefinedTexts!.push(PredefinedText.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SdWorkspacePredefinedTextsModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdWorkspacePredefinedTextsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.predefinedTexts)) {
            data["predefinedTexts"] = [];
            for (let item of this.predefinedTexts)
                data["predefinedTexts"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISdWorkspacePredefinedTextsModel {
    predefinedTexts: PredefinedText[];
}

export class ResultWithCodeOfBooleanAndSdWorkspaceStorageConfigError implements IResultWithCodeOfBooleanAndSdWorkspaceStorageConfigError {
    succeeded!: boolean;
    result!: boolean;
    errors!: ErrorWithCodeOfSdWorkspaceStorageConfigError[];

    constructor(data?: IResultWithCodeOfBooleanAndSdWorkspaceStorageConfigError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.result = _data["result"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorWithCodeOfSdWorkspaceStorageConfigError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultWithCodeOfBooleanAndSdWorkspaceStorageConfigError {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithCodeOfBooleanAndSdWorkspaceStorageConfigError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["result"] = this.result;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResultWithCodeOfBooleanAndSdWorkspaceStorageConfigError {
    succeeded: boolean;
    result: boolean;
    errors: ErrorWithCodeOfSdWorkspaceStorageConfigError[];
}

export class ErrorWithCodeOfSdWorkspaceStorageConfigError implements IErrorWithCodeOfSdWorkspaceStorageConfigError {
    code!: SdWorkspaceStorageConfigError;
    error!: string;

    constructor(data?: IErrorWithCodeOfSdWorkspaceStorageConfigError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): ErrorWithCodeOfSdWorkspaceStorageConfigError {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorWithCodeOfSdWorkspaceStorageConfigError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["error"] = this.error;
        return data;
    }
}

export interface IErrorWithCodeOfSdWorkspaceStorageConfigError {
    code: SdWorkspaceStorageConfigError;
    error: string;
}

export enum SdWorkspaceStorageConfigError {
    CouldNotCreateStorage = 10,
    CouldNotGetSharePointConfiguration = 20,
    CouldNotGetSharePointSite = 30,
    CouldNotGetGlossaryDirectoryItems = 40,
    CouldNotGetExportDirectoryItems = 50,
    CouldNotGetGlobalGlossaryItem = 60,
}

export class ResultWithCodeOfBooleanAndSdStorageConfigError implements IResultWithCodeOfBooleanAndSdStorageConfigError {
    succeeded!: boolean;
    result!: boolean;
    errors!: ErrorWithCodeOfSdStorageConfigError[];

    constructor(data?: IResultWithCodeOfBooleanAndSdStorageConfigError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.result = _data["result"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorWithCodeOfSdStorageConfigError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultWithCodeOfBooleanAndSdStorageConfigError {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithCodeOfBooleanAndSdStorageConfigError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["result"] = this.result;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResultWithCodeOfBooleanAndSdStorageConfigError {
    succeeded: boolean;
    result: boolean;
    errors: ErrorWithCodeOfSdStorageConfigError[];
}

export class ErrorWithCodeOfSdStorageConfigError implements IErrorWithCodeOfSdStorageConfigError {
    code!: SdStorageConfigError;
    error!: string;

    constructor(data?: IErrorWithCodeOfSdStorageConfigError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): ErrorWithCodeOfSdStorageConfigError {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorWithCodeOfSdStorageConfigError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["error"] = this.error;
        return data;
    }
}

export interface IErrorWithCodeOfSdStorageConfigError {
    code: SdStorageConfigError;
    error: string;
}

export enum SdStorageConfigError {
    Unsupported = 0,
    ConfigurationNotFound = 10,
    InvalidPath = 20,
    ItemNotFound = 30,
    UploadFailed = 40,
}

export class SdWorkspaceImportEmailViewModel implements ISdWorkspaceImportEmailViewModel {
    emailToImport!: string | undefined;

    constructor(data?: ISdWorkspaceImportEmailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailToImport = _data["emailToImport"];
        }
    }

    static fromJS(data: any): SdWorkspaceImportEmailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdWorkspaceImportEmailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailToImport"] = this.emailToImport;
        return data;
    }
}

export interface ISdWorkspaceImportEmailViewModel {
    emailToImport: string | undefined;
}

export class SdWorkspaceUpdateBasicInfoModel implements ISdWorkspaceUpdateBasicInfoModel {
    id!: number | undefined;
    displayName!: string;
    description!: string | undefined;
    isDefault!: boolean;
    transcriptLanguage!: string | undefined;
    inputLanguage!: string | undefined;
    outputLanguage!: string | undefined;

    constructor(data?: ISdWorkspaceUpdateBasicInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isDefault = _data["isDefault"];
            this.transcriptLanguage = _data["transcriptLanguage"];
            this.inputLanguage = _data["inputLanguage"];
            this.outputLanguage = _data["outputLanguage"];
        }
    }

    static fromJS(data: any): SdWorkspaceUpdateBasicInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdWorkspaceUpdateBasicInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isDefault"] = this.isDefault;
        data["transcriptLanguage"] = this.transcriptLanguage;
        data["inputLanguage"] = this.inputLanguage;
        data["outputLanguage"] = this.outputLanguage;
        return data;
    }
}

export interface ISdWorkspaceUpdateBasicInfoModel {
    id: number | undefined;
    displayName: string;
    description: string | undefined;
    isDefault: boolean;
    transcriptLanguage: string | undefined;
    inputLanguage: string | undefined;
    outputLanguage: string | undefined;
}

export class SdWorkspaceBasicInfoViewModel extends SdWorkspaceUpdateBasicInfoModel implements ISdWorkspaceBasicInfoViewModel {
    tenantId!: string;
    workspaceType!: number;
    allowGlobalSave!: boolean;
    checkoutExpireMinutes!: number;
    pipelineId!: string | undefined;
    daysUntilHistoryRemoval!: number;

    constructor(data?: ISdWorkspaceBasicInfoViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.workspaceType = _data["workspaceType"];
            this.allowGlobalSave = _data["allowGlobalSave"];
            this.checkoutExpireMinutes = _data["checkoutExpireMinutes"];
            this.pipelineId = _data["pipelineId"];
            this.daysUntilHistoryRemoval = _data["daysUntilHistoryRemoval"];
        }
    }

    static fromJS(data: any): SdWorkspaceBasicInfoViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdWorkspaceBasicInfoViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["workspaceType"] = this.workspaceType;
        data["allowGlobalSave"] = this.allowGlobalSave;
        data["checkoutExpireMinutes"] = this.checkoutExpireMinutes;
        data["pipelineId"] = this.pipelineId;
        data["daysUntilHistoryRemoval"] = this.daysUntilHistoryRemoval;
        super.toJSON(data);
        return data;
    }
}

export interface ISdWorkspaceBasicInfoViewModel extends ISdWorkspaceUpdateBasicInfoModel {
    tenantId: string;
    workspaceType: number;
    allowGlobalSave: boolean;
    checkoutExpireMinutes: number;
    pipelineId: string | undefined;
    daysUntilHistoryRemoval: number;
}

export class ResultWithCodeOfDuplicateWorkspaceResultViewModelAndDuplicateWorkspaceError implements IResultWithCodeOfDuplicateWorkspaceResultViewModelAndDuplicateWorkspaceError {
    succeeded!: boolean;
    result!: DuplicateWorkspaceResultViewModel | undefined;
    errors!: ErrorWithCodeOfDuplicateWorkspaceError[];

    constructor(data?: IResultWithCodeOfDuplicateWorkspaceResultViewModelAndDuplicateWorkspaceError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.result = _data["result"] ? DuplicateWorkspaceResultViewModel.fromJS(_data["result"]) : <any>undefined;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorWithCodeOfDuplicateWorkspaceError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultWithCodeOfDuplicateWorkspaceResultViewModelAndDuplicateWorkspaceError {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithCodeOfDuplicateWorkspaceResultViewModelAndDuplicateWorkspaceError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResultWithCodeOfDuplicateWorkspaceResultViewModelAndDuplicateWorkspaceError {
    succeeded: boolean;
    result: DuplicateWorkspaceResultViewModel | undefined;
    errors: ErrorWithCodeOfDuplicateWorkspaceError[];
}

export class DuplicateWorkspaceResultViewModel implements IDuplicateWorkspaceResultViewModel {
    workspaceId!: number;
    workspaceType!: WorkspaceType;
    taskType!: TaskType;
    displayName!: string;

    constructor(data?: IDuplicateWorkspaceResultViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workspaceId = _data["workspaceId"];
            this.workspaceType = _data["workspaceType"];
            this.taskType = _data["taskType"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): DuplicateWorkspaceResultViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicateWorkspaceResultViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workspaceId"] = this.workspaceId;
        data["workspaceType"] = this.workspaceType;
        data["taskType"] = this.taskType;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IDuplicateWorkspaceResultViewModel {
    workspaceId: number;
    workspaceType: WorkspaceType;
    taskType: TaskType;
    displayName: string;
}

export class ErrorWithCodeOfDuplicateWorkspaceError implements IErrorWithCodeOfDuplicateWorkspaceError {
    code!: DuplicateWorkspaceError;
    error!: string;

    constructor(data?: IErrorWithCodeOfDuplicateWorkspaceError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): ErrorWithCodeOfDuplicateWorkspaceError {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorWithCodeOfDuplicateWorkspaceError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["error"] = this.error;
        return data;
    }
}

export interface IErrorWithCodeOfDuplicateWorkspaceError {
    code: DuplicateWorkspaceError;
    error: string;
}

export enum DuplicateWorkspaceError {
    NotAllowedToDuplicateWorkspace = 10,
    UnsupportedWorkspaceType = 20,
    WorkspaceNotConfiguredForDuplication = 30,
    InvalidDuplicateWorkspaceOptions = 40,
    DuplicateWorkspaceFailed = 50,
    DuplicateWorkspaceAnalyzerFailed = 60,
    DuplicateWorkspaceStorageOrExportFailed = 70,
}

export class DuplicateWorkspaceRequest implements IDuplicateWorkspaceRequest {
    displayName!: string | undefined;
    options!: DuplicateWorkspaceOptions | undefined;

    constructor(data?: IDuplicateWorkspaceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.options = _data["options"] ? DuplicateWorkspaceOptions.fromJS(_data["options"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DuplicateWorkspaceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicateWorkspaceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["options"] = this.options ? this.options.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDuplicateWorkspaceRequest {
    displayName: string | undefined;
    options: DuplicateWorkspaceOptions | undefined;
}

export class DuplicateWorkspaceOptions implements IDuplicateWorkspaceOptions {
    copyUsers!: boolean;
    copyDefaultAssignments!: boolean;
    copyRules!: boolean;
    copyAdvancedSettings!: boolean;
    copyStorage!: boolean;
    copyExport!: boolean;
    copyNotifications!: boolean;

    constructor(data?: IDuplicateWorkspaceOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.copyUsers = _data["copyUsers"];
            this.copyDefaultAssignments = _data["copyDefaultAssignments"];
            this.copyRules = _data["copyRules"];
            this.copyAdvancedSettings = _data["copyAdvancedSettings"];
            this.copyStorage = _data["copyStorage"];
            this.copyExport = _data["copyExport"];
            this.copyNotifications = _data["copyNotifications"];
        }
    }

    static fromJS(data: any): DuplicateWorkspaceOptions {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicateWorkspaceOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["copyUsers"] = this.copyUsers;
        data["copyDefaultAssignments"] = this.copyDefaultAssignments;
        data["copyRules"] = this.copyRules;
        data["copyAdvancedSettings"] = this.copyAdvancedSettings;
        data["copyStorage"] = this.copyStorage;
        data["copyExport"] = this.copyExport;
        data["copyNotifications"] = this.copyNotifications;
        return data;
    }
}

export interface IDuplicateWorkspaceOptions {
    copyUsers: boolean;
    copyDefaultAssignments: boolean;
    copyRules: boolean;
    copyAdvancedSettings: boolean;
    copyStorage: boolean;
    copyExport: boolean;
    copyNotifications: boolean;
}

export class SdWorkspaceTemplateViewModel implements ISdWorkspaceTemplateViewModel {
    taskType!: TaskType;
    displayName!: string;
    description!: string | undefined;
    groupType!: string | undefined;
    iconSource!: string | undefined;
    color!: string | undefined;
    rowKey!: string;
    partitionKey!: string;

    constructor(data?: ISdWorkspaceTemplateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskType = _data["taskType"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.groupType = _data["groupType"];
            this.iconSource = _data["iconSource"];
            this.color = _data["color"];
            this.rowKey = _data["rowKey"];
            this.partitionKey = _data["partitionKey"];
        }
    }

    static fromJS(data: any): SdWorkspaceTemplateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdWorkspaceTemplateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskType"] = this.taskType;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["groupType"] = this.groupType;
        data["iconSource"] = this.iconSource;
        data["color"] = this.color;
        data["rowKey"] = this.rowKey;
        data["partitionKey"] = this.partitionKey;
        return data;
    }
}

export interface ISdWorkspaceTemplateViewModel {
    taskType: TaskType;
    displayName: string;
    description: string | undefined;
    groupType: string | undefined;
    iconSource: string | undefined;
    color: string | undefined;
    rowKey: string;
    partitionKey: string;
}

export class SdWorkspaceUpsertModel extends SdWorkspaceUpdateBasicInfoModel implements ISdWorkspaceUpsertModel {
    workspaceTemplateRowKey!: string;
    workspaceTemplatePartitionKey!: string;

    constructor(data?: ISdWorkspaceUpsertModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.workspaceTemplateRowKey = _data["workspaceTemplateRowKey"];
            this.workspaceTemplatePartitionKey = _data["workspaceTemplatePartitionKey"];
        }
    }

    static fromJS(data: any): SdWorkspaceUpsertModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdWorkspaceUpsertModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workspaceTemplateRowKey"] = this.workspaceTemplateRowKey;
        data["workspaceTemplatePartitionKey"] = this.workspaceTemplatePartitionKey;
        super.toJSON(data);
        return data;
    }
}

export interface ISdWorkspaceUpsertModel extends ISdWorkspaceUpdateBasicInfoModel {
    workspaceTemplateRowKey: string;
    workspaceTemplatePartitionKey: string;
}

export class SdWorkspace extends TenantIntEntity implements ISdWorkspace {
    displayName!: string;
    description!: string | undefined;
    workspaceType!: number;
    templateType!: number;
    isDefault!: boolean;
    allowGlobalSave!: boolean;
    checkoutExpireMinutes!: number;
    daysUntilHistoryRemoval!: number;
    maxRestartCount!: number;
    hoursUntilTasksConsideredStuck!: number;
    customConfigRowKey!: string | undefined;
    trainingConfigRowKey!: string | undefined;
    pipelineId!: string | undefined;
    emailAlias!: string | undefined;
    workspaceTemplateRowKey!: string | undefined;
    workspaceTemplatePartitionKey!: string | undefined;
    customModelId!: number | undefined;
    softDeleted!: boolean;
    storageConfigRowKey!: string | undefined;
    taskType!: number;
    formRecognizerServiceName!: string | undefined;
    contentUnderstandingServiceName!: string | undefined;
    videoIndexerServiceName!: string | undefined;
    transcriptsChatBotServiceName!: string | undefined;
    genericStorageConfigRowKey!: string | undefined;

    constructor(data?: ISdWorkspace) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.workspaceType = _data["workspaceType"];
            this.templateType = _data["templateType"];
            this.isDefault = _data["isDefault"];
            this.allowGlobalSave = _data["allowGlobalSave"];
            this.checkoutExpireMinutes = _data["checkoutExpireMinutes"];
            this.daysUntilHistoryRemoval = _data["daysUntilHistoryRemoval"];
            this.maxRestartCount = _data["maxRestartCount"];
            this.hoursUntilTasksConsideredStuck = _data["hoursUntilTasksConsideredStuck"];
            this.customConfigRowKey = _data["customConfigRowKey"];
            this.trainingConfigRowKey = _data["trainingConfigRowKey"];
            this.pipelineId = _data["pipelineId"];
            this.emailAlias = _data["emailAlias"];
            this.workspaceTemplateRowKey = _data["workspaceTemplateRowKey"];
            this.workspaceTemplatePartitionKey = _data["workspaceTemplatePartitionKey"];
            this.customModelId = _data["customModelId"];
            this.softDeleted = _data["softDeleted"];
            this.storageConfigRowKey = _data["storageConfigRowKey"];
            this.taskType = _data["taskType"];
            this.formRecognizerServiceName = _data["formRecognizerServiceName"];
            this.contentUnderstandingServiceName = _data["contentUnderstandingServiceName"];
            this.videoIndexerServiceName = _data["videoIndexerServiceName"];
            this.transcriptsChatBotServiceName = _data["transcriptsChatBotServiceName"];
            this.genericStorageConfigRowKey = _data["genericStorageConfigRowKey"];
        }
    }

    static fromJS(data: any): SdWorkspace {
        data = typeof data === 'object' ? data : {};
        let result = new SdWorkspace();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["workspaceType"] = this.workspaceType;
        data["templateType"] = this.templateType;
        data["isDefault"] = this.isDefault;
        data["allowGlobalSave"] = this.allowGlobalSave;
        data["checkoutExpireMinutes"] = this.checkoutExpireMinutes;
        data["daysUntilHistoryRemoval"] = this.daysUntilHistoryRemoval;
        data["maxRestartCount"] = this.maxRestartCount;
        data["hoursUntilTasksConsideredStuck"] = this.hoursUntilTasksConsideredStuck;
        data["customConfigRowKey"] = this.customConfigRowKey;
        data["trainingConfigRowKey"] = this.trainingConfigRowKey;
        data["pipelineId"] = this.pipelineId;
        data["emailAlias"] = this.emailAlias;
        data["workspaceTemplateRowKey"] = this.workspaceTemplateRowKey;
        data["workspaceTemplatePartitionKey"] = this.workspaceTemplatePartitionKey;
        data["customModelId"] = this.customModelId;
        data["softDeleted"] = this.softDeleted;
        data["storageConfigRowKey"] = this.storageConfigRowKey;
        data["taskType"] = this.taskType;
        data["formRecognizerServiceName"] = this.formRecognizerServiceName;
        data["contentUnderstandingServiceName"] = this.contentUnderstandingServiceName;
        data["videoIndexerServiceName"] = this.videoIndexerServiceName;
        data["transcriptsChatBotServiceName"] = this.transcriptsChatBotServiceName;
        data["genericStorageConfigRowKey"] = this.genericStorageConfigRowKey;
        super.toJSON(data);
        return data;
    }
}

export interface ISdWorkspace extends ITenantIntEntity {
    displayName: string;
    description: string | undefined;
    workspaceType: number;
    templateType: number;
    isDefault: boolean;
    allowGlobalSave: boolean;
    checkoutExpireMinutes: number;
    daysUntilHistoryRemoval: number;
    maxRestartCount: number;
    hoursUntilTasksConsideredStuck: number;
    customConfigRowKey: string | undefined;
    trainingConfigRowKey: string | undefined;
    pipelineId: string | undefined;
    emailAlias: string | undefined;
    workspaceTemplateRowKey: string | undefined;
    workspaceTemplatePartitionKey: string | undefined;
    customModelId: number | undefined;
    softDeleted: boolean;
    storageConfigRowKey: string | undefined;
    taskType: number;
    formRecognizerServiceName: string | undefined;
    contentUnderstandingServiceName: string | undefined;
    videoIndexerServiceName: string | undefined;
    transcriptsChatBotServiceName: string | undefined;
    genericStorageConfigRowKey: string | undefined;
}

export class BaseStepConfigModel implements IBaseStepConfigModel {
    stepId!: string;
    tenantCode!: string | undefined;
    defaultOrder!: number | undefined;
    displayName!: string;
    description!: string | undefined;
    externalIdRequired!: boolean | undefined;
    contextCustomForm!: SdcCustomForm | undefined;
    configurationCustomForm!: SdcCustomForm | undefined;
    suggestAdvancedEditingMode!: boolean | undefined;
    detectableFields!: SdFieldViewModel[] | undefined;
    supportedFileTypes!: string[] | undefined;
    iconUrl!: string | undefined;
    forceSingleChunk!: boolean | undefined;
    maxFileSizeBytes!: number | undefined;
    unsupportedTaskTypes!: TaskType[];
    docsUrl!: string | undefined;

    constructor(data?: IBaseStepConfigModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stepId = _data["stepId"];
            this.tenantCode = _data["tenantCode"];
            this.defaultOrder = _data["defaultOrder"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.externalIdRequired = _data["externalIdRequired"];
            this.contextCustomForm = _data["contextCustomForm"] ? SdcCustomForm.fromJS(_data["contextCustomForm"]) : <any>undefined;
            this.configurationCustomForm = _data["configurationCustomForm"] ? SdcCustomForm.fromJS(_data["configurationCustomForm"]) : <any>undefined;
            this.suggestAdvancedEditingMode = _data["suggestAdvancedEditingMode"];
            if (Array.isArray(_data["detectableFields"])) {
                this.detectableFields = [] as any;
                for (let item of _data["detectableFields"])
                    this.detectableFields!.push(SdFieldViewModel.fromJS(item));
            }
            if (Array.isArray(_data["supportedFileTypes"])) {
                this.supportedFileTypes = [] as any;
                for (let item of _data["supportedFileTypes"])
                    this.supportedFileTypes!.push(item);
            }
            this.iconUrl = _data["iconUrl"];
            this.forceSingleChunk = _data["forceSingleChunk"];
            this.maxFileSizeBytes = _data["maxFileSizeBytes"];
            if (Array.isArray(_data["unsupportedTaskTypes"])) {
                this.unsupportedTaskTypes = [] as any;
                for (let item of _data["unsupportedTaskTypes"])
                    this.unsupportedTaskTypes!.push(item);
            }
            this.docsUrl = _data["docsUrl"];
        }
    }

    static fromJS(data: any): BaseStepConfigModel {
        data = typeof data === 'object' ? data : {};
        let result = new BaseStepConfigModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stepId"] = this.stepId;
        data["tenantCode"] = this.tenantCode;
        data["defaultOrder"] = this.defaultOrder;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["externalIdRequired"] = this.externalIdRequired;
        data["contextCustomForm"] = this.contextCustomForm ? this.contextCustomForm.toJSON() : <any>undefined;
        data["configurationCustomForm"] = this.configurationCustomForm ? this.configurationCustomForm.toJSON() : <any>undefined;
        data["suggestAdvancedEditingMode"] = this.suggestAdvancedEditingMode;
        if (Array.isArray(this.detectableFields)) {
            data["detectableFields"] = [];
            for (let item of this.detectableFields)
                data["detectableFields"].push(item.toJSON());
        }
        if (Array.isArray(this.supportedFileTypes)) {
            data["supportedFileTypes"] = [];
            for (let item of this.supportedFileTypes)
                data["supportedFileTypes"].push(item);
        }
        data["iconUrl"] = this.iconUrl;
        data["forceSingleChunk"] = this.forceSingleChunk;
        data["maxFileSizeBytes"] = this.maxFileSizeBytes;
        if (Array.isArray(this.unsupportedTaskTypes)) {
            data["unsupportedTaskTypes"] = [];
            for (let item of this.unsupportedTaskTypes)
                data["unsupportedTaskTypes"].push(item);
        }
        data["docsUrl"] = this.docsUrl;
        return data;
    }
}

export interface IBaseStepConfigModel {
    stepId: string;
    tenantCode: string | undefined;
    defaultOrder: number | undefined;
    displayName: string;
    description: string | undefined;
    externalIdRequired: boolean | undefined;
    contextCustomForm: SdcCustomForm | undefined;
    configurationCustomForm: SdcCustomForm | undefined;
    suggestAdvancedEditingMode: boolean | undefined;
    detectableFields: SdFieldViewModel[] | undefined;
    supportedFileTypes: string[] | undefined;
    iconUrl: string | undefined;
    forceSingleChunk: boolean | undefined;
    maxFileSizeBytes: number | undefined;
    unsupportedTaskTypes: TaskType[];
    docsUrl: string | undefined;
}

export class IntegrationStepConfigModel extends BaseStepConfigModel implements IIntegrationStepConfigModel {
    customFormValuesCustomForm!: SdcCustomForm | undefined;
    customFormValuesDefaultsCustomForm!: SdcCustomForm | undefined;
    isPlaceholder!: boolean | undefined;

    constructor(data?: IIntegrationStepConfigModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.customFormValuesCustomForm = _data["customFormValuesCustomForm"] ? SdcCustomForm.fromJS(_data["customFormValuesCustomForm"]) : <any>undefined;
            this.customFormValuesDefaultsCustomForm = _data["customFormValuesDefaultsCustomForm"] ? SdcCustomForm.fromJS(_data["customFormValuesDefaultsCustomForm"]) : <any>undefined;
            this.isPlaceholder = _data["isPlaceholder"];
        }
    }

    static fromJS(data: any): IntegrationStepConfigModel {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationStepConfigModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customFormValuesCustomForm"] = this.customFormValuesCustomForm ? this.customFormValuesCustomForm.toJSON() : <any>undefined;
        data["customFormValuesDefaultsCustomForm"] = this.customFormValuesDefaultsCustomForm ? this.customFormValuesDefaultsCustomForm.toJSON() : <any>undefined;
        data["isPlaceholder"] = this.isPlaceholder;
        super.toJSON(data);
        return data;
    }
}

export interface IIntegrationStepConfigModel extends IBaseStepConfigModel {
    customFormValuesCustomForm: SdcCustomForm | undefined;
    customFormValuesDefaultsCustomForm: SdcCustomForm | undefined;
    isPlaceholder: boolean | undefined;
}

export class SdCustomModelUpdateAvailableViewModel implements ISdCustomModelUpdateAvailableViewModel {
    currentModelInfo!: SdCustomModelUpdateInfoViewModel;
    activeModelInfo!: SdCustomModelUpdateInfoViewModel | undefined;

    constructor(data?: ISdCustomModelUpdateAvailableViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentModelInfo = _data["currentModelInfo"] ? SdCustomModelUpdateInfoViewModel.fromJS(_data["currentModelInfo"]) : <any>undefined;
            this.activeModelInfo = _data["activeModelInfo"] ? SdCustomModelUpdateInfoViewModel.fromJS(_data["activeModelInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SdCustomModelUpdateAvailableViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdCustomModelUpdateAvailableViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentModelInfo"] = this.currentModelInfo ? this.currentModelInfo.toJSON() : <any>undefined;
        data["activeModelInfo"] = this.activeModelInfo ? this.activeModelInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISdCustomModelUpdateAvailableViewModel {
    currentModelInfo: SdCustomModelUpdateInfoViewModel;
    activeModelInfo: SdCustomModelUpdateInfoViewModel | undefined;
}

export class SdCustomModelUpdateInfoViewModel implements ISdCustomModelUpdateInfoViewModel {
    customModelId!: number;
    versionNumber!: number;
    averageConfidence!: number | undefined;
    createdOn!: Date;
    fields!: TemplateBuilderCustomFieldsModel;

    constructor(data?: ISdCustomModelUpdateInfoViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customModelId = _data["customModelId"];
            this.versionNumber = _data["versionNumber"];
            this.averageConfidence = _data["averageConfidence"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.fields = _data["fields"] ? TemplateBuilderCustomFieldsModel.fromJS(_data["fields"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SdCustomModelUpdateInfoViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdCustomModelUpdateInfoViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customModelId"] = this.customModelId;
        data["versionNumber"] = this.versionNumber;
        data["averageConfidence"] = this.averageConfidence;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["fields"] = this.fields ? this.fields.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISdCustomModelUpdateInfoViewModel {
    customModelId: number;
    versionNumber: number;
    averageConfidence: number | undefined;
    createdOn: Date;
    fields: TemplateBuilderCustomFieldsModel;
}

export class TemplateBuilderCustomFieldsModel implements ITemplateBuilderCustomFieldsModel {
    fields!: TemplateBuilderCustomFieldModel[];

    constructor(data?: ITemplateBuilderCustomFieldsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(TemplateBuilderCustomFieldModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TemplateBuilderCustomFieldsModel {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateBuilderCustomFieldsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITemplateBuilderCustomFieldsModel {
    fields: TemplateBuilderCustomFieldModel[];
}

export class CreateTemplateBuilderCustomFieldModel extends SdFieldViewModel implements ICreateTemplateBuilderCustomFieldModel {
    workspaceId!: number;
    templateFieldType!: TemplateBuilderFieldType;
    table!: TemplateBuilderTableFieldModel | undefined;

    constructor(data?: ICreateTemplateBuilderCustomFieldModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.workspaceId = _data["workspaceId"];
            this.templateFieldType = _data["templateFieldType"];
            this.table = _data["table"] ? TemplateBuilderTableFieldModel.fromJS(_data["table"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateTemplateBuilderCustomFieldModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTemplateBuilderCustomFieldModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workspaceId"] = this.workspaceId;
        data["templateFieldType"] = this.templateFieldType;
        data["table"] = this.table ? this.table.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateTemplateBuilderCustomFieldModel extends ISdFieldViewModel {
    workspaceId: number;
    templateFieldType: TemplateBuilderFieldType;
    table: TemplateBuilderTableFieldModel | undefined;
}

export class TemplateBuilderCustomFieldModel extends CreateTemplateBuilderCustomFieldModel implements ITemplateBuilderCustomFieldModel {
    uniqueId!: string;

    constructor(data?: ITemplateBuilderCustomFieldModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.uniqueId = _data["uniqueId"];
        }
    }

    static fromJS(data: any): TemplateBuilderCustomFieldModel {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateBuilderCustomFieldModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        super.toJSON(data);
        return data;
    }
}

export interface ITemplateBuilderCustomFieldModel extends ICreateTemplateBuilderCustomFieldModel {
    uniqueId: string;
}

export class UpdateWorkspaceCustomModelRequest implements IUpdateWorkspaceCustomModelRequest {
    workspaceId!: number;
    customModelId!: number;

    constructor(data?: IUpdateWorkspaceCustomModelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workspaceId = _data["workspaceId"];
            this.customModelId = _data["customModelId"];
        }
    }

    static fromJS(data: any): UpdateWorkspaceCustomModelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkspaceCustomModelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workspaceId"] = this.workspaceId;
        data["customModelId"] = this.customModelId;
        return data;
    }
}

export interface IUpdateWorkspaceCustomModelRequest {
    workspaceId: number;
    customModelId: number;
}

export class StepRedirectedViewModel implements IStepRedirectedViewModel {
    stepId!: string;
    enabled!: boolean;
    availableAdditionalQueueNames!: string[];
    overrideQueueName!: string | undefined;

    constructor(data?: IStepRedirectedViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stepId = _data["stepId"];
            this.enabled = _data["enabled"];
            if (Array.isArray(_data["availableAdditionalQueueNames"])) {
                this.availableAdditionalQueueNames = [] as any;
                for (let item of _data["availableAdditionalQueueNames"])
                    this.availableAdditionalQueueNames!.push(item);
            }
            this.overrideQueueName = _data["overrideQueueName"];
        }
    }

    static fromJS(data: any): StepRedirectedViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new StepRedirectedViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stepId"] = this.stepId;
        data["enabled"] = this.enabled;
        if (Array.isArray(this.availableAdditionalQueueNames)) {
            data["availableAdditionalQueueNames"] = [];
            for (let item of this.availableAdditionalQueueNames)
                data["availableAdditionalQueueNames"].push(item);
        }
        data["overrideQueueName"] = this.overrideQueueName;
        return data;
    }
}

export interface IStepRedirectedViewModel {
    stepId: string;
    enabled: boolean;
    availableAdditionalQueueNames: string[];
    overrideQueueName: string | undefined;
}

export class SetStepRedirectedModel implements ISetStepRedirectedModel {
    pipelineId!: string;
    stepId!: string;
    enabled!: boolean;
    queueName!: string | undefined;

    constructor(data?: ISetStepRedirectedModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pipelineId = _data["pipelineId"];
            this.stepId = _data["stepId"];
            this.enabled = _data["enabled"];
            this.queueName = _data["queueName"];
        }
    }

    static fromJS(data: any): SetStepRedirectedModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetStepRedirectedModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pipelineId"] = this.pipelineId;
        data["stepId"] = this.stepId;
        data["enabled"] = this.enabled;
        data["queueName"] = this.queueName;
        return data;
    }
}

export interface ISetStepRedirectedModel {
    pipelineId: string;
    stepId: string;
    enabled: boolean;
    queueName: string | undefined;
}

export class PipelineWithStepsViewModel implements IPipelineWithStepsViewModel {
    pipelineId!: string;
    preProcessingSteps!: StepWithNameViewModel[];
    recognizerStep!: StepWithNameViewModel;
    postProcessingSteps!: StepWithNameViewModel[];
    integrationSteps!: StepWithNameViewModel[];

    constructor(data?: IPipelineWithStepsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pipelineId = _data["pipelineId"];
            if (Array.isArray(_data["preProcessingSteps"])) {
                this.preProcessingSteps = [] as any;
                for (let item of _data["preProcessingSteps"])
                    this.preProcessingSteps!.push(StepWithNameViewModel.fromJS(item));
            }
            this.recognizerStep = _data["recognizerStep"] ? StepWithNameViewModel.fromJS(_data["recognizerStep"]) : <any>undefined;
            if (Array.isArray(_data["postProcessingSteps"])) {
                this.postProcessingSteps = [] as any;
                for (let item of _data["postProcessingSteps"])
                    this.postProcessingSteps!.push(StepWithNameViewModel.fromJS(item));
            }
            if (Array.isArray(_data["integrationSteps"])) {
                this.integrationSteps = [] as any;
                for (let item of _data["integrationSteps"])
                    this.integrationSteps!.push(StepWithNameViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PipelineWithStepsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PipelineWithStepsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pipelineId"] = this.pipelineId;
        if (Array.isArray(this.preProcessingSteps)) {
            data["preProcessingSteps"] = [];
            for (let item of this.preProcessingSteps)
                data["preProcessingSteps"].push(item.toJSON());
        }
        data["recognizerStep"] = this.recognizerStep ? this.recognizerStep.toJSON() : <any>undefined;
        if (Array.isArray(this.postProcessingSteps)) {
            data["postProcessingSteps"] = [];
            for (let item of this.postProcessingSteps)
                data["postProcessingSteps"].push(item.toJSON());
        }
        if (Array.isArray(this.integrationSteps)) {
            data["integrationSteps"] = [];
            for (let item of this.integrationSteps)
                data["integrationSteps"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPipelineWithStepsViewModel {
    pipelineId: string;
    preProcessingSteps: StepWithNameViewModel[];
    recognizerStep: StepWithNameViewModel;
    postProcessingSteps: StepWithNameViewModel[];
    integrationSteps: StepWithNameViewModel[];
}

export class StepWithNameViewModel implements IStepWithNameViewModel {
    stepId!: string;
    displayName!: string;
    description!: string | undefined;
    isPlaceholder!: boolean;

    constructor(data?: IStepWithNameViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stepId = _data["stepId"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isPlaceholder = _data["isPlaceholder"];
        }
    }

    static fromJS(data: any): StepWithNameViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new StepWithNameViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stepId"] = this.stepId;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isPlaceholder"] = this.isPlaceholder;
        return data;
    }
}

export interface IStepWithNameViewModel {
    stepId: string;
    displayName: string;
    description: string | undefined;
    isPlaceholder: boolean;
}

export class ResultWithCodeOfBooleanAndSdWorkspaceError implements IResultWithCodeOfBooleanAndSdWorkspaceError {
    succeeded!: boolean;
    result!: boolean;
    errors!: ErrorWithCodeOfSdWorkspaceError[];

    constructor(data?: IResultWithCodeOfBooleanAndSdWorkspaceError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.result = _data["result"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorWithCodeOfSdWorkspaceError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultWithCodeOfBooleanAndSdWorkspaceError {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithCodeOfBooleanAndSdWorkspaceError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["result"] = this.result;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResultWithCodeOfBooleanAndSdWorkspaceError {
    succeeded: boolean;
    result: boolean;
    errors: ErrorWithCodeOfSdWorkspaceError[];
}

export class ErrorWithCodeOfSdWorkspaceError implements IErrorWithCodeOfSdWorkspaceError {
    code!: SdWorkspaceError;
    error!: string;

    constructor(data?: IErrorWithCodeOfSdWorkspaceError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): ErrorWithCodeOfSdWorkspaceError {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorWithCodeOfSdWorkspaceError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["error"] = this.error;
        return data;
    }
}

export interface IErrorWithCodeOfSdWorkspaceError {
    code: SdWorkspaceError;
    error: string;
}

export enum SdWorkspaceError {
    SoftDeleteIsLabelingAndTraining = 1,
    SoftDeleteIsDefaultWorkspaceAndNotLastWorkspace = 2,
}

export class SdWorkspaceHooksModel implements ISdWorkspaceHooksModel {
    hookServiceNames!: string[];

    constructor(data?: ISdWorkspaceHooksModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["hookServiceNames"])) {
                this.hookServiceNames = [] as any;
                for (let item of _data["hookServiceNames"])
                    this.hookServiceNames!.push(item);
            }
        }
    }

    static fromJS(data: any): SdWorkspaceHooksModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdWorkspaceHooksModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.hookServiceNames)) {
            data["hookServiceNames"] = [];
            for (let item of this.hookServiceNames)
                data["hookServiceNames"].push(item);
        }
        return data;
    }
}

export interface ISdWorkspaceHooksModel {
    hookServiceNames: string[];
}

export class DefaultAssignmentsModel implements IDefaultAssignmentsModel {
    assignedUsers!: number[];
    order!: TaskAssignmentOrderType;

    constructor(data?: IDefaultAssignmentsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assignedUsers"])) {
                this.assignedUsers = [] as any;
                for (let item of _data["assignedUsers"])
                    this.assignedUsers!.push(item);
            }
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): DefaultAssignmentsModel {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultAssignmentsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assignedUsers)) {
            data["assignedUsers"] = [];
            for (let item of this.assignedUsers)
                data["assignedUsers"].push(item);
        }
        data["order"] = this.order;
        return data;
    }
}

export interface IDefaultAssignmentsModel {
    assignedUsers: number[];
    order: TaskAssignmentOrderType;
}

export class ResultWithCodeOfListOfDriveItemModelAndSharePointError implements IResultWithCodeOfListOfDriveItemModelAndSharePointError {
    succeeded!: boolean;
    result!: DriveItemModel[] | undefined;
    errors!: ErrorWithCodeOfSharePointError[];

    constructor(data?: IResultWithCodeOfListOfDriveItemModelAndSharePointError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(DriveItemModel.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorWithCodeOfSharePointError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultWithCodeOfListOfDriveItemModelAndSharePointError {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithCodeOfListOfDriveItemModelAndSharePointError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResultWithCodeOfListOfDriveItemModelAndSharePointError {
    succeeded: boolean;
    result: DriveItemModel[] | undefined;
    errors: ErrorWithCodeOfSharePointError[];
}

export class DriveItemModel implements IDriveItemModel {
    id!: string;
    name!: string;
    webUrl!: string;
    downloadUrl!: string;
    isFile!: boolean;
    mimeType!: string;
    isFolder!: boolean;
    folderPath!: string;
    displayFullPath!: string;
    lastModifiedDateTime!: Date;
    lastModifiedUserDisplayName!: string;

    constructor(data?: IDriveItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.webUrl = _data["webUrl"];
            this.downloadUrl = _data["downloadUrl"];
            this.isFile = _data["isFile"];
            this.mimeType = _data["mimeType"];
            this.isFolder = _data["isFolder"];
            this.folderPath = _data["folderPath"];
            this.displayFullPath = _data["displayFullPath"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? new Date(_data["lastModifiedDateTime"].toString()) : <any>undefined;
            this.lastModifiedUserDisplayName = _data["lastModifiedUserDisplayName"];
        }
    }

    static fromJS(data: any): DriveItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new DriveItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["webUrl"] = this.webUrl;
        data["downloadUrl"] = this.downloadUrl;
        data["isFile"] = this.isFile;
        data["mimeType"] = this.mimeType;
        data["isFolder"] = this.isFolder;
        data["folderPath"] = this.folderPath;
        data["displayFullPath"] = this.displayFullPath;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>undefined;
        data["lastModifiedUserDisplayName"] = this.lastModifiedUserDisplayName;
        return data;
    }
}

export interface IDriveItemModel {
    id: string;
    name: string;
    webUrl: string;
    downloadUrl: string;
    isFile: boolean;
    mimeType: string;
    isFolder: boolean;
    folderPath: string;
    displayFullPath: string;
    lastModifiedDateTime: Date;
    lastModifiedUserDisplayName: string;
}

export class ErrorWithCodeOfSharePointError implements IErrorWithCodeOfSharePointError {
    code!: SharePointError;
    error!: string;

    constructor(data?: IErrorWithCodeOfSharePointError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): ErrorWithCodeOfSharePointError {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorWithCodeOfSharePointError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["error"] = this.error;
        return data;
    }
}

export interface IErrorWithCodeOfSharePointError {
    code: SharePointError;
    error: string;
}

export enum SharePointError {
    CouldNotGetConfiguration = 10,
    CouldNotCreateClient = 20,
    CouldNotGetSite = 30,
    CouldNotGetItem = 40,
    CouldNotGetItems = 50,
    CouldNotUploadFile = 60,
    CouldNotUploadFileAccessIsLock = 61,
    CouldNotDeleteFile = 70,
    AuthenticationNotImplemented = 80,
    GrantKeyRequired = 90,
    InvalidGrantKey = 100,
    DelegatedGrantNotFound = 110,
}

export class StorePlanTypeViewModel implements IStorePlanTypeViewModel {
    id!: number;
    code!: string | undefined;
    productId!: string;
    title!: string | undefined;
    subtitle!: string | undefined;
    imgSrc!: string | undefined;
    imgWidth!: number | undefined;
    imgHeight!: number | undefined;
    monthlyPrice!: number;
    yearlyPrice!: number;
    trialDays!: number | undefined;
    isDefault!: boolean;
    noExpiration!: boolean;
    licenseQuantity!: number | undefined;
    licenseVolume!: number | undefined;
    planBenefits!: PlanFeatureModel[] | undefined;
    yearlyPlan!: YearlyPlanModel | undefined;

    constructor(data?: IStorePlanTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.productId = _data["productId"];
            this.title = _data["title"];
            this.subtitle = _data["subtitle"];
            this.imgSrc = _data["imgSrc"];
            this.imgWidth = _data["imgWidth"];
            this.imgHeight = _data["imgHeight"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.yearlyPrice = _data["yearlyPrice"];
            this.trialDays = _data["trialDays"];
            this.isDefault = _data["isDefault"];
            this.noExpiration = _data["noExpiration"];
            this.licenseQuantity = _data["licenseQuantity"];
            this.licenseVolume = _data["licenseVolume"];
            if (Array.isArray(_data["planBenefits"])) {
                this.planBenefits = [] as any;
                for (let item of _data["planBenefits"])
                    this.planBenefits!.push(PlanFeatureModel.fromJS(item));
            }
            this.yearlyPlan = _data["yearlyPlan"] ? YearlyPlanModel.fromJS(_data["yearlyPlan"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StorePlanTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new StorePlanTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["productId"] = this.productId;
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        data["imgSrc"] = this.imgSrc;
        data["imgWidth"] = this.imgWidth;
        data["imgHeight"] = this.imgHeight;
        data["monthlyPrice"] = this.monthlyPrice;
        data["yearlyPrice"] = this.yearlyPrice;
        data["trialDays"] = this.trialDays;
        data["isDefault"] = this.isDefault;
        data["noExpiration"] = this.noExpiration;
        data["licenseQuantity"] = this.licenseQuantity;
        data["licenseVolume"] = this.licenseVolume;
        if (Array.isArray(this.planBenefits)) {
            data["planBenefits"] = [];
            for (let item of this.planBenefits)
                data["planBenefits"].push(item.toJSON());
        }
        data["yearlyPlan"] = this.yearlyPlan ? this.yearlyPlan.toJSON() : <any>undefined;
        return data;
    }
}

export interface IStorePlanTypeViewModel {
    id: number;
    code: string | undefined;
    productId: string;
    title: string | undefined;
    subtitle: string | undefined;
    imgSrc: string | undefined;
    imgWidth: number | undefined;
    imgHeight: number | undefined;
    monthlyPrice: number;
    yearlyPrice: number;
    trialDays: number | undefined;
    isDefault: boolean;
    noExpiration: boolean;
    licenseQuantity: number | undefined;
    licenseVolume: number | undefined;
    planBenefits: PlanFeatureModel[] | undefined;
    yearlyPlan: YearlyPlanModel | undefined;
}

export class PlanFeatureModel implements IPlanFeatureModel {
    id!: number;
    code!: string | undefined;
    descriptionMonth!: string | undefined;
    descriptionAnnual!: string | undefined;
    quantityMonth!: number | undefined;
    quantityYear!: number | undefined;
    quantityApplied!: boolean;

    constructor(data?: IPlanFeatureModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.descriptionMonth = _data["descriptionMonth"];
            this.descriptionAnnual = _data["descriptionAnnual"];
            this.quantityMonth = _data["quantityMonth"];
            this.quantityYear = _data["quantityYear"];
            this.quantityApplied = _data["quantityApplied"];
        }
    }

    static fromJS(data: any): PlanFeatureModel {
        data = typeof data === 'object' ? data : {};
        let result = new PlanFeatureModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["descriptionMonth"] = this.descriptionMonth;
        data["descriptionAnnual"] = this.descriptionAnnual;
        data["quantityMonth"] = this.quantityMonth;
        data["quantityYear"] = this.quantityYear;
        data["quantityApplied"] = this.quantityApplied;
        return data;
    }
}

export interface IPlanFeatureModel {
    id: number;
    code: string | undefined;
    descriptionMonth: string | undefined;
    descriptionAnnual: string | undefined;
    quantityMonth: number | undefined;
    quantityYear: number | undefined;
    quantityApplied: boolean;
}

export class YearlyPlanModel implements IYearlyPlanModel {
    perMonth!: number;
    totalAnnual!: number;

    constructor(data?: IYearlyPlanModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.perMonth = _data["perMonth"];
            this.totalAnnual = _data["totalAnnual"];
        }
    }

    static fromJS(data: any): YearlyPlanModel {
        data = typeof data === 'object' ? data : {};
        let result = new YearlyPlanModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["perMonth"] = this.perMonth;
        data["totalAnnual"] = this.totalAnnual;
        return data;
    }
}

export interface IYearlyPlanModel {
    perMonth: number;
    totalAnnual: number;
}

export class StoreFeatureViewModel implements IStoreFeatureViewModel {
    id!: number;
    storeProductId!: string;
    code!: string | undefined;
    title!: string | undefined;
    description!: string | undefined;
    logoUrl!: string | undefined;
    defaultQuantityYear!: number | undefined;
    price!: number;
    quantityApplied!: boolean;

    constructor(data?: IStoreFeatureViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.storeProductId = _data["storeProductId"];
            this.code = _data["code"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.logoUrl = _data["logoUrl"];
            this.defaultQuantityYear = _data["defaultQuantityYear"];
            this.price = _data["price"];
            this.quantityApplied = _data["quantityApplied"];
        }
    }

    static fromJS(data: any): StoreFeatureViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new StoreFeatureViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeProductId"] = this.storeProductId;
        data["code"] = this.code;
        data["title"] = this.title;
        data["description"] = this.description;
        data["logoUrl"] = this.logoUrl;
        data["defaultQuantityYear"] = this.defaultQuantityYear;
        data["price"] = this.price;
        data["quantityApplied"] = this.quantityApplied;
        return data;
    }
}

export interface IStoreFeatureViewModel {
    id: number;
    storeProductId: string;
    code: string | undefined;
    title: string | undefined;
    description: string | undefined;
    logoUrl: string | undefined;
    defaultQuantityYear: number | undefined;
    price: number;
    quantityApplied: boolean;
}

export class TrainConditionsModel implements ITrainConditionsModel {
    workspaceId!: number;
    conditionsPerType!: TrainConditionValues[];
    unclassifiedTaskCount!: number;

    constructor(data?: ITrainConditionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workspaceId = _data["workspaceId"];
            if (Array.isArray(_data["conditionsPerType"])) {
                this.conditionsPerType = [] as any;
                for (let item of _data["conditionsPerType"])
                    this.conditionsPerType!.push(TrainConditionValues.fromJS(item));
            }
            this.unclassifiedTaskCount = _data["unclassifiedTaskCount"];
        }
    }

    static fromJS(data: any): TrainConditionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new TrainConditionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workspaceId"] = this.workspaceId;
        if (Array.isArray(this.conditionsPerType)) {
            data["conditionsPerType"] = [];
            for (let item of this.conditionsPerType)
                data["conditionsPerType"].push(item.toJSON());
        }
        data["unclassifiedTaskCount"] = this.unclassifiedTaskCount;
        return data;
    }
}

export interface ITrainConditionsModel {
    workspaceId: number;
    conditionsPerType: TrainConditionValues[];
    unclassifiedTaskCount: number;
}

export class TrainConditionValues implements ITrainConditionValues {
    templateType!: TemplateType;
    hasEnoughTasksForHighQualityTrain!: boolean;
    hasValidNumberOfPagesForTrain!: boolean;

    constructor(data?: ITrainConditionValues) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateType = _data["templateType"];
            this.hasEnoughTasksForHighQualityTrain = _data["hasEnoughTasksForHighQualityTrain"];
            this.hasValidNumberOfPagesForTrain = _data["hasValidNumberOfPagesForTrain"];
        }
    }

    static fromJS(data: any): TrainConditionValues {
        data = typeof data === 'object' ? data : {};
        let result = new TrainConditionValues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateType"] = this.templateType;
        data["hasEnoughTasksForHighQualityTrain"] = this.hasEnoughTasksForHighQualityTrain;
        data["hasValidNumberOfPagesForTrain"] = this.hasValidNumberOfPagesForTrain;
        return data;
    }
}

export interface ITrainConditionValues {
    templateType: TemplateType;
    hasEnoughTasksForHighQualityTrain: boolean;
    hasValidNumberOfPagesForTrain: boolean;
}

export class PaginatedListOfSdCustomModelViewModel implements IPaginatedListOfSdCustomModelViewModel {
    items!: SdCustomModelViewModel[];
    pageNumber!: number;
    totalPages!: number;
    totalCount!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfSdCustomModelViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SdCustomModelViewModel.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfSdCustomModelViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfSdCustomModelViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfSdCustomModelViewModel {
    items: SdCustomModelViewModel[];
    pageNumber: number;
    totalPages: number;
    totalCount: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class SdCustomModelViewModel implements ISdCustomModelViewModel {
    id!: number;
    modelName!: string;
    serviceName!: string;
    versionNumber!: number;
    averageConfidence!: number | undefined;
    trainingStatus!: TrainingStatus;
    createdOn!: Date;
    trainingDurationMinutes!: number | undefined;

    constructor(data?: ISdCustomModelViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modelName = _data["modelName"];
            this.serviceName = _data["serviceName"];
            this.versionNumber = _data["versionNumber"];
            this.averageConfidence = _data["averageConfidence"];
            this.trainingStatus = _data["trainingStatus"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.trainingDurationMinutes = _data["trainingDurationMinutes"];
        }
    }

    static fromJS(data: any): SdCustomModelViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdCustomModelViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modelName"] = this.modelName;
        data["serviceName"] = this.serviceName;
        data["versionNumber"] = this.versionNumber;
        data["averageConfidence"] = this.averageConfidence;
        data["trainingStatus"] = this.trainingStatus;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["trainingDurationMinutes"] = this.trainingDurationMinutes;
        return data;
    }
}

export interface ISdCustomModelViewModel {
    id: number;
    modelName: string;
    serviceName: string;
    versionNumber: number;
    averageConfidence: number | undefined;
    trainingStatus: TrainingStatus;
    createdOn: Date;
    trainingDurationMinutes: number | undefined;
}

export enum TrainingStatus {
    Deleted = 20,
    QueuedForPreProcessing = 30,
    PreProcessingInProgress = 31,
    PreProcessingFailed = 32,
    PreProcessingSuccessful = 33,
    QueuedForTraining = 40,
    TrainingInProgress = 41,
    TrainingFailed = 42,
    TrainingSuccessful = 43,
    Trained = 50,
    Active = 60,
}

export class SharePointConfigurationModel implements ISharePointConfigurationModel {
    id!: number | undefined;
    displayName!: string;
    name!: string;
    tenantId!: string | undefined;
    clientId!: string | undefined;
    clientSecret!: string | undefined;
    hostname!: string;
    defaultSite!: string;
    driveId!: string;
    connectorInteractiveGrant!: ConnectorInteractiveGrant | undefined;

    constructor(data?: ISharePointConfigurationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.name = _data["name"];
            this.tenantId = _data["tenantId"];
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.hostname = _data["hostname"];
            this.defaultSite = _data["defaultSite"];
            this.driveId = _data["driveId"];
            this.connectorInteractiveGrant = _data["connectorInteractiveGrant"] ? ConnectorInteractiveGrant.fromJS(_data["connectorInteractiveGrant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SharePointConfigurationModel {
        data = typeof data === 'object' ? data : {};
        let result = new SharePointConfigurationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["name"] = this.name;
        data["tenantId"] = this.tenantId;
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["hostname"] = this.hostname;
        data["defaultSite"] = this.defaultSite;
        data["driveId"] = this.driveId;
        data["connectorInteractiveGrant"] = this.connectorInteractiveGrant ? this.connectorInteractiveGrant.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISharePointConfigurationModel {
    id: number | undefined;
    displayName: string;
    name: string;
    tenantId: string | undefined;
    clientId: string | undefined;
    clientSecret: string | undefined;
    hostname: string;
    defaultSite: string;
    driveId: string;
    connectorInteractiveGrant: ConnectorInteractiveGrant | undefined;
}

export class ConnectorInteractiveGrant implements IConnectorInteractiveGrant {
    connectorType!: LoadBalancedServiceType;
    scopes!: string[];
    externalAccountId!: string;
    userEmail!: string;
    userName!: string;
    accessTokenCacheName!: string;
    refreshTokenSecretName!: string;

    constructor(data?: IConnectorInteractiveGrant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectorType = _data["connectorType"];
            if (Array.isArray(_data["scopes"])) {
                this.scopes = [] as any;
                for (let item of _data["scopes"])
                    this.scopes!.push(item);
            }
            this.externalAccountId = _data["externalAccountId"];
            this.userEmail = _data["userEmail"];
            this.userName = _data["userName"];
            this.accessTokenCacheName = _data["accessTokenCacheName"];
            this.refreshTokenSecretName = _data["refreshTokenSecretName"];
        }
    }

    static fromJS(data: any): ConnectorInteractiveGrant {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectorInteractiveGrant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectorType"] = this.connectorType;
        if (Array.isArray(this.scopes)) {
            data["scopes"] = [];
            for (let item of this.scopes)
                data["scopes"].push(item);
        }
        data["externalAccountId"] = this.externalAccountId;
        data["userEmail"] = this.userEmail;
        data["userName"] = this.userName;
        data["accessTokenCacheName"] = this.accessTokenCacheName;
        data["refreshTokenSecretName"] = this.refreshTokenSecretName;
        return data;
    }
}

export interface IConnectorInteractiveGrant {
    connectorType: LoadBalancedServiceType;
    scopes: string[];
    externalAccountId: string;
    userEmail: string;
    userName: string;
    accessTokenCacheName: string;
    refreshTokenSecretName: string;
}

export class ResultWithCodeOfSharePointConfigurationModelAndSharePointError implements IResultWithCodeOfSharePointConfigurationModelAndSharePointError {
    succeeded!: boolean;
    result!: SharePointConfigurationModel | undefined;
    errors!: ErrorWithCodeOfSharePointError[];

    constructor(data?: IResultWithCodeOfSharePointConfigurationModelAndSharePointError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.result = _data["result"] ? SharePointConfigurationModel.fromJS(_data["result"]) : <any>undefined;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorWithCodeOfSharePointError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultWithCodeOfSharePointConfigurationModelAndSharePointError {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithCodeOfSharePointConfigurationModelAndSharePointError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResultWithCodeOfSharePointConfigurationModelAndSharePointError {
    succeeded: boolean;
    result: SharePointConfigurationModel | undefined;
    errors: ErrorWithCodeOfSharePointError[];
}

export class ConnectorConfigurationModel implements IConnectorConfigurationModel {
    id!: number;
    displayName!: string;
    name!: string;
    connectorType!: LoadBalancedServiceType;
    detailSections!: ConnectorDetailSection[];

    constructor(data?: IConnectorConfigurationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.name = _data["name"];
            this.connectorType = _data["connectorType"];
            if (Array.isArray(_data["detailSections"])) {
                this.detailSections = [] as any;
                for (let item of _data["detailSections"])
                    this.detailSections!.push(ConnectorDetailSection.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConnectorConfigurationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectorConfigurationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["name"] = this.name;
        data["connectorType"] = this.connectorType;
        if (Array.isArray(this.detailSections)) {
            data["detailSections"] = [];
            for (let item of this.detailSections)
                data["detailSections"].push(item.toJSON());
        }
        return data;
    }
}

export interface IConnectorConfigurationModel {
    id: number;
    displayName: string;
    name: string;
    connectorType: LoadBalancedServiceType;
    detailSections: ConnectorDetailSection[];
}

export class ConnectorDetailSection implements IConnectorDetailSection {
    name!: ConnectorDetailSectionType;
    items!: ConnectorDetailItem[];

    constructor(data?: IConnectorDetailSection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ConnectorDetailItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConnectorDetailSection {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectorDetailSection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IConnectorDetailSection {
    name: ConnectorDetailSectionType;
    items: ConnectorDetailItem[];
}

export enum ConnectorDetailSectionType {
    AppOnly = 0,
    Delegated = 1,
    Common = 2,
}

export class ConnectorDetailItem implements IConnectorDetailItem {
    label!: ConnectorDetailLabelType;
    value!: string;
    isSecret!: boolean;

    constructor(data?: IConnectorDetailItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
            this.isSecret = _data["isSecret"];
        }
    }

    static fromJS(data: any): ConnectorDetailItem {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectorDetailItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        data["isSecret"] = this.isSecret;
        return data;
    }
}

export interface IConnectorDetailItem {
    label: ConnectorDetailLabelType;
    value: string;
    isSecret: boolean;
}

export enum ConnectorDetailLabelType {
    ClientId = 0,
    ClientSecret = 1,
    TenantId = 2,
    UserEmail = 3,
    UserName = 4,
    Hostname = 5,
    DefaultSite = 6,
    OwnerUserPrincipalName = 7,
}

export enum ConnectorAuthType {
    AppOnlyClientCredentials = 10,
    Delegated = 20,
}

export class SharePointConnectorCreateModel implements ISharePointConnectorCreateModel {
    displayName!: string;
    hostname!: string;
    defaultSite!: string | undefined;
    authType!: ConnectorAuthType;
    tenantId!: string | undefined;
    clientId!: string | undefined;
    clientSecret!: string | undefined;
    grantKey!: string | undefined;

    constructor(data?: ISharePointConnectorCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.hostname = _data["hostname"];
            this.defaultSite = _data["defaultSite"];
            this.authType = _data["authType"];
            this.tenantId = _data["tenantId"];
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.grantKey = _data["grantKey"];
        }
    }

    static fromJS(data: any): SharePointConnectorCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new SharePointConnectorCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["hostname"] = this.hostname;
        data["defaultSite"] = this.defaultSite;
        data["authType"] = this.authType;
        data["tenantId"] = this.tenantId;
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["grantKey"] = this.grantKey;
        return data;
    }
}

export interface ISharePointConnectorCreateModel {
    displayName: string;
    hostname: string;
    defaultSite: string | undefined;
    authType: ConnectorAuthType;
    tenantId: string | undefined;
    clientId: string | undefined;
    clientSecret: string | undefined;
    grantKey: string | undefined;
}

export class ResultWithCodeOfOneDriveConfigurationModelAndOneDriveError implements IResultWithCodeOfOneDriveConfigurationModelAndOneDriveError {
    succeeded!: boolean;
    result!: OneDriveConfigurationModel | undefined;
    errors!: ErrorWithCodeOfOneDriveError[];

    constructor(data?: IResultWithCodeOfOneDriveConfigurationModelAndOneDriveError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.result = _data["result"] ? OneDriveConfigurationModel.fromJS(_data["result"]) : <any>undefined;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorWithCodeOfOneDriveError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultWithCodeOfOneDriveConfigurationModelAndOneDriveError {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithCodeOfOneDriveConfigurationModelAndOneDriveError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResultWithCodeOfOneDriveConfigurationModelAndOneDriveError {
    succeeded: boolean;
    result: OneDriveConfigurationModel | undefined;
    errors: ErrorWithCodeOfOneDriveError[];
}

export class OneDriveConfigurationModel implements IOneDriveConfigurationModel {
    id!: number | undefined;
    displayName!: string;
    name!: string;
    tenantId!: string | undefined;
    clientId!: string | undefined;
    clientSecret!: string | undefined;
    ownerUserPrincipalName!: string;
    driveId!: string;
    connectorInteractiveGrant!: ConnectorInteractiveGrant | undefined;

    constructor(data?: IOneDriveConfigurationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.name = _data["name"];
            this.tenantId = _data["tenantId"];
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.ownerUserPrincipalName = _data["ownerUserPrincipalName"];
            this.driveId = _data["driveId"];
            this.connectorInteractiveGrant = _data["connectorInteractiveGrant"] ? ConnectorInteractiveGrant.fromJS(_data["connectorInteractiveGrant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OneDriveConfigurationModel {
        data = typeof data === 'object' ? data : {};
        let result = new OneDriveConfigurationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["name"] = this.name;
        data["tenantId"] = this.tenantId;
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["ownerUserPrincipalName"] = this.ownerUserPrincipalName;
        data["driveId"] = this.driveId;
        data["connectorInteractiveGrant"] = this.connectorInteractiveGrant ? this.connectorInteractiveGrant.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOneDriveConfigurationModel {
    id: number | undefined;
    displayName: string;
    name: string;
    tenantId: string | undefined;
    clientId: string | undefined;
    clientSecret: string | undefined;
    ownerUserPrincipalName: string;
    driveId: string;
    connectorInteractiveGrant: ConnectorInteractiveGrant | undefined;
}

export class ErrorWithCodeOfOneDriveError implements IErrorWithCodeOfOneDriveError {
    code!: OneDriveError;
    error!: string;

    constructor(data?: IErrorWithCodeOfOneDriveError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): ErrorWithCodeOfOneDriveError {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorWithCodeOfOneDriveError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["error"] = this.error;
        return data;
    }
}

export interface IErrorWithCodeOfOneDriveError {
    code: OneDriveError;
    error: string;
}

export enum OneDriveError {
    CouldNotGetConfiguration = 10,
    CouldNotCreateClient = 20,
    CouldNotGetDrive = 30,
    CouldNotGetItem = 40,
    CouldNotGetItems = 50,
    CouldNotUploadFile = 60,
    AuthenticationNotImplemented = 80,
    GrantKeyRequired = 90,
    InvalidGrantKey = 100,
    DelegatedGrantNotFound = 110,
}

export class OneDriveConnectorCreateModel implements IOneDriveConnectorCreateModel {
    displayName!: string;
    authType!: ConnectorAuthType;
    tenantId!: string | undefined;
    clientId!: string | undefined;
    clientSecret!: string | undefined;
    ownerUserPrincipalName!: string | undefined;
    grantKey!: string | undefined;

    constructor(data?: IOneDriveConnectorCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.authType = _data["authType"];
            this.tenantId = _data["tenantId"];
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.ownerUserPrincipalName = _data["ownerUserPrincipalName"];
            this.grantKey = _data["grantKey"];
        }
    }

    static fromJS(data: any): OneDriveConnectorCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new OneDriveConnectorCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["authType"] = this.authType;
        data["tenantId"] = this.tenantId;
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["ownerUserPrincipalName"] = this.ownerUserPrincipalName;
        data["grantKey"] = this.grantKey;
        return data;
    }
}

export interface IOneDriveConnectorCreateModel {
    displayName: string;
    authType: ConnectorAuthType;
    tenantId: string | undefined;
    clientId: string | undefined;
    clientSecret: string | undefined;
    ownerUserPrincipalName: string | undefined;
    grantKey: string | undefined;
}

export class TenantViewModel implements ITenantViewModel {
    id!: number;
    code!: string;
    name!: string;

    constructor(data?: ITenantViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TenantViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TenantViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface ITenantViewModel {
    id: number;
    code: string;
    name: string;
}

export class TenantUpdateModel implements ITenantUpdateModel {
    id!: number;
    code!: string;
    name!: string;

    constructor(data?: ITenantUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TenantUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new TenantUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface ITenantUpdateModel {
    id: number;
    code: string;
    name: string;
}

export class UserInTenantViewModel implements IUserInTenantViewModel {
    tenantName!: string;
    userId!: number;
    tenantId!: number;
    isDefault!: boolean;
    roleId!: number;
    impersonateRoleId!: number | undefined;
    isTenantOwner!: boolean;

    constructor(data?: IUserInTenantViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantName = _data["tenantName"];
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.isDefault = _data["isDefault"];
            this.roleId = _data["roleId"];
            this.impersonateRoleId = _data["impersonateRoleId"];
            this.isTenantOwner = _data["isTenantOwner"];
        }
    }

    static fromJS(data: any): UserInTenantViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserInTenantViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["isDefault"] = this.isDefault;
        data["roleId"] = this.roleId;
        data["impersonateRoleId"] = this.impersonateRoleId;
        data["isTenantOwner"] = this.isTenantOwner;
        return data;
    }
}

export interface IUserInTenantViewModel {
    tenantName: string;
    userId: number;
    tenantId: number;
    isDefault: boolean;
    roleId: number;
    impersonateRoleId: number | undefined;
    isTenantOwner: boolean;
}

export class SecretsResponse implements ISecretsResponse {
    clientId!: string | undefined;
    clientSecret!: string | undefined;
    expiration!: Date | undefined;
    expired!: boolean;

    constructor(data?: ISecretsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.expiration = _data["expiration"] ? new Date(_data["expiration"].toString()) : <any>undefined;
            this.expired = _data["expired"];
        }
    }

    static fromJS(data: any): SecretsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SecretsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["expiration"] = this.expiration ? this.expiration.toISOString() : <any>undefined;
        data["expired"] = this.expired;
        return data;
    }
}

export interface ISecretsResponse {
    clientId: string | undefined;
    clientSecret: string | undefined;
    expiration: Date | undefined;
    expired: boolean;
}

export class GenericUpdateUserRoleModel implements IGenericUpdateUserRoleModel {
    userId!: number;
    roleId!: number;
    workspaceId!: number | undefined;

    constructor(data?: IGenericUpdateUserRoleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.roleId = _data["roleId"];
            this.workspaceId = _data["workspaceId"];
        }
    }

    static fromJS(data: any): GenericUpdateUserRoleModel {
        data = typeof data === 'object' ? data : {};
        let result = new GenericUpdateUserRoleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        data["workspaceId"] = this.workspaceId;
        return data;
    }
}

export interface IGenericUpdateUserRoleModel {
    userId: number;
    roleId: number;
    workspaceId: number | undefined;
}

export class TenantFeatureFlagCatalogItem implements ITenantFeatureFlagCatalogItem {
    featureKey!: string;
    name!: string;
    description!: string;
    order!: number;
    enabledTenantCount!: number;
    activeTenantCount!: number;

    constructor(data?: ITenantFeatureFlagCatalogItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.featureKey = _data["featureKey"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.order = _data["order"];
            this.enabledTenantCount = _data["enabledTenantCount"];
            this.activeTenantCount = _data["activeTenantCount"];
        }
    }

    static fromJS(data: any): TenantFeatureFlagCatalogItem {
        data = typeof data === 'object' ? data : {};
        let result = new TenantFeatureFlagCatalogItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["featureKey"] = this.featureKey;
        data["name"] = this.name;
        data["description"] = this.description;
        data["order"] = this.order;
        data["enabledTenantCount"] = this.enabledTenantCount;
        data["activeTenantCount"] = this.activeTenantCount;
        return data;
    }
}

export interface ITenantFeatureFlagCatalogItem {
    featureKey: string;
    name: string;
    description: string;
    order: number;
    enabledTenantCount: number;
    activeTenantCount: number;
}

export class TenantFeatureFlagTenantPage implements ITenantFeatureFlagTenantPage {
    items!: TenantFeatureFlagTenantItem[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    enabledTenantCount!: number;
    activeTenantCount!: number;

    constructor(data?: ITenantFeatureFlagTenantPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantFeatureFlagTenantItem.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.enabledTenantCount = _data["enabledTenantCount"];
            this.activeTenantCount = _data["activeTenantCount"];
        }
    }

    static fromJS(data: any): TenantFeatureFlagTenantPage {
        data = typeof data === 'object' ? data : {};
        let result = new TenantFeatureFlagTenantPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["enabledTenantCount"] = this.enabledTenantCount;
        data["activeTenantCount"] = this.activeTenantCount;
        return data;
    }
}

export interface ITenantFeatureFlagTenantPage {
    items: TenantFeatureFlagTenantItem[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    enabledTenantCount: number;
    activeTenantCount: number;
}

export class TenantFeatureFlagTenantItem implements ITenantFeatureFlagTenantItem {
    tenantId!: number;
    tenantName!: string;
    enabled!: boolean;
    version!: string;
    modifiedOn!: Date | undefined;
    modifiedBy!: number | undefined;

    constructor(data?: ITenantFeatureFlagTenantItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenantName = _data["tenantName"];
            this.enabled = _data["enabled"];
            this.version = _data["version"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
        }
    }

    static fromJS(data: any): TenantFeatureFlagTenantItem {
        data = typeof data === 'object' ? data : {};
        let result = new TenantFeatureFlagTenantItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        data["enabled"] = this.enabled;
        data["version"] = this.version;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        return data;
    }
}

export interface ITenantFeatureFlagTenantItem {
    tenantId: number;
    tenantName: string;
    enabled: boolean;
    version: string;
    modifiedOn: Date | undefined;
    modifiedBy: number | undefined;
}

export class TenantFeatureFlagChangeResult implements ITenantFeatureFlagChangeResult {
    batchId!: string;
    results!: TenantFeatureFlagTenantChangeResult[];

    constructor(data?: ITenantFeatureFlagChangeResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchId = _data["batchId"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(TenantFeatureFlagTenantChangeResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantFeatureFlagChangeResult {
        data = typeof data === 'object' ? data : {};
        let result = new TenantFeatureFlagChangeResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchId"] = this.batchId;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITenantFeatureFlagChangeResult {
    batchId: string;
    results: TenantFeatureFlagTenantChangeResult[];
}

export class TenantFeatureFlagTenantChangeResult implements ITenantFeatureFlagTenantChangeResult {
    tenantId!: number;
    status!: TenantFeatureFlagChangeStatus;
    version!: string | undefined;

    constructor(data?: ITenantFeatureFlagTenantChangeResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.status = _data["status"];
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): TenantFeatureFlagTenantChangeResult {
        data = typeof data === 'object' ? data : {};
        let result = new TenantFeatureFlagTenantChangeResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["status"] = this.status;
        data["version"] = this.version;
        return data;
    }
}

export interface ITenantFeatureFlagTenantChangeResult {
    tenantId: number;
    status: TenantFeatureFlagChangeStatus;
    version: string | undefined;
}

export enum TenantFeatureFlagChangeStatus {
    Succeeded = 0,
    VersionConflict = 1,
    TenantNotFound = 2,
    PropagationFailed = 3,
    AppliedWithAuditWarning = 4,
    Failed = 5,
}

export class TenantFeatureFlagChangeRequest implements ITenantFeatureFlagChangeRequest {
    reason!: string;
    changes!: TenantFeatureFlagChangeItem[];

    constructor(data?: ITenantFeatureFlagChangeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
            if (Array.isArray(_data["changes"])) {
                this.changes = [] as any;
                for (let item of _data["changes"])
                    this.changes!.push(TenantFeatureFlagChangeItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantFeatureFlagChangeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TenantFeatureFlagChangeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        if (Array.isArray(this.changes)) {
            data["changes"] = [];
            for (let item of this.changes)
                data["changes"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITenantFeatureFlagChangeRequest {
    reason: string;
    changes: TenantFeatureFlagChangeItem[];
}

export class TenantFeatureFlagChangeItem implements ITenantFeatureFlagChangeItem {
    tenantId!: number;
    enabled!: boolean;
    version!: string | undefined;

    constructor(data?: ITenantFeatureFlagChangeItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.enabled = _data["enabled"];
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): TenantFeatureFlagChangeItem {
        data = typeof data === 'object' ? data : {};
        let result = new TenantFeatureFlagChangeItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["enabled"] = this.enabled;
        data["version"] = this.version;
        return data;
    }
}

export interface ITenantFeatureFlagChangeItem {
    tenantId: number;
    enabled: boolean;
    version: string | undefined;
}

export class TenantFeatureFlagHistoryPage implements ITenantFeatureFlagHistoryPage {
    items!: TenantFeatureFlagHistoryBatch[];
    continuationToken!: string | undefined;

    constructor(data?: ITenantFeatureFlagHistoryPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantFeatureFlagHistoryBatch.fromJS(item));
            }
            this.continuationToken = _data["continuationToken"];
        }
    }

    static fromJS(data: any): TenantFeatureFlagHistoryPage {
        data = typeof data === 'object' ? data : {};
        let result = new TenantFeatureFlagHistoryPage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["continuationToken"] = this.continuationToken;
        return data;
    }
}

export interface ITenantFeatureFlagHistoryPage {
    items: TenantFeatureFlagHistoryBatch[];
    continuationToken: string | undefined;
}

export class TenantFeatureFlagHistoryBatch implements ITenantFeatureFlagHistoryBatch {
    batchId!: string;
    reason!: string;
    createdBy!: number;
    createdByName!: string;
    createdOn!: Date;
    changes!: TenantFeatureFlagHistoryItem[];

    constructor(data?: ITenantFeatureFlagHistoryBatch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchId = _data["batchId"];
            this.reason = _data["reason"];
            this.createdBy = _data["createdBy"];
            this.createdByName = _data["createdByName"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["changes"])) {
                this.changes = [] as any;
                for (let item of _data["changes"])
                    this.changes!.push(TenantFeatureFlagHistoryItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantFeatureFlagHistoryBatch {
        data = typeof data === 'object' ? data : {};
        let result = new TenantFeatureFlagHistoryBatch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchId"] = this.batchId;
        data["reason"] = this.reason;
        data["createdBy"] = this.createdBy;
        data["createdByName"] = this.createdByName;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        if (Array.isArray(this.changes)) {
            data["changes"] = [];
            for (let item of this.changes)
                data["changes"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITenantFeatureFlagHistoryBatch {
    batchId: string;
    reason: string;
    createdBy: number;
    createdByName: string;
    createdOn: Date;
    changes: TenantFeatureFlagHistoryItem[];
}

export class TenantFeatureFlagHistoryItem implements ITenantFeatureFlagHistoryItem {
    tenantId!: number;
    tenantName!: string;
    previousValue!: boolean;
    newValue!: boolean;

    constructor(data?: ITenantFeatureFlagHistoryItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenantName = _data["tenantName"];
            this.previousValue = _data["previousValue"];
            this.newValue = _data["newValue"];
        }
    }

    static fromJS(data: any): TenantFeatureFlagHistoryItem {
        data = typeof data === 'object' ? data : {};
        let result = new TenantFeatureFlagHistoryItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        data["previousValue"] = this.previousValue;
        data["newValue"] = this.newValue;
        return data;
    }
}

export interface ITenantFeatureFlagHistoryItem {
    tenantId: number;
    tenantName: string;
    previousValue: boolean;
    newValue: boolean;
}

export class TenantSettingsViewModel implements ITenantSettingsViewModel {
    settings!: TenantSettingViewModel[];

    constructor(data?: ITenantSettingsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["settings"])) {
                this.settings = [] as any;
                for (let item of _data["settings"])
                    this.settings!.push(TenantSettingViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantSettingsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSettingsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.settings)) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITenantSettingsViewModel {
    settings: TenantSettingViewModel[];
}

export class TenantSettingViewModel implements ITenantSettingViewModel {
    code!: string;
    value!: string;

    constructor(data?: ITenantSettingViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TenantSettingViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSettingViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["value"] = this.value;
        return data;
    }
}

export interface ITenantSettingViewModel {
    code: string;
    value: string;
}

export class TenantSettingsUpdateModel implements ITenantSettingsUpdateModel {
    settings!: KeyValuePairOfStringAndString[];

    constructor(data?: ITenantSettingsUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["settings"])) {
                this.settings = [] as any;
                for (let item of _data["settings"])
                    this.settings!.push(KeyValuePairOfStringAndString.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantSettingsUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSettingsUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.settings)) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITenantSettingsUpdateModel {
    settings: KeyValuePairOfStringAndString[];
}

export class KeyValuePairOfStringAndString implements IKeyValuePairOfStringAndString {
    key!: string | undefined;
    value!: string | undefined;

    constructor(data?: IKeyValuePairOfStringAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): KeyValuePairOfStringAndString {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfStringAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IKeyValuePairOfStringAndString {
    key: string | undefined;
    value: string | undefined;
}

export class ResultWithCodeOfSdTaskMediaUrlAndTranscriptFullViewModelAndBlobError implements IResultWithCodeOfSdTaskMediaUrlAndTranscriptFullViewModelAndBlobError {
    succeeded!: boolean;
    result!: SdTaskMediaUrlAndTranscriptFullViewModel | undefined;
    errors!: ErrorWithCodeOfBlobError[];

    constructor(data?: IResultWithCodeOfSdTaskMediaUrlAndTranscriptFullViewModelAndBlobError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.result = _data["result"] ? SdTaskMediaUrlAndTranscriptFullViewModel.fromJS(_data["result"]) : <any>undefined;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorWithCodeOfBlobError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultWithCodeOfSdTaskMediaUrlAndTranscriptFullViewModelAndBlobError {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithCodeOfSdTaskMediaUrlAndTranscriptFullViewModelAndBlobError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResultWithCodeOfSdTaskMediaUrlAndTranscriptFullViewModelAndBlobError {
    succeeded: boolean;
    result: SdTaskMediaUrlAndTranscriptFullViewModel | undefined;
    errors: ErrorWithCodeOfBlobError[];
}

export class SdTaskMediaUrlAndTranscriptFullViewModel implements ISdTaskMediaUrlAndTranscriptFullViewModel {
    urlResult!: ResultWithCodeOfStringAndBlobError;
    transcriptFullResult!: ResultWithCodeOfTranscriptFullViewModelAndBlobError;
    predefinedSpeakers!: PredefinedSpeakersViewModel;
    waveformUrlResult!: ResultWithCodeOfStringAndBlobError;
    isVideo!: boolean;
    speakers!: SpeakerViewModel[];

    constructor(data?: ISdTaskMediaUrlAndTranscriptFullViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.urlResult = _data["urlResult"] ? ResultWithCodeOfStringAndBlobError.fromJS(_data["urlResult"]) : <any>undefined;
            this.transcriptFullResult = _data["transcriptFullResult"] ? ResultWithCodeOfTranscriptFullViewModelAndBlobError.fromJS(_data["transcriptFullResult"]) : <any>undefined;
            this.predefinedSpeakers = _data["predefinedSpeakers"] ? PredefinedSpeakersViewModel.fromJS(_data["predefinedSpeakers"]) : <any>undefined;
            this.waveformUrlResult = _data["waveformUrlResult"] ? ResultWithCodeOfStringAndBlobError.fromJS(_data["waveformUrlResult"]) : <any>undefined;
            this.isVideo = _data["isVideo"];
            if (Array.isArray(_data["speakers"])) {
                this.speakers = [] as any;
                for (let item of _data["speakers"])
                    this.speakers!.push(SpeakerViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SdTaskMediaUrlAndTranscriptFullViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdTaskMediaUrlAndTranscriptFullViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["urlResult"] = this.urlResult ? this.urlResult.toJSON() : <any>undefined;
        data["transcriptFullResult"] = this.transcriptFullResult ? this.transcriptFullResult.toJSON() : <any>undefined;
        data["predefinedSpeakers"] = this.predefinedSpeakers ? this.predefinedSpeakers.toJSON() : <any>undefined;
        data["waveformUrlResult"] = this.waveformUrlResult ? this.waveformUrlResult.toJSON() : <any>undefined;
        data["isVideo"] = this.isVideo;
        if (Array.isArray(this.speakers)) {
            data["speakers"] = [];
            for (let item of this.speakers)
                data["speakers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISdTaskMediaUrlAndTranscriptFullViewModel {
    urlResult: ResultWithCodeOfStringAndBlobError;
    transcriptFullResult: ResultWithCodeOfTranscriptFullViewModelAndBlobError;
    predefinedSpeakers: PredefinedSpeakersViewModel;
    waveformUrlResult: ResultWithCodeOfStringAndBlobError;
    isVideo: boolean;
    speakers: SpeakerViewModel[];
}

export class ResultWithCodeOfTranscriptFullViewModelAndBlobError implements IResultWithCodeOfTranscriptFullViewModelAndBlobError {
    succeeded!: boolean;
    result!: TranscriptFullViewModel | undefined;
    errors!: ErrorWithCodeOfBlobError[];

    constructor(data?: IResultWithCodeOfTranscriptFullViewModelAndBlobError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.result = _data["result"] ? TranscriptFullViewModel.fromJS(_data["result"]) : <any>undefined;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorWithCodeOfBlobError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultWithCodeOfTranscriptFullViewModelAndBlobError {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithCodeOfTranscriptFullViewModelAndBlobError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResultWithCodeOfTranscriptFullViewModelAndBlobError {
    succeeded: boolean;
    result: TranscriptFullViewModel | undefined;
    errors: ErrorWithCodeOfBlobError[];
}

export class TranscriptFullViewModel implements ITranscriptFullViewModel {
    accurateWordTimestamps!: boolean;
    transcripts!: TranscriptViewModel[];
    speakers!: Speaker[];
    annotations!: Annotation[];

    constructor(data?: ITranscriptFullViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accurateWordTimestamps = _data["accurateWordTimestamps"];
            if (Array.isArray(_data["transcripts"])) {
                this.transcripts = [] as any;
                for (let item of _data["transcripts"])
                    this.transcripts!.push(TranscriptViewModel.fromJS(item));
            }
            if (Array.isArray(_data["speakers"])) {
                this.speakers = [] as any;
                for (let item of _data["speakers"])
                    this.speakers!.push(Speaker.fromJS(item));
            }
            if (Array.isArray(_data["annotations"])) {
                this.annotations = [] as any;
                for (let item of _data["annotations"])
                    this.annotations!.push(Annotation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TranscriptFullViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TranscriptFullViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accurateWordTimestamps"] = this.accurateWordTimestamps;
        if (Array.isArray(this.transcripts)) {
            data["transcripts"] = [];
            for (let item of this.transcripts)
                data["transcripts"].push(item.toJSON());
        }
        if (Array.isArray(this.speakers)) {
            data["speakers"] = [];
            for (let item of this.speakers)
                data["speakers"].push(item.toJSON());
        }
        if (Array.isArray(this.annotations)) {
            data["annotations"] = [];
            for (let item of this.annotations)
                data["annotations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITranscriptFullViewModel {
    accurateWordTimestamps: boolean;
    transcripts: TranscriptViewModel[];
    speakers: Speaker[];
    annotations: Annotation[];
}

export class TranscriptViewModel implements ITranscriptViewModel {
    type!: ParagraphType;
    speakerId!: string;
    start!: number;
    end!: number;
    duration!: number;
    confidence!: number;
    children!: SlateLeaf[];

    constructor(data?: ITranscriptViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.speakerId = _data["speakerId"];
            this.start = _data["start"];
            this.end = _data["end"];
            this.duration = _data["duration"];
            this.confidence = _data["confidence"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(SlateLeaf.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TranscriptViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TranscriptViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["speakerId"] = this.speakerId;
        data["start"] = this.start;
        data["end"] = this.end;
        data["duration"] = this.duration;
        data["confidence"] = this.confidence;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITranscriptViewModel {
    type: ParagraphType;
    speakerId: string;
    start: number;
    end: number;
    duration: number;
    confidence: number;
    children: SlateLeaf[];
}

export enum ParagraphType {
    Timed = 10,
    Token = 20,
}

export class SlateLeaf implements ISlateLeaf {
    text!: string;
    bold!: boolean | undefined;
    italic!: boolean | undefined;
    underline!: boolean | undefined;
    offsetInSeconds!: number | undefined;
    durationInSeconds!: number | undefined;
    confidence!: number;

    constructor(data?: ISlateLeaf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.bold = _data["bold"];
            this.italic = _data["italic"];
            this.underline = _data["underline"];
            this.offsetInSeconds = _data["offsetInSeconds"];
            this.durationInSeconds = _data["durationInSeconds"];
            this.confidence = _data["confidence"];
        }
    }

    static fromJS(data: any): SlateLeaf {
        data = typeof data === 'object' ? data : {};
        let result = new SlateLeaf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["bold"] = this.bold;
        data["italic"] = this.italic;
        data["underline"] = this.underline;
        data["offsetInSeconds"] = this.offsetInSeconds;
        data["durationInSeconds"] = this.durationInSeconds;
        data["confidence"] = this.confidence;
        return data;
    }
}

export interface ISlateLeaf {
    text: string;
    bold: boolean | undefined;
    italic: boolean | undefined;
    underline: boolean | undefined;
    offsetInSeconds: number | undefined;
    durationInSeconds: number | undefined;
    confidence: number;
}

export class Speaker implements ISpeaker {
    speakerId!: string;
    speakerName!: string;
    speakerPrefix!: string | undefined;
    speakerSuffix!: string | undefined;
    isDefault!: boolean;
    createdBy!: number | undefined;
    createdOn!: Date | undefined;
    modifiedBy!: number | undefined;
    modifiedOn!: Date | undefined;

    constructor(data?: ISpeaker) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.speakerId = _data["speakerId"];
            this.speakerName = _data["speakerName"];
            this.speakerPrefix = _data["speakerPrefix"];
            this.speakerSuffix = _data["speakerSuffix"];
            this.isDefault = _data["isDefault"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Speaker {
        data = typeof data === 'object' ? data : {};
        let result = new Speaker();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["speakerId"] = this.speakerId;
        data["speakerName"] = this.speakerName;
        data["speakerPrefix"] = this.speakerPrefix;
        data["speakerSuffix"] = this.speakerSuffix;
        data["isDefault"] = this.isDefault;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISpeaker {
    speakerId: string;
    speakerName: string;
    speakerPrefix: string | undefined;
    speakerSuffix: string | undefined;
    isDefault: boolean;
    createdBy: number | undefined;
    createdOn: Date | undefined;
    modifiedBy: number | undefined;
    modifiedOn: Date | undefined;
}

export class Annotation implements IAnnotation {
    uniqueId!: string;
    content!: string;
    start!: number;
    end!: number;
    createdByUserName!: string;
    createdBy!: number;
    createdOn!: Date;
    modifiedByUserName!: string;
    modifiedBy!: number;
    modifiedOn!: Date;

    constructor(data?: IAnnotation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.content = _data["content"];
            this.start = _data["start"];
            this.end = _data["end"];
            this.createdByUserName = _data["createdByUserName"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedByUserName = _data["modifiedByUserName"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Annotation {
        data = typeof data === 'object' ? data : {};
        let result = new Annotation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["content"] = this.content;
        data["start"] = this.start;
        data["end"] = this.end;
        data["createdByUserName"] = this.createdByUserName;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedByUserName"] = this.modifiedByUserName;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAnnotation {
    uniqueId: string;
    content: string;
    start: number;
    end: number;
    createdByUserName: string;
    createdBy: number;
    createdOn: Date;
    modifiedByUserName: string;
    modifiedBy: number;
    modifiedOn: Date;
}

export class PredefinedSpeakersViewModel implements IPredefinedSpeakersViewModel {
    predefinedSpeakers!: Speaker[];

    constructor(data?: IPredefinedSpeakersViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["predefinedSpeakers"])) {
                this.predefinedSpeakers = [] as any;
                for (let item of _data["predefinedSpeakers"])
                    this.predefinedSpeakers!.push(Speaker.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PredefinedSpeakersViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PredefinedSpeakersViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.predefinedSpeakers)) {
            data["predefinedSpeakers"] = [];
            for (let item of this.predefinedSpeakers)
                data["predefinedSpeakers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPredefinedSpeakersViewModel {
    predefinedSpeakers: Speaker[];
}

export class SpeakerViewModel implements ISpeakerViewModel {
    speakerId!: string;
    speakerName!: string;
    speakerPrefix!: string | undefined;
    speakerSuffix!: string | undefined;
    isDefault!: boolean;
    source!: SpeakerSource;
    isOnTask!: boolean;
    action!: SpeakerAction;
    createdBy!: number | undefined;
    createdOn!: Date | undefined;
    modifiedBy!: number | undefined;
    modifiedOn!: Date | undefined;

    constructor(data?: ISpeakerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.speakerId = _data["speakerId"];
            this.speakerName = _data["speakerName"];
            this.speakerPrefix = _data["speakerPrefix"];
            this.speakerSuffix = _data["speakerSuffix"];
            this.isDefault = _data["isDefault"];
            this.source = _data["source"];
            this.isOnTask = _data["isOnTask"];
            this.action = _data["action"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SpeakerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SpeakerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["speakerId"] = this.speakerId;
        data["speakerName"] = this.speakerName;
        data["speakerPrefix"] = this.speakerPrefix;
        data["speakerSuffix"] = this.speakerSuffix;
        data["isDefault"] = this.isDefault;
        data["source"] = this.source;
        data["isOnTask"] = this.isOnTask;
        data["action"] = this.action;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISpeakerViewModel {
    speakerId: string;
    speakerName: string;
    speakerPrefix: string | undefined;
    speakerSuffix: string | undefined;
    isDefault: boolean;
    source: SpeakerSource;
    isOnTask: boolean;
    action: SpeakerAction;
    createdBy: number | undefined;
    createdOn: Date | undefined;
    modifiedBy: number | undefined;
    modifiedOn: Date | undefined;
}

export enum SpeakerSource {
    Task = 10,
    Batch = 20,
    Workspace = 30,
}

export enum SpeakerAction {
    None = 10,
    Added = 20,
    Edited = 30,
    Removed = 40,
}

export class ResultWithCodeOfSavedTranscriptFullViewModelAndSdTaskError implements IResultWithCodeOfSavedTranscriptFullViewModelAndSdTaskError {
    succeeded!: boolean;
    result!: SavedTranscriptFullViewModel | undefined;
    errors!: ErrorWithCodeOfSdTaskError[];

    constructor(data?: IResultWithCodeOfSavedTranscriptFullViewModelAndSdTaskError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.result = _data["result"] ? SavedTranscriptFullViewModel.fromJS(_data["result"]) : <any>undefined;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorWithCodeOfSdTaskError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultWithCodeOfSavedTranscriptFullViewModelAndSdTaskError {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithCodeOfSavedTranscriptFullViewModelAndSdTaskError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResultWithCodeOfSavedTranscriptFullViewModelAndSdTaskError {
    succeeded: boolean;
    result: SavedTranscriptFullViewModel | undefined;
    errors: ErrorWithCodeOfSdTaskError[];
}

export class SavedTranscriptFullViewModel implements ISavedTranscriptFullViewModel {
    savedResult!: ResultWithCodeOfBooleanAndBlobError;
    transcript!: TranscriptFullViewModel;

    constructor(data?: ISavedTranscriptFullViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.savedResult = _data["savedResult"] ? ResultWithCodeOfBooleanAndBlobError.fromJS(_data["savedResult"]) : <any>undefined;
            this.transcript = _data["transcript"] ? TranscriptFullViewModel.fromJS(_data["transcript"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SavedTranscriptFullViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SavedTranscriptFullViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["savedResult"] = this.savedResult ? this.savedResult.toJSON() : <any>undefined;
        data["transcript"] = this.transcript ? this.transcript.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISavedTranscriptFullViewModel {
    savedResult: ResultWithCodeOfBooleanAndBlobError;
    transcript: TranscriptFullViewModel;
}

export class ResultWithCodeOfBooleanAndBlobError implements IResultWithCodeOfBooleanAndBlobError {
    succeeded!: boolean;
    result!: boolean;
    errors!: ErrorWithCodeOfBlobError[];

    constructor(data?: IResultWithCodeOfBooleanAndBlobError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.result = _data["result"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorWithCodeOfBlobError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultWithCodeOfBooleanAndBlobError {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithCodeOfBooleanAndBlobError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["result"] = this.result;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResultWithCodeOfBooleanAndBlobError {
    succeeded: boolean;
    result: boolean;
    errors: ErrorWithCodeOfBlobError[];
}

export class SaveTranscriptFullModel implements ISaveTranscriptFullModel {
    taskId!: number;
    workspaceId!: number;
    transcript!: TranscriptFullViewModel;
    changedSpeakers!: SpeakerViewModel[];

    constructor(data?: ISaveTranscriptFullModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.workspaceId = _data["workspaceId"];
            this.transcript = _data["transcript"] ? TranscriptFullViewModel.fromJS(_data["transcript"]) : <any>undefined;
            if (Array.isArray(_data["changedSpeakers"])) {
                this.changedSpeakers = [] as any;
                for (let item of _data["changedSpeakers"])
                    this.changedSpeakers!.push(SpeakerViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveTranscriptFullModel {
        data = typeof data === 'object' ? data : {};
        let result = new SaveTranscriptFullModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["workspaceId"] = this.workspaceId;
        data["transcript"] = this.transcript ? this.transcript.toJSON() : <any>undefined;
        if (Array.isArray(this.changedSpeakers)) {
            data["changedSpeakers"] = [];
            for (let item of this.changedSpeakers)
                data["changedSpeakers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveTranscriptFullModel {
    taskId: number;
    workspaceId: number;
    transcript: TranscriptFullViewModel;
    changedSpeakers: SpeakerViewModel[];
}

export class TranscriptExportModel implements ITranscriptExportModel {
    type!: ExportType;
    includeTimestamps!: boolean;
    includeSpeakers!: boolean;
    mergeParagraphs!: boolean;

    constructor(data?: ITranscriptExportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.includeTimestamps = _data["includeTimestamps"];
            this.includeSpeakers = _data["includeSpeakers"];
            this.mergeParagraphs = _data["mergeParagraphs"];
        }
    }

    static fromJS(data: any): TranscriptExportModel {
        data = typeof data === 'object' ? data : {};
        let result = new TranscriptExportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["includeTimestamps"] = this.includeTimestamps;
        data["includeSpeakers"] = this.includeSpeakers;
        data["mergeParagraphs"] = this.mergeParagraphs;
        return data;
    }
}

export interface ITranscriptExportModel {
    type: ExportType;
    includeTimestamps: boolean;
    includeSpeakers: boolean;
    mergeParagraphs: boolean;
}

export class TranscriptMultipleExportDataModel implements ITranscriptMultipleExportDataModel {
    type!: ExportType;
    includeTimestamps!: boolean;
    includeSpeakers!: boolean;
    mergeParagraphs!: boolean;
    workspaceId!: number;
    taskIdList!: number[];
    filters!: PaginatedRequestQueryFilter[];
    allSelected!: boolean;

    constructor(data?: ITranscriptMultipleExportDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.includeTimestamps = _data["includeTimestamps"];
            this.includeSpeakers = _data["includeSpeakers"];
            this.mergeParagraphs = _data["mergeParagraphs"];
            this.workspaceId = _data["workspaceId"];
            if (Array.isArray(_data["taskIdList"])) {
                this.taskIdList = [] as any;
                for (let item of _data["taskIdList"])
                    this.taskIdList!.push(item);
            }
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(PaginatedRequestQueryFilter.fromJS(item));
            }
            this.allSelected = _data["allSelected"];
        }
    }

    static fromJS(data: any): TranscriptMultipleExportDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new TranscriptMultipleExportDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["includeTimestamps"] = this.includeTimestamps;
        data["includeSpeakers"] = this.includeSpeakers;
        data["mergeParagraphs"] = this.mergeParagraphs;
        data["workspaceId"] = this.workspaceId;
        if (Array.isArray(this.taskIdList)) {
            data["taskIdList"] = [];
            for (let item of this.taskIdList)
                data["taskIdList"].push(item);
        }
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        data["allSelected"] = this.allSelected;
        return data;
    }
}

export interface ITranscriptMultipleExportDataModel {
    type: ExportType;
    includeTimestamps: boolean;
    includeSpeakers: boolean;
    mergeParagraphs: boolean;
    workspaceId: number;
    taskIdList: number[];
    filters: PaginatedRequestQueryFilter[];
    allSelected: boolean;
}

export class PredefinedSpeakersModel implements IPredefinedSpeakersModel {
    predefinedSpeakers!: Speaker[];

    constructor(data?: IPredefinedSpeakersModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["predefinedSpeakers"])) {
                this.predefinedSpeakers = [] as any;
                for (let item of _data["predefinedSpeakers"])
                    this.predefinedSpeakers!.push(Speaker.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PredefinedSpeakersModel {
        data = typeof data === 'object' ? data : {};
        let result = new PredefinedSpeakersModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.predefinedSpeakers)) {
            data["predefinedSpeakers"] = [];
            for (let item of this.predefinedSpeakers)
                data["predefinedSpeakers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPredefinedSpeakersModel {
    predefinedSpeakers: Speaker[];
}

export class UserDetailsViewModel implements IUserDetailsViewModel {
    email!: string;
    name!: string;
    userName!: string;
    role!: string;
    roleId!: number | undefined;
    impersonateRoleId!: number | undefined;
    contact!: string | undefined;
    emailConfirmed!: boolean;
    hasPassword!: boolean;
    userId!: number;
    profilePicture!: string | undefined;

    constructor(data?: IUserDetailsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.name = _data["name"];
            this.userName = _data["userName"];
            this.role = _data["role"];
            this.roleId = _data["roleId"];
            this.impersonateRoleId = _data["impersonateRoleId"];
            this.contact = _data["contact"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.hasPassword = _data["hasPassword"];
            this.userId = _data["userId"];
            this.profilePicture = _data["profilePicture"];
        }
    }

    static fromJS(data: any): UserDetailsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserDetailsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["name"] = this.name;
        data["userName"] = this.userName;
        data["role"] = this.role;
        data["roleId"] = this.roleId;
        data["impersonateRoleId"] = this.impersonateRoleId;
        data["contact"] = this.contact;
        data["emailConfirmed"] = this.emailConfirmed;
        data["hasPassword"] = this.hasPassword;
        data["userId"] = this.userId;
        data["profilePicture"] = this.profilePicture;
        return data;
    }
}

export interface IUserDetailsViewModel {
    email: string;
    name: string;
    userName: string;
    role: string;
    roleId: number | undefined;
    impersonateRoleId: number | undefined;
    contact: string | undefined;
    emailConfirmed: boolean;
    hasPassword: boolean;
    userId: number;
    profilePicture: string | undefined;
}

export class UserAuthDetailsViewModel extends UserDetailsViewModel implements IUserAuthDetailsViewModel {
    abilities!: AbilityViewModel[];

    constructor(data?: IUserAuthDetailsViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["abilities"])) {
                this.abilities = [] as any;
                for (let item of _data["abilities"])
                    this.abilities!.push(AbilityViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserAuthDetailsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserAuthDetailsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.abilities)) {
            data["abilities"] = [];
            for (let item of this.abilities)
                data["abilities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUserAuthDetailsViewModel extends IUserDetailsViewModel {
    abilities: AbilityViewModel[];
}

export class AbilityViewModel implements IAbilityViewModel {
    subject!: string;
    action!: string;

    constructor(data?: IAbilityViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.action = _data["action"];
        }
    }

    static fromJS(data: any): AbilityViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AbilityViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["action"] = this.action;
        return data;
    }
}

export interface IAbilityViewModel {
    subject: string;
    action: string;
}

export class UserViewModel implements IUserViewModel {
    tenantId!: number;
    userId!: number;
    userName!: string;
    userEmail!: string;
    userStatusId!: number;
    userRoleId!: number;
    userRoleName!: string;
    isDefault!: boolean;

    constructor(data?: IUserViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.userEmail = _data["userEmail"];
            this.userStatusId = _data["userStatusId"];
            this.userRoleId = _data["userRoleId"];
            this.userRoleName = _data["userRoleName"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): UserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["userEmail"] = this.userEmail;
        data["userStatusId"] = this.userStatusId;
        data["userRoleId"] = this.userRoleId;
        data["userRoleName"] = this.userRoleName;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface IUserViewModel {
    tenantId: number;
    userId: number;
    userName: string;
    userEmail: string;
    userStatusId: number;
    userRoleId: number;
    userRoleName: string;
    isDefault: boolean;
}

export class PaginatedListOfUserViewModel implements IPaginatedListOfUserViewModel {
    items!: UserViewModel[];
    pageNumber!: number;
    totalPages!: number;
    totalCount!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfUserViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserViewModel.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfUserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfUserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfUserViewModel {
    items: UserViewModel[];
    pageNumber: number;
    totalPages: number;
    totalCount: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class UpdateDefaultTenantUserModel implements IUpdateDefaultTenantUserModel {
    tenantId!: number;

    constructor(data?: IUpdateDefaultTenantUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): UpdateDefaultTenantUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDefaultTenantUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IUpdateDefaultTenantUserModel {
    tenantId: number;
}

export class AuthorizationRole implements IAuthorizationRole {
    id!: number;
    name!: string;
    order!: number;
    tenantSelectable!: boolean;
    hidden!: boolean;
    superUser!: boolean;

    constructor(data?: IAuthorizationRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.order = _data["order"];
            this.tenantSelectable = _data["tenantSelectable"];
            this.hidden = _data["hidden"];
            this.superUser = _data["superUser"];
        }
    }

    static fromJS(data: any): AuthorizationRole {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizationRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["order"] = this.order;
        data["tenantSelectable"] = this.tenantSelectable;
        data["hidden"] = this.hidden;
        data["superUser"] = this.superUser;
        return data;
    }
}

export interface IAuthorizationRole {
    id: number;
    name: string;
    order: number;
    tenantSelectable: boolean;
    hidden: boolean;
    superUser: boolean;
}

export class Result implements IResult {
    succeeded!: boolean;
    errors!: string[];

    constructor(data?: IResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): Result {
        data = typeof data === 'object' ? data : {};
        let result = new Result();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IResult {
    succeeded: boolean;
    errors: string[];
}

export class ConfirmEmailDataModel implements IConfirmEmailDataModel {
    userId!: string;
    code!: string;

    constructor(data?: IConfirmEmailDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ConfirmEmailDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmEmailDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["code"] = this.code;
        return data;
    }
}

export interface IConfirmEmailDataModel {
    userId: string;
    code: string;
}

export class ConfirmChangeEmailDataModel implements IConfirmChangeEmailDataModel {
    userId!: string;
    email!: string;
    code!: string;

    constructor(data?: IConfirmChangeEmailDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ConfirmChangeEmailDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmChangeEmailDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["code"] = this.code;
        return data;
    }
}

export interface IConfirmChangeEmailDataModel {
    userId: string;
    email: string;
    code: string;
}

export class PersonalInfoModel implements IPersonalInfoModel {
    fullName!: string;
    contact!: string | undefined;

    constructor(data?: IPersonalInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.contact = _data["contact"];
        }
    }

    static fromJS(data: any): PersonalInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["contact"] = this.contact;
        return data;
    }
}

export interface IPersonalInfoModel {
    fullName: string;
    contact: string | undefined;
}

export class PersonalMetricsViewModel implements IPersonalMetricsViewModel {
    workspaceCount!: number;
    processedTasksCount!: number;

    constructor(data?: IPersonalMetricsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workspaceCount = _data["workspaceCount"];
            this.processedTasksCount = _data["processedTasksCount"];
        }
    }

    static fromJS(data: any): PersonalMetricsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalMetricsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workspaceCount"] = this.workspaceCount;
        data["processedTasksCount"] = this.processedTasksCount;
        return data;
    }
}

export interface IPersonalMetricsViewModel {
    workspaceCount: number;
    processedTasksCount: number;
}

export class ExternalLoginsViewModel implements IExternalLoginsViewModel {
    currentLogins!: UserLoginInfo[];
    canRemoveLogin!: boolean;

    constructor(data?: IExternalLoginsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["currentLogins"])) {
                this.currentLogins = [] as any;
                for (let item of _data["currentLogins"])
                    this.currentLogins!.push(UserLoginInfo.fromJS(item));
            }
            this.canRemoveLogin = _data["canRemoveLogin"];
        }
    }

    static fromJS(data: any): ExternalLoginsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.currentLogins)) {
            data["currentLogins"] = [];
            for (let item of this.currentLogins)
                data["currentLogins"].push(item.toJSON());
        }
        data["canRemoveLogin"] = this.canRemoveLogin;
        return data;
    }
}

export interface IExternalLoginsViewModel {
    currentLogins: UserLoginInfo[];
    canRemoveLogin: boolean;
}

export class UserLoginInfo implements IUserLoginInfo {
    loginProvider!: string;
    providerKey!: string;
    providerDisplayName!: string | undefined;

    constructor(data?: IUserLoginInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loginProvider = _data["loginProvider"];
            this.providerKey = _data["providerKey"];
            this.providerDisplayName = _data["providerDisplayName"];
        }
    }

    static fromJS(data: any): UserLoginInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loginProvider"] = this.loginProvider;
        data["providerKey"] = this.providerKey;
        data["providerDisplayName"] = this.providerDisplayName;
        return data;
    }
}

export interface IUserLoginInfo {
    loginProvider: string;
    providerKey: string;
    providerDisplayName: string | undefined;
}

export class SecurityModel implements ISecurityModel {
    oldPassword!: string;
    newPassword!: string;

    constructor(data?: ISecurityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): SecurityModel {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface ISecurityModel {
    oldPassword: string;
    newPassword: string;
}

export class LoginInfoModel implements ILoginInfoModel {
    loginProvider!: string;
    providerKey!: string;

    constructor(data?: ILoginInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loginProvider = _data["loginProvider"];
            this.providerKey = _data["providerKey"];
        }
    }

    static fromJS(data: any): LoginInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoginInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loginProvider"] = this.loginProvider;
        data["providerKey"] = this.providerKey;
        return data;
    }
}

export interface ILoginInfoModel {
    loginProvider: string;
    providerKey: string;
}

export enum UserDeleteInfo {
    IsOnlyAdmin = 1,
    IsNormalUser = 2,
    NotIsOnlyAdmin = 3,
    IsOnlyAdminAndOnlyUser = 4,
}

export class PersonalDataViewModel implements IPersonalDataViewModel {
    contentType!: string;
    content!: string;
    fileName!: string;

    constructor(data?: IPersonalDataViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contentType = _data["contentType"];
            this.content = _data["content"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): PersonalDataViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalDataViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentType"] = this.contentType;
        data["content"] = this.content;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IPersonalDataViewModel {
    contentType: string;
    content: string;
    fileName: string;
}

export class ResultWithCodeOfPictureImportViewModelAndUserError implements IResultWithCodeOfPictureImportViewModelAndUserError {
    succeeded!: boolean;
    result!: PictureImportViewModel | undefined;
    errors!: ErrorWithCodeOfUserError[];

    constructor(data?: IResultWithCodeOfPictureImportViewModelAndUserError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.result = _data["result"] ? PictureImportViewModel.fromJS(_data["result"]) : <any>undefined;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorWithCodeOfUserError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultWithCodeOfPictureImportViewModelAndUserError {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithCodeOfPictureImportViewModelAndUserError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResultWithCodeOfPictureImportViewModelAndUserError {
    succeeded: boolean;
    result: PictureImportViewModel | undefined;
    errors: ErrorWithCodeOfUserError[];
}

export class PictureImportViewModel implements IPictureImportViewModel {
    taskId!: number;
    displayName!: string;

    constructor(data?: IPictureImportViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): PictureImportViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PictureImportViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IPictureImportViewModel {
    taskId: number;
    displayName: string;
}

export class ErrorWithCodeOfUserError implements IErrorWithCodeOfUserError {
    code!: UserError;
    error!: string;

    constructor(data?: IErrorWithCodeOfUserError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): ErrorWithCodeOfUserError {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorWithCodeOfUserError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["error"] = this.error;
        return data;
    }
}

export interface IErrorWithCodeOfUserError {
    code: UserError;
    error: string;
}

export enum UserError {
    CurrentUserIdNotFound = 1,
    NotFound = 2,
    UrlOrFileRequired = 3,
    MaximumFileSize = 4,
    BlobStorageUploadError = 5,
}

export class PictureImportModel implements IPictureImportModel {
    displayName!: string;
    url!: string | undefined;
    data!: PictureImportDataModel | undefined;

    constructor(data?: IPictureImportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.url = _data["url"];
            this.data = _data["data"] ? PictureImportDataModel.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PictureImportModel {
        data = typeof data === 'object' ? data : {};
        let result = new PictureImportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["url"] = this.url;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPictureImportModel {
    displayName: string;
    url: string | undefined;
    data: PictureImportDataModel | undefined;
}

export class PictureImportDataModel implements IPictureImportDataModel {
    base64!: string;
    displayName!: string;
    name!: string;
    type!: string;

    constructor(data?: IPictureImportDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.base64 = _data["base64"];
            this.displayName = _data["displayName"];
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): PictureImportDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new PictureImportDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["base64"] = this.base64;
        data["displayName"] = this.displayName;
        data["name"] = this.name;
        data["type"] = this.type;
        return data;
    }
}

export interface IPictureImportDataModel {
    base64: string;
    displayName: string;
    name: string;
    type: string;
}

export class SdTaskAssignmentUserInfo implements ISdTaskAssignmentUserInfo {
    userId!: number;
    profilePicture!: string | undefined;

    constructor(data?: ISdTaskAssignmentUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.profilePicture = _data["profilePicture"];
        }
    }

    static fromJS(data: any): SdTaskAssignmentUserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SdTaskAssignmentUserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["profilePicture"] = this.profilePicture;
        return data;
    }
}

export interface ISdTaskAssignmentUserInfo {
    userId: number;
    profilePicture: string | undefined;
}

export class UserTourViewModel implements IUserTourViewModel {
    userId!: number;
    taskListSeen!: boolean;
    taskViewerSeen!: boolean;

    constructor(data?: IUserTourViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.taskListSeen = _data["taskListSeen"];
            this.taskViewerSeen = _data["taskViewerSeen"];
        }
    }

    static fromJS(data: any): UserTourViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserTourViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["taskListSeen"] = this.taskListSeen;
        data["taskViewerSeen"] = this.taskViewerSeen;
        return data;
    }
}

export interface IUserTourViewModel {
    userId: number;
    taskListSeen: boolean;
    taskViewerSeen: boolean;
}

export class ResultWithCodeOfSdTaskViewerInitViewModelAndSdTaskError implements IResultWithCodeOfSdTaskViewerInitViewModelAndSdTaskError {
    succeeded!: boolean;
    result!: SdTaskViewerInitViewModel | undefined;
    errors!: ErrorWithCodeOfSdTaskError[];

    constructor(data?: IResultWithCodeOfSdTaskViewerInitViewModelAndSdTaskError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.result = _data["result"] ? SdTaskViewerInitViewModel.fromJS(_data["result"]) : <any>undefined;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorWithCodeOfSdTaskError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultWithCodeOfSdTaskViewerInitViewModelAndSdTaskError {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithCodeOfSdTaskViewerInitViewModelAndSdTaskError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResultWithCodeOfSdTaskViewerInitViewModelAndSdTaskError {
    succeeded: boolean;
    result: SdTaskViewerInitViewModel | undefined;
    errors: ErrorWithCodeOfSdTaskError[];
}

export class SdTaskViewerInitViewModel implements ISdTaskViewerInitViewModel {
    taskId!: number;
    displayName!: string;
    externalId!: string | undefined;
    workspaceId!: number;
    tenantId!: number;
    taskType!: TaskType;
    status!: SdTaskStatus;
    fromHistory!: boolean | undefined;

    constructor(data?: ISdTaskViewerInitViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.displayName = _data["displayName"];
            this.externalId = _data["externalId"];
            this.workspaceId = _data["workspaceId"];
            this.tenantId = _data["tenantId"];
            this.taskType = _data["taskType"];
            this.status = _data["status"];
            this.fromHistory = _data["fromHistory"];
        }
    }

    static fromJS(data: any): SdTaskViewerInitViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdTaskViewerInitViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["displayName"] = this.displayName;
        data["externalId"] = this.externalId;
        data["workspaceId"] = this.workspaceId;
        data["tenantId"] = this.tenantId;
        data["taskType"] = this.taskType;
        data["status"] = this.status;
        data["fromHistory"] = this.fromHistory;
        return data;
    }
}

export interface ISdTaskViewerInitViewModel {
    taskId: number;
    displayName: string;
    externalId: string | undefined;
    workspaceId: number;
    tenantId: number;
    taskType: TaskType;
    status: SdTaskStatus;
    fromHistory: boolean | undefined;
}

export class ResultWithCodeOfSdTaskCheckoutViewModelAndSdTaskError implements IResultWithCodeOfSdTaskCheckoutViewModelAndSdTaskError {
    succeeded!: boolean;
    result!: SdTaskCheckoutViewModel | undefined;
    errors!: ErrorWithCodeOfSdTaskError[];

    constructor(data?: IResultWithCodeOfSdTaskCheckoutViewModelAndSdTaskError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.result = _data["result"] ? SdTaskCheckoutViewModel.fromJS(_data["result"]) : <any>undefined;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorWithCodeOfSdTaskError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultWithCodeOfSdTaskCheckoutViewModelAndSdTaskError {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithCodeOfSdTaskCheckoutViewModelAndSdTaskError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResultWithCodeOfSdTaskCheckoutViewModelAndSdTaskError {
    succeeded: boolean;
    result: SdTaskCheckoutViewModel | undefined;
    errors: ErrorWithCodeOfSdTaskError[];
}

export class SdTaskCheckoutViewModel implements ISdTaskCheckoutViewModel {
    taskId!: number;
    originalFileUrl!: string | undefined;
    displayName!: string;
    sequentialByWorkspaceId!: number | undefined;
    totalPages!: number;
    workspaceConfig!: SdWorkspaceCustomConfigModel;
    batchId!: number | undefined;
    batchName!: string | undefined;
    offsetStart!: number | undefined;
    offsetEnd!: number | undefined;
    avgConfidence!: number | undefined;
    smallestConfidence!: number | undefined;
    status!: SdTaskStatus | undefined;
    fromHistory!: boolean | undefined;
    useHigherQuality!: boolean;
    hasBeenEdited!: boolean;

    constructor(data?: ISdTaskCheckoutViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.originalFileUrl = _data["originalFileUrl"];
            this.displayName = _data["displayName"];
            this.sequentialByWorkspaceId = _data["sequentialByWorkspaceId"];
            this.totalPages = _data["totalPages"];
            this.workspaceConfig = _data["workspaceConfig"] ? SdWorkspaceCustomConfigModel.fromJS(_data["workspaceConfig"]) : <any>undefined;
            this.batchId = _data["batchId"];
            this.batchName = _data["batchName"];
            this.offsetStart = _data["offsetStart"];
            this.offsetEnd = _data["offsetEnd"];
            this.avgConfidence = _data["avgConfidence"];
            this.smallestConfidence = _data["smallestConfidence"];
            this.status = _data["status"];
            this.fromHistory = _data["fromHistory"];
            this.useHigherQuality = _data["useHigherQuality"];
            this.hasBeenEdited = _data["hasBeenEdited"];
        }
    }

    static fromJS(data: any): SdTaskCheckoutViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdTaskCheckoutViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["originalFileUrl"] = this.originalFileUrl;
        data["displayName"] = this.displayName;
        data["sequentialByWorkspaceId"] = this.sequentialByWorkspaceId;
        data["totalPages"] = this.totalPages;
        data["workspaceConfig"] = this.workspaceConfig ? this.workspaceConfig.toJSON() : <any>undefined;
        data["batchId"] = this.batchId;
        data["batchName"] = this.batchName;
        data["offsetStart"] = this.offsetStart;
        data["offsetEnd"] = this.offsetEnd;
        data["avgConfidence"] = this.avgConfidence;
        data["smallestConfidence"] = this.smallestConfidence;
        data["status"] = this.status;
        data["fromHistory"] = this.fromHistory;
        data["useHigherQuality"] = this.useHigherQuality;
        data["hasBeenEdited"] = this.hasBeenEdited;
        return data;
    }
}

export interface ISdTaskCheckoutViewModel {
    taskId: number;
    originalFileUrl: string | undefined;
    displayName: string;
    sequentialByWorkspaceId: number | undefined;
    totalPages: number;
    workspaceConfig: SdWorkspaceCustomConfigModel;
    batchId: number | undefined;
    batchName: string | undefined;
    offsetStart: number | undefined;
    offsetEnd: number | undefined;
    avgConfidence: number | undefined;
    smallestConfidence: number | undefined;
    status: SdTaskStatus | undefined;
    fromHistory: boolean | undefined;
    useHigherQuality: boolean;
    hasBeenEdited: boolean;
}

export class SdTaskCheckoutModel implements ISdTaskCheckoutModel {
    externalId!: string | undefined;
    taskId!: number | undefined;

    constructor(data?: ISdTaskCheckoutModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.taskId = _data["taskId"];
        }
    }

    static fromJS(data: any): SdTaskCheckoutModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdTaskCheckoutModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["taskId"] = this.taskId;
        return data;
    }
}

export interface ISdTaskCheckoutModel {
    externalId: string | undefined;
    taskId: number | undefined;
}

export class ResultWithCodeOfBooleanAndSdTaskError implements IResultWithCodeOfBooleanAndSdTaskError {
    succeeded!: boolean;
    result!: boolean;
    errors!: ErrorWithCodeOfSdTaskError[];

    constructor(data?: IResultWithCodeOfBooleanAndSdTaskError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.result = _data["result"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorWithCodeOfSdTaskError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultWithCodeOfBooleanAndSdTaskError {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithCodeOfBooleanAndSdTaskError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["result"] = this.result;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResultWithCodeOfBooleanAndSdTaskError {
    succeeded: boolean;
    result: boolean;
    errors: ErrorWithCodeOfSdTaskError[];
}

export class WorkspaceFieldAssistantStateModel implements IWorkspaceFieldAssistantStateModel {
    isEnabled!: boolean;
    document!: FieldAssistantDocumentModel | undefined;
    pages!: FieldAssistantOcrPageModel[] | undefined;

    constructor(data?: IWorkspaceFieldAssistantStateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            this.document = _data["document"] ? FieldAssistantDocumentModel.fromJS(_data["document"]) : <any>undefined;
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(FieldAssistantOcrPageModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkspaceFieldAssistantStateModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkspaceFieldAssistantStateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWorkspaceFieldAssistantStateModel {
    isEnabled: boolean;
    document: FieldAssistantDocumentModel | undefined;
    pages: FieldAssistantOcrPageModel[] | undefined;
}

export class FieldAssistantDocumentModel implements IFieldAssistantDocumentModel {
    fileName!: string;
    contentType!: string;
    readUrl!: string;
    ocrStatus!: string;

    constructor(data?: IFieldAssistantDocumentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
            this.readUrl = _data["readUrl"];
            this.ocrStatus = _data["ocrStatus"];
        }
    }

    static fromJS(data: any): FieldAssistantDocumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new FieldAssistantDocumentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["readUrl"] = this.readUrl;
        data["ocrStatus"] = this.ocrStatus;
        return data;
    }
}

export interface IFieldAssistantDocumentModel {
    fileName: string;
    contentType: string;
    readUrl: string;
    ocrStatus: string;
}

export class FieldAssistantOcrPageModel implements IFieldAssistantOcrPageModel {
    pageNumber!: number;
    width!: number;
    height!: number;
    words!: FieldAssistantOcrWordModel[];

    constructor(data?: IFieldAssistantOcrPageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.width = _data["width"];
            this.height = _data["height"];
            if (Array.isArray(_data["words"])) {
                this.words = [] as any;
                for (let item of _data["words"])
                    this.words!.push(FieldAssistantOcrWordModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FieldAssistantOcrPageModel {
        data = typeof data === 'object' ? data : {};
        let result = new FieldAssistantOcrPageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["width"] = this.width;
        data["height"] = this.height;
        if (Array.isArray(this.words)) {
            data["words"] = [];
            for (let item of this.words)
                data["words"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFieldAssistantOcrPageModel {
    pageNumber: number;
    width: number;
    height: number;
    words: FieldAssistantOcrWordModel[];
}

export class FieldAssistantOcrWordModel implements IFieldAssistantOcrWordModel {
    id!: string;
    text!: string;
    polygon!: FieldAssistantPointModel[];

    constructor(data?: IFieldAssistantOcrWordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            if (Array.isArray(_data["polygon"])) {
                this.polygon = [] as any;
                for (let item of _data["polygon"])
                    this.polygon!.push(FieldAssistantPointModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FieldAssistantOcrWordModel {
        data = typeof data === 'object' ? data : {};
        let result = new FieldAssistantOcrWordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        if (Array.isArray(this.polygon)) {
            data["polygon"] = [];
            for (let item of this.polygon)
                data["polygon"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFieldAssistantOcrWordModel {
    id: string;
    text: string;
    polygon: FieldAssistantPointModel[];
}

export class FieldAssistantPointModel implements IFieldAssistantPointModel {
    x!: number;
    y!: number;

    constructor(data?: IFieldAssistantPointModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"];
            this.y = _data["y"];
        }
    }

    static fromJS(data: any): FieldAssistantPointModel {
        data = typeof data === 'object' ? data : {};
        let result = new FieldAssistantPointModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        return data;
    }
}

export interface IFieldAssistantPointModel {
    x: number;
    y: number;
}

export class GenerateFieldDescriptionResponse implements IGenerateFieldDescriptionResponse {
    description!: string;

    constructor(data?: IGenerateFieldDescriptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): GenerateFieldDescriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateFieldDescriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        return data;
    }
}

export interface IGenerateFieldDescriptionResponse {
    description: string;
}

export class GenerateFieldDescriptionRequest implements IGenerateFieldDescriptionRequest {
    targetField!: FieldAssistantPromptFieldModel;
    selectedText!: string | undefined;
    additionalContext!: string | undefined;
    analyzerDescription!: string | undefined;

    constructor(data?: IGenerateFieldDescriptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetField = _data["targetField"] ? FieldAssistantPromptFieldModel.fromJS(_data["targetField"]) : <any>undefined;
            this.selectedText = _data["selectedText"];
            this.additionalContext = _data["additionalContext"];
            this.analyzerDescription = _data["analyzerDescription"];
        }
    }

    static fromJS(data: any): GenerateFieldDescriptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateFieldDescriptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetField"] = this.targetField ? this.targetField.toJSON() : <any>undefined;
        data["selectedText"] = this.selectedText;
        data["additionalContext"] = this.additionalContext;
        data["analyzerDescription"] = this.analyzerDescription;
        return data;
    }
}

export interface IGenerateFieldDescriptionRequest {
    targetField: FieldAssistantPromptFieldModel;
    selectedText: string | undefined;
    additionalContext: string | undefined;
    analyzerDescription: string | undefined;
}

export class FieldAssistantPromptFieldModel implements IFieldAssistantPromptFieldModel {
    categoryKey!: string;
    displayName!: string | undefined;
    type!: string | undefined;
    description!: string | undefined;
    generationMethod!: string | undefined;
    parentCategoryKey!: string | undefined;
    isRequired!: boolean | undefined;
    placeholder!: string | undefined;
    validationLabel!: string | undefined;
    selectOptions!: string[] | undefined;

    constructor(data?: IFieldAssistantPromptFieldModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryKey = _data["categoryKey"];
            this.displayName = _data["displayName"];
            this.type = _data["type"];
            this.description = _data["description"];
            this.generationMethod = _data["generationMethod"];
            this.parentCategoryKey = _data["parentCategoryKey"];
            this.isRequired = _data["isRequired"];
            this.placeholder = _data["placeholder"];
            this.validationLabel = _data["validationLabel"];
            if (Array.isArray(_data["selectOptions"])) {
                this.selectOptions = [] as any;
                for (let item of _data["selectOptions"])
                    this.selectOptions!.push(item);
            }
        }
    }

    static fromJS(data: any): FieldAssistantPromptFieldModel {
        data = typeof data === 'object' ? data : {};
        let result = new FieldAssistantPromptFieldModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryKey"] = this.categoryKey;
        data["displayName"] = this.displayName;
        data["type"] = this.type;
        data["description"] = this.description;
        data["generationMethod"] = this.generationMethod;
        data["parentCategoryKey"] = this.parentCategoryKey;
        data["isRequired"] = this.isRequired;
        data["placeholder"] = this.placeholder;
        data["validationLabel"] = this.validationLabel;
        if (Array.isArray(this.selectOptions)) {
            data["selectOptions"] = [];
            for (let item of this.selectOptions)
                data["selectOptions"].push(item);
        }
        return data;
    }
}

export interface IFieldAssistantPromptFieldModel {
    categoryKey: string;
    displayName: string | undefined;
    type: string | undefined;
    description: string | undefined;
    generationMethod: string | undefined;
    parentCategoryKey: string | undefined;
    isRequired: boolean | undefined;
    placeholder: string | undefined;
    validationLabel: string | undefined;
    selectOptions: string[] | undefined;
}

export class FieldAssistantTestResponse implements IFieldAssistantTestResponse {
    fields!: FieldAssistantExtractedFieldModel[];
    tables!: FieldAssistantExtractedTableModel[];
    pages!: FieldAssistantPageModel[];

    constructor(data?: IFieldAssistantTestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(FieldAssistantExtractedFieldModel.fromJS(item));
            }
            if (Array.isArray(_data["tables"])) {
                this.tables = [] as any;
                for (let item of _data["tables"])
                    this.tables!.push(FieldAssistantExtractedTableModel.fromJS(item));
            }
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(FieldAssistantPageModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FieldAssistantTestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FieldAssistantTestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        if (Array.isArray(this.tables)) {
            data["tables"] = [];
            for (let item of this.tables)
                data["tables"].push(item.toJSON());
        }
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFieldAssistantTestResponse {
    fields: FieldAssistantExtractedFieldModel[];
    tables: FieldAssistantExtractedTableModel[];
    pages: FieldAssistantPageModel[];
}

export class FieldAssistantExtractedFieldModel implements IFieldAssistantExtractedFieldModel {
    name!: string;
    type!: string | undefined;
    value!: string | undefined;
    confidence!: number | undefined;
    boundingRegions!: FieldAssistantBoundingRegionModel[];

    constructor(data?: IFieldAssistantExtractedFieldModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            this.value = _data["value"];
            this.confidence = _data["confidence"];
            if (Array.isArray(_data["boundingRegions"])) {
                this.boundingRegions = [] as any;
                for (let item of _data["boundingRegions"])
                    this.boundingRegions!.push(FieldAssistantBoundingRegionModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FieldAssistantExtractedFieldModel {
        data = typeof data === 'object' ? data : {};
        let result = new FieldAssistantExtractedFieldModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        data["value"] = this.value;
        data["confidence"] = this.confidence;
        if (Array.isArray(this.boundingRegions)) {
            data["boundingRegions"] = [];
            for (let item of this.boundingRegions)
                data["boundingRegions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFieldAssistantExtractedFieldModel {
    name: string;
    type: string | undefined;
    value: string | undefined;
    confidence: number | undefined;
    boundingRegions: FieldAssistantBoundingRegionModel[];
}

export class FieldAssistantBoundingRegionModel implements IFieldAssistantBoundingRegionModel {
    pageNumber!: number;
    polygon!: FieldAssistantPointModel[];

    constructor(data?: IFieldAssistantBoundingRegionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            if (Array.isArray(_data["polygon"])) {
                this.polygon = [] as any;
                for (let item of _data["polygon"])
                    this.polygon!.push(FieldAssistantPointModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FieldAssistantBoundingRegionModel {
        data = typeof data === 'object' ? data : {};
        let result = new FieldAssistantBoundingRegionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        if (Array.isArray(this.polygon)) {
            data["polygon"] = [];
            for (let item of this.polygon)
                data["polygon"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFieldAssistantBoundingRegionModel {
    pageNumber: number;
    polygon: FieldAssistantPointModel[];
}

export class FieldAssistantExtractedTableModel implements IFieldAssistantExtractedTableModel {
    name!: string;
    columns!: string[];
    rows!: { [key: string]: FieldAssistantExtractedTableCellModel; }[];
    confidence!: number | undefined;

    constructor(data?: IFieldAssistantExtractedTableModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(item);
            }
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(item);
            }
            this.confidence = _data["confidence"];
        }
    }

    static fromJS(data: any): FieldAssistantExtractedTableModel {
        data = typeof data === 'object' ? data : {};
        let result = new FieldAssistantExtractedTableModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item);
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item);
        }
        data["confidence"] = this.confidence;
        return data;
    }
}

export interface IFieldAssistantExtractedTableModel {
    name: string;
    columns: string[];
    rows: { [key: string]: FieldAssistantExtractedTableCellModel; }[];
    confidence: number | undefined;
}

export class FieldAssistantExtractedTableCellModel implements IFieldAssistantExtractedTableCellModel {
    value!: string | undefined;
    confidence!: number | undefined;

    constructor(data?: IFieldAssistantExtractedTableCellModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.confidence = _data["confidence"];
        }
    }

    static fromJS(data: any): FieldAssistantExtractedTableCellModel {
        data = typeof data === 'object' ? data : {};
        let result = new FieldAssistantExtractedTableCellModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["confidence"] = this.confidence;
        return data;
    }
}

export interface IFieldAssistantExtractedTableCellModel {
    value: string | undefined;
    confidence: number | undefined;
}

export class FieldAssistantPageModel implements IFieldAssistantPageModel {
    pageNumber!: number;
    width!: number;
    height!: number;

    constructor(data?: IFieldAssistantPageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.width = _data["width"];
            this.height = _data["height"];
        }
    }

    static fromJS(data: any): FieldAssistantPageModel {
        data = typeof data === 'object' ? data : {};
        let result = new FieldAssistantPageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["width"] = this.width;
        data["height"] = this.height;
        return data;
    }
}

export interface IFieldAssistantPageModel {
    pageNumber: number;
    width: number;
    height: number;
}

export class ScheduleIndexPayload implements IScheduleIndexPayload {
    taskId!: number;
    workspaceId!: number;
    tenantId!: number;
    indexId!: string;
    indexServiceName!: string;
    expiresOn!: Date;

    constructor(data?: IScheduleIndexPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.workspaceId = _data["workspaceId"];
            this.tenantId = _data["tenantId"];
            this.indexId = _data["indexId"];
            this.indexServiceName = _data["indexServiceName"];
            this.expiresOn = _data["expiresOn"] ? new Date(_data["expiresOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ScheduleIndexPayload {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleIndexPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["workspaceId"] = this.workspaceId;
        data["tenantId"] = this.tenantId;
        data["indexId"] = this.indexId;
        data["indexServiceName"] = this.indexServiceName;
        data["expiresOn"] = this.expiresOn ? this.expiresOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IScheduleIndexPayload {
    taskId: number;
    workspaceId: number;
    tenantId: number;
    indexId: string;
    indexServiceName: string;
    expiresOn: Date;
}

export class SetSdTaskResultStoragePropsModel implements ISetSdTaskResultStoragePropsModel {
    resultBlobFileName!: string | undefined;
    resultSharepointServiceName!: string | undefined;
    resultSharepointId!: string | undefined;
    resultSharepointDriveId!: string | undefined;

    constructor(data?: ISetSdTaskResultStoragePropsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultBlobFileName = _data["resultBlobFileName"];
            this.resultSharepointServiceName = _data["resultSharepointServiceName"];
            this.resultSharepointId = _data["resultSharepointId"];
            this.resultSharepointDriveId = _data["resultSharepointDriveId"];
        }
    }

    static fromJS(data: any): SetSdTaskResultStoragePropsModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetSdTaskResultStoragePropsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultBlobFileName"] = this.resultBlobFileName;
        data["resultSharepointServiceName"] = this.resultSharepointServiceName;
        data["resultSharepointId"] = this.resultSharepointId;
        data["resultSharepointDriveId"] = this.resultSharepointDriveId;
        return data;
    }
}

export interface ISetSdTaskResultStoragePropsModel {
    resultBlobFileName: string | undefined;
    resultSharepointServiceName: string | undefined;
    resultSharepointId: string | undefined;
    resultSharepointDriveId: string | undefined;
}

export class BuildProxiedUrlModel implements IBuildProxiedUrlModel {
    storageAccountName!: string;
    containerName!: string;
    blobSasUrl!: string;

    constructor(data?: IBuildProxiedUrlModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storageAccountName = _data["storageAccountName"];
            this.containerName = _data["containerName"];
            this.blobSasUrl = _data["blobSasUrl"];
        }
    }

    static fromJS(data: any): BuildProxiedUrlModel {
        data = typeof data === 'object' ? data : {};
        let result = new BuildProxiedUrlModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storageAccountName"] = this.storageAccountName;
        data["containerName"] = this.containerName;
        data["blobSasUrl"] = this.blobSasUrl;
        return data;
    }
}

export interface IBuildProxiedUrlModel {
    storageAccountName: string;
    containerName: string;
    blobSasUrl: string;
}

export class IndexInfoViewModel implements IIndexInfoViewModel {
    taskId!: number;
    workspaceId!: number;
    tenantId!: number;
    indexId!: string | undefined;
    indexServiceName!: string | undefined;
    indexStatus!: IndexStatus | undefined;
    lastIndexedOn!: Date | undefined;
    scheduleIndexSequenceId!: number | undefined;

    constructor(data?: IIndexInfoViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.workspaceId = _data["workspaceId"];
            this.tenantId = _data["tenantId"];
            this.indexId = _data["indexId"];
            this.indexServiceName = _data["indexServiceName"];
            this.indexStatus = _data["indexStatus"];
            this.lastIndexedOn = _data["lastIndexedOn"] ? new Date(_data["lastIndexedOn"].toString()) : <any>undefined;
            this.scheduleIndexSequenceId = _data["scheduleIndexSequenceId"];
        }
    }

    static fromJS(data: any): IndexInfoViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new IndexInfoViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["workspaceId"] = this.workspaceId;
        data["tenantId"] = this.tenantId;
        data["indexId"] = this.indexId;
        data["indexServiceName"] = this.indexServiceName;
        data["indexStatus"] = this.indexStatus;
        data["lastIndexedOn"] = this.lastIndexedOn ? this.lastIndexedOn.toISOString() : <any>undefined;
        data["scheduleIndexSequenceId"] = this.scheduleIndexSequenceId;
        return data;
    }
}

export interface IIndexInfoViewModel {
    taskId: number;
    workspaceId: number;
    tenantId: number;
    indexId: string | undefined;
    indexServiceName: string | undefined;
    indexStatus: IndexStatus | undefined;
    lastIndexedOn: Date | undefined;
    scheduleIndexSequenceId: number | undefined;
}

export class UpdateIndexInfoModel implements IUpdateIndexInfoModel {
    indexId!: string;
    indexServiceName!: string;
    indexStatus!: IndexStatus;
    logMessage!: string;

    constructor(data?: IUpdateIndexInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.indexId = _data["indexId"];
            this.indexServiceName = _data["indexServiceName"];
            this.indexStatus = _data["indexStatus"];
            this.logMessage = _data["logMessage"];
        }
    }

    static fromJS(data: any): UpdateIndexInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIndexInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["indexId"] = this.indexId;
        data["indexServiceName"] = this.indexServiceName;
        data["indexStatus"] = this.indexStatus;
        data["logMessage"] = this.logMessage;
        return data;
    }
}

export interface IUpdateIndexInfoModel {
    indexId: string;
    indexServiceName: string;
    indexStatus: IndexStatus;
    logMessage: string;
}

export class AvailableLoadBalancedService implements IAvailableLoadBalancedService {
    serviceName!: string;
    serviceType!: LoadBalancedServiceType;
    capabilities!: string[];
    metricName!: string;
    metricValue!: number;
    tenantId!: number;

    constructor(data?: IAvailableLoadBalancedService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceName = _data["serviceName"];
            this.serviceType = _data["serviceType"];
            if (Array.isArray(_data["capabilities"])) {
                this.capabilities = [] as any;
                for (let item of _data["capabilities"])
                    this.capabilities!.push(item);
            }
            this.metricName = _data["metricName"];
            this.metricValue = _data["metricValue"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): AvailableLoadBalancedService {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableLoadBalancedService();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceName"] = this.serviceName;
        data["serviceType"] = this.serviceType;
        if (Array.isArray(this.capabilities)) {
            data["capabilities"] = [];
            for (let item of this.capabilities)
                data["capabilities"].push(item);
        }
        data["metricName"] = this.metricName;
        data["metricValue"] = this.metricValue;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IAvailableLoadBalancedService {
    serviceName: string;
    serviceType: LoadBalancedServiceType;
    capabilities: string[];
    metricName: string;
    metricValue: number;
    tenantId: number;
}

export class UpdateLoadBalancedServiceMetricRequest implements IUpdateLoadBalancedServiceMetricRequest {
    serviceName!: string;
    metricName!: string;
    metricValue!: number;

    constructor(data?: IUpdateLoadBalancedServiceMetricRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceName = _data["serviceName"];
            this.metricName = _data["metricName"];
            this.metricValue = _data["metricValue"];
        }
    }

    static fromJS(data: any): UpdateLoadBalancedServiceMetricRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLoadBalancedServiceMetricRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceName"] = this.serviceName;
        data["metricName"] = this.metricName;
        data["metricValue"] = this.metricValue;
        return data;
    }
}

export interface IUpdateLoadBalancedServiceMetricRequest {
    serviceName: string;
    metricName: string;
    metricValue: number;
}

export class StructuredExportModel implements IStructuredExportModel {
    taskId!: number;
    originalFileUrl!: string | undefined;
    workspaceId!: number;
    batchId!: number | undefined;
    taskNumber!: number | undefined;
    externalId!: string | undefined;
    displayName!: string;
    description!: string | undefined;
    totalPages!: number;
    lastCheckoutByUserName!: string | undefined;
    lastCheckedOutBy!: number | undefined;
    lastCheckedOutUntil!: Date | undefined;
    chunks!: DocumentExportModel[];
    lastIntegratedBy!: number | undefined;
    lastIntegratedByUserName!: string;
    lastIntegratedOn!: Date | undefined;
    averageConfidence!: number;
    metadata!: { [key: string]: string; };

    constructor(data?: IStructuredExportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.originalFileUrl = _data["originalFileUrl"];
            this.workspaceId = _data["workspaceId"];
            this.batchId = _data["batchId"];
            this.taskNumber = _data["taskNumber"];
            this.externalId = _data["externalId"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.totalPages = _data["totalPages"];
            this.lastCheckoutByUserName = _data["lastCheckoutByUserName"];
            this.lastCheckedOutBy = _data["lastCheckedOutBy"];
            this.lastCheckedOutUntil = _data["lastCheckedOutUntil"] ? new Date(_data["lastCheckedOutUntil"].toString()) : <any>undefined;
            if (Array.isArray(_data["chunks"])) {
                this.chunks = [] as any;
                for (let item of _data["chunks"])
                    this.chunks!.push(DocumentExportModel.fromJS(item));
            }
            this.lastIntegratedBy = _data["lastIntegratedBy"];
            this.lastIntegratedByUserName = _data["lastIntegratedByUserName"];
            this.lastIntegratedOn = _data["lastIntegratedOn"] ? new Date(_data["lastIntegratedOn"].toString()) : <any>undefined;
            this.averageConfidence = _data["averageConfidence"];
            if (_data["metadata"]) {
                this.metadata = {} as any;
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        (<any>this.metadata)![key] = _data["metadata"][key];
                }
            }
        }
    }

    static fromJS(data: any): StructuredExportModel {
        data = typeof data === 'object' ? data : {};
        let result = new StructuredExportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["originalFileUrl"] = this.originalFileUrl;
        data["workspaceId"] = this.workspaceId;
        data["batchId"] = this.batchId;
        data["taskNumber"] = this.taskNumber;
        data["externalId"] = this.externalId;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["totalPages"] = this.totalPages;
        data["lastCheckoutByUserName"] = this.lastCheckoutByUserName;
        data["lastCheckedOutBy"] = this.lastCheckedOutBy;
        data["lastCheckedOutUntil"] = this.lastCheckedOutUntil ? this.lastCheckedOutUntil.toISOString() : <any>undefined;
        if (Array.isArray(this.chunks)) {
            data["chunks"] = [];
            for (let item of this.chunks)
                data["chunks"].push(item.toJSON());
        }
        data["lastIntegratedBy"] = this.lastIntegratedBy;
        data["lastIntegratedByUserName"] = this.lastIntegratedByUserName;
        data["lastIntegratedOn"] = this.lastIntegratedOn ? this.lastIntegratedOn.toISOString() : <any>undefined;
        data["averageConfidence"] = this.averageConfidence;
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (<any>data["metadata"])[key] = (<any>this.metadata)[key];
            }
        }
        return data;
    }
}

export interface IStructuredExportModel {
    taskId: number;
    originalFileUrl: string | undefined;
    workspaceId: number;
    batchId: number | undefined;
    taskNumber: number | undefined;
    externalId: string | undefined;
    displayName: string;
    description: string | undefined;
    totalPages: number;
    lastCheckoutByUserName: string | undefined;
    lastCheckedOutBy: number | undefined;
    lastCheckedOutUntil: Date | undefined;
    chunks: DocumentExportModel[];
    lastIntegratedBy: number | undefined;
    lastIntegratedByUserName: string;
    lastIntegratedOn: Date | undefined;
    averageConfidence: number;
    metadata: { [key: string]: string; };
}

export class SimplifiedStructuredExportModel implements ISimplifiedStructuredExportModel {
    taskId!: number;
    originalFileUrl!: string | undefined;
    taskNumber!: number | undefined;
    workspaceId!: number;
    batchId!: number | undefined;
    externalId!: string | undefined;
    displayName!: string;
    description!: string | undefined;
    totalPages!: number;
    lastCheckoutByUserName!: string | undefined;
    lastCheckedOutBy!: number | undefined;
    lastCheckedOutUntil!: Date | undefined;
    pages!: SimplifiedDocumentExportModel[];
    lastIntegratedBy!: number | undefined;
    lastIntegratedByUserName!: string;
    lastIntegratedOn!: Date | undefined;
    metadata!: { [key: string]: string; };
    averageConfidence!: number;

    constructor(data?: ISimplifiedStructuredExportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.originalFileUrl = _data["originalFileUrl"];
            this.taskNumber = _data["taskNumber"];
            this.workspaceId = _data["workspaceId"];
            this.batchId = _data["batchId"];
            this.externalId = _data["externalId"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.totalPages = _data["totalPages"];
            this.lastCheckoutByUserName = _data["lastCheckoutByUserName"];
            this.lastCheckedOutBy = _data["lastCheckedOutBy"];
            this.lastCheckedOutUntil = _data["lastCheckedOutUntil"] ? new Date(_data["lastCheckedOutUntil"].toString()) : <any>undefined;
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(SimplifiedDocumentExportModel.fromJS(item));
            }
            this.lastIntegratedBy = _data["lastIntegratedBy"];
            this.lastIntegratedByUserName = _data["lastIntegratedByUserName"];
            this.lastIntegratedOn = _data["lastIntegratedOn"] ? new Date(_data["lastIntegratedOn"].toString()) : <any>undefined;
            if (_data["metadata"]) {
                this.metadata = {} as any;
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        (<any>this.metadata)![key] = _data["metadata"][key];
                }
            }
            this.averageConfidence = _data["averageConfidence"];
        }
    }

    static fromJS(data: any): SimplifiedStructuredExportModel {
        data = typeof data === 'object' ? data : {};
        let result = new SimplifiedStructuredExportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["originalFileUrl"] = this.originalFileUrl;
        data["taskNumber"] = this.taskNumber;
        data["workspaceId"] = this.workspaceId;
        data["batchId"] = this.batchId;
        data["externalId"] = this.externalId;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["totalPages"] = this.totalPages;
        data["lastCheckoutByUserName"] = this.lastCheckoutByUserName;
        data["lastCheckedOutBy"] = this.lastCheckedOutBy;
        data["lastCheckedOutUntil"] = this.lastCheckedOutUntil ? this.lastCheckedOutUntil.toISOString() : <any>undefined;
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item.toJSON());
        }
        data["lastIntegratedBy"] = this.lastIntegratedBy;
        data["lastIntegratedByUserName"] = this.lastIntegratedByUserName;
        data["lastIntegratedOn"] = this.lastIntegratedOn ? this.lastIntegratedOn.toISOString() : <any>undefined;
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (<any>data["metadata"])[key] = (<any>this.metadata)[key];
            }
        }
        data["averageConfidence"] = this.averageConfidence;
        return data;
    }
}

export interface ISimplifiedStructuredExportModel {
    taskId: number;
    originalFileUrl: string | undefined;
    taskNumber: number | undefined;
    workspaceId: number;
    batchId: number | undefined;
    externalId: string | undefined;
    displayName: string;
    description: string | undefined;
    totalPages: number;
    lastCheckoutByUserName: string | undefined;
    lastCheckedOutBy: number | undefined;
    lastCheckedOutUntil: Date | undefined;
    pages: SimplifiedDocumentExportModel[];
    lastIntegratedBy: number | undefined;
    lastIntegratedByUserName: string;
    lastIntegratedOn: Date | undefined;
    metadata: { [key: string]: string; };
    averageConfidence: number;
}

export class SimplifiedDocumentExportModel implements ISimplifiedDocumentExportModel {
    entities!: SimplifiedDocumentEntityExportModel[];
    averageConfidence!: number;

    constructor(data?: ISimplifiedDocumentExportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(SimplifiedDocumentEntityExportModel.fromJS(item));
            }
            this.averageConfidence = _data["averageConfidence"];
        }
    }

    static fromJS(data: any): SimplifiedDocumentExportModel {
        data = typeof data === 'object' ? data : {};
        let result = new SimplifiedDocumentExportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        data["averageConfidence"] = this.averageConfidence;
        return data;
    }
}

export interface ISimplifiedDocumentExportModel {
    entities: SimplifiedDocumentEntityExportModel[];
    averageConfidence: number;
}

export class SimplifiedDocumentEntityExportModel implements ISimplifiedDocumentEntityExportModel {
    confidence!: number;
    category!: string;
    content!: string;
    pageNumber!: number;
    table!: SimplifiedDocumentTableModel | undefined;
    qrCode!: SimplifiedDocumentQrCodeModel | undefined;

    constructor(data?: ISimplifiedDocumentEntityExportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.confidence = _data["confidence"];
            this.category = _data["category"];
            this.content = _data["content"];
            this.pageNumber = _data["pageNumber"];
            this.table = _data["table"] ? SimplifiedDocumentTableModel.fromJS(_data["table"]) : <any>undefined;
            this.qrCode = _data["qrCode"] ? SimplifiedDocumentQrCodeModel.fromJS(_data["qrCode"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SimplifiedDocumentEntityExportModel {
        data = typeof data === 'object' ? data : {};
        let result = new SimplifiedDocumentEntityExportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["confidence"] = this.confidence;
        data["category"] = this.category;
        data["content"] = this.content;
        data["pageNumber"] = this.pageNumber;
        data["table"] = this.table ? this.table.toJSON() : <any>undefined;
        data["qrCode"] = this.qrCode ? this.qrCode.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISimplifiedDocumentEntityExportModel {
    confidence: number;
    category: string;
    content: string;
    pageNumber: number;
    table: SimplifiedDocumentTableModel | undefined;
    qrCode: SimplifiedDocumentQrCodeModel | undefined;
}

export class SimplifiedDocumentTableModel implements ISimplifiedDocumentTableModel {
    rowCount!: number;
    columnCount!: number;
    tableHeaders!: SimplifiedDocumentTableHeaderModel[];
    tableRows!: { [key: string]: SimplifiedDocumentTableCellModel[]; };
    tableRowsTableContent!: { [key: string]: string; } | undefined;

    constructor(data?: ISimplifiedDocumentTableModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowCount = _data["rowCount"];
            this.columnCount = _data["columnCount"];
            if (Array.isArray(_data["tableHeaders"])) {
                this.tableHeaders = [] as any;
                for (let item of _data["tableHeaders"])
                    this.tableHeaders!.push(SimplifiedDocumentTableHeaderModel.fromJS(item));
            }
            if (_data["tableRows"]) {
                this.tableRows = {} as any;
                for (let key in _data["tableRows"]) {
                    if (_data["tableRows"].hasOwnProperty(key))
                        (<any>this.tableRows)![key] = _data["tableRows"][key] ? _data["tableRows"][key].map((i: any) => SimplifiedDocumentTableCellModel.fromJS(i)) : [];
                }
            }
            if (_data["tableRowsTableContent"]) {
                this.tableRowsTableContent = {} as any;
                for (let key in _data["tableRowsTableContent"]) {
                    if (_data["tableRowsTableContent"].hasOwnProperty(key))
                        (<any>this.tableRowsTableContent)![key] = _data["tableRowsTableContent"][key];
                }
            }
        }
    }

    static fromJS(data: any): SimplifiedDocumentTableModel {
        data = typeof data === 'object' ? data : {};
        let result = new SimplifiedDocumentTableModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowCount"] = this.rowCount;
        data["columnCount"] = this.columnCount;
        if (Array.isArray(this.tableHeaders)) {
            data["tableHeaders"] = [];
            for (let item of this.tableHeaders)
                data["tableHeaders"].push(item.toJSON());
        }
        if (this.tableRows) {
            data["tableRows"] = {};
            for (let key in this.tableRows) {
                if (this.tableRows.hasOwnProperty(key))
                    (<any>data["tableRows"])[key] = (<any>this.tableRows)[key];
            }
        }
        if (this.tableRowsTableContent) {
            data["tableRowsTableContent"] = {};
            for (let key in this.tableRowsTableContent) {
                if (this.tableRowsTableContent.hasOwnProperty(key))
                    (<any>data["tableRowsTableContent"])[key] = (<any>this.tableRowsTableContent)[key];
            }
        }
        return data;
    }
}

export interface ISimplifiedDocumentTableModel {
    rowCount: number;
    columnCount: number;
    tableHeaders: SimplifiedDocumentTableHeaderModel[];
    tableRows: { [key: string]: SimplifiedDocumentTableCellModel[]; };
    tableRowsTableContent: { [key: string]: string; } | undefined;
}

export class SimplifiedDocumentTableHeaderModel implements ISimplifiedDocumentTableHeaderModel {
    columnIndex!: number;
    category!: string;
    confidence!: number;

    constructor(data?: ISimplifiedDocumentTableHeaderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.columnIndex = _data["columnIndex"];
            this.category = _data["category"];
            this.confidence = _data["confidence"];
        }
    }

    static fromJS(data: any): SimplifiedDocumentTableHeaderModel {
        data = typeof data === 'object' ? data : {};
        let result = new SimplifiedDocumentTableHeaderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["columnIndex"] = this.columnIndex;
        data["category"] = this.category;
        data["confidence"] = this.confidence;
        return data;
    }
}

export interface ISimplifiedDocumentTableHeaderModel {
    columnIndex: number;
    category: string;
    confidence: number;
}

export class SimplifiedDocumentTableCellModel implements ISimplifiedDocumentTableCellModel {
    rowIndex!: number;
    columnIndex!: number;
    content!: string;
    confidence!: number;

    constructor(data?: ISimplifiedDocumentTableCellModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowIndex = _data["rowIndex"];
            this.columnIndex = _data["columnIndex"];
            this.content = _data["content"];
            this.confidence = _data["confidence"];
        }
    }

    static fromJS(data: any): SimplifiedDocumentTableCellModel {
        data = typeof data === 'object' ? data : {};
        let result = new SimplifiedDocumentTableCellModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowIndex"] = this.rowIndex;
        data["columnIndex"] = this.columnIndex;
        data["content"] = this.content;
        data["confidence"] = this.confidence;
        return data;
    }
}

export interface ISimplifiedDocumentTableCellModel {
    rowIndex: number;
    columnIndex: number;
    content: string;
    confidence: number;
}

export class SimplifiedDocumentQrCodeModel implements ISimplifiedDocumentQrCodeModel {
    keyValues!: SimplifiedDocumentKeyValueModel[] | undefined;
    qrCodeContent!: string | undefined;

    constructor(data?: ISimplifiedDocumentQrCodeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["keyValues"])) {
                this.keyValues = [] as any;
                for (let item of _data["keyValues"])
                    this.keyValues!.push(SimplifiedDocumentKeyValueModel.fromJS(item));
            }
            this.qrCodeContent = _data["qrCodeContent"];
        }
    }

    static fromJS(data: any): SimplifiedDocumentQrCodeModel {
        data = typeof data === 'object' ? data : {};
        let result = new SimplifiedDocumentQrCodeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.keyValues)) {
            data["keyValues"] = [];
            for (let item of this.keyValues)
                data["keyValues"].push(item.toJSON());
        }
        data["qrCodeContent"] = this.qrCodeContent;
        return data;
    }
}

export interface ISimplifiedDocumentQrCodeModel {
    keyValues: SimplifiedDocumentKeyValueModel[] | undefined;
    qrCodeContent: string | undefined;
}

export class SimplifiedDocumentKeyValueModel implements ISimplifiedDocumentKeyValueModel {
    category!: string;
    confidence!: number;
    content!: string;

    constructor(data?: ISimplifiedDocumentKeyValueModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.confidence = _data["confidence"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): SimplifiedDocumentKeyValueModel {
        data = typeof data === 'object' ? data : {};
        let result = new SimplifiedDocumentKeyValueModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["confidence"] = this.confidence;
        data["content"] = this.content;
        return data;
    }
}

export interface ISimplifiedDocumentKeyValueModel {
    category: string;
    confidence: number;
    content: string;
}

export class ExportTranscriptFileToUrlPageModel extends ExportFileToUrlModel implements IExportTranscriptFileToUrlPageModel {

    constructor(data?: IExportTranscriptFileToUrlPageModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ExportTranscriptFileToUrlPageModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExportTranscriptFileToUrlPageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IExportTranscriptFileToUrlPageModel extends IExportFileToUrlModel {
}

export class StructuredTranscriptExportModel implements IStructuredTranscriptExportModel {
    taskId!: number;
    originalFileUrl!: string | undefined;
    workspaceId!: number;
    batchId!: number | undefined;
    taskNumber!: number | undefined;
    externalId!: string | undefined;
    displayName!: string;
    description!: string | undefined;
    totalTimeInSeconds!: number;
    lastCheckoutByUserName!: string | undefined;
    lastCheckedOutBy!: number | undefined;
    lastCheckedOutUntil!: Date | undefined;
    lastIntegratedBy!: number | undefined;
    lastIntegratedByUserName!: string;
    lastIntegratedOn!: Date | undefined;
    transcript!: ExportTranscriptFullViewModel;
    metadata!: { [key: string]: string; };

    constructor(data?: IStructuredTranscriptExportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.originalFileUrl = _data["originalFileUrl"];
            this.workspaceId = _data["workspaceId"];
            this.batchId = _data["batchId"];
            this.taskNumber = _data["taskNumber"];
            this.externalId = _data["externalId"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.totalTimeInSeconds = _data["totalTimeInSeconds"];
            this.lastCheckoutByUserName = _data["lastCheckoutByUserName"];
            this.lastCheckedOutBy = _data["lastCheckedOutBy"];
            this.lastCheckedOutUntil = _data["lastCheckedOutUntil"] ? new Date(_data["lastCheckedOutUntil"].toString()) : <any>undefined;
            this.lastIntegratedBy = _data["lastIntegratedBy"];
            this.lastIntegratedByUserName = _data["lastIntegratedByUserName"];
            this.lastIntegratedOn = _data["lastIntegratedOn"] ? new Date(_data["lastIntegratedOn"].toString()) : <any>undefined;
            this.transcript = _data["transcript"] ? ExportTranscriptFullViewModel.fromJS(_data["transcript"]) : <any>undefined;
            if (_data["metadata"]) {
                this.metadata = {} as any;
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        (<any>this.metadata)![key] = _data["metadata"][key];
                }
            }
        }
    }

    static fromJS(data: any): StructuredTranscriptExportModel {
        data = typeof data === 'object' ? data : {};
        let result = new StructuredTranscriptExportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["originalFileUrl"] = this.originalFileUrl;
        data["workspaceId"] = this.workspaceId;
        data["batchId"] = this.batchId;
        data["taskNumber"] = this.taskNumber;
        data["externalId"] = this.externalId;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["totalTimeInSeconds"] = this.totalTimeInSeconds;
        data["lastCheckoutByUserName"] = this.lastCheckoutByUserName;
        data["lastCheckedOutBy"] = this.lastCheckedOutBy;
        data["lastCheckedOutUntil"] = this.lastCheckedOutUntil ? this.lastCheckedOutUntil.toISOString() : <any>undefined;
        data["lastIntegratedBy"] = this.lastIntegratedBy;
        data["lastIntegratedByUserName"] = this.lastIntegratedByUserName;
        data["lastIntegratedOn"] = this.lastIntegratedOn ? this.lastIntegratedOn.toISOString() : <any>undefined;
        data["transcript"] = this.transcript ? this.transcript.toJSON() : <any>undefined;
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (<any>data["metadata"])[key] = (<any>this.metadata)[key];
            }
        }
        return data;
    }
}

export interface IStructuredTranscriptExportModel {
    taskId: number;
    originalFileUrl: string | undefined;
    workspaceId: number;
    batchId: number | undefined;
    taskNumber: number | undefined;
    externalId: string | undefined;
    displayName: string;
    description: string | undefined;
    totalTimeInSeconds: number;
    lastCheckoutByUserName: string | undefined;
    lastCheckedOutBy: number | undefined;
    lastCheckedOutUntil: Date | undefined;
    lastIntegratedBy: number | undefined;
    lastIntegratedByUserName: string;
    lastIntegratedOn: Date | undefined;
    transcript: ExportTranscriptFullViewModel;
    metadata: { [key: string]: string; };
}

export class ExportTranscriptFullViewModel implements IExportTranscriptFullViewModel {
    transcripts!: ExportTranscriptViewModel[];
    speakers!: ExportSpeaker[];
    annotations!: ExportAnnotation[];

    constructor(data?: IExportTranscriptFullViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["transcripts"])) {
                this.transcripts = [] as any;
                for (let item of _data["transcripts"])
                    this.transcripts!.push(ExportTranscriptViewModel.fromJS(item));
            }
            if (Array.isArray(_data["speakers"])) {
                this.speakers = [] as any;
                for (let item of _data["speakers"])
                    this.speakers!.push(ExportSpeaker.fromJS(item));
            }
            if (Array.isArray(_data["annotations"])) {
                this.annotations = [] as any;
                for (let item of _data["annotations"])
                    this.annotations!.push(ExportAnnotation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExportTranscriptFullViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExportTranscriptFullViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.transcripts)) {
            data["transcripts"] = [];
            for (let item of this.transcripts)
                data["transcripts"].push(item.toJSON());
        }
        if (Array.isArray(this.speakers)) {
            data["speakers"] = [];
            for (let item of this.speakers)
                data["speakers"].push(item.toJSON());
        }
        if (Array.isArray(this.annotations)) {
            data["annotations"] = [];
            for (let item of this.annotations)
                data["annotations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExportTranscriptFullViewModel {
    transcripts: ExportTranscriptViewModel[];
    speakers: ExportSpeaker[];
    annotations: ExportAnnotation[];
}

export class ExportTranscriptViewModel implements IExportTranscriptViewModel {
    speakerId!: string;
    start!: number;
    end!: number;
    duration!: number;
    confidence!: number;
    displayText!: string;
    displayWords!: ExportWord[];
    originalWords!: ExportWord[];

    constructor(data?: IExportTranscriptViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.speakerId = _data["speakerId"];
            this.start = _data["start"];
            this.end = _data["end"];
            this.duration = _data["duration"];
            this.confidence = _data["confidence"];
            this.displayText = _data["displayText"];
            if (Array.isArray(_data["displayWords"])) {
                this.displayWords = [] as any;
                for (let item of _data["displayWords"])
                    this.displayWords!.push(ExportWord.fromJS(item));
            }
            if (Array.isArray(_data["originalWords"])) {
                this.originalWords = [] as any;
                for (let item of _data["originalWords"])
                    this.originalWords!.push(ExportWord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExportTranscriptViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExportTranscriptViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["speakerId"] = this.speakerId;
        data["start"] = this.start;
        data["end"] = this.end;
        data["duration"] = this.duration;
        data["confidence"] = this.confidence;
        data["displayText"] = this.displayText;
        if (Array.isArray(this.displayWords)) {
            data["displayWords"] = [];
            for (let item of this.displayWords)
                data["displayWords"].push(item.toJSON());
        }
        if (Array.isArray(this.originalWords)) {
            data["originalWords"] = [];
            for (let item of this.originalWords)
                data["originalWords"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExportTranscriptViewModel {
    speakerId: string;
    start: number;
    end: number;
    duration: number;
    confidence: number;
    displayText: string;
    displayWords: ExportWord[];
    originalWords: ExportWord[];
}

export class ExportWord implements IExportWord {
    text!: string;
    offsetInSeconds!: number | undefined;
    durationInSeconds!: number | undefined;
    confidence!: number;

    constructor(data?: IExportWord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.offsetInSeconds = _data["offsetInSeconds"];
            this.durationInSeconds = _data["durationInSeconds"];
            this.confidence = _data["confidence"];
        }
    }

    static fromJS(data: any): ExportWord {
        data = typeof data === 'object' ? data : {};
        let result = new ExportWord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["offsetInSeconds"] = this.offsetInSeconds;
        data["durationInSeconds"] = this.durationInSeconds;
        data["confidence"] = this.confidence;
        return data;
    }
}

export interface IExportWord {
    text: string;
    offsetInSeconds: number | undefined;
    durationInSeconds: number | undefined;
    confidence: number;
}

export class ExportSpeaker implements IExportSpeaker {
    speakerId!: string;
    speakerName!: string;
    speakerPrefix!: string | undefined;
    speakerSuffix!: string | undefined;

    constructor(data?: IExportSpeaker) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.speakerId = _data["speakerId"];
            this.speakerName = _data["speakerName"];
            this.speakerPrefix = _data["speakerPrefix"];
            this.speakerSuffix = _data["speakerSuffix"];
        }
    }

    static fromJS(data: any): ExportSpeaker {
        data = typeof data === 'object' ? data : {};
        let result = new ExportSpeaker();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["speakerId"] = this.speakerId;
        data["speakerName"] = this.speakerName;
        data["speakerPrefix"] = this.speakerPrefix;
        data["speakerSuffix"] = this.speakerSuffix;
        return data;
    }
}

export interface IExportSpeaker {
    speakerId: string;
    speakerName: string;
    speakerPrefix: string | undefined;
    speakerSuffix: string | undefined;
}

export class ExportAnnotation implements IExportAnnotation {
    uniqueId!: string;
    content!: string;
    start!: number;
    end!: number;
    createdByUserName!: string;
    createdBy!: number;
    createdOn!: Date;
    modifiedByUserName!: string;
    modifiedBy!: number;
    modifiedOn!: Date;

    constructor(data?: IExportAnnotation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.content = _data["content"];
            this.start = _data["start"];
            this.end = _data["end"];
            this.createdByUserName = _data["createdByUserName"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedByUserName = _data["modifiedByUserName"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ExportAnnotation {
        data = typeof data === 'object' ? data : {};
        let result = new ExportAnnotation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["content"] = this.content;
        data["start"] = this.start;
        data["end"] = this.end;
        data["createdByUserName"] = this.createdByUserName;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedByUserName"] = this.modifiedByUserName;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IExportAnnotation {
    uniqueId: string;
    content: string;
    start: number;
    end: number;
    createdByUserName: string;
    createdBy: number;
    createdOn: Date;
    modifiedByUserName: string;
    modifiedBy: number;
    modifiedOn: Date;
}

export class StructuredSimplifiedTranscriptExportModel implements IStructuredSimplifiedTranscriptExportModel {
    taskId!: number;
    originalFileUrl!: string | undefined;
    workspaceId!: number;
    batchId!: number | undefined;
    taskNumber!: number | undefined;
    externalId!: string | undefined;
    displayName!: string;
    description!: string | undefined;
    totalTimeInSeconds!: number;
    lastCheckoutByUserName!: string | undefined;
    lastCheckedOutBy!: number | undefined;
    lastCheckedOutUntil!: Date | undefined;
    lastIntegratedBy!: number | undefined;
    lastIntegratedByUserName!: string;
    lastIntegratedOn!: Date | undefined;
    transcript!: ExportSimplifiedTranscriptFullViewModel;
    metadata!: { [key: string]: string; };

    constructor(data?: IStructuredSimplifiedTranscriptExportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.originalFileUrl = _data["originalFileUrl"];
            this.workspaceId = _data["workspaceId"];
            this.batchId = _data["batchId"];
            this.taskNumber = _data["taskNumber"];
            this.externalId = _data["externalId"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.totalTimeInSeconds = _data["totalTimeInSeconds"];
            this.lastCheckoutByUserName = _data["lastCheckoutByUserName"];
            this.lastCheckedOutBy = _data["lastCheckedOutBy"];
            this.lastCheckedOutUntil = _data["lastCheckedOutUntil"] ? new Date(_data["lastCheckedOutUntil"].toString()) : <any>undefined;
            this.lastIntegratedBy = _data["lastIntegratedBy"];
            this.lastIntegratedByUserName = _data["lastIntegratedByUserName"];
            this.lastIntegratedOn = _data["lastIntegratedOn"] ? new Date(_data["lastIntegratedOn"].toString()) : <any>undefined;
            this.transcript = _data["transcript"] ? ExportSimplifiedTranscriptFullViewModel.fromJS(_data["transcript"]) : <any>undefined;
            if (_data["metadata"]) {
                this.metadata = {} as any;
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        (<any>this.metadata)![key] = _data["metadata"][key];
                }
            }
        }
    }

    static fromJS(data: any): StructuredSimplifiedTranscriptExportModel {
        data = typeof data === 'object' ? data : {};
        let result = new StructuredSimplifiedTranscriptExportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["originalFileUrl"] = this.originalFileUrl;
        data["workspaceId"] = this.workspaceId;
        data["batchId"] = this.batchId;
        data["taskNumber"] = this.taskNumber;
        data["externalId"] = this.externalId;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["totalTimeInSeconds"] = this.totalTimeInSeconds;
        data["lastCheckoutByUserName"] = this.lastCheckoutByUserName;
        data["lastCheckedOutBy"] = this.lastCheckedOutBy;
        data["lastCheckedOutUntil"] = this.lastCheckedOutUntil ? this.lastCheckedOutUntil.toISOString() : <any>undefined;
        data["lastIntegratedBy"] = this.lastIntegratedBy;
        data["lastIntegratedByUserName"] = this.lastIntegratedByUserName;
        data["lastIntegratedOn"] = this.lastIntegratedOn ? this.lastIntegratedOn.toISOString() : <any>undefined;
        data["transcript"] = this.transcript ? this.transcript.toJSON() : <any>undefined;
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (<any>data["metadata"])[key] = (<any>this.metadata)[key];
            }
        }
        return data;
    }
}

export interface IStructuredSimplifiedTranscriptExportModel {
    taskId: number;
    originalFileUrl: string | undefined;
    workspaceId: number;
    batchId: number | undefined;
    taskNumber: number | undefined;
    externalId: string | undefined;
    displayName: string;
    description: string | undefined;
    totalTimeInSeconds: number;
    lastCheckoutByUserName: string | undefined;
    lastCheckedOutBy: number | undefined;
    lastCheckedOutUntil: Date | undefined;
    lastIntegratedBy: number | undefined;
    lastIntegratedByUserName: string;
    lastIntegratedOn: Date | undefined;
    transcript: ExportSimplifiedTranscriptFullViewModel;
    metadata: { [key: string]: string; };
}

export class ExportSimplifiedTranscriptFullViewModel implements IExportSimplifiedTranscriptFullViewModel {
    transcripts!: ExportSimplifiedTranscriptViewModel[];
    speakers!: ExportSpeaker[];

    constructor(data?: IExportSimplifiedTranscriptFullViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["transcripts"])) {
                this.transcripts = [] as any;
                for (let item of _data["transcripts"])
                    this.transcripts!.push(ExportSimplifiedTranscriptViewModel.fromJS(item));
            }
            if (Array.isArray(_data["speakers"])) {
                this.speakers = [] as any;
                for (let item of _data["speakers"])
                    this.speakers!.push(ExportSpeaker.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExportSimplifiedTranscriptFullViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExportSimplifiedTranscriptFullViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.transcripts)) {
            data["transcripts"] = [];
            for (let item of this.transcripts)
                data["transcripts"].push(item.toJSON());
        }
        if (Array.isArray(this.speakers)) {
            data["speakers"] = [];
            for (let item of this.speakers)
                data["speakers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExportSimplifiedTranscriptFullViewModel {
    transcripts: ExportSimplifiedTranscriptViewModel[];
    speakers: ExportSpeaker[];
}

export class ExportSimplifiedTranscriptViewModel implements IExportSimplifiedTranscriptViewModel {
    speakerId!: string;
    start!: number;
    end!: number;
    duration!: number;
    confidence!: number;
    displayText!: string;

    constructor(data?: IExportSimplifiedTranscriptViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.speakerId = _data["speakerId"];
            this.start = _data["start"];
            this.end = _data["end"];
            this.duration = _data["duration"];
            this.confidence = _data["confidence"];
            this.displayText = _data["displayText"];
        }
    }

    static fromJS(data: any): ExportSimplifiedTranscriptViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExportSimplifiedTranscriptViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["speakerId"] = this.speakerId;
        data["start"] = this.start;
        data["end"] = this.end;
        data["duration"] = this.duration;
        data["confidence"] = this.confidence;
        data["displayText"] = this.displayText;
        return data;
    }
}

export interface IExportSimplifiedTranscriptViewModel {
    speakerId: string;
    start: number;
    end: number;
    duration: number;
    confidence: number;
    displayText: string;
}

export class PatchExternalIntegrationStatusModel implements IPatchExternalIntegrationStatusModel {
    externalIntegrationStatus!: string;

    constructor(data?: IPatchExternalIntegrationStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalIntegrationStatus = _data["externalIntegrationStatus"];
        }
    }

    static fromJS(data: any): PatchExternalIntegrationStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new PatchExternalIntegrationStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalIntegrationStatus"] = this.externalIntegrationStatus;
        return data;
    }
}

export interface IPatchExternalIntegrationStatusModel {
    externalIntegrationStatus: string;
}

export class ProblemDetails implements IProblemDetails {
    type!: string | undefined;
    title!: string | undefined;
    status!: number | undefined;
    detail!: string | undefined;
    instance!: string | undefined;
    extensions!: { [key: string]: any; };

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (<any>this.extensions)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (<any>data["extensions"])[key] = (<any>this.extensions)[key];
            }
        }
        return data;
    }
}

export interface IProblemDetails {
    type: string | undefined;
    title: string | undefined;
    status: number | undefined;
    detail: string | undefined;
    instance: string | undefined;
    extensions: { [key: string]: any; };

    [key: string]: any;
}

export class WorkspaceIdViewModel implements IWorkspaceIdViewModel {
    workspaceId!: number;
    tenantId!: number;

    constructor(data?: IWorkspaceIdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workspaceId = _data["workspaceId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): WorkspaceIdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkspaceIdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workspaceId"] = this.workspaceId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IWorkspaceIdViewModel {
    workspaceId: number;
    tenantId: number;
}

export class WorkspaceUserGetSimplifiedViewModel implements IWorkspaceUserGetSimplifiedViewModel {
    workspaceId!: number;
    tenantId!: number;
    workspaceName!: string;
    workspaceDescription!: string;
    isDefault!: boolean;
    taskType!: TaskType;
    workspaceType!: WorkspaceType;
    templateType!: TemplateType;
    workspaceTemplateName!: string | undefined;

    constructor(data?: IWorkspaceUserGetSimplifiedViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workspaceId = _data["workspaceId"];
            this.tenantId = _data["tenantId"];
            this.workspaceName = _data["workspaceName"];
            this.workspaceDescription = _data["workspaceDescription"];
            this.isDefault = _data["isDefault"];
            this.taskType = _data["taskType"];
            this.workspaceType = _data["workspaceType"];
            this.templateType = _data["templateType"];
            this.workspaceTemplateName = _data["workspaceTemplateName"];
        }
    }

    static fromJS(data: any): WorkspaceUserGetSimplifiedViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkspaceUserGetSimplifiedViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workspaceId"] = this.workspaceId;
        data["tenantId"] = this.tenantId;
        data["workspaceName"] = this.workspaceName;
        data["workspaceDescription"] = this.workspaceDescription;
        data["isDefault"] = this.isDefault;
        data["taskType"] = this.taskType;
        data["workspaceType"] = this.workspaceType;
        data["templateType"] = this.templateType;
        data["workspaceTemplateName"] = this.workspaceTemplateName;
        return data;
    }
}

export interface IWorkspaceUserGetSimplifiedViewModel {
    workspaceId: number;
    tenantId: number;
    workspaceName: string;
    workspaceDescription: string;
    isDefault: boolean;
    taskType: TaskType;
    workspaceType: WorkspaceType;
    templateType: TemplateType;
    workspaceTemplateName: string | undefined;
}

export class SdWorkspaceDefaultIdViewModel implements ISdWorkspaceDefaultIdViewModel {
    defaultWorkspaceId!: number;

    constructor(data?: ISdWorkspaceDefaultIdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultWorkspaceId = _data["defaultWorkspaceId"];
        }
    }

    static fromJS(data: any): SdWorkspaceDefaultIdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdWorkspaceDefaultIdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultWorkspaceId"] = this.defaultWorkspaceId;
        return data;
    }
}

export interface ISdWorkspaceDefaultIdViewModel {
    defaultWorkspaceId: number;
}

export class ResultWithCodeOfSdWorkspaceIdViewModelAndWorkspaceIdByNifError implements IResultWithCodeOfSdWorkspaceIdViewModelAndWorkspaceIdByNifError {
    succeeded!: boolean;
    result!: SdWorkspaceIdViewModel | undefined;
    errors!: ErrorWithCodeOfWorkspaceIdByNifError[];

    constructor(data?: IResultWithCodeOfSdWorkspaceIdViewModelAndWorkspaceIdByNifError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.result = _data["result"] ? SdWorkspaceIdViewModel.fromJS(_data["result"]) : <any>undefined;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorWithCodeOfWorkspaceIdByNifError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultWithCodeOfSdWorkspaceIdViewModelAndWorkspaceIdByNifError {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithCodeOfSdWorkspaceIdViewModelAndWorkspaceIdByNifError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResultWithCodeOfSdWorkspaceIdViewModelAndWorkspaceIdByNifError {
    succeeded: boolean;
    result: SdWorkspaceIdViewModel | undefined;
    errors: ErrorWithCodeOfWorkspaceIdByNifError[];
}

export class SdWorkspaceIdViewModel implements ISdWorkspaceIdViewModel {
    workspaceId!: number;

    constructor(data?: ISdWorkspaceIdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workspaceId = _data["workspaceId"];
        }
    }

    static fromJS(data: any): SdWorkspaceIdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SdWorkspaceIdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workspaceId"] = this.workspaceId;
        return data;
    }
}

export interface ISdWorkspaceIdViewModel {
    workspaceId: number;
}

export class ErrorWithCodeOfWorkspaceIdByNifError implements IErrorWithCodeOfWorkspaceIdByNifError {
    code!: WorkspaceIdByNifError;
    error!: string;

    constructor(data?: IErrorWithCodeOfWorkspaceIdByNifError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): ErrorWithCodeOfWorkspaceIdByNifError {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorWithCodeOfWorkspaceIdByNifError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["error"] = this.error;
        return data;
    }
}

export interface IErrorWithCodeOfWorkspaceIdByNifError {
    code: WorkspaceIdByNifError;
    error: string;
}

export enum WorkspaceIdByNifError {
    InvalidNif = 10,
    NifNotMapped = 20,
    DefaultWorkspaceNotContentUnderstanding = 30,
}

export class ExternalUserViewModel implements IExternalUserViewModel {
    id!: number;
    roleName!: string;
    name!: string;
    userName!: string;
    email!: string;
    createdAt!: Date;
    emailConfirmed!: boolean;
    status!: string;

    constructor(data?: IExternalUserViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.roleName = _data["roleName"];
            this.name = _data["name"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.emailConfirmed = _data["emailConfirmed"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ExternalUserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalUserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["roleName"] = this.roleName;
        data["name"] = this.name;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["emailConfirmed"] = this.emailConfirmed;
        data["status"] = this.status;
        return data;
    }
}

export interface IExternalUserViewModel {
    id: number;
    roleName: string;
    name: string;
    userName: string;
    email: string;
    createdAt: Date;
    emailConfirmed: boolean;
    status: string;
}

export class InviteUsersRequest implements IInviteUsersRequest {
    users!: ExternalUserModel[];

    constructor(data?: IInviteUsersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(ExternalUserModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InviteUsersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InviteUsersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInviteUsersRequest {
    users: ExternalUserModel[];
}

export class InviteWorkspaceUsersRequest extends InviteUsersRequest implements IInviteWorkspaceUsersRequest {
    workspaceId!: number;

    constructor(data?: IInviteWorkspaceUsersRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.workspaceId = _data["workspaceId"];
        }
    }

    static fromJS(data: any): InviteWorkspaceUsersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InviteWorkspaceUsersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workspaceId"] = this.workspaceId;
        super.toJSON(data);
        return data;
    }
}

export interface IInviteWorkspaceUsersRequest extends IInviteUsersRequest {
    workspaceId: number;
}

export class ExternalUserModel implements IExternalUserModel {
    email!: string;
    roleName!: string;

    constructor(data?: IExternalUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any): ExternalUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["roleName"] = this.roleName;
        return data;
    }
}

export interface IExternalUserModel {
    email: string;
    roleName: string;
}

export class ResultWithCodeOfDriveItemModelAndSharePointError implements IResultWithCodeOfDriveItemModelAndSharePointError {
    succeeded!: boolean;
    result!: DriveItemModel | undefined;
    errors!: ErrorWithCodeOfSharePointError[];

    constructor(data?: IResultWithCodeOfDriveItemModelAndSharePointError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.result = _data["result"] ? DriveItemModel.fromJS(_data["result"]) : <any>undefined;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorWithCodeOfSharePointError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultWithCodeOfDriveItemModelAndSharePointError {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithCodeOfDriveItemModelAndSharePointError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResultWithCodeOfDriveItemModelAndSharePointError {
    succeeded: boolean;
    result: DriveItemModel | undefined;
    errors: ErrorWithCodeOfSharePointError[];
}

export class UploadFileModel implements IUploadFileModel {
    serviceName!: string;
    directoryPath!: string;
    fileName!: string;
    fileUrl!: string;

    constructor(data?: IUploadFileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceName = _data["serviceName"];
            this.directoryPath = _data["directoryPath"];
            this.fileName = _data["fileName"];
            this.fileUrl = _data["fileUrl"];
        }
    }

    static fromJS(data: any): UploadFileModel {
        data = typeof data === 'object' ? data : {};
        let result = new UploadFileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceName"] = this.serviceName;
        data["directoryPath"] = this.directoryPath;
        data["fileName"] = this.fileName;
        data["fileUrl"] = this.fileUrl;
        return data;
    }
}

export interface IUploadFileModel {
    serviceName: string;
    directoryPath: string;
    fileName: string;
    fileUrl: string;
}

export class ResultWithCodeOfStorageItemResolvedModelAndStorageIntegrationError implements IResultWithCodeOfStorageItemResolvedModelAndStorageIntegrationError {
    succeeded!: boolean;
    result!: StorageItemResolvedModel | undefined;
    errors!: ErrorWithCodeOfStorageIntegrationError[];

    constructor(data?: IResultWithCodeOfStorageItemResolvedModelAndStorageIntegrationError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.result = _data["result"] ? StorageItemResolvedModel.fromJS(_data["result"]) : <any>undefined;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorWithCodeOfStorageIntegrationError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultWithCodeOfStorageItemResolvedModelAndStorageIntegrationError {
        data = typeof data === 'object' ? data : {};
        let result = new ResultWithCodeOfStorageItemResolvedModelAndStorageIntegrationError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResultWithCodeOfStorageItemResolvedModelAndStorageIntegrationError {
    succeeded: boolean;
    result: StorageItemResolvedModel | undefined;
    errors: ErrorWithCodeOfStorageIntegrationError[];
}

export class StorageItemResolvedModel implements IStorageItemResolvedModel {
    id!: string;
    path!: string;
    displayFullPath!: string;
    downloadUrl!: string;
    webUrl!: string;
    metadata!: { [key: string]: string; };

    constructor(data?: IStorageItemResolvedModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.path = _data["path"];
            this.displayFullPath = _data["displayFullPath"];
            this.downloadUrl = _data["downloadUrl"];
            this.webUrl = _data["webUrl"];
            if (_data["metadata"]) {
                this.metadata = {} as any;
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        (<any>this.metadata)![key] = _data["metadata"][key];
                }
            }
        }
    }

    static fromJS(data: any): StorageItemResolvedModel {
        data = typeof data === 'object' ? data : {};
        let result = new StorageItemResolvedModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["path"] = this.path;
        data["displayFullPath"] = this.displayFullPath;
        data["downloadUrl"] = this.downloadUrl;
        data["webUrl"] = this.webUrl;
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (<any>data["metadata"])[key] = (<any>this.metadata)[key];
            }
        }
        return data;
    }
}

export interface IStorageItemResolvedModel {
    id: string;
    path: string;
    displayFullPath: string;
    downloadUrl: string;
    webUrl: string;
    metadata: { [key: string]: string; };
}

export class TaskToTrainModel implements ITaskToTrainModel {
    taskId!: number;
    taskStorageConfig!: SdTaskStorageConfig;

    constructor(data?: ITaskToTrainModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.taskStorageConfig = _data["taskStorageConfig"] ? SdTaskStorageConfig.fromJS(_data["taskStorageConfig"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TaskToTrainModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskToTrainModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["taskStorageConfig"] = this.taskStorageConfig ? this.taskStorageConfig.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITaskToTrainModel {
    taskId: number;
    taskStorageConfig: SdTaskStorageConfig;
}

export class SdTaskStorageConfig extends TableStorageEntity implements ISdTaskStorageConfig {
    taskId!: number;
    storageAccount!: string;
    containerName!: string;
    basePath!: string;
    originalFilePath!: string;
    version!: string;
    fileType!: string;
    blobPath!: string;
    originalFileUrl!: string | undefined;
    splitSourceTaskStorageRowKey!: string | undefined;
    resultBlobFileName!: string | undefined;
    resultSharepointServiceName!: string | undefined;
    resultSharepointId!: string | undefined;
    resultSharepointDriveId!: string | undefined;

    constructor(data?: ISdTaskStorageConfig) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.taskId = _data["taskId"];
            this.storageAccount = _data["storageAccount"];
            this.containerName = _data["containerName"];
            this.basePath = _data["basePath"];
            this.originalFilePath = _data["originalFilePath"];
            this.version = _data["version"];
            this.fileType = _data["fileType"];
            this.blobPath = _data["blobPath"];
            this.originalFileUrl = _data["originalFileUrl"];
            this.splitSourceTaskStorageRowKey = _data["splitSourceTaskStorageRowKey"];
            this.resultBlobFileName = _data["resultBlobFileName"];
            this.resultSharepointServiceName = _data["resultSharepointServiceName"];
            this.resultSharepointId = _data["resultSharepointId"];
            this.resultSharepointDriveId = _data["resultSharepointDriveId"];
        }
    }

    static fromJS(data: any): SdTaskStorageConfig {
        data = typeof data === 'object' ? data : {};
        let result = new SdTaskStorageConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["storageAccount"] = this.storageAccount;
        data["containerName"] = this.containerName;
        data["basePath"] = this.basePath;
        data["originalFilePath"] = this.originalFilePath;
        data["version"] = this.version;
        data["fileType"] = this.fileType;
        data["blobPath"] = this.blobPath;
        data["originalFileUrl"] = this.originalFileUrl;
        data["splitSourceTaskStorageRowKey"] = this.splitSourceTaskStorageRowKey;
        data["resultBlobFileName"] = this.resultBlobFileName;
        data["resultSharepointServiceName"] = this.resultSharepointServiceName;
        data["resultSharepointId"] = this.resultSharepointId;
        data["resultSharepointDriveId"] = this.resultSharepointDriveId;
        super.toJSON(data);
        return data;
    }
}

export interface ISdTaskStorageConfig extends ITableStorageEntity {
    taskId: number;
    storageAccount: string;
    containerName: string;
    basePath: string;
    originalFilePath: string;
    version: string;
    fileType: string;
    blobPath: string;
    originalFileUrl: string | undefined;
    splitSourceTaskStorageRowKey: string | undefined;
    resultBlobFileName: string | undefined;
    resultSharepointServiceName: string | undefined;
    resultSharepointId: string | undefined;
    resultSharepointDriveId: string | undefined;
}

export class AvailableRoleViewModel implements IAvailableRoleViewModel {
    name!: string;

    constructor(data?: IAvailableRoleViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AvailableRoleViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableRoleViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IAvailableRoleViewModel {
    name: string;
}

export class ExternalTaskSpeakers implements IExternalTaskSpeakers {
    speakers!: ExternalTaskSpeakerViewModel[];

    constructor(data?: IExternalTaskSpeakers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["speakers"])) {
                this.speakers = [] as any;
                for (let item of _data["speakers"])
                    this.speakers!.push(ExternalTaskSpeakerViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExternalTaskSpeakers {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalTaskSpeakers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.speakers)) {
            data["speakers"] = [];
            for (let item of this.speakers)
                data["speakers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExternalTaskSpeakers {
    speakers: ExternalTaskSpeakerViewModel[];
}

export class ExternalTaskSpeakerViewModel implements IExternalTaskSpeakerViewModel {
    speakerId!: string;
    speakerName!: string;
    speakerPrefix!: string | undefined;
    speakerSuffix!: string | undefined;
    isDefault!: boolean;
    source!: SpeakerSource;

    constructor(data?: IExternalTaskSpeakerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.speakerId = _data["speakerId"];
            this.speakerName = _data["speakerName"];
            this.speakerPrefix = _data["speakerPrefix"];
            this.speakerSuffix = _data["speakerSuffix"];
            this.isDefault = _data["isDefault"];
            this.source = _data["source"];
        }
    }

    static fromJS(data: any): ExternalTaskSpeakerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalTaskSpeakerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["speakerId"] = this.speakerId;
        data["speakerName"] = this.speakerName;
        data["speakerPrefix"] = this.speakerPrefix;
        data["speakerSuffix"] = this.speakerSuffix;
        data["isDefault"] = this.isDefault;
        data["source"] = this.source;
        return data;
    }
}

export interface IExternalTaskSpeakerViewModel {
    speakerId: string;
    speakerName: string;
    speakerPrefix: string | undefined;
    speakerSuffix: string | undefined;
    isDefault: boolean;
    source: SpeakerSource;
}

export class ExternalTaskSpeakerModel implements IExternalTaskSpeakerModel {
    speakerId!: string;
    speakerName!: string;
    speakerPrefix!: string | undefined;
    speakerSuffix!: string | undefined;
    isDefault!: boolean;

    constructor(data?: IExternalTaskSpeakerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.speakerId = _data["speakerId"];
            this.speakerName = _data["speakerName"];
            this.speakerPrefix = _data["speakerPrefix"];
            this.speakerSuffix = _data["speakerSuffix"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): ExternalTaskSpeakerModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalTaskSpeakerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["speakerId"] = this.speakerId;
        data["speakerName"] = this.speakerName;
        data["speakerPrefix"] = this.speakerPrefix;
        data["speakerSuffix"] = this.speakerSuffix;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface IExternalTaskSpeakerModel {
    speakerId: string;
    speakerName: string;
    speakerPrefix: string | undefined;
    speakerSuffix: string | undefined;
    isDefault: boolean;
}

export class ExternalWorkspaceSpeakers implements IExternalWorkspaceSpeakers {
    speakers!: ExternalWorkspaceSpeakerViewModel[];

    constructor(data?: IExternalWorkspaceSpeakers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["speakers"])) {
                this.speakers = [] as any;
                for (let item of _data["speakers"])
                    this.speakers!.push(ExternalWorkspaceSpeakerViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExternalWorkspaceSpeakers {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalWorkspaceSpeakers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.speakers)) {
            data["speakers"] = [];
            for (let item of this.speakers)
                data["speakers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExternalWorkspaceSpeakers {
    speakers: ExternalWorkspaceSpeakerViewModel[];
}

export class ExternalWorkspaceSpeakerViewModel implements IExternalWorkspaceSpeakerViewModel {
    speakerId!: string;
    speakerName!: string;
    speakerPrefix!: string | undefined;
    speakerSuffix!: string | undefined;

    constructor(data?: IExternalWorkspaceSpeakerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.speakerId = _data["speakerId"];
            this.speakerName = _data["speakerName"];
            this.speakerPrefix = _data["speakerPrefix"];
            this.speakerSuffix = _data["speakerSuffix"];
        }
    }

    static fromJS(data: any): ExternalWorkspaceSpeakerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalWorkspaceSpeakerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["speakerId"] = this.speakerId;
        data["speakerName"] = this.speakerName;
        data["speakerPrefix"] = this.speakerPrefix;
        data["speakerSuffix"] = this.speakerSuffix;
        return data;
    }
}

export interface IExternalWorkspaceSpeakerViewModel {
    speakerId: string;
    speakerName: string;
    speakerPrefix: string | undefined;
    speakerSuffix: string | undefined;
}

export class CurrentUserWithAbilities implements ICurrentUserWithAbilities {
    user!: CurrentUser;
    abilities!: string[];

    constructor(data?: ICurrentUserWithAbilities) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? CurrentUser.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["abilities"])) {
                this.abilities = [] as any;
                for (let item of _data["abilities"])
                    this.abilities!.push(item);
            }
        }
    }

    static fromJS(data: any): CurrentUserWithAbilities {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUserWithAbilities();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.abilities)) {
            data["abilities"] = [];
            for (let item of this.abilities)
                data["abilities"].push(item);
        }
        return data;
    }
}

export interface ICurrentUserWithAbilities {
    user: CurrentUser;
    abilities: string[];
}

export class CurrentUser implements ICurrentUser {
    userId!: number | undefined;
    userName!: string;
    externalUserId!: string | undefined;
    roleId!: number | undefined;
    impersonateRoleId!: number | undefined;
    cultureId!: string;
    tenantId!: number | undefined;
    tenantCode!: string | undefined;
    workspaceIds!: number[];

    constructor(data?: ICurrentUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.externalUserId = _data["externalUserId"];
            this.roleId = _data["roleId"];
            this.impersonateRoleId = _data["impersonateRoleId"];
            this.cultureId = _data["cultureId"];
            this.tenantId = _data["tenantId"];
            this.tenantCode = _data["tenantCode"];
            if (Array.isArray(_data["workspaceIds"])) {
                this.workspaceIds = [] as any;
                for (let item of _data["workspaceIds"])
                    this.workspaceIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CurrentUser {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["externalUserId"] = this.externalUserId;
        data["roleId"] = this.roleId;
        data["impersonateRoleId"] = this.impersonateRoleId;
        data["cultureId"] = this.cultureId;
        data["tenantId"] = this.tenantId;
        data["tenantCode"] = this.tenantCode;
        if (Array.isArray(this.workspaceIds)) {
            data["workspaceIds"] = [];
            for (let item of this.workspaceIds)
                data["workspaceIds"].push(item);
        }
        return data;
    }
}

export interface ICurrentUser {
    userId: number | undefined;
    userName: string;
    externalUserId: string | undefined;
    roleId: number | undefined;
    impersonateRoleId: number | undefined;
    cultureId: string;
    tenantId: number | undefined;
    tenantCode: string | undefined;
    workspaceIds: number[];
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}